(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[441],{

/***/ 30384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_CopyButton; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/theme/index.ts
var theme = __webpack_require__(57214);
// EXTERNAL MODULE: ./src/theme/keyframes.ts
var keyframes = __webpack_require__(59731);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Loader/CopySuccessLoader.tsx








var CopySuccessLoader = function CopySuccessLoader(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    size: size,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 130.2 130.2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        className: "path circle",
        fill: "none",
        stroke: theme/* default.colors.success */.Z.colors.success,
        strokeWidth: "6",
        strokeMiterlimit: "10",
        cx: "65.1",
        cy: "65.1",
        r: "62.1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("polyline", {
        className: "path check",
        fill: "none",
        stroke: theme/* default.colors.success */.Z.colors.success,
        strokeWidth: "6",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        points: "100.2,40.2 51.5,88.8 29.8,67.5 "
      })]
    })
  });
};

var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs({
  as: 'span'
}).withConfig({
  displayName: "CopySuccessLoader__Wrapper",
  componentId: "sc-12oepq6-0"
})(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n\n  svg {\n    width: ", "px;\n    height: ", "px;\n\n    circle,\n    polyline {\n      stroke-dasharray: 1000;\n      stroke-dashoffset: 0;\n    }\n\n    circle {\n      animation: ", " 0.9s ease-in-out;\n    }\n    polyline {\n      stroke-dashoffset: -100;\n      animation: ", " 0.9s 0.35s ease-in-out forwards;\n    }\n  }\n"], function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var size = _ref3.size;
  return size;
}, keyframes/* default.dash */.Z.dash, keyframes/* default.dashChecked */.Z.dashChecked);
/* harmony default export */ var Loader_CopySuccessLoader = (/*#__PURE__*/react.memo(CopySuccessLoader));
// EXTERNAL MODULE: ./node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(20640);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
;// CONCATENATED MODULE: ./src/hooks/useCopy.ts



var useCopy = function useCopy() {
  var _useState = (0,react.useState)(false),
      copied = _useState[0],
      setCopied = _useState[1];

  var handleCopy = function handleCopy(copyStr) {
    var copiedString = copy_to_clipboard_default()(copyStr);
    setCopied(copiedString);
    setTimeout(function () {
      setCopied(false);
    }, 3000);
  };

  return {
    copied: copied,
    handleCopy: handleCopy
  };
};

/* harmony default export */ var hooks_useCopy = (useCopy);
// EXTERNAL MODULE: ./src/svgs/index.ts + 103 modules
var svgs = __webpack_require__(8400);
// EXTERNAL MODULE: ./src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(19784);
;// CONCATENATED MODULE: ./src/components/Button/CopyButton.tsx


var _excluded = ["text", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CopyButton = function CopyButton(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useCopy = hooks_useCopy(),
      copied = _useCopy.copied,
      handleCopy = _useCopy.handleCopy;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
      onClick: function onClick() {
        handleCopy(text);
      },
      children: [!copied && (icon || /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.CopyIcon */.P.CopyIcon, {
        fill: theme/* default.colors.textSubtle */.Z.colors.textSubtle
      })), copied && /*#__PURE__*/(0,jsx_runtime.jsx)(Loader_CopySuccessLoader, {})]
    })
  }));
};

/* harmony default export */ var Button_CopyButton = (CopyButton);

/***/ }),

/***/ 19784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55704);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39281);



var IconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
  as: components_Box_Box__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
}).withConfig({
  displayName: "IconButton",
  componentId: "sc-19tea0i-0"
})(["\n  background: transparent;\n  padding: 0px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  svg {\n    fill: ", " !important;\n  }\n\n  &:hover {\n    svg {\n      fill: ", " !important;\n    }\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.textSubtle;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.text;
});
/* harmony default export */ __webpack_exports__["Z"] = (IconButton);

/***/ }),

/***/ 34812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./src/components/Input/index.tsx + 1 modules
var Input = __webpack_require__(89850);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.tsx



var Checkbox = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "Checkbox",
  componentId: "sc-1fm9ry8-0"
})(["\n  appearance: none;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n  transition: background-color 0.2s ease-in-out;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  margin: 0;\n  display: block;\n\n  &:after {\n    content: '';\n    position: absolute;\n    border-bottom: 2px solid;\n    border-left: 2px solid;\n    border-color: transparent;\n    top: 30%;\n    left: 0;\n    right: 0;\n    width: 50%;\n    height: 25%;\n    margin: auto;\n    transform: rotate(-50deg);\n    transition: border-color 0.2s ease-in-out;\n  }\n\n  &:checked {\n    background-color: ", ";\n    border-color: ", ";\n    border: none;\n    &:after {\n      border-color: rgb(21, 18, 29);\n    }\n  }\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.6;\n  }\n\n  ", "\n  ", "\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.textSubtle;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.tiny;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.strokeAlt;
}, index_esm/* layout */.bK, index_esm/* space */.Dh);
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
;// CONCATENATED MODULE: ./src/components/Checkbox/index.tsx


/***/ }),

/***/ 38097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormControl_FormInput; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Input/InputAdornment/index.tsx


var _excluded = ["endAdornment", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var InputAdornment = function InputAdornment(_ref) {
  var endAdornment = _ref.endAdornment,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var containerRef = (0,react.useRef)(null);
  var focusInput = (0,react.useCallback)(function () {
    var input = containerRef.current.querySelector('input');

    if (input) {
      input.focus();
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, _objectSpread(_objectSpread({
    ref: containerRef,
    width: "100%",
    alignItems: "center",
    onClick: focusInput
  }, props), {}, {
    children: [children, endAdornment && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledRightAdornmentContainer, {
      ml: "8px",
      alignItems: "center",
      children: endAdornment
    })]
  }));
};

var StyledRightAdornmentContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "InputAdornment__StyledRightAdornmentContainer",
  componentId: "sc-1squrw7-0"
})(["\n  gap: 6px;\n"]);
var StyledAdornment = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "InputAdornment__StyledAdornment",
  componentId: "sc-1squrw7-1"
})(["\n  display: flex;\n"]);
var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "InputAdornment__StyledContainer",
  componentId: "sc-1squrw7-2"
})(["\n  width: 100%;\n  position: relative;\n  cursor: text;\n\n  .hide-when-focus {\n    display: block;\n  }\n\n  &:focus-within {\n    .hide-when-focus {\n      display: none;\n    }\n  }\n"]);
/* harmony default export */ var Input_InputAdornment = (InputAdornment);
// EXTERNAL MODULE: ./src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(19784);
// EXTERNAL MODULE: ./src/svgs/index.ts + 103 modules
var svgs = __webpack_require__(8400);
;// CONCATENATED MODULE: ./src/components/Input/InputAdornment/RemoveValueInputAdornment.tsx


var RemoveValueInputAdornment_excluded = ["value", "onRemove"];

function RemoveValueInputAdornment_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RemoveValueInputAdornment_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RemoveValueInputAdornment_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RemoveValueInputAdornment_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var RemoveValueInputAdornment = function RemoveValueInputAdornment(_ref) {
  var value = _ref.value,
      onRemove = _ref.onRemove,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, RemoveValueInputAdornment_excluded);

  var isDisplayRemoveIcon = value !== null && value !== '' && value !== undefined;
  return isDisplayRemoveIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAdornment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, RemoveValueInputAdornment_objectSpread(RemoveValueInputAdornment_objectSpread({
      onClick: onRemove,
      display: isDisplayRemoveIcon ? 'block' : 'none'
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.CloseCircleIcon */.P.CloseCircleIcon, {
        height: "20px",
        width: "20px"
      })
    }))
  });
};

/* harmony default export */ var InputAdornment_RemoveValueInputAdornment = (RemoveValueInputAdornment);
// EXTERNAL MODULE: ./src/components/Input/styled.tsx
var styled = __webpack_require__(9025);
;// CONCATENATED MODULE: ./src/components/FormControl/FormInput.tsx


var FormInput_excluded = ["control", "adornment", "icon"];

function FormInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FormInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FormInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FormInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var addRemoveValueAdornment = function addRemoveValueAdornment(adornment, value, setValue) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [adornment, /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment_RemoveValueInputAdornment, {
      value: value,
      onRemove: function onRemove() {
        setValue('');
      }
    })]
  });
};

var FormInput = function FormInput(_ref) {
  var control = _ref.control,
      adornment = _ref.adornment,
      icon = _ref.icon,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, FormInput_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* InputContainer */.fv, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Input_InputAdornment, {
      endAdornment: addRemoveValueAdornment(adornment, control.value, control.onValueChanged),
      p: "0px 12px",
      children: [icon && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        width: "20px",
        mr: "6px",
        children: icon
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* StyledInput */.Fy, FormInput_objectSpread(FormInput_objectSpread({}, control), props))]
    })
  });
};

/* harmony default export */ var FormControl_FormInput = (FormInput);

/***/ }),

/***/ 66938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_FormControl; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Input/styled.tsx
var styled = __webpack_require__(9025);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 3 modules
var Trans = __webpack_require__(93955);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./src/components/OpenEffect/index.tsx
var OpenEffect = __webpack_require__(5790);
// EXTERNAL MODULE: ./src/components/Text/index.ts
var Text = __webpack_require__(19500);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/svgs/index.ts + 103 modules
var svgs = __webpack_require__(8400);
// EXTERNAL MODULE: ./src/theme/colors.ts
var colors = __webpack_require__(72959);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Input/InputInstruction.tsx


var _excluded = ["data", "errors"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var InputInstruction = function InputInstruction(_ref) {
  var data = _ref.data,
      errors = _ref.errors,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    position: "relative",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledInstructionContainer, _objectSpread(_objectSpread({}, props), {}, {
      children: data.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
          alignItems: "center",
          mb: "10px",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            width: "16px",
            height: "16px",
            children: errors.includes(item.validationError) ? /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.CloseCircleIcon */.P.CloseCircleIcon, {
              fill: colors/* colors.error */.O.error,
              width: "16px",
              height: "16px"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.SuccessIcon */.P.SuccessIcon, {
              fill: colors/* colors.success */.O.success,
              width: "16px",
              height: "16px"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            fontSize: "12px",
            color: "textTertiary",
            fontWeight: "300",
            ml: "6px",
            children: item.message
          })]
        }, item.validationError);
      })
    }))
  });
};

var StyledInstructionContainer = (0,styled_components_browser_esm/* default */.ZP)(OpenEffect/* default */.Z).withConfig({
  displayName: "InputInstruction__StyledInstructionContainer",
  componentId: "sc-9wr1q9-0"
})(["\n  position: absolute;\n  margin-top: 8px;\n  border-radius: ", ";\n  background: ", ";\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);\n  z-index: 2;\n\n  padding: 16px 12px;\n  padding-bottom: 6px;\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.large;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.backgroundAlt3;
});
/* harmony default export */ var Input_InputInstruction = (InputInstruction);
// EXTERNAL MODULE: ./src/components/FormControl/styled.tsx
var FormControl_styled = __webpack_require__(92644);
;// CONCATENATED MODULE: ./src/components/FormControl/index.tsx


var FormControl_excluded = ["state", "label", "formatErrorMessage", "instructionConfig", "children"];

function FormControl_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FormControl_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FormControl_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FormControl_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var FormControl = function FormControl(_ref) {
  var state = _ref.state,
      label = _ref.label,
      formatErrorMessage = _ref.formatErrorMessage,
      instructionConfig = _ref.instructionConfig,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, FormControl_excluded);

  var isDisplayInstruction = (0,react.useMemo)(function () {
    return instructionConfig && state.value && !!instructionConfig.filter(function (config) {
      return state.errors.includes(config.validationError);
    }).length;
  }, [instructionConfig, state]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormControl_styled/* StyledControlContainer */.l, FormControl_objectSpread(FormControl_objectSpread({
    state: state
  }, props), {}, {
    children: [label && /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* InputLabel */.AZ, {
      children: label
    }), children, isDisplayInstruction && /*#__PURE__*/(0,jsx_runtime.jsx)(Input_InputInstruction, {
      className: "display-when-active",
      data: instructionConfig,
      errors: state.errors
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* InputMessage */.LK, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
        children: formatErrorMessage(state.errors) || ''
      })
    })]
  }));
};

/* harmony default export */ var components_FormControl = (FormControl);

/***/ }),

/***/ 92644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ StyledControlContainer; }
/* harmony export */ });
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55704);
/* harmony import */ var components_Checkbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34812);
/* harmony import */ var components_Input_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9025);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);





var getControlDirtyStyles = function getControlDirtyStyles(_ref) {
  var state = _ref.state,
      theme = _ref.theme;
  var isError = (state === null || state === void 0 ? void 0 : state.errors.length) > 0;
  if (!state || !state.isDirty || !isError) return '';
  return "\n    ".concat(components_Input_styled__WEBPACK_IMPORTED_MODULE_2__/* .InputMessage */ .LK, " {\n      color: ").concat(theme.colors.error, " !important;\n    }\n\n    ").concat(components_Input_styled__WEBPACK_IMPORTED_MODULE_2__/* .InputContainer */ .fv, " {\n      background-color: rgb(30, 18, 18) !important;\n       border-color: ").concat(theme.colors.error, " !important;\n     }\n\n    ").concat(components_Checkbox__WEBPACK_IMPORTED_MODULE_1__/* .Checkbox */ .X, " {\n      border-color: ").concat(theme.colors.error, " ;\n    }\n  ");
};

var StyledControlContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(components_Box_Box__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).withConfig({
  displayName: "styled__StyledControlContainer",
  componentId: "sc-2vqvhc-0"
})(["\n  display: flex;\n  flex-direction: column;\n  vertical-align: top;\n  position: relative;\n  width: 100%;\n\n  ", " {\n    color: ", ";\n  }\n\n  ", " {\n    height: 54px;\n  }\n\n  .display-when-active {\n    visibility: hidden;\n    pointer-events: none;\n    transition: ", ";\n    opacity: 0;\n  }\n\n  &:focus-within,\n  &:hover {\n    ", " {\n      border-color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    }\n\n    ", " {\n      color: ", ";\n    }\n  }\n\n  &:focus-within {\n    .display-when-active {\n      visibility: visible;\n      pointer-events: auto;\n      opacity: 1;\n    }\n  }\n\n  ", "\n"], components_Input_styled__WEBPACK_IMPORTED_MODULE_2__/* .InputLabel */ .AZ, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.textSubtle;
}, components_Input_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledInput */ .Fy, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transitions.fast;
}, components_Input_styled__WEBPACK_IMPORTED_MODULE_2__/* .InputContainer */ .fv, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.strokeAlt;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.text;
}, components_Input_styled__WEBPACK_IMPORTED_MODULE_2__/* .InputLabel */ .AZ, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.text;
}, getControlDirtyStyles);

/***/ }),

/***/ 12842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Heading_Heading; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx + 1 modules
var Text = __webpack_require__(50011);
;// CONCATENATED MODULE: ./src/components/Heading/types.ts
var tags = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6'
};
var scales = {
  XS: 'xs',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl'
};
;// CONCATENATED MODULE: ./src/components/Heading/Heading.tsx


var _styleScale;





var styleScale = (_styleScale = {}, (0,defineProperty/* default */.Z)(_styleScale, scales.XS, {
  fontSize: ['14px', '14px', '16px', '16px']
}), (0,defineProperty/* default */.Z)(_styleScale, scales.MD, {
  fontSize: ['14px', '16px', '16px', '20px']
}), (0,defineProperty/* default */.Z)(_styleScale, scales.LG, {
  fontSize: ['18px', '20px', '20px', '24px']
}), (0,defineProperty/* default */.Z)(_styleScale, scales.XL, {
  fontSize: ['22px', '26px', '26px', '28px']
}), (0,defineProperty/* default */.Z)(_styleScale, scales.XXL, {
  fontSize: '44px'
}), _styleScale);
var Heading = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
  bold: true
}).withConfig({
  displayName: "Heading",
  componentId: "sc-1258ju4-0"
})(["\n  font-weight: 600;\n  line-height: 1.1;\n\n  ", "\n"], (0,index_esm/* variant */.bU)({
  prop: 'scale',
  variants: styleScale
}));
Heading.defaultProps = {
  as: tags.H2,
  scale: scales.MD
};
/* harmony default export */ var Heading_Heading = (Heading);

/***/ }),

/***/ 1227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Heading__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12842);


/***/ }),

/***/ 89850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Input; },
  "Q": function() { return /* binding */ validateFormControl; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/hooks/useDebounceCallback.ts
var useDebounceCallback = __webpack_require__(47520);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/requestHelper.ts
var requestHelper = __webpack_require__(75391);
;// CONCATENATED MODULE: ./src/hooks/useIsMounted.ts


function useIsMounted() {
  var isMounted = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  return (0,react.useCallback)(function () {
    return isMounted.current;
  }, []);
}

/* harmony default export */ var hooks_useIsMounted = (useIsMounted);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(58491);
// EXTERNAL MODULE: ./src/hooks/useRequest.ts
var useRequest = __webpack_require__(89058);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Input/index.tsx



var _excluded = ["value", "validators", "validateOnchange", "type", "onValueChanged", "onErrorChanged", "onValidating", "onValidated"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var validateFormControl = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(validators) {
    var result;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,requestHelper/* forkjoinRequest */.Rm)(validators);

          case 2:
            result = _context.sent;
            return _context.abrupt("return", result.filter(function (error) {
              return error;
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateFormControl(_x) {
    return _ref.apply(this, arguments);
  };
}();

var Input = function Input(_ref2) {
  var value = _ref2.value,
      validators = _ref2.validators,
      validateOnchange = _ref2.validateOnchange,
      type = _ref2.type,
      onValueChanged = _ref2.onValueChanged,
      onErrorChanged = _ref2.onErrorChanged,
      onValidating = _ref2.onValidating,
      onValidated = _ref2.onValidated,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  var debounceCallback = (0,useDebounceCallback/* default */.Z)();

  var _useState = (0,react.useState)([]),
      errors = _useState[0],
      setErrors = _useState[1];

  var validatedValue = (0,react.useRef)(null);
  var isMounted = hooks_useIsMounted();

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute,
      cancelAllRequest = _useRequest.cancelAllRequest;

  var validate = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var hasAsyncValidator, parsedValidators, validateErrors;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(validators && validators.length > 0 && onErrorChanged)) {
                _context2.next = 12;
                break;
              }

              if (!(validatedValue.current === value)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", errors);

            case 3:
              hasAsyncValidator = false;
              parsedValidators = validators.map(function (validator) {
                var result = validator(value);
                var hunnyRequest = result;

                if (hunnyRequest !== null && hunnyRequest !== void 0 && hunnyRequest.call && hunnyRequest !== null && hunnyRequest !== void 0 && hunnyRequest.cancel) {
                  hasAsyncValidator = true;
                  if (onValidating) onValidating();
                  return execute(hunnyRequest);
                }

                return Promise.resolve(result);
              }).filter(function (validator) {
                return validator;
              });
              _context2.next = 7;
              return validateFormControl(parsedValidators);

            case 7:
              validateErrors = _context2.sent;
              validatedValue.current = value;

              if (hasAsyncValidator && onValidated) {
                onValidated();
              }

              onErrorChanged(validateErrors);
              setErrors(validateErrors);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function validate() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function () {
    if (!isMounted()) {
      return;
    }

    if (errors.length > 0 || validateOnchange) {
      debounceCallback(function () {
        validate();
      }, 50);
    }

    return function () {
      cancelAllRequest();
    };
  }, [value]);

  var handleOnBlur = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              validate();

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleOnBlur() {
      return _ref4.apply(this, arguments);
    };
  }();

  var onChange = function onChange(e) {
    if (type === 'checkbox') {
      onValueChanged(e.target.checked);
    } else {
      onValueChanged(e.target.value);
    }
  };

  var valueProps = type === 'checkbox' ? {
    checked: value
  } : {
    value: value
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, props), {}, {
    onBlur: handleOnBlur,
    onChange: onChange,
    type: type
  }, valueProps));
};

/* harmony default export */ var components_Input = (Input);

/***/ }),

/***/ 9025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AZ": function() { return /* binding */ InputLabel; },
/* harmony export */   "Fy": function() { return /* binding */ StyledInput; },
/* harmony export */   "LK": function() { return /* binding */ InputMessage; },
/* harmony export */   "fv": function() { return /* binding */ InputContainer; }
/* harmony export */ });
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55704);
/* harmony import */ var components_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19500);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57247);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89850);





var InputLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
  as: 'label'
}).withConfig({
  displayName: "styled__InputLabel",
  componentId: "sc-1huc3i6-0"
})(["\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 4px;\n  transition: 0.2s all;\n"]);
var InputMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
  displayName: "styled__InputMessage",
  componentId: "sc-1huc3i6-1"
})(["\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  display: block;\n"]);
var InputContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_Box_Box__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).withConfig({
  displayName: "styled__InputContainer",
  componentId: "sc-1huc3i6-2"
})(["\n  overflow: hidden;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n\n  svg {\n    fill: ", ";\n  }\n\n  &:has(input:disabled) {\n    border: 1px solid ", " !important;\n\n    input {\n      cursor: not-allowed !important;\n    }\n  }\n\n  ", "\n\n  &:has(input:disabled) {\n    border: 1px solid ", " !important;\n\n    input {\n      cursor: not-allowed !important;\n    }\n  }\n\n  &:focus-within,\n  &:hover {\n    border-color: ", ";\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.stroke;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.textSubtle;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.stroke;
}, function (_ref5) {
  var $disabled = _ref5.$disabled;
  return $disabled ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["\n          border: 1px solid ", " !important;\n\n          input {\n            cursor: not-allowed !important;\n          }\n        "], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.stroke;
  }) : '';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.stroke;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.strokeAlt;
});
var StyledInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(___WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "styled__StyledInput",
  componentId: "sc-1huc3i6-3"
})(["\n  background-color: transparent;\n  border: none;\n  border-radius: ", ";\n  width: 100%;\n\n  color: ", ";\n  font-size: 14px;\n  font-weight: 400;\n\n  background-clip: content-box;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &::placeholder {\n    text-transform: capitalize;\n    color: ", "aa;\n  }\n\n  &:-webkit-autofill {\n    -webkit-text-fill-color: ", ";\n    -webkit-background-clip: text !important;\n    opacity: 1;\n    caret-color: ", ";\n  }\n\n  ", "\n"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.radii.small;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.textTertiary;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.textSubtle;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.text;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.text;
}, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh);

/***/ }),

/***/ 38767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var components_NextLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var utils_getExternalLinkProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87369);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19500);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


var _excluded = ["external", "href", "children", "target", "title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/default-props-match-prop-types */






var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-18a5aku-0"
})(["\n  display: flex;\n  align-items: center;\n\n  &:hover {\n    color: ", ";\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.text;
});

var Link = function Link(_ref2) {
  var external = _ref2.external,
      href = _ref2.href,
      children = _ref2.children,
      target = _ref2.target,
      title = _ref2.title,
      props = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref2, _excluded);

  var internalProps = external ? (0,utils_getExternalLinkProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)() : {};
  return external ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", _objectSpread(_objectSpread({
    title: title,
    href: href,
    target: target
  }, internalProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledLink, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  })) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_NextLink__WEBPACK_IMPORTED_MODULE_1__/* .NextLinkFromReactRouter */ .a, _objectSpread(_objectSpread({
    title: title,
    to: href
  }, internalProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledLink, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  }));
};

Link.defaultProps = {
  color: 'text'
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);

/***/ }),

/***/ 44785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Link__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38767);


/***/ }),

/***/ 95322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var svgs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8400);
/* harmony import */ var theme_keyframes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59731);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var CircleLoader = function CircleLoader() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(svgs__WEBPACK_IMPORTED_MODULE_2__/* .Icons.CircleLoadingBackgroundIcon */ .P.CircleLoadingBackgroundIcon, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledSpin, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(svgs__WEBPACK_IMPORTED_MODULE_2__/* .Icons.CircleLoadingIcon */ .P.CircleLoadingIcon, {})
    })]
  });
};

var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "CircleLoader__Wrapper",
  componentId: "sc-fcuvjw-0"
})(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  svg {\n    max-width: 24px;\n  }\n"]);
var StyledSpin = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(components_Box_Box__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).withConfig({
  displayName: "CircleLoader__StyledSpin",
  componentId: "sc-fcuvjw-1"
})(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 1;\n  animation: ", " 2s linear infinite;\n"], theme_keyframes__WEBPACK_IMPORTED_MODULE_3__/* ["default"].rotate */ .Z.rotate);
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(CircleLoader));

/***/ }),

/***/ 46405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);

var Dots = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Dots",
  componentId: "sc-qua21p-0"
})(["\n  &::after {\n    display: inline-block;\n    animation: ellipsis 1.25s infinite;\n    content: '.';\n    width: 1em;\n    text-align: left;\n  }\n  @keyframes ellipsis {\n    0% {\n      content: '.';\n    }\n    33% {\n      content: '..';\n    }\n    66% {\n      content: '...';\n    }\n  }\n"]);
/* harmony default export */ __webpack_exports__["Z"] = (Dots);

/***/ }),

/***/ 20458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55704);
/* harmony import */ var components_Button_IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19784);
/* harmony import */ var hooks_useKeydownEventListener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67238);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19521);
/* harmony import */ var svgs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8400);
/* harmony import */ var theme_keyframes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59731);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


var _excluded = ["id", "onDismiss", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var Modal = function Modal(_ref) {
  var id = _ref.id,
      onDismiss = _ref.onDismiss,
      children = _ref.children,
      props = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var handleOnDismiss = function handleOnDismiss() {
    if (onDismiss) {
      onDismiss();
    }
  };

  (0,hooks_useKeydownEventListener__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function (event) {
    if (event && event.key === 'Escape') {
      handleOnDismiss();
    }
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(StyledModal, _objectSpread(_objectSpread({
    id: id
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledCloseButton, {
      className: "modal-closebutton",
      id: "modal-closebutton",
      onClick: onDismiss,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(svgs__WEBPACK_IMPORTED_MODULE_5__/* .Icons.CloseIcon */ .P.CloseIcon, {})
    }), children]
  }));
};

var StyledModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
  displayName: "Modal__StyledModal",
  componentId: "sc-1s36pax-0"
})(["\n  box-sizing: border-box;\n  backdrop-filter: blur(10px);\n\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  min-width: 100%;\n  width: 100%;\n  min-height: 100px;\n  background: ", ";\n  max-width: 512px;\n  max-height: calc(var(--screen-height) - 24px);\n  overflow: auto;\n\n  ", " {\n    backdrop-filter: unset;\n  }\n\n  ", " {\n    min-width: 512px;\n    border-radius: ", ";\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.large;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.large;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.modalBackground;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediaQueries.xs;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.sm;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.radii.large;
});
var StyledCloseButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(components_Button_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  displayName: "Modal__StyledCloseButton",
  componentId: "sc-1s36pax-1"
})(["\n  position: absolute;\n  background: transparent;\n  z-index: 1;\n  width: 24px;\n  height: 24px;\n  top: 18px;\n  right: 25px;\n  cursor: pointer;\n  animation: ", " 1s ease-out forwards;\n\n  > svg {\n    margin-left: 0 !important;\n  }\n"], theme_keyframes__WEBPACK_IMPORTED_MODULE_6__/* ["default"].fade */ .Z.fade);
/* harmony default export */ __webpack_exports__["Z"] = (Modal);

/***/ }),

/***/ 23043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      props = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledModalBody, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
};

var StyledModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
  displayName: "ModalBody__StyledModalBody",
  componentId: "sc-1vr5t1y-0"
})(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  position: relative;\n\n  width: 100%;\n\n  background: ", ";\n  border-radius: ", ";\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.modalBackground;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.modal;
});
/* harmony default export */ __webpack_exports__["Z"] = (ModalBody);

/***/ }),

/***/ 67498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fe": function() { return /* reexport */ ModalBody/* default */.Z; },
  "xB": function() { return /* reexport */ components_ModalHeader; },
  "ZP": function() { return /* reexport */ Modal/* default */.Z; }
});

// UNUSED EXPORTS: ModalFooter

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Modal/components/ModalHeader.tsx


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledContainer, {
    minHeight: "70px",
    mb: "-10px",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHeaderContainer, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "ModalHeader__StyledContainer",
  componentId: "sc-1bryhge-0"
})(["\n  background: ", ";\n"], function (_ref2) {
  var colors = _ref2.theme.colors;
  return colors.modalHeaderBackground;
});
var StyledHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "ModalHeader__StyledHeaderContainer",
  componentId: "sc-1bryhge-1"
})(["\n  width: 100%;\n  height: 60px;\n  display: flex;\n  align-items: center;\n"]);
/* harmony default export */ var components_ModalHeader = (ModalHeader);
;// CONCATENATED MODULE: ./src/components/Modal/components/ModalFooter.tsx


var ModalFooter_excluded = (/* unused pure expression or super */ null && (["children"]));

function ModalFooter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ModalFooter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ModalFooter_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ModalFooter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ModalFooter_excluded);

  return /*#__PURE__*/_jsx(StyledFooterContainer, ModalFooter_objectSpread(ModalFooter_objectSpread({}, props), {}, {
    children: children
  }));
};

var StyledFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "ModalFooter__StyledFooterContainer",
  componentId: "sc-162o9z9-0"
})(["\n  width: 100%;\n  padding: ", ";\n  display: flex;\n  align-items: center;\n"], function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return spacing[1];
});
/* harmony default export */ var components_ModalFooter = ((/* unused pure expression or super */ null && (ModalFooter)));
// EXTERNAL MODULE: ./src/components/Modal/components/ModalBody.tsx
var ModalBody = __webpack_require__(23043);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx
var Modal = __webpack_require__(20458);
;// CONCATENATED MODULE: ./src/components/Modal/index.ts






/***/ }),

/***/ 80155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ NextLinkFromReactRouter; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83485);
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49279);
/* harmony import */ var hooks_useActionQueryListener__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66064);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


var _excluded = ["to", "href", "replace", "children", "prefetch"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // react-router-dom LinkProps types



/**
 * temporary solution for migrating React Router to Next.js Link
 */
var NextLinkFromReactRouter = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var to = _ref.to,
      href = _ref.href,
      replace = _ref.replace,
      children = _ref.children,
      prefetch = _ref.prefetch,
      props = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_4__/* .useRouter */ .t)();
  var handleAction = (0,hooks_useActionQueryListener__WEBPACK_IMPORTED_MODULE_5__/* .useActionQueryHandler */ .E6)();
  var urlDetails = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    try {
      var link = new URL(to || href || '/', window.location.origin);
      return {
        pathname: link.pathname,
        query: Object.fromEntries(link.searchParams.entries())
      };
    } catch (_unused) {
      return {
        pathname: to || href,
        query: {}
      };
    }
  }, [to, href]);
  var action = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    if (router.pathname === urlDetails.pathname) {
      if (urlDetails.query.action && Object.keys(urlDetails.query).length === 1) {
        return urlDetails.query.action;
      }
    }

    return null;
  }, [urlDetails, router]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread(_objectSpread({
    ref: ref,
    replace: replace,
    passHref: true,
    prefetch: prefetch
  }, props), {}, {
    onClick: function onClick(e) {
      if (!e.ctrlKey && action) {
        e.preventDefault();
        handleAction(action);
      }
    },
    href: {
      pathname: urlDetails.pathname,
      query: _objectSpread(_objectSpread({}, urlDetails.query), (0,utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__/* .filterAllowedParams */ .fb)(_objectSpread({}, router.query)))
    },
    children: children
  }));
});

/***/ }),

/***/ 5790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OpenEffect */
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var theme_keyframes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59731);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


var _excluded = ["children", "openType", "duration"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
  displayName: "OpenEffect__StyledContainer",
  componentId: "sc-1pjauk3-0"
})(["\n  animation: ", " ", ";\n"], function (_ref) {
  var openType = _ref.openType;
  return theme_keyframes__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[openType];
}, function (_ref2) {
  var duration = _ref2.duration;
  return "".concat(duration, "s");
});
var OpenEffect = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref3, ref) {
  var children = _ref3.children,
      _ref3$openType = _ref3.openType,
      openType = _ref3$openType === void 0 ? 'fade' : _ref3$openType,
      _ref3$duration = _ref3.duration,
      duration = _ref3$duration === void 0 ? 0.3 : _ref3$duration,
      props = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref3, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledContainer, _objectSpread(_objectSpread({
    ref: ref,
    openType: openType,
    duration: duration
  }, props), {}, {
    children: children
  }));
});
/* harmony default export */ __webpack_exports__["Z"] = (OpenEffect);

/***/ }),

/***/ 88796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Select; }
});

// UNUSED EXPORTS: SelectDropdown

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Popper/Popper.tsx


var _excluded = ["children", "dropdownContent", "dropdownPosition", "width", "maxWidth", "open", "setOpen"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var getLeft = function getLeft(_ref) {
  var position = _ref.position;

  if (position === 'top-right') {
    return '100%';
  }

  if (position === 'top-left') {
    return '0%';
  }

  if (position === 'bottom-left') {
    return '0%';
  }

  if (position === 'bottom-right') {
    return 'unset';
  }

  return '50%';
};

var getRight = function getRight(_ref2) {
  var position = _ref2.position;

  if (position === 'bottom-right') {
    return '0%';
  }

  return 'unset';
};

var getTransformWhenActive = function getTransformWhenActive(_ref3) {
  var position = _ref3.position;

  if (position === 'bottom-left' || position === 'bottom-right' || position === 'top-left') {
    return 'translate(0%, 0%)';
  }

  return 'translate(-50%, 0%)';
};

var getBottom = function getBottom(_ref4) {
  var position = _ref4.position;

  if (position === 'top' || position === 'top-right' || position === 'top-left') {
    return '100%';
  }

  return 'auto';
};

var StyleContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Popper__StyleContainer",
  componentId: "sc-o31d55-0"
})(["\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n"]);
var StyledMenuDropdownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Popper__StyledMenuDropdownContainer",
  componentId: "sc-o31d55-1"
})(["\n  flex-direction: column;\n  position: absolute;\n  overflow-y: auto;\n  z-index: ", ";\n  transition: ", ";\n\n  bottom: ", ";\n  left: 50%;\n\n  display: flex;\n  transform: ", ";\n  overflow: visible;\n  min-width: 100%;\n\n  ", " {\n    width: max-content;\n    left: ", ";\n    right: ", ";\n  }\n"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.zIndices.dropdown;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transitions.fast;
}, getBottom, getTransformWhenActive, function (_ref7) {
  var theme = _ref7.theme;
  return theme.mediaQueries.sm;
}, getLeft, getRight);
var StyledMenuDropdownWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Popper__StyledMenuDropdownWrapper",
  componentId: "sc-o31d55-2"
})(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"]);

var Popper = function Popper(_ref8) {
  var children = _ref8.children,
      dropdownContent = _ref8.dropdownContent,
      _ref8$dropdownPositio = _ref8.dropdownPosition,
      dropdownPosition = _ref8$dropdownPositio === void 0 ? 'bottom' : _ref8$dropdownPositio,
      width = _ref8.width,
      maxWidth = _ref8.maxWidth,
      open = _ref8.open,
      setOpen = _ref8.setOpen,
      props = (0,objectWithoutProperties/* default */.Z)(_ref8, _excluded);

  var container = (0,react.useRef)(null);
  var dropdown = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    function handleClickOutside(e) {
      if (dropdown.current && !dropdown.current.contains(e.target) && !container.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside, {
      passive: true
    });
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdown, container]);

  var handleToggle = function handleToggle(e) {
    if (dropdown.current && dropdown.current.contains(e.target)) {
      return;
    }

    setOpen(!open);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledMenuDropdownWrapper, {
    ref: container,
    onClick: handleToggle,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyleContainer, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    })), open && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledMenuDropdownContainer, {
      ref: dropdown,
      position: dropdownPosition,
      children: /*#__PURE__*/react.isValidElement(dropdownContent) ? /*#__PURE__*/react.cloneElement(dropdownContent, {
        onDismiss: function onDismiss() {
          return setOpen(false);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: dropdownContent
      })
    })]
  });
};

/* harmony default export */ var Popper_Popper = (Popper);
;// CONCATENATED MODULE: ./src/components/Popper/index.ts

// EXTERNAL MODULE: ./src/hooks/useKeydownEventListener.ts + 2 modules
var useKeydownEventListener = __webpack_require__(67238);
// EXTERNAL MODULE: ./node_modules/react-spring/dist/esm/index.js + 5 modules
var esm = __webpack_require__(97421);
// EXTERNAL MODULE: ./src/svgs/index.ts + 103 modules
var svgs = __webpack_require__(8400);
// EXTERNAL MODULE: ./src/theme/colors.ts
var colors = __webpack_require__(72959);
;// CONCATENATED MODULE: ./src/components/Select/index.tsx


var Select_excluded = ["toggle", "setOpen", "OptionItemComponent", "options", "onDismiss", "onSelect", "maxHeight"],
    _excluded2 = ["OptionItemComponent", "options", "onSelect", "children", "dropdownContentProps", "onSelectOpen", "disabled"];

function Select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Select_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/no-array-index-key */











var SelectDropdown = function SelectDropdown(_ref) {
  var toggle = _ref.toggle,
      setOpen = _ref.setOpen,
      OptionItemComponent = _ref.OptionItemComponent,
      options = _ref.options,
      onDismiss = _ref.onDismiss,
      onSelect = _ref.onSelect,
      maxHeight = _ref.maxHeight,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Select_excluded);

  var containerRef = (0,react.useRef)(null);
  var eventHandler = (0,react.useCallback)(function (event) {
    if (event && event.key === 'ArrowDown') {
      event.preventDefault();
      var next = document.activeElement.nextSibling;

      if (next) {
        next.focus();
      } else {
        var firstChild = containerRef.current.firstChild;
        firstChild.focus();
      }
    } else if (event && event.key === 'ArrowUp') {
      event.preventDefault();
      var previous = document.activeElement.previousSibling;

      if (previous) {
        previous.focus();
      } else {
        var lastChild = containerRef.current.lastChild;
        lastChild.focus();
      }
    } else if (event && event.key === 'Enter') {
      var activeElement = document.activeElement;

      if (activeElement) {
        activeElement.click();
      }
    } else if (event && event.key === 'Escape') {
      onDismiss();
    }
  }, [onDismiss]);
  (0,useKeydownEventListener/* default */.Z)(eventHandler);
  var styleOpenOption = (0,esm/* useSpring */.q_)({
    config: {
      duration: 150
    },
    opacity: toggle ? 1 : 0,
    y: toggle ? 0 : 20,
    from: toggle ? {
      opacity: 0,
      y: 20
    } : {
      opacity: 1,
      y: 0
    },
    onResolve: function onResolve() {
      if (!toggle) {
        setOpen(false);
      }
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAnim, {
    style: Select_objectSpread({}, styleOpenOption),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledOptionsContainer, Select_objectSpread(Select_objectSpread({
      background: colors/* colors.inputAlt */.O.inputAlt
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledOptionsInnerContainer, {
        ref: containerRef,
        maxHeight: maxHeight,
        children: options.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledOptionItem, {
            className: "option-items",
            autoFocus: index === 0,
            $disabled: (item === null || item === void 0 ? void 0 : item.disabled) || false,
            onClick: function onClick() {
              if (!(item !== null && item !== void 0 && item.disabled)) onSelect(item);
              onDismiss();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(OptionItemComponent, {
              item: item
            })
          }, "option-".concat(index));
        })
      })
    }))
  });
};

var Select = function Select(_ref2) {
  var OptionItemComponent = _ref2.OptionItemComponent,
      options = _ref2.options,
      onSelect = _ref2.onSelect,
      children = _ref2.children,
      dropdownContentProps = _ref2.dropdownContentProps,
      onSelectOpen = _ref2.onSelectOpen,
      disabled = _ref2.disabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);

  var _useState = (0,react.useState)(false),
      toggle = _useState[0],
      setToggle = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClickSelect = (0,react.useCallback)(function (value) {
    if (value && options.length > 0) {
      setOpen(true);
      setToggle(true);

      if (onSelectOpen) {
        onSelectOpen();
      }
    } else {
      setToggle(false);
    }
  }, [onSelectOpen, options]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Popper_Popper, Select_objectSpread(Select_objectSpread({
    open: open,
    setOpen: handleClickSelect,
    disabled: disabled,
    dropdownContent: /*#__PURE__*/(0,jsx_runtime.jsx)(SelectDropdown, Select_objectSpread({
      toggle: toggle,
      setOpen: setOpen,
      OptionItemComponent: OptionItemComponent,
      options: options,
      onSelect: onSelect
    }, dropdownContentProps)),
    dropdownPosition: "bottom"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      height: "100%",
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flex: "1 1",
        width: "100%",
        children: children
      }), (options === null || options === void 0 ? void 0 : options.length) > 0 && !disabled && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExpansitionIconContainer, {
        $Open: open,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.ArrowDownIcon */.P.ArrowDownIcon, {
          fill: colors/* colors.textSubtle */.O.textSubtle
        })
      })]
    })
  }));
};

var StyledExpansitionIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Select__StyledExpansitionIconContainer",
  componentId: "sc-1lwz4te-0"
})(["\n  transition: ", ";\n  transform: ", ";\n  margin-top: 4px;\n  margin-right: 4px;\n\n  padding: 4px;\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.transitions.fast;
}, function (_ref4) {
  var $Open = _ref4.$Open;
  return $Open ? 'rotate(180deg) translateY(4px)' : '';
});
var StyledAnim = (0,styled_components_browser_esm/* default */.ZP)(esm/* animated.div */.q.div).withConfig({
  displayName: "Select__StyledAnim",
  componentId: "sc-1lwz4te-1"
})(["\n  width: 100%;\n  box-sizing: border-box;\n"]);
var StyledOptionsContainer = (0,styled_components_browser_esm/* default */.ZP)(esm/* animated.div */.q.div).withConfig({
  displayName: "Select__StyledOptionsContainer",
  componentId: "sc-1lwz4te-2"
})(["\n  margin-top: 6px;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n  overflow: hidden;\n"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.radii.small;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.stroke;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.inputAlt;
});
var StyledOptionsInnerContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Select__StyledOptionsInnerContainer",
  componentId: "sc-1lwz4te-3"
})(["\n  width: 100%;\n  scroll-behavior: smooth;\n  margin: 8px 0px;\n  scrollbar-width: none;\n  max-height: 300px;\n  overflow-y: overlay;\n  overflow-x: hidden;\n\n  ::-webkit-scrollbar {\n    width: 3px !important;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #2d3137 !important;\n    visibility: visible;\n  }\n"]);
var StyledOptionItem = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Select__StyledOptionItem",
  componentId: "sc-1lwz4te-4"
})(["\n  cursor: pointer;\n  background: ", ";\n  display: block;\n  width: 100%;\n  border-radius: 0px;\n  padding: 12px;\n  outline: none;\n  border: none;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.05) !important;\n  }\n\n  &:focus-visible {\n    background-color: rgba(0, 0, 0, 0.15);\n  }\n  &:disabled {\n    background-color: rgba(255, 255, 255, 0.05) !important;\n  }\n"], function (_ref8) {
  var $disabled = _ref8.$disabled;
  return $disabled ? 'rgba(255, 255, 255, 0.05)' : 'transparent';
});
/* harmony default export */ var components_Select = (Select);

/***/ }),

/***/ 98034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/components/Skeleton/types.ts
var animation = {
  WAVES: 'waves',
  PULSE: 'pulse'
};
var types_variant = {
  RECT: 'rect',
  CIRCLE: 'circle'
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Skeleton/Skeleton.tsx


var _excluded = ["variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var waves = (0,styled_components_browser_esm/* keyframes */.F4)(["\n   from {\n        left: -150px;\n    }\n    to   {\n        left: 100%;\n    }\n"]);
var pulse = (0,styled_components_browser_esm/* keyframes */.F4)(["\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n"]);
var Root = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Skeleton__Root",
  componentId: "sc-yjgyrh-0"
})(["\n  min-height: 20px;\n  display: block;\n  background-color: ", ";\n  border-radius: ", ";\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.backgroundAlt;
}, function (_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return variant === types_variant.CIRCLE ? '50%' : theme.radii.small;
});
var Waves = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
  displayName: "Skeleton__Waves",
  componentId: "sc-yjgyrh-1"
})(["\n  position: relative;\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n  &:before {\n    content: '';\n    position: absolute;\n    background-image: linear-gradient(90deg, transparent, rgb(67 80 98 / 50%), transparent);\n    top: 0;\n    left: -150px;\n    height: 100%;\n    width: 150px;\n    animation: ", " 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  }\n"], waves);

var Skeleton = function Skeleton(_ref3) {
  var _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? types_variant.RECT : _ref3$variant,
      props = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Waves, _objectSpread({
    variant: variant
  }, props));
};

/* harmony default export */ var Skeleton_Skeleton = (Skeleton);
;// CONCATENATED MODULE: ./src/components/Skeleton/index.tsx


/***/ }),

/***/ 45918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["value", "onTagChanged", "selectedValue", "children", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
  displayName: "Tab__StyledContainer",
  componentId: "sc-16x9xem-0"
})(["\n  cursor: pointer;\n\n  &:focus-visible {\n    outline: none;\n  }\n\n  cursor: ", ";\n"], function (_ref) {
  var $disabled = _ref.$disabled;
  return $disabled ? 'not-allowed' : 'pointer';
});

var Tab = function Tab(_ref2) {
  var value = _ref2.value,
      onTagChanged = _ref2.onTagChanged,
      selectedValue = _ref2.selectedValue,
      children = _ref2.children,
      disabled = _ref2.disabled,
      props = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded);

  var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);

  var handleSelect = function handleSelect() {
    if (disabled) return;
    onTagChanged(value);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledContainer, _objectSpread(_objectSpread({
    id: value,
    ref: ref,
    $disabled: disabled,
    $active: selectedValue === value,
    onClick: handleSelect,
    tabIndex: selectedValue === value ? 0 : -1
  }, props), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Tab);

/***/ }),

/***/ 40296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ StyledIndicator; },
  "Z": function() { return /* binding */ components_Tabs; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./src/components/OpenEffect/index.tsx
var OpenEffect = __webpack_require__(5790);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useDebounceCallback.ts
var useDebounceCallback = __webpack_require__(47520);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(58491);
;// CONCATENATED MODULE: ./src/hooks/useResizeEventListener.ts




var useResizeEventListener = function useResizeEventListener(callback) {
  var elementRef = (0,react.useRef)(null);
  var debounce = (0,useDebounceCallback/* default */.Z)();
  (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function () {
    if (!elementRef.current) return;
    var observer = new ResizeObserver(function () {
      debounce(function () {
        callback();
      }, 100);
    });
    observer.observe(elementRef.current);
    return function () {
      observer.disconnect();
    };
  }, [elementRef, callback]);
  return {
    elementRef: elementRef
  };
};

/* harmony default export */ var hooks_useResizeEventListener = (useResizeEventListener);
;// CONCATENATED MODULE: ./src/hooks/useElementScrollable.ts



var useElementScrollable = function useElementScrollable() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'vertical';

  var _useState = (0,react.useState)(false),
      scrollable = _useState[0],
      setScrollable = _useState[1];

  var _useState2 = (0,react.useState)(0),
      offset = _useState2[0],
      setOffset = _useState2[1];

  var _useResizeEventListen = hooks_useResizeEventListener(function () {
    if (!elementRef.current) return;
    var offset = type === 'vertical' ? elementRef.current.offsetHeight : elementRef.current.offsetWidth;
    var scroll = type === 'vertical' ? elementRef.current.scrollHeight : elementRef.current.scrollWidth;
    setOffset(offset);
    setScrollable(offset < scroll);
  }),
      elementRef = _useResizeEventListen.elementRef;

  return {
    scrollable: scrollable,
    elementRef: elementRef,
    offset: offset
  };
};

/* harmony default export */ var hooks_useElementScrollable = (useElementScrollable);
;// CONCATENATED MODULE: ./src/hooks/useElementScrollInfo.ts




var ScrollViewPostion;

(function (ScrollViewPostion) {
  ScrollViewPostion["Start"] = "start";
  ScrollViewPostion["Center"] = "center";
  ScrollViewPostion["End"] = "end";
})(ScrollViewPostion || (ScrollViewPostion = {}));

var useElementScrollInfo = function useElementScrollInfo() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'vertical';

  var _useElementScrollable = hooks_useElementScrollable(type),
      offset = _useElementScrollable.offset,
      elementRef = _useElementScrollable.elementRef,
      scrollable = _useElementScrollable.scrollable;

  var _useState = (0,react.useState)(null),
      position = _useState[0],
      setPosition = _useState[1];

  var debounce = (0,useDebounceCallback/* default */.Z)();
  (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function () {
    if (!offset || !scrollable || !elementRef) {
      setPosition(null);
      return;
    }

    var handler = function handler() {
      debounce(function () {
        var scrollMargin = type === 'vertical' ? elementRef.current.scrollTop : elementRef.current.scrollLeft;
        var viewSize = scrollMargin + (type === 'vertical' ? elementRef.current.offsetHeight : elementRef.current.offsetWidth);
        var scrollSize = type === 'vertical' ? elementRef.current.scrollHeight : elementRef.current.scrollWidth;

        if (elementRef.current.offsetWidth === scrollSize) {
          setPosition(null);
          return;
        }

        if (scrollMargin === 0) {
          setPosition(ScrollViewPostion.Start);
        } else if (scrollSize - viewSize < 1) {
          setPosition(ScrollViewPostion.End);
        } else {
          setPosition(ScrollViewPostion.Center);
        }
      }, 150);
    };

    handler();
    elementRef.current.addEventListener('scroll', handler, {
      passive: true
    });
    return function () {
      var _elementRef$current;

      (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.removeEventListener('scroll', handler);
    };
  }, [offset, scrollable]);
  return {
    elementRef: elementRef,
    scroll: position && {
      start: position === ScrollViewPostion.Start,
      center: position === ScrollViewPostion.Center,
      end: position === ScrollViewPostion.End
    }
  };
};

/* harmony default export */ var hooks_useElementScrollInfo = (useElementScrollInfo);
// EXTERNAL MODULE: ./src/hooks/useKeydownEventListener.ts + 2 modules
var useKeydownEventListener = __webpack_require__(67238);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/svgs/index.ts + 103 modules
var svgs = __webpack_require__(8400);
;// CONCATENATED MODULE: ./src/utils/scroll.ts
/* eslint-disable no-param-reassign */
function animate(property, element, to) {
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 150;
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var from = element[property];
  var start = null;
  var cancelled = false;

  var cancel = function cancel() {
    cancelled = true;
  };

  var step = function step(timestamp) {
    if (cancelled) {
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    var time = Math.min(1, (timestamp - start) / duration);
    element[property] = time * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(function () {
        cb();
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Tabs/index.tsx


var _excluded = ["value", "children", "onTagChanged", "backgroundBlurColor", "hideIndicator", "hideScrollIcon", "indicator", "disabledScroll"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var StyledIndicator = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Tabs__StyledIndicator",
  componentId: "sc-m4hgo0-0"
})(["\n  background-color: ", ";\n  height: 2px;\n  width: 30px;\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
var StyledIndicatorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Tabs__StyledIndicatorContainer",
  componentId: "sc-m4hgo0-1"
})(["\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  position: absolute;\n  height: 100%;\n  top: 0px;\n  transition: ", ";\n\n  pointer-events: none;\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.transitions.fast;
});
var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Tabs__StyledContainer",
  componentId: "sc-m4hgo0-2"
})(["\n  ::-webkit-scrollbar {\n    width: 0px !important;\n    height: 0px !important;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    visibility: hidden;\n  }\n"]);
var StyledArrowButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Tabs__StyledArrowButton",
  componentId: "sc-m4hgo0-3"
})(["\n  z-index: 2;\n  position: absolute;\n  top: 50%;\n  overflow: hidden;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  border-radius: 50%;\n  background: ", ";\n  display: none;\n\n  svg {\n    fill: ", ";\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n  }\n\n  ", " {\n    display: flex;\n  }\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.backgroundAlt2;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.textSubtle;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.text;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.sm;
});
var StyledArrowLeftButton = (0,styled_components_browser_esm/* default */.ZP)(StyledArrowButton).withConfig({
  displayName: "Tabs__StyledArrowLeftButton",
  componentId: "sc-m4hgo0-4"
})(["\n  left: -12px;\n  transform: translateY(-50%) rotate(-90deg);\n"]);
var StyledArrowRightButton = (0,styled_components_browser_esm/* default */.ZP)(StyledArrowButton).withConfig({
  displayName: "Tabs__StyledArrowRightButton",
  componentId: "sc-m4hgo0-5"
})(["\n  right: -12px;\n  transform: translateY(-50%) rotate(90deg);\n"]);
var StyledBlur = (0,styled_components_browser_esm/* default */.ZP)(OpenEffect/* default */.Z).withConfig({
  displayName: "Tabs__StyledBlur",
  componentId: "sc-m4hgo0-6"
})(["\n  width: 150px;\n  pointer-events: none;\n  height: 105%;\n  position: absolute;\n"]);
var StyledBlurLeft = (0,styled_components_browser_esm/* default */.ZP)(StyledBlur).withConfig({
  displayName: "Tabs__StyledBlurLeft",
  componentId: "sc-m4hgo0-7"
})(["\n  z-index: 2;\n  top: 50%;\n  left: -12px;\n  transform: translateY(-50%);\n  background: linear-gradient(\n    90deg,\n    ", " 10px,\n    ", "a8 40%,\n    transparent 50%\n  );\n"], function (_ref7) {
  var blurBackground = _ref7.blurBackground;
  return blurBackground;
}, function (_ref8) {
  var blurBackground = _ref8.blurBackground;
  return blurBackground;
});
var StyledBlurRight = (0,styled_components_browser_esm/* default */.ZP)(StyledBlur).withConfig({
  displayName: "Tabs__StyledBlurRight",
  componentId: "sc-m4hgo0-8"
})(["\n  top: 50%;\n  right: -12px;\n  transform: translateY(-50%);\n  background: linear-gradient(\n    270deg,\n    ", " 10px,\n    ", " 40%,\n    transparent 50%\n  );\n"], function (_ref9) {
  var blurBackground = _ref9.blurBackground;
  return blurBackground;
}, function (_ref10) {
  var blurBackground = _ref10.blurBackground;
  return blurBackground;
});

var Tabs = function Tabs(_ref11) {
  var value = _ref11.value,
      children = _ref11.children,
      onTagChanged = _ref11.onTagChanged,
      backgroundBlurColor = _ref11.backgroundBlurColor,
      hideIndicator = _ref11.hideIndicator,
      _ref11$hideScrollIcon = _ref11.hideScrollIcon,
      hideScrollIcon = _ref11$hideScrollIcon === void 0 ? false : _ref11$hideScrollIcon,
      indicator = _ref11.indicator,
      _ref11$disabledScroll = _ref11.disabledScroll,
      disabledScroll = _ref11$disabledScroll === void 0 ? false : _ref11$disabledScroll,
      props = (0,objectWithoutProperties/* default */.Z)(_ref11, _excluded);

  var tabsRef = (0,react.useRef)(null);
  var selectedIndexRef = (0,react.useRef)(null);

  var _useElementScrollInfo = hooks_useElementScrollInfo('horizontal'),
      elementRef = _useElementScrollInfo.elementRef,
      scroll = _useElementScrollInfo.scroll;

  var _useState = (0,react.useState)(null),
      indicatorStyles = _useState[0],
      setIndicatorStyles = _useState[1];

  (0,useKeydownEventListener/* default */.Z)(function (event) {
    if (event && event.key === 'ArrowLeft') {
      var previous = document.activeElement.previousSibling;

      if (previous) {
        previous.focus();
      }
    }

    if (event && event.key === 'ArrowRight') {
      var next = document.activeElement.nextSibling;

      if (next) {
        next.focus();
      }
    }

    if (event && event.key === 'Enter') {
      var activeElement = document.activeElement;

      if (activeElement) {
        activeElement.click();
      }
    }
  });
  var updateTabView = (0,react.useCallback)(function () {
    var _tabsRef$current;

    var selectedIndex = -1;
    var selectedTabScrollLeft = 0;
    var selectedTabWidth = 0;
    var nextTabWidth = 0;
    var preTabWidth = 0;
    react.Children.forEach(children, function (element, index) {
      if (! /*#__PURE__*/react.isValidElement(element)) return;
      var childValue = element.props.value;

      if (childValue === value) {
        selectedIndex = index;
      }
    });
    selectedIndexRef.current = selectedIndex;
    tabsRef === null || tabsRef === void 0 ? void 0 : (_tabsRef$current = tabsRef.current) === null || _tabsRef$current === void 0 ? void 0 : _tabsRef$current.childNodes.forEach(function (node, index) {
      var width = window.getComputedStyle(node).width.replaceAll('px', '');

      if (selectedIndex >= index) {
        selectedTabScrollLeft += Number(width);
        selectedTabWidth = Number(width);
      }

      if (selectedIndex >= index - 1) {
        nextTabWidth = Number(width);
      }

      if (selectedIndex >= index + 1) {
        preTabWidth = Number(width);
      }
    });
    if (!elementRef.current) return;
    var _elementRef$current = elementRef.current,
        _elementRef$current$s = _elementRef$current.scrollLeft,
        scrollLeft = _elementRef$current$s === void 0 ? 0 : _elementRef$current$s,
        _elementRef$current$o = _elementRef$current.offsetWidth,
        offsetWidth = _elementRef$current$o === void 0 ? 0 : _elementRef$current$o; // Scroll tab to view

    if (scrollLeft + offsetWidth < selectedTabScrollLeft + nextTabWidth) {
      animate('scrollLeft', elementRef.current, selectedTabScrollLeft + nextTabWidth - offsetWidth);
    } else if (scrollLeft > selectedTabScrollLeft - selectedTabWidth - preTabWidth) {
      animate('scrollLeft', elementRef.current, selectedTabScrollLeft - selectedTabWidth - preTabWidth);
    } // Update indicator


    if (!hideIndicator) setIndicatorStyles({
      left: "".concat(selectedTabScrollLeft - selectedTabWidth, "px"),
      width: "".concat(selectedTabWidth, "px")
    });
  }, [children, elementRef, hideIndicator, value]);

  var _useResizeEventListen = hooks_useResizeEventListener(updateTabView),
      containerRef = _useResizeEventListen.elementRef;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, _objectSpread(_objectSpread({
    ref: containerRef,
    position: "relative"
  }, props), {}, {
    children: [!disabledScroll && scroll && !scroll.start && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [backgroundBlurColor && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBlurLeft, {
        blurBackground: backgroundBlurColor
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledArrowLeftButton, {
        onClick: function onClick() {
          var _elementRef$current2, _elementRef$current3;

          animate('scrollLeft', elementRef.current, (((_elementRef$current2 = elementRef.current) === null || _elementRef$current2 === void 0 ? void 0 : _elementRef$current2.scrollLeft) || 0) - (((_elementRef$current3 = elementRef.current) === null || _elementRef$current3 === void 0 ? void 0 : _elementRef$current3.offsetWidth) || 0) / 1.5, 450);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.ArrowUpIcon */.P.ArrowUpIcon, {})
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, {
      ref: elementRef,
      overflowX: "auto",
      position: "relative",
      zIndex: "0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
        ref: tabsRef,
        children: react.Children.map(children, function (child) {
          return /*#__PURE__*/react.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
            selectedValue: value,
            onTagChanged: onTagChanged
          }));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        width: "100%",
        height: "2px",
        children: !hideIndicator && indicatorStyles && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIndicatorContainer, {
          style: indicatorStyles,
          children: indicator ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: indicator
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIndicator, {})
        })
      })]
    }), !disabledScroll && scroll && !scroll.end && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [backgroundBlurColor && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBlurRight, {
        blurBackground: backgroundBlurColor
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledArrowRightButton, {
        onClick: function onClick() {
          var _elementRef$current4, _elementRef$current5;

          animate('scrollLeft', elementRef.current, (((_elementRef$current4 = elementRef.current) === null || _elementRef$current4 === void 0 ? void 0 : _elementRef$current4.scrollLeft) || 0) + (((_elementRef$current5 = elementRef.current) === null || _elementRef$current5 === void 0 ? void 0 : _elementRef$current5.offsetWidth) || 0) / 1.5, 450);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.ArrowUpIcon */.P.ArrowUpIcon, {})
      })]
    })]
  }));
};

/* harmony default export */ var components_Tabs = (Tabs);

/***/ }),

/***/ 62068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55704);
/* harmony import */ var components_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59441);
/* harmony import */ var config_constants_network__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17961);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


var _excluded = ["token", "tokenImageProps", "networkImageProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var TokenLogo = function TokenLogo(_ref) {
  var token = _ref.token,
      tokenImageProps = _ref.tokenImageProps,
      networkImageProps = _ref.networkImageProps,
      props = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, {
    position: "relative",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      src: token.logo,
      alt: "".concat(token.name, " LOGO"),
      width: 24,
      height: 24
    }, tokenImageProps)), !token.isNative && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      position: "absolute",
      top: "-3px",
      right: "-2px",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
        src: config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .NETWORK_MAP */ .mF[token.network].networkInfo.icon,
        alt: "".concat(token.name, " LOGO"),
        width: 12,
        height: 12
      }, networkImageProps))
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (TokenLogo);

/***/ }),

/***/ 96584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UT": function() { return /* binding */ commomErrorMessage; }
/* harmony export */ });
/* unused harmony exports checkInputIsEmpty, checkIsJSON */
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59499);
/* harmony import */ var utils_stringHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57430);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70794);
/* harmony import */ var utils_requestHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75391);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19485);
/* harmony import */ var _types_validator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1872);








var commomErrorMessage = {
  Email: 'Please enter a correct email address',
  EmailDuplicate: 'This email is already in use',
  Required: 'Please enter a value.',
  Integer: 'Please enter a correct integer number'
};

var FormValidator = /*#__PURE__*/function () {
  function FormValidator() {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, FormValidator);
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(FormValidator, null, [{
    key: "required",
    value: function required(value) {
      return checkInputIsEmpty(value) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.Required */ .p.Required : null;
    }
  }, {
    key: "blockCharaters",
    value: function blockCharaters(chars) {
      return function (value) {
        return chars.find(function (_char) {
          return value.includes(_char);
        }) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.IncorrectType */ .p.IncorrectType : null;
      };
    }
  }, {
    key: "requiredNumber",
    value: function requiredNumber(value) {
      return !/\d/.test(value) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.RequiredNumber */ .p.RequiredNumber : null;
    }
  }, {
    key: "requiredUppercase",
    value: function requiredUppercase(value) {
      return !/[A-Z]/.test(value) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.RequiredUppercase */ .p.RequiredUppercase : null;
    }
  }, {
    key: "checked",
    value: function checked(value) {
      return !value ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.NotChecked */ .p.NotChecked : null;
    }
  }, {
    key: "integer",
    value: function integer(value) {
      return !Number.isInteger(Number(value)) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.Integer */ .p.Integer : null;
    }
  }, {
    key: "email",
    value: function email(value) {
      return !checkInputIsEmpty(value) && !(0,utils_stringHelper__WEBPACK_IMPORTED_MODULE_0__/* .isEmail */ .Jh)(value) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.Email */ .p.Email : null;
    }
  }, {
    key: "etherAddress",
    value: function etherAddress(value) {
      return !ethers__WEBPACK_IMPORTED_MODULE_6__/* .isAddress */ .UJ(value) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.IsEtherAddress */ .p.IsEtherAddress : null;
    }
  }, {
    key: "uniqueEmail",
    value: function uniqueEmail(reqFn) {
      return function (value) {
        if (FormValidator.required(value) || FormValidator.email(value)) return null;
        var request = reqFn(value);
        return (0,utils_requestHelper__WEBPACK_IMPORTED_MODULE_2__/* .transformHunnyRequest */ .Tc)(request, function (value) {
          return value ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.EmailDuplicate */ .p.EmailDuplicate : null;
        });
      };
    }
  }, {
    key: "existEmail",
    value: function existEmail(reqFn) {
      return function (value) {
        if (FormValidator.required(value) || FormValidator.email(value)) return null;
        var request = reqFn(value);
        return (0,utils_requestHelper__WEBPACK_IMPORTED_MODULE_2__/* .transformHunnyRequest */ .Tc)(request, function (value) {
          return value ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.EmailNotExist */ .p.EmailNotExist : null;
        });
      };
    }
  }, {
    key: "inputLength",
    value: function inputLength(config) {
      return function (value) {
        var min = config.min,
            max = config.max;

        if ((value === null || value === void 0 ? void 0 : value.length) < min) {
          return _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.TooShort */ .p.TooShort;
        }

        if ((value === null || value === void 0 ? void 0 : value.length) > max) {
          return _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.TooLong */ .p.TooLong;
        }

        return null;
      };
    }
  }, {
    key: "requiredLength",
    value: function requiredLength(number) {
      return function (value) {
        if ((value === null || value === void 0 ? void 0 : value.length) !== number) {
          return _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.IncorrectLength */ .p.IncorrectLength;
        }

        return null;
      };
    } // eslint-disable-next-line

  }, {
    key: "equal",
    value: function equal(input) {
      if (input[0] === '$') {
        var fieldName = input.replaceAll('$', '');
        return function (formControlValues) {
          return function (value) {
            return JSON.stringify(value) !== JSON.stringify(formControlValues[fieldName].value) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.NotEqual */ .p.NotEqual : null;
          };
        };
      }

      return function (value) {
        // eslint-disable-next-line no-self-compare
        return JSON.stringify(value) !== JSON.stringify(value) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.NotEqual */ .p.NotEqual : null;
      };
    }
  }]);

  return FormValidator;
}();

(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(FormValidator, "gte", function (min) {
  return function (value) {
    return new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(value).gte(new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(min)) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.GreatThanEqual */ .p.GreatThanEqual : null;
  };
});

(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(FormValidator, "lte", function (min) {
  return function (value) {
    return new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(value).lte(new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(min)) ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.LessThanEqual */ .p.LessThanEqual : null;
  };
});

(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(FormValidator, "min", function (min) {
  return function (value) {
    return new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(min).lte(new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(value)) ? null : _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.NotEnough */ .p.NotEnough;
  };
});

(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(FormValidator, "max", function (max) {
  return function (value) {
    return new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(max).lt(new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(value)) && value !== null ? _types_validator__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError.Insufficient */ .p.Insufficient : null;
  };
});

var checkInputIsEmpty = function checkInputIsEmpty(value) {
  return value == null || (typeof value === 'string' || Array.isArray(value)) && value.length === 0;
};
var checkIsJSON = function checkIsJSON(str) {
  var result = null;

  try {
    result = JSON.parse(str);
  } catch (e) {
    return false;
  }

  return result;
};
/* harmony default export */ __webpack_exports__["ZP"] = (FormValidator);

/***/ }),

/***/ 34418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HW": function() { return /* binding */ BIG_ZERO; },
/* harmony export */   "U8": function() { return /* binding */ UINT256_MAX; },
/* harmony export */   "xp": function() { return /* binding */ BIG_TEN; }
/* harmony export */ });
/* unused harmony exports BIG_ONE, BIG_NINE */
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);

var BIG_ZERO = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber */ .O(0);
var BIG_ONE = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber */ .O(1);
var BIG_NINE = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber */ .O(9);
var BIG_TEN = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber */ .O(10);
var UINT256_MAX = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber */ .O('115792089237316195423570985008687907853269984665640564039457584007913129639935');

/***/ }),

/***/ 34798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ WALLET_INFO; }
/* harmony export */ });
/* harmony import */ var config_types_wallet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3877);
/* harmony import */ var utils_web3React__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89484);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(170);
// import {
//   PhantomWalletName,
//   PhantomWalletAdapter,
//   SlopeWalletName,
//   SlopeWalletAdapter,
//   SolletWalletName,
//   SolletWalletAdapter,
//   SolletExtensionWalletName,
//   SolletExtensionWalletAdapter,
//   SolflareWalletName,
//   SolflareWalletAdapter,
//   SolflareWebWalletName,
//   SolflareWebWalletAdapter,
//   BitKeepWalletName,
//   BitKeepWalletAdapter,
//   CloverWalletName,
//   CloverWalletAdapter,
//   Coin98WalletName,
//   Coin98WalletAdapter,
//   MathWalletName,
//   MathWalletAdapter,
//   SafePalWalletName,
//   SafePalWalletAdapter,
// } from '@solana/wallet-adapter-wallets'



var WALLET_INFO = [// if udpate anything for this array, please also update for utils trackingWallet
{
  name: 'Metamask',
  icon: 'MetamaskIcon',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.Injected */ .Oh.Injected],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.EVM */ .S.EVM
}, {
  name: 'WalletConnect',
  icon: 'WalletConnect',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.WalletConnect */ .Oh.WalletConnect],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.EVM */ .S.EVM
}, {
  name: 'TrustWallet',
  icon: 'TrustWallet',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.Injected */ .Oh.Injected],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.EVM */ .S.EVM
}, {
  name: 'MathWallet',
  icon: 'MathWallet',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.Injected */ .Oh.Injected],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.EVM */ .S.EVM
}, {
  name: 'SafePal',
  icon: 'SafePal',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.Injected */ .Oh.Injected],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.EVM */ .S.EVM
}, {
  name: 'Binance Wallet',
  icon: 'BSCWallet',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.BSC */ .Oh.BSC],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.BSC */ .S.BSC
}, {
  name: 'Coin98',
  icon: 'Coin98',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.Injected */ .Oh.Injected],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.EVM */ .S.EVM
}, {
  name: 'TokenPocket',
  icon: 'TokenPocket',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.Injected */ .Oh.Injected],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.EVM */ .S.EVM
}, {
  name: 'BitKeep',
  icon: 'BitKeepIcon',
  adapter: utils_web3React__WEBPACK_IMPORTED_MODULE_1__/* .connectorsByName */ .BA[___WEBPACK_IMPORTED_MODULE_2__/* .ConnectorNameEnum.Injected */ .Oh.Injected],
  type: config_types_wallet__WEBPACK_IMPORTED_MODULE_0__/* .WalletType.EVM */ .S.EVM
} // {
//   name: PhantomWalletName,
//   url: 'https://www.phantom.app',
//   adapter: new PhantomWalletAdapter(),
//   icon: 'PhantomWallet',
//   type: WalletType.SOL,
// },
// {
//   name: SolletWalletName,
//   url: 'https://www.sollet.io',
//   adapter: new SolletWalletAdapter({ provider: 'https://www.sollet.io' }),
//   icon: 'SolletWallet',
//   type: WalletType.SOL,
// },
// {
//   name: SolflareWalletName,
//   url: 'https://solflare.com',
//   installUrl: 'https://addons.mozilla.org/en-US/firefox/addon/solflare-wallet',
//   adapter: new SolflareWalletAdapter(),
//   icon: 'SolflareWallet',
//   type: WalletType.SOL,
// },
// {
//   name: SlopeWalletName,
//   url: 'https://slope.finance',
//   adapter: new SlopeWalletAdapter(),
//   icon: 'SlopeWallet',
//   type: WalletType.SOL,
// },
// {
//   name: SolletExtensionWalletName,
//   url: '',
//   adapter: new SolletExtensionWalletAdapter({
//     provider: typeof window === 'undefined' ? null : (window as any).sollet,
//   }),
//   icon: 'SolletWallet',
//   type: WalletType.SOL,
// },
// {
//   name: SolflareWebWalletName,
//   url: 'https://solflare.com',
//   installUrl: 'https://addons.mozilla.org/en-US/firefox/addon/solflare-wallet',
//   adapter: new SolflareWebWalletAdapter(),
//   icon: 'SolflareWallet',
//   type: WalletType.SOL,
// },
// {
//   name: `${BitKeepWalletName} (Solana)`,
//   url: 'https://bitkeep.com',
//   adapter: new BitKeepWalletAdapter(),
//   icon: 'BitKeepIcon',
//   type: WalletType.SOL,
// },
// {
//   name: CloverWalletName,
//   url: 'https://clover.finance',
//   adapter: new CloverWalletAdapter(),
//   icon: 'CloverWallet',
//   type: WalletType.SOL,
// },
// {
//   name: `${Coin98WalletName} (Solana)`,
//   url: 'https://www.coin98.com',
//   installUrl: 'https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg',
//   adapter: new Coin98WalletAdapter(),
//   icon: 'Coin98',
//   type: WalletType.SOL,
// },
// {
//   name: `${MathWalletName} (Solana)`,
//   url: 'https://mathwallet.org',
//   adapter: new MathWalletAdapter(),
//   icon: 'MathWallet',
//   type: WalletType.SOL,
// },
// {
//   name: `${SafePalWalletName} (Solana)`,
//   url: 'https://www.safepal.io',
//   adapter: new SafePalWalletAdapter(),
//   icon: 'SafePal',
//   type: WalletType.SOL,
// },
];

/***/ }),

/***/ 87876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AuthModalMethodEnums; },
/* harmony export */   "i": function() { return /* binding */ AuthModalPageEnums; }
/* harmony export */ });
var AuthModalPageEnums;

(function (AuthModalPageEnums) {
  AuthModalPageEnums["LOG_IN"] = "LOG_IN";
  AuthModalPageEnums["SIGN_UP"] = "SIGN_UP";
})(AuthModalPageEnums || (AuthModalPageEnums = {}));

var AuthModalMethodEnums;

(function (AuthModalMethodEnums) {
  AuthModalMethodEnums[AuthModalMethodEnums["WEB3"] = 0] = "WEB3";
  AuthModalMethodEnums[AuthModalMethodEnums["TRADITIONAL"] = 1] = "TRADITIONAL";
})(AuthModalMethodEnums || (AuthModalMethodEnums = {}));

/***/ }),

/***/ 46391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CX": function() { return /* binding */ BonusTagEnums; },
/* harmony export */   "FF": function() { return /* binding */ DepositCommonBonus; },
/* harmony export */   "db": function() { return /* binding */ BonusCondition; },
/* harmony export */   "dj": function() { return /* binding */ ApiBonusTypeEnums; },
/* harmony export */   "ns": function() { return /* binding */ BonusStatusEnums; }
/* harmony export */ });
/* unused harmony exports BonusStatusFilterEnums, WageringBonusStatusEnums, CommonBonus, WageringConditionCommonBonus, NoDepositCommonBonus */
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10748);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45959);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70794);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var BonusTagEnums;

(function (BonusTagEnums) {
  BonusTagEnums[BonusTagEnums["CanActive"] = 0] = "CanActive";
  BonusTagEnums[BonusTagEnums["OnlyUse"] = 1] = "OnlyUse";
  BonusTagEnums[BonusTagEnums["NoDeposit"] = 2] = "NoDeposit";
})(BonusTagEnums || (BonusTagEnums = {}));

var BonusStatusEnums;

(function (BonusStatusEnums) {
  BonusStatusEnums[BonusStatusEnums["Available"] = 1] = "Available";
  BonusStatusEnums[BonusStatusEnums["Active"] = 2] = "Active";
  BonusStatusEnums[BonusStatusEnums["Cancel"] = 3] = "Cancel";
  BonusStatusEnums[BonusStatusEnums["Used"] = 10] = "Used";
  BonusStatusEnums[BonusStatusEnums["Unknown"] = -999] = "Unknown";
})(BonusStatusEnums || (BonusStatusEnums = {}));

var BonusStatusFilterEnums;

(function (BonusStatusFilterEnums) {
  BonusStatusFilterEnums[BonusStatusFilterEnums["Available"] = 1] = "Available";
  BonusStatusFilterEnums[BonusStatusFilterEnums["History"] = -1] = "History";
})(BonusStatusFilterEnums || (BonusStatusFilterEnums = {}));

var ApiBonusTypeEnums;

(function (ApiBonusTypeEnums) {
  ApiBonusTypeEnums[ApiBonusTypeEnums["DepositBonus"] = 1] = "DepositBonus";
  ApiBonusTypeEnums[ApiBonusTypeEnums["NoDepositBonus"] = 2] = "NoDepositBonus";
})(ApiBonusTypeEnums || (ApiBonusTypeEnums = {}));

var WageringBonusStatusEnums;

(function (WageringBonusStatusEnums) {
  WageringBonusStatusEnums[WageringBonusStatusEnums["Available"] = 0] = "Available";
  WageringBonusStatusEnums[WageringBonusStatusEnums["WaitingDeposit"] = 1] = "WaitingDeposit";
  WageringBonusStatusEnums[WageringBonusStatusEnums["InProgressWagering"] = 2] = "InProgressWagering";
  WageringBonusStatusEnums[WageringBonusStatusEnums["Claimed"] = 3] = "Claimed";
  WageringBonusStatusEnums[WageringBonusStatusEnums["Cancelled"] = 4] = "Cancelled";
  WageringBonusStatusEnums[WageringBonusStatusEnums["Unknown"] = 5] = "Unknown";
})(WageringBonusStatusEnums || (WageringBonusStatusEnums = {}));

var BonusCondition = /*#__PURE__*/function () {
  function BonusCondition(condition) {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, BonusCondition);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "expiryDate", void 0);

    this.expiryDate = condition.expiryDate;
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BonusCondition, [{
    key: "isExpired",
    get: function get() {
      return new Date().getTime() > this.expiryDate;
    }
  }]);

  return BonusCondition;
}();
var CommonBonus = /*#__PURE__*/(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function CommonBonus(bonus) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CommonBonus);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "code", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "info", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "condition", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "tags", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "status", BonusStatusEnums.Unknown);

  this.info = bonus.info;
  this.condition = new BonusCondition(bonus.condition);
}); // ---------------------- Wagering Common Bonus --------------------------

var WageringConditionCommonBonus = /*#__PURE__*/function (_CommonBonus) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(WageringConditionCommonBonus, _CommonBonus);

  var _super = _createSuper(WageringConditionCommonBonus);

  function WageringConditionCommonBonus(bonus, wageringConditionValues) {
    var _this;

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, WageringConditionCommonBonus);

    _this = _super.call(this, bonus);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "rakeFeeRequirement", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "minDeposit", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "activeDurationInDays", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "wageringBonusStatus", WageringBonusStatusEnums.Unknown);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "bonusAmount", void 0);

    _this.rakeFeeRequirement = wageringConditionValues.rakeFeeRequirement;
    _this.minDeposit = wageringConditionValues.minDeposit;
    _this.activeDurationInDays = wageringConditionValues.activeDurationInDays;
    return _this;
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WageringConditionCommonBonus, [{
    key: "minDepositBigAmount",
    get: function get() {
      return new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(this.minDeposit);
    }
  }]);

  return WageringConditionCommonBonus;
}(CommonBonus); // ---------------------- Deposit Common Bonus -------------------------- DepositBonus

var DepositCommonBonus = /*#__PURE__*/function (_WageringConditionCom) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(DepositCommonBonus, _WageringConditionCom);

  var _super2 = _createSuper(DepositCommonBonus);

  function DepositCommonBonus(bonus, wageringConditionValues, depositCommonBonus) {
    var _this2;

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, DepositCommonBonus);

    _this2 = _super2.call(this, bonus, wageringConditionValues);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this2), "percent", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this2), "tags", [BonusTagEnums.CanActive]);

    _this2.percent = depositCommonBonus.percent;
    return _this2;
  }

  return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(DepositCommonBonus);
}(WageringConditionCommonBonus);
var NoDepositCommonBonus = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_WageringConditionCom2) {
  _inherits(NoDepositCommonBonus, _WageringConditionCom2);

  var _super3 = _createSuper(NoDepositCommonBonus);

  function NoDepositCommonBonus() {
    var _this3;

    _classCallCheck(this, NoDepositCommonBonus);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "minDeposit", '0');

    _defineProperty(_assertThisInitialized(_this3), "tags", [BonusTagEnums.NoDeposit, BonusTagEnums.CanActive]);

    return _this3;
  }

  return _createClass(NoDepositCommonBonus);
}(WageringConditionCommonBonus)));

/***/ }),

/***/ 95793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jn": function() { return /* binding */ DepositBonus; },
/* harmony export */   "Oh": function() { return /* binding */ NoDepositBonus; }
/* harmony export */ });
/* unused harmony exports ApiBonusStatusEnums, UserBonus, WageringConditionBonus */
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10748);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45959);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59499);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70794);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46391);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var ApiBonusStatusEnums;

(function (ApiBonusStatusEnums) {
  ApiBonusStatusEnums[ApiBonusStatusEnums["WaitDeposit"] = 1] = "WaitDeposit";
  ApiBonusStatusEnums[ApiBonusStatusEnums["WaitActive"] = 2] = "WaitActive";
  ApiBonusStatusEnums[ApiBonusStatusEnums["Processing"] = 3] = "Processing";
  ApiBonusStatusEnums[ApiBonusStatusEnums["Completed"] = 4] = "Completed";
  ApiBonusStatusEnums[ApiBonusStatusEnums["UserCancel"] = 5] = "UserCancel";
  ApiBonusStatusEnums[ApiBonusStatusEnums["Cancel"] = 6] = "Cancel";
})(ApiBonusStatusEnums || (ApiBonusStatusEnums = {}));

var UserBonus = /*#__PURE__*/(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function UserBonus(bonus) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, UserBonus);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, "id", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, "info", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, "condition", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, "apiStatus", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, "tags", void 0);

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, "status", void 0);

  this.id = bonus.id;
  this.info = bonus.info;
  this.condition = new ___WEBPACK_IMPORTED_MODULE_3__/* .BonusCondition */ .db(bonus.condition);
  this.apiStatus = bonus.apiStatus;
  this.status = ___WEBPACK_IMPORTED_MODULE_3__/* .BonusStatusEnums.Available */ .ns.Available;
});
var WageringConditionBonus = /*#__PURE__*/function (_UserBonus) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(WageringConditionBonus, _UserBonus);

  var _super = _createSuper(WageringConditionBonus);

  function WageringConditionBonus(bonus, wageringConditionValues) {
    var _this;

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, WageringConditionBonus);

    _this = _super.call(this, bonus);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "tags", [___WEBPACK_IMPORTED_MODULE_3__/* .BonusTagEnums.CanActive */ .CX.CanActive]);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "minBet", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "rakeFeeRequirement", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "minDeposit", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "maxBonus", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "wageringBonusStatus", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "currentWager", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "targetWager", void 0);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "activeDurationInDays", void 0);

    _this.rakeFeeRequirement = wageringConditionValues.rakeFeeRequirement;
    _this.minDeposit = wageringConditionValues.minDeposit;
    _this.currentWager = wageringConditionValues.currentWager;
    _this.targetWager = wageringConditionValues.targetWager;
    _this.activeDurationInDays = wageringConditionValues.activeDurationInDays;
    _this.status = ___WEBPACK_IMPORTED_MODULE_3__/* .BonusStatusEnums.Available */ .ns.Available;
    return _this;
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WageringConditionBonus, [{
    key: "currentWagerBigAmount",
    get: function get() {
      var currentWagerBigAmount = new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(this.currentWager);
      return currentWagerBigAmount.gt(this.targetWagerBigAmount) ? this.targetWagerBigAmount : currentWagerBigAmount;
    }
  }, {
    key: "targetWagerBigAmount",
    get: function get() {
      return new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(this.targetWager);
    }
  }, {
    key: "progress",
    get: function get() {
      if (this.targetWagerBigAmount.eq(0)) return 100;
      return Math.floor(this.currentWagerBigAmount.div(this.targetWagerBigAmount).multipliedBy(10000).toNumber()) / 100;
    }
  }, {
    key: "minDepositBigAmount",
    get: function get() {
      return new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(this.minDeposit);
    }
  }, {
    key: "maxBonusBigAmount",
    get: function get() {
      return new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(this.maxBonus);
    }
  }]);

  return WageringConditionBonus;
}(UserBonus);
var DepositBonus = /*#__PURE__*/function (_WageringConditionBon) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(DepositBonus, _WageringConditionBon);

  var _super2 = _createSuper(DepositBonus);

  function DepositBonus(bonus, wageringConditionValues) {
    var _this2;

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, DepositBonus);

    _this2 = _super2.call(this, bonus, wageringConditionValues);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this2), "percent", void 0);

    _this2.percent = new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(wageringConditionValues.currentWager).dividedBy(wageringConditionValues.targetWager).multipliedBy(100).toNumber();
    return _this2;
  }

  return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DepositBonus);
}(WageringConditionBonus);
var NoDepositBonus = /*#__PURE__*/function (_WageringConditionBon2) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(NoDepositBonus, _WageringConditionBon2);

  var _super3 = _createSuper(NoDepositBonus);

  // eslint-disable-next-line no-useless-constructor
  function NoDepositBonus(bonus, wageringConditionValues) {
    var _this3;

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, NoDepositBonus);

    _this3 = _super3.call(this, bonus, wageringConditionValues);

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this3), "tags", [___WEBPACK_IMPORTED_MODULE_3__/* .BonusTagEnums.CanActive */ .CX.CanActive, ___WEBPACK_IMPORTED_MODULE_3__/* .BonusTagEnums.NoDeposit */ .CX.NoDeposit]);

    return _this3;
  }

  return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(NoDepositBonus);
}(WageringConditionBonus);

/***/ }),

/***/ 38004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zc": function() { return /* binding */ TransactionStatusEnum; },
/* harmony export */   "bL": function() { return /* binding */ TransactionTypeEnum; }
/* harmony export */ });
/* unused harmony exports Transaction, TransactionWithdraw, QueryDepositInfo */



var TransactionStatusEnum;

(function (TransactionStatusEnum) {
  TransactionStatusEnum[TransactionStatusEnum["Failed"] = -1] = "Failed";
  TransactionStatusEnum[TransactionStatusEnum["Pending"] = 1] = "Pending";
  TransactionStatusEnum[TransactionStatusEnum["InBatch"] = 2] = "InBatch";
  TransactionStatusEnum[TransactionStatusEnum["Reviewing"] = 3] = "Reviewing";
  TransactionStatusEnum[TransactionStatusEnum["Succeeded"] = 10] = "Succeeded";
})(TransactionStatusEnum || (TransactionStatusEnum = {}));

var TransactionTypeEnum;

(function (TransactionTypeEnum) {
  TransactionTypeEnum[TransactionTypeEnum["Deposit"] = 0] = "Deposit";
  TransactionTypeEnum[TransactionTypeEnum["Withdraw"] = 1] = "Withdraw";
  TransactionTypeEnum[TransactionTypeEnum["Reward"] = 2] = "Reward";
  TransactionTypeEnum[TransactionTypeEnum["Bonus"] = 3] = "Bonus";
  TransactionTypeEnum[TransactionTypeEnum["Swap"] = 4] = "Swap";
})(TransactionTypeEnum || (TransactionTypeEnum = {}));

var Transaction = /*#__PURE__*/(/* unused pure expression or super */ null && (_createClass(function Transaction() {
  _classCallCheck(this, Transaction);

  _defineProperty(this, "id", void 0);

  _defineProperty(this, "status", void 0);

  _defineProperty(this, "txnHash", void 0);

  _defineProperty(this, "value", void 0);

  _defineProperty(this, "createTime", void 0);

  _defineProperty(this, "currency", void 0);

  _defineProperty(this, "network", void 0);

  _defineProperty(this, "type", void 0);

  _defineProperty(this, "fee", void 0);
})));
var TransactionWithdraw = /*#__PURE__*/(/* unused pure expression or super */ null && (_createClass(function TransactionWithdraw() {
  _classCallCheck(this, TransactionWithdraw);

  _defineProperty(this, "status", void 0);

  _defineProperty(this, "code", void 0);

  _defineProperty(this, "value", void 0);

  _defineProperty(this, "createTime", void 0);

  _defineProperty(this, "currency", void 0);

  _defineProperty(this, "network", void 0);

  _defineProperty(this, "type", void 0);

  _defineProperty(this, "fee", void 0);
})));
var QueryDepositInfo = /*#__PURE__*/(/* unused pure expression or super */ null && (_createClass(function QueryDepositInfo() {
  _classCallCheck(this, QueryDepositInfo);

  _defineProperty(this, "depositInfo", void 0);

  _defineProperty(this, "status", void 0);
})));

/***/ }),

/***/ 1872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ValidationError; }
/* harmony export */ });
var ValidationError;

(function (ValidationError) {
  ValidationError["Email"] = "Email";
  ValidationError["EmailDuplicate"] = "EmailDuplicate";
  ValidationError["EmailNotExist"] = "EmailNotExist";
  ValidationError["WrongPassword"] = "WrongPassword";
  ValidationError["Required"] = "Required";
  ValidationError["RequiredNumber"] = "RequiredNumber";
  ValidationError["RequiredUppercase"] = "RequiredUppercase";
  ValidationError["Integer"] = "Integer";
  ValidationError["IncorrectLength"] = "IncorrectLength";
  ValidationError["IncorrectType"] = "IncorrectType";
  ValidationError["DataExpired"] = "DataExpired";
  ValidationError["NotEqual"] = "NotEqual";
  ValidationError["TooShort"] = "TooShort";
  ValidationError["TooLong"] = "TooLong";
  ValidationError["NotEnough"] = "NotEnough";
  ValidationError["Insufficient"] = "Insufficient";
  ValidationError["IsZero"] = "IsZero";
  ValidationError["InCorrect"] = "InCorrect";
  ValidationError["NotChecked"] = "NotChecked";
  ValidationError["GreatThanEqual"] = "GreatThanEqual";
  ValidationError["LessThanEqual"] = "LessThanEqual";
  ValidationError["IsEtherAddress"] = "IsEtherAddress";
})(ValidationError || (ValidationError = {}));

/***/ }),

/***/ 3877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ WalletType; }
/* harmony export */ });
// INTERGRATE SOLANA
var WalletType;

(function (WalletType) {
  WalletType[WalletType["EVM"] = 0] = "EVM";
  WalletType[WalletType["BSC"] = 1] = "BSC";
})(WalletType || (WalletType = {}));

/***/ }),

/***/ 35550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ Context; },
  "Z": function() { return /* reexport */ Modals_Modals; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-spring/dist/esm/index.js + 5 modules
var esm = __webpack_require__(97421);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/contexts/Modals/Modals.tsx


var _excluded = ["onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var Context = /*#__PURE__*/(0,react.createContext)({
  onPresent: function onPresent() {},
  onDismiss: function onDismiss() {},
  closeModal: function closeModal() {}
});
var animationDuration = 200;

var OpenModalEffect = function OpenModalEffect(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      display = _ref.display,
      children = _ref.children;
  var styleOpenModal = (0,esm/* useSpring */.q_)({
    from: {
      scale: open ? 0.8 : 1,
      opacity: open ? 0 : 1
    },
    to: {
      scale: open ? 1 : 0.8,
      opacity: open ? 1 : 0
    },
    config: {
      duration: animationDuration
    },
    onResolve: function onResolve() {
      if (!open) {
        onClose();
      }
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledResponsiveWrapper, {
    display: display,
    style: styleOpenModal,
    children: children
  });
};

var Modals = function Modals(_ref2) {
  var children = _ref2.children;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      toggle = _useState2[0],
      setToggle = _useState2[1];

  var _useState3 = (0,react.useState)(),
      contentId = _useState3[0],
      setContentId = _useState3[1]; // Make sure modal will open when metadata ready


  var serverTime = (0,state/* useAppSelector */.CG)(function (state) {
    return state.app.serverTime;
  });
  var contentsRef = (0,react.useRef)([]);
  var isClosingRef = (0,react.useRef)(false);
  var handleCloseAllModal = (0,react.useCallback)(function () {
    if (contentsRef.current.length > 0) {
      isClosingRef.current = true;
      setToggle(false);
    }
  }, [setToggle]);
  var handleDismiss = (0,react.useCallback)(function (id) {
    var contents = id ? contentsRef.current.filter(function (item) {
      return item.id !== id;
    }) : contentsRef.current.slice(0, contentsRef.current.length - 1);

    if (contents.length === 0) {
      handleCloseAllModal();
      return;
    }

    contentsRef.current = contents;
    setContentId(contentsRef.current[contentsRef.current.length - 1].id);
  }, [handleCloseAllModal]);
  var handlePresent = (0,react.useCallback)(function (id, Component, data) {
    var present = function present() {
      contentsRef.current.push({
        id: id,
        content: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
          data: data,
          onDismiss: function onDismiss() {
            handleDismiss(id);
          }
        }, id)
      });
      setContentId(id);
      setToggle(true);
      setIsOpen(true);
      document.body.classList.add('no-scroll');
      document.body.classList.add('modal-open');
    };

    if (!isClosingRef.current) {
      present();
    } else {
      setTimeout(present, animationDuration + 1000);
    }
  }, [handleDismiss]);
  var closeModal = (0,react.useCallback)(function () {
    setIsOpen(false);
    contentsRef.current = [];
    setContentId(undefined);
    document.body.classList.remove('no-scroll');
    document.body.classList.remove('modal-open');
    isClosingRef.current = false;
  }, [setIsOpen]);
  var value = (0,react.useMemo)(function () {
    return {
      onPresent: handlePresent,
      onDismiss: handleDismiss,
      closeModal: handleCloseAllModal
    };
  }, [handlePresent, handleDismiss, handleCloseAllModal]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Context.Provider, {
    value: value,
    children: [children, isOpen && serverTime && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledModalWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Backdrop, {
        id: "modal-backdrop",
        onClick: function onClick() {
          return handleDismiss();
        },
        style: {
          background: toggle ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.0)'
        }
      }), contentsRef.current.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(OpenModalEffect, {
          open: toggle,
          onClose: closeModal,
          display: item.id === contentId ? 'flex' : 'none',
          children: item.content
        }, item.id);
      })]
    })]
  });
};

var Backdrop = function Backdrop(_ref3) {
  var onClick = _ref3.onClick,
      props = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  var isModalOpened = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    setTimeout(function () {
      isModalOpened.current = true;
    }, 300);
  });

  var handleClick = function handleClick() {
    if (isModalOpened.current) {
      onClick(null);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledModalBackdrop, _objectSpread({
    onClick: handleClick
  }, props));
};

var mobileKeyframes = (0,styled_components_browser_esm/* keyframes */.F4)(["\n  0% {\n    transform: translateY(0%);\n  }\n  100% {\n    transform: translateY(-100%);\n  }\n"]);
var StyledResponsiveWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* animated.div */.q.div).withConfig({
  displayName: "Modals__StyledResponsiveWrapper",
  componentId: "sc-1ja4i8-0"
})(["\n  display: ", ";\n  align-items: center;\n  flex-direction: column;\n  justify-content: flex-end;\n  position: absolute;\n  top: 100%;\n  right: 0;\n  left: 0;\n  animation: ", " 0.2s forwards ease-out;\n\n  ", " {\n    position: relative;\n    animation: none;\n    top: 0%;\n    justify-content: center;\n  }\n"], function (_ref4) {
  var display = _ref4.display;
  return display;
}, mobileKeyframes, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediaQueries.sm;
});
var StyledModalWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Modals__StyledModalWrapper",
  componentId: "sc-1ja4i8-1"
})(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n"]);
var StyledModalBackdrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Modals__StyledModalBackdrop",
  componentId: "sc-1ja4i8-2"
})(["\n  transition: 0.3s;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"]);
/* harmony default export */ var Modals_Modals = (Modals);
;// CONCATENATED MODULE: ./src/contexts/Modals/index.ts


/***/ }),

/***/ 66064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E6": function() { return /* binding */ useActionQueryHandler; },
/* harmony export */   "Vt": function() { return /* binding */ ActionQueryEnum; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16835);
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49279);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82813);
/* harmony import */ var state_auth_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71581);
/* harmony import */ var views_Authentication__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43624);
/* harmony import */ var views_Payment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9242);
/* harmony import */ var config_types_authentication__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87876);
/* harmony import */ var _useIsomorphicEffect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58491);
/* harmony import */ var _useModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13911);
/* harmony import */ var _useQueryParam__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77059);












var ActionQueryEnum;

(function (ActionQueryEnum) {
  ActionQueryEnum["Login"] = "onLogin";
  ActionQueryEnum["LoginEmail"] = "onEmailLogin";
  ActionQueryEnum["SignUp"] = "onSignUp";
  ActionQueryEnum["UnlockHUSD"] = "unlockHUSD";
  ActionQueryEnum["Deposit"] = "deposit";
  ActionQueryEnum["Withdraw"] = "withdraw";
  ActionQueryEnum["OpenLuckySpin"] = "openLuckySpin";
})(ActionQueryEnum || (ActionQueryEnum = {}));

var useActionQueryHandler = function useActionQueryHandler() {
  var _useModal = (0,_useModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(views_Authentication__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z),
      _useModal2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useModal, 1),
      onPresentAuthModal = _useModal2[0];

  var _useModal3 = (0,_useModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(views_Payment__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z),
      _useModal4 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useModal3, 1),
      onPressentModalPaymnet = _useModal4[0];

  var _useAuth = (0,state_auth_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)(),
      isSigned = _useAuth.isSigned,
      hasSession = _useAuth.hasSession;

  var actions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var _ref;

    return _ref = {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref, ActionQueryEnum.Login, {
      call: function call() {
        return onPresentAuthModal({
          page: config_types_authentication__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalPageEnums.LOG_IN */ .i.LOG_IN
        });
      },
      condition: !isSigned && !hasSession
    }), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref, ActionQueryEnum.LoginEmail, {
      call: function call() {
        return onPresentAuthModal({
          page: config_types_authentication__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalPageEnums.LOG_IN */ .i.LOG_IN,
          method: config_types_authentication__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalMethodEnums.TRADITIONAL */ .h.TRADITIONAL
        });
      },
      condition: !isSigned && !hasSession
    }), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref, ActionQueryEnum.Deposit, {
      call: function call() {
        return onPressentModalPaymnet();
      },
      condition: isSigned,
      fallback: function fallback() {
        return onPresentAuthModal({
          page: config_types_authentication__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalPageEnums.LOG_IN */ .i.LOG_IN
        });
      }
    }), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref, ActionQueryEnum.Withdraw, {
      call: function call() {
        return onPressentModalPaymnet({
          defaultPage: views_Payment__WEBPACK_IMPORTED_MODULE_5__/* .PaymentPageEnums.Withdraw */ .E.Withdraw
        });
      },
      condition: isSigned,
      fallback: function fallback() {
        return onPresentAuthModal({
          page: config_types_authentication__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalPageEnums.LOG_IN */ .i.LOG_IN
        });
      }
    }), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref, ActionQueryEnum.SignUp, {
      call: function call() {
        return onPresentAuthModal({
          page: config_types_authentication__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalPageEnums.SIGN_UP */ .i.SIGN_UP
        });
      },
      condition: !isSigned && !hasSession
    }), _ref;
  }, [isSigned, hasSession, onPresentAuthModal, onPressentModalPaymnet]);
  var handle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (action) {
    if (!action || isSigned === null) return;
    var selectedAction = actions[action.toString()];

    if (!selectedAction || selectedAction.condition === false) {
      if (selectedAction !== null && selectedAction !== void 0 && selectedAction.fallback) {
        selectedAction.fallback();
      }
    } else selectedAction.call();
  }, [actions, isSigned]);
  return handle;
};

var useActionQueryListener = function useActionQueryListener() {
  var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_0__/* .useRouter */ .t)();

  var _useQueryParam = (0,_useQueryParam__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(),
      removeParam = _useQueryParam.removeParam;

  var handleAction = useActionQueryHandler();
  var isLayoutRendered = (0,state__WEBPACK_IMPORTED_MODULE_2__/* .useAppSelector */ .CG)(function (state) {
    return state.app.isLayoutRendered;
  });
  (0,_useIsomorphicEffect__WEBPACK_IMPORTED_MODULE_7__/* .useIsomorphicEffect */ .Y)(function () {
    var action = router.query.action;
    if (!action || !isLayoutRendered) return;
    handleAction(action);
    removeParam('action');
  }, [router.query.action, handleAction, isLayoutRendered]);
};

/* harmony default export */ __webpack_exports__["ZP"] = (useActionQueryListener);

/***/ }),

/***/ 42705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useAnalytics; }
/* harmony export */ });
/* harmony import */ var state_auth_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71581);

var useAnalytics = function useAnalytics() {
  var _useUserInfo = (0,state_auth_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useUserInfo */ .Pc)(),
      uid = _useUserInfo.uid;

  var recordEvent = function recordEvent(event, value) {
    var leafValue = value || {};
    var parsedValue = "[".concat(event, "]");

    while (typeof leafValue === 'object') {
      var key = Object.keys(leafValue)[0];
      leafValue = leafValue[key];
      if (key) parsedValue = "".concat(parsedValue, "[").concat(key, "]");
    }

    if (leafValue) parsedValue = "".concat(parsedValue, "[").concat(leafValue, "]");
    window.dataLayer.push({
      event: parsedValue,
      userId: uid
    });
  };

  var addEventString = function addEventString(event) {
    var _window, _window$dataLayer;

    (_window = window) === null || _window === void 0 ? void 0 : (_window$dataLayer = _window.dataLayer) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push({
      event: event,
      userId: uid
    });
  };

  var updateUserType = function updateUserType(key, value) {// window?.dataLayer?.push({ [key]: value, userId: Number(uid) });
  };

  var updateUserId = function updateUserId(uid) {
    var _window2, _window2$dataLayer;

    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$dataLayer = _window2.dataLayer) === null || _window2$dataLayer === void 0 ? void 0 : _window2$dataLayer.push({
      userId: uid
    });
  };

  return {
    recordEvent: recordEvent,
    updateUserType: updateUserType,
    updateUserId: updateUserId,
    addEventString: addEventString
  };
}; // Initialize Analytics and get a reference to the service

/***/ }),

/***/ 97379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useConnectWallet; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _binance_chain_bsc_connector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29831);
/* harmony import */ var _web3_react_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34713);
/* harmony import */ var _web3_react_injected_connector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30950);
/* harmony import */ var _web3_react_walletconnect_connector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83929);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(170);
/* harmony import */ var config_types_wallet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3877);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18132);
/* harmony import */ var utils_sentry__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7737);
/* harmony import */ var utils_toastify__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7006);
/* harmony import */ var utils_web3React__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89484);



 // INTERGRATE SOLANA
// import { WalletDisconnectionError, WalletNotReadyError } from '@solana/wallet-adapter-base'
// import { useWallet as useSolWallet } from '@solana/wallet-adapter-react'











var useConnectWallet = function useConnectWallet() {
  var _useWeb3React = (0,_web3_react_core__WEBPACK_IMPORTED_MODULE_2__/* .useWeb3React */ .Ge)(),
      activate = _useWeb3React.activate,
      deactivate = _useWeb3React.deactivate; // const { select, disconnect, connected } = useSolWallet()


  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$)(),
      t = _useTranslation.t; // const handleSolWalletConnect = async (adapter: any) => {
  //   try {
  //     select(adapter.name)
  //     return true
  //   } catch (e) {
  //     if (e instanceof WalletNotReadyError) {
  //       HunnyToast.error(t('Your wallet is not ready'), null, {
  //         toastId: 'not-ready-wallet',
  //       })
  //     } else {
  //       HunnyToast.error(t('Something went wrong'), null, {
  //         toastId: 'reject-connect-wallet',
  //       })
  //       logError(`Connect ${adapter.name} (SOL) Wallet`, e)
  //     }
  //     return true
  //   }
  // }


  var handleEVMDisconnect = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function () {
    deactivate();

    if (window.localStorage.getItem(config_constants__WEBPACK_IMPORTED_MODULE_5__/* .ConnectorNameEnum.WalletConnect */ .Oh.WalletConnect)) {
      window.localStorage.removeItem(config_constants__WEBPACK_IMPORTED_MODULE_5__/* .ConnectorNameEnum.WalletConnect */ .Oh.WalletConnect);
      utils_web3React__WEBPACK_IMPORTED_MODULE_9__/* .connectorsByName.walletconnect.close */ .BA.walletconnect.close();
    }
  }, [deactivate]);
  var handleEVMWalletConnect = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(adapter) {
      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (adapter) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              if (!(adapter instanceof _web3_react_walletconnect_connector__WEBPACK_IMPORTED_MODULE_4__/* .WalletConnectConnector */ .zw)) {
                _context3.next = 7;
                break;
              }

              if (!window.localStorage.getItem(config_constants__WEBPACK_IMPORTED_MODULE_5__/* .ConnectorNameEnum.WalletConnect */ .Oh.WalletConnect)) {
                _context3.next = 7;
                break;
              }

              window.localStorage.removeItem(config_constants__WEBPACK_IMPORTED_MODULE_5__/* .ConnectorNameEnum.WalletConnect */ .Oh.WalletConnect);
              _context3.next = 7;
              return adapter.close();

            case 7:
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(resolve) {
                  return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return activate(adapter, /*#__PURE__*/function () {
                            var _ref3 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
                              return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      resolve(false);

                                      if (error instanceof _web3_react_injected_connector__WEBPACK_IMPORTED_MODULE_3__/* .NoEthereumProviderError */ .A5 || error instanceof _binance_chain_bsc_connector__WEBPACK_IMPORTED_MODULE_1__/* .NoBscProviderError */ .r9 && !(adapter instanceof _web3_react_walletconnect_connector__WEBPACK_IMPORTED_MODULE_4__/* .WalletConnectConnector */ .zw)) {
                                        utils_toastify__WEBPACK_IMPORTED_MODULE_8__/* .HunnyToast.error */ .f.error(t('Wallet is not found!'));
                                      } else if (error instanceof _web3_react_injected_connector__WEBPACK_IMPORTED_MODULE_3__/* .UserRejectedRequestError */ .ab || error instanceof _web3_react_walletconnect_connector__WEBPACK_IMPORTED_MODULE_4__/* .UserRejectedRequestError */ .ab) {
                                        if (adapter instanceof _web3_react_walletconnect_connector__WEBPACK_IMPORTED_MODULE_4__/* .WalletConnectConnector */ .zw) {
                                          adapter.walletConnectProvider = null;
                                        }

                                        utils_toastify__WEBPACK_IMPORTED_MODULE_8__/* .HunnyToast.warn */ .f.warn(t('Rejected.'), t('You have been rejected connect wallet.'));
                                      } else if (error.code === -32002) {
                                        utils_toastify__WEBPACK_IMPORTED_MODULE_8__/* .HunnyToast.error */ .f.error(t('Please confirm connect wallet.'), t('Please check your wallet and confirm to connect HunnyPoker.'));
                                      } else {
                                        if (adapter instanceof _web3_react_walletconnect_connector__WEBPACK_IMPORTED_MODULE_4__/* .WalletConnectConnector */ .zw) {
                                          handleEVMDisconnect();
                                          utils_toastify__WEBPACK_IMPORTED_MODULE_8__/* .HunnyToast.error */ .f.error(t('Wrong chain'), t('Please switch to your selected network and connect again'));
                                        }

                                        (0,utils_sentry__WEBPACK_IMPORTED_MODULE_12__/* .logError */ .H)('Connect EVM Wallet', error);
                                      }

                                    case 2:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee);
                            }));

                            return function (_x3) {
                              return _ref3.apply(this, arguments);
                            };
                          }());

                        case 2:
                          resolve(true);

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [activate, handleEVMDisconnect, t]); // const handleSOLDisconnect = async () => {
  //   if (connected) {
  //     try {
  //       await disconnect()
  //     } catch (error) {
  //       if (error instanceof WalletDisconnectionError)
  //         HunnyToast.error(error.name, error.message, {
  //           toastId: 'reject-disconnect-wallet',
  //         })
  //       logError(`Disconnect SOL Wallet`, error)
  //     }
  //   }
  // }

  return (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function () {
    var _ref4;

    return _ref4 = {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_ref4, config_types_wallet__WEBPACK_IMPORTED_MODULE_6__/* .WalletType.EVM */ .S.EVM, {
      connect: handleEVMWalletConnect,
      disconnect: handleEVMDisconnect
    }), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_ref4, config_types_wallet__WEBPACK_IMPORTED_MODULE_6__/* .WalletType.BSC */ .S.BSC, {
      connect: handleEVMWalletConnect,
      disconnect: handleEVMDisconnect
    }), _ref4;
  }, [handleEVMWalletConnect, handleEVMDisconnect]);
};

/***/ }),

/***/ 87625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useCountDown; }
/* harmony export */ });
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(170);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82813);
/* harmony import */ var utils_dateHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46030);




var useCountDown = function useCountDown(to, formatDisplay, callback) {
  var serverTimeMargin = (0,state__WEBPACK_IMPORTED_MODULE_2__/* .useAppSelector */ .CG)(function (state) {
    return state.app.serverTimeMargin;
  });
  var elementRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!to) return;
    var interval = setInterval(function () {
      if (!elementRef.current || serverTimeMargin === undefined || serverTimeMargin === null) return;
      var result = (0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_3__/* .generateTimeDisplay */ .y2)(to, serverTimeMargin);
      elementRef.current.innerHTML = formatDisplay(result.seconds, result.minutes, result.hours, result.days);

      if (result === config_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_TIME */ .pj) {
        clearInterval(interval);

        if (callback) {
          callback();
        }
      }
    }, 1000);
    return function () {
      clearInterval(interval);
    };
  }, [to, serverTimeMargin, formatDisplay, callback]);
  return elementRef;
};

/***/ }),

/***/ 47520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useDebounceCallback = function useDebounceCallback() {
  var debounceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var submit = function submit(cb, debounceTime) {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(function () {
      cb();
    }, debounceTime);
  };

  return submit;
};

/* harmony default export */ __webpack_exports__["Z"] = (useDebounceCallback);

/***/ }),

/***/ 54040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ useFetchUserProfile; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var hooks = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/state/bonus/actions.ts
var actions = __webpack_require__(37130);
// EXTERNAL MODULE: ./src/state/profile/actions.ts
var profile_actions = __webpack_require__(3176);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./src/config/constants/server.ts
var server = __webpack_require__(25920);
// EXTERNAL MODULE: ./src/services/HunnyPokerRequest.ts
var HunnyPokerRequest = __webpack_require__(84055);
;// CONCATENATED MODULE: ./src/services/ProfileService.ts






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var ProfileService = /*#__PURE__*/function (_HunnyPokerRequest) {
  (0,inherits/* default */.Z)(ProfileService, _HunnyPokerRequest);

  var _super = _createSuper(ProfileService);

  function ProfileService() {
    (0,classCallCheck/* default */.Z)(this, ProfileService);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(ProfileService, [{
    key: "getUserInfo",
    value: function getUserInfo() {
      return this._post(server/* APIEndpointEnum.Profile */.zK.Profile, {
        excludeErrors: [server/* MessageResponseServer.unauthorized */.ty.unauthorized]
      });
    }
  }]);

  return ProfileService;
}(HunnyPokerRequest/* HunnyPokerRequest */.y);

var instance = new ProfileService();
/* harmony default export */ var services_ProfileService = (instance);
;// CONCATENATED MODULE: ./src/state/profile/calls/fetchUserInfos.ts



function fetchMyUserInfo() {
  return _fetchMyUserInfo.apply(this, arguments);
}

function _fetchMyUserInfo() {
  _fetchMyUserInfo = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var result;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return services_ProfileService.getUserInfo().call();

          case 2:
            result = _context.sent;
            return _context.abrupt("return", result === null || result === void 0 ? void 0 : result.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchMyUserInfo.apply(this, arguments);
}
;// CONCATENATED MODULE: ./src/hooks/useFetchUserProfile.tsx








var useFetchUserProfile = function useFetchUserProfile() {
  var _useAuth = (0,hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned;

  var dispatch = (0,state/* useAppDispatch */.TL)();
  var logout = (0,hooks/* useClientLogout */.jN)();
  var fetch = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var result;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isSigned) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            _context.next = 4;
            return fetchMyUserInfo();

          case 4:
            result = _context.sent;

            if (!(!result || !(result !== null && result !== void 0 && result.address))) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", logout());

          case 7:
            dispatch((0,actions/* updatePreparedBonusId */.H1)(result === null || result === void 0 ? void 0 : result.preparedBonusId));
            dispatch((0,profile_actions/* updateMyProfile */.l)({
              data: result
            }));
            return _context.abrupt("return", result);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [dispatch, isSigned, logout]);
  return fetch;
};

/***/ }),

/***/ 16145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27812);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89850);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function useForm(config) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(Object.keys(config).reduce(function (result, fieldName) {
    result = _objectSpread(_objectSpread({}, result), {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, fieldName, {
      value: config[fieldName].value,
      errors: [],
      isDirty: false
    }));
    return result;
  }, {})),
      states = _useState[0],
      setStates = _useState[1];

  var setState = function setState(key, fieldName) {
    return function (value) {
      setStates(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, fieldName, _objectSpread(_objectSpread({}, prev[fieldName]), {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, key, value))));
      });
    };
  };

  var controls = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
    return Object.keys(config).reduce(function (result, fieldName) {
      var _fieldConfig$formVali, _fieldConfig$validato;

      var fieldConfig = config[fieldName];
      var validators = [].concat((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(((_fieldConfig$formVali = fieldConfig.formValidators) !== null && _fieldConfig$formVali !== void 0 ? _fieldConfig$formVali : []).map(function (validator) {
        return validator(states);
      })), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_fieldConfig$validato = fieldConfig.validators) !== null && _fieldConfig$validato !== void 0 ? _fieldConfig$validato : []), [function (value) {
        setState('isDirty', fieldName)(true);
        setState('validatedValue', fieldName)(value);
      }]);
      result = _objectSpread(_objectSpread({}, result), {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, fieldName, {
        value: states[fieldName].value,
        onValueChanged: setState('value', fieldName),
        onErrorChanged: setState('errors', fieldName),
        onValidating: function onValidating() {
          return setState('isValidating', fieldName)(true);
        },
        onValidated: function onValidated() {
          return setState('isValidating', fieldName)(false);
        },
        validators: validators,
        validateOnchange: states[fieldName].isDirty ? true : fieldConfig.validateOnChange
      }));
      return result;
    }, {});
  }, [config, states]);

  var submit = /*#__PURE__*/function () {
    var _ref = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(callback) {
      var isFormGroupValid;
      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return validateAll();

            case 2:
              isFormGroupValid = _context.sent;

              if (isFormGroupValid && callback) {
                callback();
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var validate = /*#__PURE__*/function () {
    var _ref2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(fieldName) {
      var hasAsyncValidator, control, state, parsedValidators, validateResult;
      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              hasAsyncValidator = false;
              control = controls[fieldName];
              state = states[fieldName];

              if (!(!control.validators || control.validators.length < 1)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", null);

            case 5:
              parsedValidators = control.validators.map(function (validator) {
                var result = validator(control.value);
                var hunnyRequest = result;

                if (hunnyRequest !== null && hunnyRequest !== void 0 && hunnyRequest.call && hunnyRequest !== null && hunnyRequest !== void 0 && hunnyRequest.cancel) {
                  if (state.value !== state.validatedValue || state.isValidating) {
                    hasAsyncValidator = true;
                    setState('isValidating', fieldName)(true);
                    return hunnyRequest.call();
                  }

                  return null;
                }

                return Promise.resolve(result);
              }).filter(function (validator) {
                return validator;
              });
              _context2.next = 8;
              return (0,components_Input__WEBPACK_IMPORTED_MODULE_2__/* .validateFormControl */ .Q)(parsedValidators);

            case 8:
              validateResult = _context2.sent;
              setState('errors', fieldName)(validateResult);
              if (hasAsyncValidator) setState('isValidating', fieldName)(false);
              return _context2.abrupt("return", validateResult);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function validate(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var validateAll = /*#__PURE__*/function () {
    var _ref3 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
      var isValid, fieldNames, index, _fieldName, validateResult;

      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isValid = true;
              fieldNames = Object.keys(controls);
              index = 0;

            case 3:
              if (!(index < fieldNames.length)) {
                _context3.next = 12;
                break;
              }

              _fieldName = fieldNames[index];
              _context3.next = 7;
              return validate(_fieldName);

            case 7:
              validateResult = _context3.sent;

              if (validateResult.some(function (item) {
                return item !== null;
              })) {
                isValid = false;
              }

            case 9:
              index++;
              _context3.next = 3;
              break;

            case 12:
              return _context3.abrupt("return", isValid);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function validateAll() {
      return _ref3.apply(this, arguments);
    };
  }();

  var isValid = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
    var result = true;
    var stateValues = Object.values(states);

    for (var index = 0; index < stateValues.length; index++) {
      var state = stateValues[index];

      if (state.errors.length > 0) {
        result = false;
        break;
      }
    }

    return result;
  }, [states]);
  return {
    controls: controls,
    states: states,
    submit: submit,
    validateAll: validateAll,
    validate: validate,
    isValid: isValid
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useForm);

/***/ }),

/***/ 58491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useIsomorphicEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIsomorphicEffect =  false ? 0 : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;

/***/ }),

/***/ 67238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useKeydownEventListener; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useEventListener.ts


function useEventListener(eventName, handler, element, options) {
  // Create a ref that stores handler
  var savedHandler = (0,react.useRef)(handler);
  (0,react.useEffect)(function () {
    savedHandler.current = handler;
  }, [handler]);
  (0,react.useEffect)(function () {
    // Define the listening target
    var targetElement = (element === null || element === void 0 ? void 0 : element.current) || window;

    if (!targetElement || !targetElement.addEventListener) {
      return;
    } // Create event listener that calls handler function stored in ref


    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };

    targetElement.addEventListener(eventName, eventListener, options); // Remove event listener on cleanup

    return function () {
      targetElement.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element, options]);
}

/* harmony default export */ var hooks_useEventListener = (useEventListener);
;// CONCATENATED MODULE: ./src/hooks/useWindowRef.ts

/* harmony default export */ var useWindowRef = (function () {
  return (0,react.useRef)(window);
});
;// CONCATENATED MODULE: ./src/hooks/useKeydownEventListener.ts


/* harmony default export */ var useKeydownEventListener = (function (callback) {
  hooks_useEventListener('keydown', callback, useWindowRef());
});

/***/ }),

/***/ 13911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useCloseAllModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57632);
/* harmony import */ var _contexts_Modals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35550);




function useModal(Component) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_Modals__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._),
      onDismiss = _useContext.onDismiss,
      onPresent = _useContext.onPresent;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      id = _useState[0],
      setId = _useState[1];

  var handlePresent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (data) {
    var id = (0,uuid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    setId(id);
    onPresent(id, Component, data || {});
  }, [Component, onPresent]);
  var handleOnDimiss = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    onDismiss(id);
  }, [onDismiss, id]);
  return [handlePresent, handleOnDimiss];
}

function useCloseAllModal() {
  var _useContext2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_Modals__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._),
      closeModal = _useContext2.closeModal;

  return closeModal;
}
/* harmony default export */ __webpack_exports__["Z"] = (useModal);

/***/ }),

/***/ 90963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ usePlayGame; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var config_constants_route__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90381);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var state_auth_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71581);
/* harmony import */ var _useActionQueryListener__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66064);







var usePlayGame = function usePlayGame() {
  var _useAuth = (0,state_auth_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)(),
      isSigned = _useAuth.isSigned;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var handleRefreshToken = (0,state_auth_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useAuthRefresh */ .Gl)();
  var handlePlayGame = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var refreshSuccess;
    return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isSigned) {
              _context.next = 7;
              break;
            }

            _context.next = 3;
            return handleRefreshToken();

          case 3:
            refreshSuccess = _context.sent;

            if (!refreshSuccess) {
              _context.next = 7;
              break;
            }

            router.push(config_constants_route__WEBPACK_IMPORTED_MODULE_2__/* .RouteConfig.Play */ .F.Play);
            return _context.abrupt("return");

          case 7:
            router.push({
              pathname: router.pathname,
              query: {
                action: _useActionQueryListener__WEBPACK_IMPORTED_MODULE_5__/* .ActionQueryEnum.Login */ .Vt.Login
              }
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [handleRefreshToken, isSigned, router]);
  return handlePlayGame;
};

/***/ }),

/***/ 56600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ usePrivateSocket; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./src/config/constants/server.ts
var server = __webpack_require__(25920);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/socket.io-client/build/esm/index.js + 28 modules
var esm = __webpack_require__(9367);
// EXTERNAL MODULE: ./node_modules/socket.io-msgpack-parser/index.js
var socket_io_msgpack_parser = __webpack_require__(90885);
;// CONCATENATED MODULE: ./src/sockets/base.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var BaseSocket = /*#__PURE__*/function () {
  function BaseSocket(path) {
    (0,classCallCheck/* default */.Z)(this, BaseSocket);

    (0,defineProperty/* default */.Z)(this, "_socket", void 0);

    (0,defineProperty/* default */.Z)(this, "_path", void 0);

    this._path = path;
  }

  (0,createClass/* default */.Z)(BaseSocket, [{
    key: "Socket",
    get: function get() {
      if (!this._socket) {
        this._build();
      }

      return this._socket;
    }
  }, {
    key: "_build",
    value: function _build() {
      this._socket = (0,esm/* default */.ZP)(this._path, _objectSpread(_objectSpread({}, this._buildConfig()), {}, {
        parser: socket_io_msgpack_parser
      }));
    }
  }, {
    key: "close",
    value: function close() {
      var _this$_socket;

      (_this$_socket = this._socket) === null || _this$_socket === void 0 ? void 0 : _this$_socket.close();
      this._socket = null;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this$_socket2;

      (_this$_socket2 = this._socket) === null || _this$_socket2 === void 0 ? void 0 : _this$_socket2.disconnect();
    }
  }]);

  return BaseSocket;
}();
;// CONCATENATED MODULE: ./src/sockets/privateSocket.ts






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable class-methods-use-this */



var PrivateSocket = /*#__PURE__*/function (_BaseSocket) {
  (0,inherits/* default */.Z)(PrivateSocket, _BaseSocket);

  var _super = _createSuper(PrivateSocket);

  function PrivateSocket() {
    (0,classCallCheck/* default */.Z)(this, PrivateSocket);

    return _super.call(this, server/* SOCKET_API */.Zv);
  }

  (0,createClass/* default */.Z)(PrivateSocket, [{
    key: "_buildConfig",
    value: function _buildConfig() {
      var config = {
        path: server/* APIEndpointEnum.PrivateSocket */.zK.PrivateSocket,
        transports: ['websocket']
      };

      if (server/* APP_SITE */.sj !== server/* SOCKET_API */.Zv) {
        config.withCredentials = true;
      }

      return config;
    }
  }]);

  return PrivateSocket;
}(BaseSocket);

var privateSocket = new PrivateSocket();
/* harmony default export */ var sockets_privateSocket = (privateSocket);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var hooks = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/state/app/hooks.ts
var app_hooks = __webpack_require__(37850);
;// CONCATENATED MODULE: ./src/hooks/usePrivateSocket.ts




var usePrivateSocket = function usePrivateSocket() {
  var _useAuth = (0,hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned,
      accessToken = _useAuth.accessToken;

  var _useState = (0,react.useState)(null),
      socket = _useState[0],
      setSocket = _useState[1];

  var isInGame = (0,app_hooks/* useIsInGame */.Wq)();

  var handleCloseSocket = function handleCloseSocket() {
    sockets_privateSocket.Socket.disconnect();
    sockets_privateSocket.Socket.close();
    sockets_privateSocket.Socket.off('*');
    sockets_privateSocket.disconnect();
    sockets_privateSocket.close();
    setSocket(null);
  };

  (0,react.useEffect)(function () {
    if (!isSigned || !accessToken || isInGame) return;
    sockets_privateSocket.Socket.emit('Subscribe', {
      accessToken: accessToken
    });
    sockets_privateSocket.Socket.on('Subscribe', function () {});
    setSocket(sockets_privateSocket.Socket); // SOCKET

    return function () {
      if (socket) {
        handleCloseSocket();
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSigned, accessToken]);
  (0,react.useEffect)(function () {
    if (isInGame && socket) {
      handleCloseSocket();
    }
  }, [isInGame, socket]);
  return socket;
};

/***/ }),

/***/ 77059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49279);


var useQueryParam = function useQueryParam() {
  var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_0__/* .useRouter */ .t)();

  var removeParam = function removeParam(param) {
    var pathname = router.pathname,
        query = router.query;
    var params = new URLSearchParams(query);
    params["delete"](param);
    router.replace({
      pathname: pathname,
      query: params.toString()
    }, undefined, {
      shallow: true
    });
  };

  var addParam = function addParam(key, value) {
    var pathname = router.pathname,
        query = router.query;
    var params = new URLSearchParams(query);
    params.set(key, value);
    router.replace({
      pathname: pathname,
      query: params.toString()
    }, undefined, {
      shallow: true
    });
  };

  return {
    removeParam: removeParam,
    addParam: addParam
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useQueryParam);

/***/ }),

/***/ 89058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useRequest; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useRequest = function useRequest() {
  var requests = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
  var cancelAllRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    while (requests.current.length) {
      var request = requests.current.pop();
      request.cancel();
    }
  }, [requests]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      // Cancel all pending request before component destroyed
      cancelAllRequest();
    };
  }, [cancelAllRequest]);
  var execute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (request) {
    requests.current.push(request);
    return request.call();
  }, [requests]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      execute: execute,
      cancelAllRequest: cancelAllRequest
    };
  }, [execute, cancelAllRequest]);
};

/***/ }),

/***/ 69176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _web3_react_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34713);
/* harmony import */ var config_types_wallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3877);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18132);
/* harmony import */ var utils_toastify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7006);
/* harmony import */ var utils_web3React__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89484);


// import { useWallet } from '@solana/wallet-adapter-react'
// INTERGRATE SOLANA






var useSignMessage = function useSignMessage(type) {
  // const { signMessage: solSignMessage } = useWallet()
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var _useWeb3React = (0,_web3_react_core__WEBPACK_IMPORTED_MODULE_1__/* .useWeb3React */ .Ge)(),
      account = _useWeb3React.account,
      library = _useWeb3React.library;

  var _handleEtherWalletSignMessage = /*#__PURE__*/function () {
    var _ref = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve) {
                var callback = function callback(sign, error) {
                  resolve(sign);

                  if (error) {
                    if (error.code === 'ACTION_REJECTED') {
                      utils_toastify__WEBPACK_IMPORTED_MODULE_3__/* .HunnyToast.warn */ .f.warn(t('Rejected'), t('You have been rejected sign message on wallet'), {
                        toastId: 'sign-message-failed'
                      });
                    } else {
                      utils_toastify__WEBPACK_IMPORTED_MODULE_3__/* .HunnyToast.error */ .f.error(t('Error'), error.message, {
                        toastId: 'sign-message-failed'
                      });
                    }
                  }
                };

                (0,utils_web3React__WEBPACK_IMPORTED_MODULE_4__/* .signMessage */ .l)(library, account, message, callback);
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function _handleEtherWalletSignMessage(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // const _handleSolWalletSignMessage = async (inputMessage: string) => {
  //   try {
  //     const message = new TextEncoder().encode(inputMessage)
  //     const signature = await solSignMessage(message)
  //     if (signature) {
  //       const signatureTextString = ethers.utils.hexlify(signature)
  //       return signatureTextString
  //     }
  //   } catch (error) {
  //     HunnyToast.warn(t('Rejected'), t('You have been rejected sign message on wallet'), {
  //       toastId: 'sign-message-failed',
  //     })
  //     logError('sol wallet sign message', error)
  //     return null
  //   }
  // }


  if (type === config_types_wallet__WEBPACK_IMPORTED_MODULE_2__/* .WalletType.EVM */ .S.EVM || type === config_types_wallet__WEBPACK_IMPORTED_MODULE_2__/* .WalletType.BSC */ .S.BSC) {
    return _handleEtherWalletSignMessage;
  } // else if (type === WalletType.SOL) {
  //   return _handleSolWalletSignMessage
  // }

};

/* harmony default export */ __webpack_exports__["Z"] = (useSignMessage);

/***/ }),

/***/ 66015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59499);
/* harmony import */ var _web3_react_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34713);
/* harmony import */ var config_types_wallet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3877);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);

 // INTERGRATE SOLANA
// import { useWallet as useSolWallet } from '@solana/wallet-adapter-react'




var useWalletAccount = function useWalletAccount() {
  // const { publicKey } = useSolWallet()
  var _useWeb3React = (0,_web3_react_core__WEBPACK_IMPORTED_MODULE_0__/* .useWeb3React */ .Ge)(),
      account = _useWeb3React.account;

  return (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    var _ref;

    return _ref = {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, config_types_wallet__WEBPACK_IMPORTED_MODULE_1__/* .WalletType.EVM */ .S.EVM, account), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, config_types_wallet__WEBPACK_IMPORTED_MODULE_1__/* .WalletType.BSC */ .S.BSC, account), _ref;
  }, [account]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useWalletAccount);

/***/ }),

/***/ 78360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K7": function() { return /* binding */ RowCenter; },
/* harmony export */   "_B": function() { return /* binding */ RowMiddle; },
/* harmony export */   "m0": function() { return /* binding */ RowBetween; }
/* harmony export */ });
/* harmony import */ var components_Box_Flex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26303);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);


var RowMiddle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(components_Box_Flex__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).withConfig({
  displayName: "Row__RowMiddle",
  componentId: "sc-40ozhn-0"
})(["\n  align-items: center;\n"]);
var RowBetween = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(RowMiddle).withConfig({
  displayName: "Row__RowBetween",
  componentId: "sc-40ozhn-1"
})(["\n  justify-content: space-between;\n  flex: 1;\n"]);
var RowCenter = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(RowMiddle).withConfig({
  displayName: "Row__RowCenter",
  componentId: "sc-40ozhn-2"
})(["\n  justify-content: center;\n"]);

/***/ }),

/***/ 66475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45959);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55711);
/* harmony import */ var config_constants_server__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25920);
/* harmony import */ var _HunnyPokerRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84055);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var AuthenticationService = /*#__PURE__*/function (_HunnyPokerRequest) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(AuthenticationService, _HunnyPokerRequest);

  var _super = _createSuper(AuthenticationService);

  function AuthenticationService() {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, AuthenticationService);

    return _super.apply(this, arguments);
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(AuthenticationService, [{
    key: "getDeepLinkToken",
    value: function () {
      var _getDeepLinkToken = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.DeepLink */ .zK.DeepLink, {}));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDeepLinkToken() {
        return _getDeepLinkToken.apply(this, arguments);
      }

      return getDeepLinkToken;
    }()
  }, {
    key: "getTraditionalSignUpPrepare",
    value: function getTraditionalSignUpPrepare(payload) {
      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.SignUpPrepare */ .zK.SignUpPrepare, {
        email: payload.email
      }, {
        excludeErrors: [config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .MessageResponseServer.emailExist */ .ty.emailExist]
      });

      return result;
    }
  }, {
    key: "verifyRegisterEmail",
    value: function verifyRegisterEmail(email) {
      return this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.VerifyRegisterUser */ .zK.VerifyRegisterUser, {
        email: email
      });
    }
  }, {
    key: "verifyResetPassword",
    value: function verifyResetPassword(email) {
      return this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.VerifyResetPassword */ .zK.VerifyResetPassword, {
        email: email
      });
    }
  }, {
    key: "registerEmail",
    value: function () {
      var _registerEmail = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(payload) {
        var _result$data;

        var result, _result$data2, _result$data3;

        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.Register */ .zK.Register, {
                  email: payload.email,
                  password: payload.password,
                  verification: {
                    token: payload.verification.token,
                    otp: payload.verification.otp
                  },
                  referralCode: payload.referralCode || '',
                  deviceId: payload.deviceUid
                }, {
                  excludeErrors: ['error_auth_input', 'error_data_expired']
                });

              case 2:
                result = _context2.sent;

                if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.accessToken) {
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.AccessToken */ .B.AccessToken, result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.accessToken);
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken, result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.refreshToken);
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.UserInfo */ .B.UserInfo, JSON.stringify({
                    email: payload.email,
                    deviceUid: payload.deviceUid
                  }));
                }

                return _context2.abrupt("return", result);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function registerEmail(_x) {
        return _registerEmail.apply(this, arguments);
      }

      return registerEmail;
    }()
  }, {
    key: "validateResetPassword",
    value: function () {
      var _validateResetPassword = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(email, verification) {
        var result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.ValidateResetPassword */ .zK.ValidateResetPassword, {
                  email: email,
                  otp: verification.otp,
                  token: verification.token
                }, {
                  excludeErrors: ['error_auth_input', 'error_data_expired']
                });

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function validateResetPassword(_x2, _x3) {
        return _validateResetPassword.apply(this, arguments);
      }

      return validateResetPassword;
    }()
  }, {
    key: "submitResetPassword",
    value: function () {
      var _submitResetPassword = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4(payload) {
        var result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.SubmitResetPassword */ .zK.SubmitResetPassword, {
                  email: payload.email,
                  newPassword: payload.newPassword,
                  resetToken: payload.nonce.resetToken
                });

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function submitResetPassword(_x4) {
        return _submitResetPassword.apply(this, arguments);
      }

      return submitResetPassword;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5(email, deviceId) {
        var _result$data4;

        var result, _result$data5;

        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.Refresh */ .zK.Refresh, {
                  address: email,
                  deviceId: deviceId
                });

              case 2:
                result = _context5.sent;

                if (result !== null && result !== void 0 && (_result$data4 = result.data) !== null && _result$data4 !== void 0 && _result$data4.accessToken) {
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.AccessToken */ .B.AccessToken, result === null || result === void 0 ? void 0 : (_result$data5 = result.data) === null || _result$data5 === void 0 ? void 0 : _result$data5.accessToken);
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.UserInfo */ .B.UserInfo, JSON.stringify({
                    email: email,
                    deviceUid: deviceId
                  }));
                } else {
                  localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.AccessToken */ .B.AccessToken);
                  localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken);
                }

                return _context5.abrupt("return", result);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function refresh(_x5, _x6) {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "getMessageToWalletSign",
    value: function getMessageToWalletSign(payload) {
      var parsedPayload = {
        address: payload.address // chain_code: 'mainet',
        // chain_type: payload.walletType === WalletType.SOL ? 'solana' : 'evm', // INTERGRATE SOLANA
        // chain_type: 'evm',

      };

      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.WalletLoginPrepare */ .zK.WalletLoginPrepare, parsedPayload);

      return result;
    }
  }, {
    key: "signInByWallet",
    value: function () {
      var _signInByWallet = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee6(payload) {
        var _result$data6;

        var result, _result$data7, _result$data8;

        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.SignInByWallet */ .zK.SignInByWallet, {
                  deviceId: payload.deviceUid,
                  address: payload.address,
                  signature: payload.messageSignature,
                  referralCode: payload.referralCode || ''
                });

              case 2:
                result = _context6.sent;

                if (result !== null && result !== void 0 && (_result$data6 = result.data) !== null && _result$data6 !== void 0 && _result$data6.accessToken) {
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.AccessToken */ .B.AccessToken, result === null || result === void 0 ? void 0 : (_result$data7 = result.data) === null || _result$data7 === void 0 ? void 0 : _result$data7.accessToken);
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken, result === null || result === void 0 ? void 0 : (_result$data8 = result.data) === null || _result$data8 === void 0 ? void 0 : _result$data8.refreshToken);
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.UserInfo */ .B.UserInfo, JSON.stringify({
                    email: payload.address,
                    deviceUid: payload.deviceUid
                  }));
                }

                return _context6.abrupt("return", result);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function signInByWallet(_x7) {
        return _signInByWallet.apply(this, arguments);
      }

      return signInByWallet;
    }()
  }, {
    key: "getTraditionalSignInPrepare",
    value: function getTraditionalSignInPrepare(email) {
      return this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.PrepareTraditionalLogin */ .zK.PrepareTraditionalLogin, {
        email: email
      });
    }
  }, {
    key: "signInByEmail",
    value: function () {
      var _signInByEmail = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee7(payload) {
        var _result$data9;

        var result, _result$data10, _result$data11;

        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.SignInByEmail */ .zK.SignInByEmail, {
                  deviceId: payload.deviceUid,
                  email: payload.email,
                  password: payload.password
                });

              case 2:
                result = _context7.sent;

                if (result !== null && result !== void 0 && (_result$data9 = result.data) !== null && _result$data9 !== void 0 && _result$data9.accessToken) {
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.AccessToken */ .B.AccessToken, result === null || result === void 0 ? void 0 : (_result$data10 = result.data) === null || _result$data10 === void 0 ? void 0 : _result$data10.accessToken);
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken, result === null || result === void 0 ? void 0 : (_result$data11 = result.data) === null || _result$data11 === void 0 ? void 0 : _result$data11.refreshToken);
                  window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.UserInfo */ .B.UserInfo, JSON.stringify({
                    email: payload.email,
                    deviceUid: payload.deviceUid
                  }));
                }

                return _context7.abrupt("return", result);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function signInByEmail(_x8) {
        return _signInByEmail.apply(this, arguments);
      }

      return signInByEmail;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee8(deviceId) {
        var result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.Logout */ .zK.Logout, {
                  deviceId: deviceId
                });

              case 2:
                result = _context8.sent;
                localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.AccessToken */ .B.AccessToken);
                localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken);
                localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .TokenKeyEnum.UserInfo */ .B.UserInfo);
                return _context8.abrupt("return", result);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function logout(_x9) {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }]);

  return AuthenticationService;
}(_HunnyPokerRequest__WEBPACK_IMPORTED_MODULE_5__/* .HunnyPokerRequest */ .y);

/* harmony default export */ __webpack_exports__["Z"] = (new AuthenticationService());

/***/ }),

/***/ 55748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ BaseRequest; },
/* harmony export */   "g": function() { return /* binding */ hunnyAxios; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82262);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config_constants_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25920);
/* harmony import */ var config_constants_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55711);
/* harmony import */ var _mapper_Authenication__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44650);






var hunnyAxios = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
  timeout: 30000
});
hunnyAxios.interceptors.response.use(function (response) {
  try {
    var _response$request, _data$message;

    var originalRequest = response === null || response === void 0 ? void 0 : response.config;
    var data = JSON.parse((response === null || response === void 0 ? void 0 : (_response$request = response.request) === null || _response$request === void 0 ? void 0 : _response$request.response) || '{}');

    if (response.status === 401 && (data === null || data === void 0 ? void 0 : (_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.toLowerCase()) === config_constants_server__WEBPACK_IMPORTED_MODULE_1__/* .MessageResponseServer.unauthorized */ .ty.unauthorized && !(originalRequest !== null && originalRequest !== void 0 && originalRequest._retry)) {
      originalRequest._retry = true;
      var token = localStorage.getItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken);
      var user = JSON.parse(localStorage.getItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.UserInfo */ .B.UserInfo) || '{}');
      if (!token) return response;
      return axios__WEBPACK_IMPORTED_MODULE_0___default()({
        method: 'POST',
        url: "".concat(config_constants_server__WEBPACK_IMPORTED_MODULE_1__/* .BASE_API */ .t3, "api/v1/auth/refresh/"),
        data: {
          address: user.email,
          deviceId: user.deviceUid
        },
        headers: {
          Authorization: "Bearer ".concat(token)
        },
        transformResponse: _mapper_Authenication__WEBPACK_IMPORTED_MODULE_3__/* .LoginResponseMapper */ .J3
      }).then(function (result) {
        var _result$data, _result$data$data;

        var accessToken = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : (_result$data$data = _result$data.data) === null || _result$data$data === void 0 ? void 0 : _result$data$data.accessToken;

        if (accessToken) {
          window.localStorage.setItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.AccessToken */ .B.AccessToken, accessToken);
          originalRequest.headers.Authorization = "Bearer ".concat(accessToken);
          return axios__WEBPACK_IMPORTED_MODULE_0___default()(originalRequest);
        }

        window.location.reload();
        localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.AccessToken */ .B.AccessToken);
        localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken);
        localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.UserInfo */ .B.UserInfo);
      })["catch"](function (error) {
        window.location.reload();
        localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.AccessToken */ .B.AccessToken);
        localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken);
        localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.UserInfo */ .B.UserInfo);
        return error;
      });
    }
  } catch (e) {
    return response;
  }

  return response;
});
var BaseRequest = /*#__PURE__*/function () {
  function BaseRequest() {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, BaseRequest);
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseRequest, [{
    key: "AxiosCancelToken",
    get: function get() {
      var _cancelToken = (axios__WEBPACK_IMPORTED_MODULE_0___default().CancelToken);
      return _cancelToken.source();
    }
  }]);

  return BaseRequest;
}();

/***/ }),

/***/ 68288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45959);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants_server__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25920);
/* harmony import */ var _HunnyPokerRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84055);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50330);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var BonusService = /*#__PURE__*/function (_HunnyPokerRequest) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(BonusService, _HunnyPokerRequest);

  var _super = _createSuper(BonusService);

  function BonusService() {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, BonusService);

    return _super.apply(this, arguments);
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(BonusService, [{
    key: "getUserBonuses",
    value: function getUserBonuses() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      return this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .APIEndpointEnum.UserBonuses */ .zK.UserBonuses, {
        page: page,
        limit: limit
      });
    }
  }, {
    key: "prepareDepositBonus",
    value: function () {
      var _prepareDepositBonus = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(bonusId) {
        var result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .APIEndpointEnum.BonusPrepareDeposit */ .zK.BonusPrepareDeposit, {
                  bonusId: bonusId
                });

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.code === _types__WEBPACK_IMPORTED_MODULE_5__/* .ApiStatusCode.Success */ .qf.Success);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepareDepositBonus(_x) {
        return _prepareDepositBonus.apply(this, arguments);
      }

      return prepareDepositBonus;
    }()
  }, {
    key: "getUserBonusDetails",
    value: function getUserBonusDetails(bonusId) {
      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .APIEndpointEnum.UserBonusDetails */ .zK.UserBonusDetails, {
        bonusId: bonusId
      });

      return result;
    }
  }]);

  return BonusService;
}(_HunnyPokerRequest__WEBPACK_IMPORTED_MODULE_4__/* .HunnyPokerRequest */ .y);

var instance = new BonusService();
/* harmony default export */ __webpack_exports__["Z"] = (instance);

/***/ }),

/***/ 84055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ HunnyPokerRequest; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(27812);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4730);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45959);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37247);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var config_constants_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55711);
/* harmony import */ var config_constants_server__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25920);
/* harmony import */ var utils_sentry__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7737);
/* harmony import */ var utils_toastify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7006);
/* harmony import */ var _BaseRequest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55748);
/* harmony import */ var _mapper_Mapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29901);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50330);









var _excluded = ["excludeErrors"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var HunnyPokerRequest = /*#__PURE__*/function (_BaseRequest) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(HunnyPokerRequest, _BaseRequest);

  var _super = _createSuper(HunnyPokerRequest);

  function HunnyPokerRequest() {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(this, HunnyPokerRequest);

    return _super.apply(this, arguments);
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(HunnyPokerRequest, [{
    key: "_get",
    value: function () {
      var _get2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(url, params, config) {
        var result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _BaseRequest__WEBPACK_IMPORTED_MODULE_8__/* .hunnyAxios.get */ .g.get(url, _objectSpread({
                  params: params
                }, config));

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                (0,utils_sentry__WEBPACK_IMPORTED_MODULE_15__/* .logError */ .H)("GET ".concat(url), _context.t0);
                return _context.abrupt("return", null);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      function _get(_x, _x2, _x3) {
        return _get2.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_post",
    value: function _post(url, payload) {
      var _this = this;

      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var mapperKey = arguments.length > 3 ? arguments[3] : undefined;
      var _source = this.AxiosCancelToken;

      var call = /*#__PURE__*/function () {
        var _ref = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
          var response;
          return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this._request(url, payload, _objectSpread(_objectSpread({}, config), {}, {
                    cancelToken: _source.token
                  }), mapperKey);

                case 2:
                  response = _context2.sent;
                  return _context2.abrupt("return", response);

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function call() {
          return _ref.apply(this, arguments);
        };
      }();

      return {
        call: call,
        cancel: function cancel() {
          _source.cancel();
        }
      };
    }
  }, {
    key: "_request",
    value: function () {
      var _request2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(url, payload) {
        var config,
            mapperKey,
            _result$data,
            _result$data$message,
            mapper,
            _config$excludeErrors,
            excludeErrors,
            axiosConfig,
            token,
            _config,
            result,
            message,
            _args3 = arguments;

        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                config = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                mapperKey = _args3.length > 3 ? _args3[3] : undefined;
                _context3.prev = 2;
                mapper = _mapper_Mapper__WEBPACK_IMPORTED_MODULE_9__/* ["default"].getMapper */ .Z.getMapper(mapperKey || url);
                _config$excludeErrors = config.excludeErrors, excludeErrors = _config$excludeErrors === void 0 ? [] : _config$excludeErrors, axiosConfig = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(config, _excluded);
                token = url === config_constants_server__WEBPACK_IMPORTED_MODULE_6__/* .APIEndpointEnum.Refresh */ .zK.Refresh ? localStorage.getItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_5__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken) : localStorage.getItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_5__/* .TokenKeyEnum.AccessToken */ .B.AccessToken);
                _config = this.buildConfig(_objectSpread(_objectSpread({}, axiosConfig), {}, {
                  headers: _objectSpread({
                    Authorization: token ? "Bearer ".concat(token) : ''
                  }, axiosConfig.headers)
                }), mapper);
                _context3.next = 9;
                return this.callRequest(url, _config, payload);

              case 9:
                result = _context3.sent;

                if ((result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.code) === 'error_country_banned' && window.location.pathname !== '/restriction') {
                  window.location.href = '/restriction';
                } else if (result !== null && result !== void 0 && result.data && result.data.code === 'error_auth_blocked') {
                  window.location.replace('/403');
                } else if (result !== null && result !== void 0 && result.data && result.data.code !== _types__WEBPACK_IMPORTED_MODULE_10__/* .ApiStatusCode.Success */ .qf.Success && ![].concat((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(config_constants_server__WEBPACK_IMPORTED_MODULE_6__/* .EXCLUDE_API_ERROR */ .BH), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(excludeErrors)).includes((_result$data$message = result.data.message) === null || _result$data$message === void 0 ? void 0 : _result$data$message.toLowerCase())) {
                  if (result.data.message && !(config !== null && config !== void 0 && config.disabledToast)) {
                    utils_toastify__WEBPACK_IMPORTED_MODULE_7__/* .HunnyToast.error */ .f.error(result.data.message);
                  }

                  message = "API ".concat(url, " Failed");
                  (0,utils_sentry__WEBPACK_IMPORTED_MODULE_15__/* .logError */ .H)(message, {
                    message: message,
                    extra: {
                      response: result.data,
                      payload: payload
                    },
                    tags: ['api_failed']
                  });
                }

                return _context3.abrupt("return", result === null || result === void 0 ? void 0 : result.data);

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](2);
                if (!axios__WEBPACK_IMPORTED_MODULE_4___default().isCancel(_context3.t0)) (0,utils_sentry__WEBPACK_IMPORTED_MODULE_15__/* .logError */ .H)("CALL ".concat(url), _context3.t0);
                return _context3.abrupt("return", null);

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 14]]);
      }));

      function _request(_x4, _x5) {
        return _request2.apply(this, arguments);
      }

      return _request;
    }()
  }, {
    key: "callRequest",
    value: function () {
      var _callRequest = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4(url, config, payload) {
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", _BaseRequest__WEBPACK_IMPORTED_MODULE_8__/* .hunnyAxios.post */ .g.post(url, payload, _objectSpread(_objectSpread({}, config), {}, {
                  validateStatus: function validateStatus(id) {
                    return id !== 404;
                  }
                })));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function callRequest(_x6, _x7, _x8) {
        return _callRequest.apply(this, arguments);
      }

      return callRequest;
    }()
  }, {
    key: "buildConfig",
    value: function buildConfig(config, mapper) {
      var _config = _objectSpread({
        baseURL:  false ? 0 : config_constants_server__WEBPACK_IMPORTED_MODULE_6__/* .BASE_API */ .t3
      }, config);

      if (mapper) {
        _config = _objectSpread(_objectSpread({}, _config), {}, {
          transformResponse: mapper
        });
      }

      return _config;
    }
  }]);

  return HunnyPokerRequest;
}(_BaseRequest__WEBPACK_IMPORTED_MODULE_8__/* .BaseRequest */ .F);

/***/ }),

/***/ 92847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45959);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants_network__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17961);
/* harmony import */ var config_constants_server__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25920);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25427);
/* harmony import */ var _HunnyPokerRequest__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84055);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var PaymentService = /*#__PURE__*/function (_HunnyPokerRequest) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(PaymentService, _HunnyPokerRequest);

  var _super = _createSuper(PaymentService);

  function PaymentService() {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, PaymentService);

    return _super.apply(this, arguments);
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(PaymentService, [{
    key: "getBalances",
    value: function getBalances() {
      return this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.Balances */ .zK.Balances);
    }
  }, {
    key: "traditionalDeposit",
    value: function traditionalDeposit(_ref) {
      var currency = _ref.currency;

      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.TraditionalDeposit */ .zK.TraditionalDeposit, {
        currency: currency.code,
        network: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .formatToApiNetworkField */ .V0)(config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .ChainIdEnum */ .Li[currency.network])
      });

      return result;
    }
  }, {
    key: "getWithdrawFee",
    value: function getWithdrawFee(_ref2) {
      var amount = _ref2.amount,
          currency = _ref2.currency;

      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.WithdrawFee */ .zK.WithdrawFee, {
        currency: currency.code,
        amount: amount,
        network: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .formatToApiNetworkField */ .V0)(config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .ChainIdEnum */ .Li[currency.network])
      });

      return result;
    }
  }, {
    key: "prepareTraditionalWithdraw",
    value: function prepareTraditionalWithdraw(_ref3) {
      var amount = _ref3.amount,
          currency = _ref3.currency,
          toAddress = _ref3.toAddress;

      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.PrepareTraditionalWithdraw */ .zK.PrepareTraditionalWithdraw, {
        network: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .formatToApiNetworkField */ .V0)(config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .ChainIdEnum */ .Li[currency.network]),
        currency: currency.code,
        amount: amount,
        toAddress: toAddress
      });

      return result;
    }
  }, {
    key: "prepareWalletWithdraw",
    value: function prepareWalletWithdraw(amount, currency) {
      var payload = {
        amount: amount,
        currency: currency.code,
        network: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .formatToApiNetworkField */ .V0)(config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .ChainIdEnum */ .Li[currency.network])
      };

      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.PrepareWalletWithdraw */ .zK.PrepareWalletWithdraw, payload);

      return result;
    }
  }, {
    key: "traditionalWithdraw",
    value: function () {
      var _traditionalWithdraw = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(_ref4) {
        var amount, currency, toAddress, otp, verificationCode, result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                amount = _ref4.amount, currency = _ref4.currency, toAddress = _ref4.toAddress, otp = _ref4.otp, verificationCode = _ref4.verificationCode;
                _context.next = 3;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.TraditionalWithdraw */ .zK.TraditionalWithdraw, {
                  network: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .formatToApiNetworkField */ .V0)(config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .ChainIdEnum */ .Li[currency.network]),
                  currency: currency.code,
                  amount: amount,
                  toAddress: toAddress,
                  verification: {
                    otp: otp,
                    token: verificationCode
                  }
                });

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function traditionalWithdraw(_x) {
        return _traditionalWithdraw.apply(this, arguments);
      }

      return traditionalWithdraw;
    }()
  }, {
    key: "walletWithdraw",
    value: function () {
      var _walletWithdraw = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(currency, amount, sign) {
        var result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.WalletWithdraw */ .zK.WalletWithdraw, {
                  network: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .formatToApiNetworkField */ .V0)(config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .ChainIdEnum */ .Li[currency.network]),
                  currency: currency.code,
                  amount: amount,
                  signature: sign
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function walletWithdraw(_x2, _x3, _x4) {
        return _walletWithdraw.apply(this, arguments);
      }

      return walletWithdraw;
    }()
  }, {
    key: "getWithdrawal",
    value: function getWithdrawal(code) {
      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.WithdrawalTransaction */ .zK.WithdrawalTransaction, {
        ref: Number(code)
      });

      return result;
    }
  }, {
    key: "getWithdrawals",
    value: function getWithdrawals(offset, limit) {
      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.WithdrawalTransactions */ .zK.WithdrawalTransactions, {
        paging: {
          offset: offset,
          limit: limit
        }
      });

      return result;
    }
  }, {
    key: "getTransactionHistory",
    value: function getTransactionHistory(page, limit) {
      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.TransactionHistory */ .zK.TransactionHistory, {
        page: page,
        limit: limit
      });

      return result;
    }
  }, {
    key: "getDeposit",
    value: function getDeposit(hash) {
      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.DepositTransaction */ .zK.DepositTransaction, {
        txnHash: hash
      });

      return result;
    }
  }, {
    key: "getDeposits",
    value: function getDeposits(offset, limit) {
      return this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.DepositTransactions */ .zK.DepositTransactions, {
        paging: {
          offset: offset,
          limit: limit
        }
      });
    }
  }, {
    key: "subscribeDeposit",
    value: function () {
      var _subscribeDeposit = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(chainId, currency) {
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.SubscribeDeposit */ .zK.SubscribeDeposit, {
                  network: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .formatToApiNetworkField */ .V0)(config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .ChainIdEnum */ .Li[chainId]),
                  currency: currency.code
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function subscribeDeposit(_x5, _x6) {
        return _subscribeDeposit.apply(this, arguments);
      }

      return subscribeDeposit;
    }()
  }, {
    key: "subscribeDepositByHash",
    value: function () {
      var _subscribeDepositByHash = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4(currency, chainId, txnHash) {
        var response;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.SubscribeDepositByHash */ .zK.SubscribeDepositByHash, {
                  currency: currency,
                  network: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .formatToApiNetworkField */ .V0)(config_constants_network__WEBPACK_IMPORTED_MODULE_3__/* .ChainIdEnum */ .Li[chainId]),
                  txnHash: txnHash
                });

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", response);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function subscribeDepositByHash(_x7, _x8, _x9) {
        return _subscribeDepositByHash.apply(this, arguments);
      }

      return subscribeDepositByHash;
    }()
  }, {
    key: "queryDepositByHash",
    value: function queryDepositByHash(id) {
      var result = this._post(config_constants_server__WEBPACK_IMPORTED_MODULE_4__/* .APIEndpointEnum.QueryDepositByHash */ .zK.QueryDepositByHash, {
        id: id
      });

      return result;
    }
  }]);

  return PaymentService;
}(_HunnyPokerRequest__WEBPACK_IMPORTED_MODULE_6__/* .HunnyPokerRequest */ .y);

var instance = new PaymentService();
/* harmony default export */ __webpack_exports__["Z"] = (instance);

/***/ }),

/***/ 44650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cp": function() { return /* binding */ ResetPasswordVerificationResponseMapper; },
/* harmony export */   "Cs": function() { return /* binding */ NewPasswordNonceMapper; },
/* harmony export */   "D8": function() { return /* binding */ VerificationResponseMapper; },
/* harmony export */   "E3": function() { return /* binding */ PrepareSignMessageMapper; },
/* harmony export */   "J3": function() { return /* binding */ LoginResponseMapper; },
/* harmony export */   "mK": function() { return /* binding */ RegisterMapper; },
/* harmony export */   "v0": function() { return /* binding */ DeepLinkMapper; },
/* harmony export */   "y3": function() { return /* binding */ PasswordNonceResponseMapper; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77671);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var PrepareSignMessageMapper = function PrepareSignMessageMapper(rawResponse) {
  var response = JSON.parse(rawResponse);
  return {
    code: response.code,
    message: response.message,
    data: response.data && {
      address: response.data.address,
      acceptMessageText: response.data.message,
      acceptMessage: response.data.message
    }
  };
};
var RegisterMapper = function RegisterMapper(rawResponse) {
  var _response$data;

  var response = JSON.parse(rawResponse);
  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.accessToken) && {
      accessToken: response === null || response === void 0 ? void 0 : response.data.accessToken,
      refreshToken: response === null || response === void 0 ? void 0 : response.data.refreshToken
    }
  };
};
var DeepLinkMapper = function DeepLinkMapper(rawResponse) {
  var _response$data2;

  var response = JSON.parse(rawResponse);
  return {
    code: response.code,
    message: response.message,
    data: {
      token: (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.token) || ''
    }
  };
};
var LoginResponseMapper = function LoginResponseMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    errors: response.errors,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      accessToken: response.data.accessToken,
      refreshToken: response.data.refreshToken,
      uid: response.data.uid || null
    }
  };
};
var PasswordNonceResponseMapper = function PasswordNonceResponseMapper(rawResponse) {
  var response = JSON.parse(rawResponse);
  return {
    code: response.code,
    message: response.message,
    errors: [(0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getErrorCodeByMessage */ .tR)(response)],
    data: response.data && _objectSpread({}, parseDataNonce(response.data))
  };
};
var VerificationResponseMapper = function VerificationResponseMapper(rawResponse) {
  var _response$data3, _response$data4;

  var response = JSON.parse(rawResponse);
  return {
    code: response.code,
    message: response.message,
    errors: response.errors,
    data: response.data && {
      expireTime: parseInt(((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.expireTime) || 0, 10),
      nextResendTime: parseInt(((_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.nextResendTime) || 0, 10),
      token: response.data.token
    }
  };
};
var ResetPasswordVerificationResponseMapper = function ResetPasswordVerificationResponseMapper(rawResponse) {
  var response = JSON.parse(rawResponse);
  return {
    code: response.code,
    message: response.message,
    errors: response.errors,
    data: response !== null && response !== void 0 && response.data ? {
      expireTime: parseInt(response.data.expireTime, 10),
      nextResendTime: parseInt(response.data.nextResendTime, 10),
      token: response.data.token
    } : null
  };
};
var NewPasswordNonceMapper = function NewPasswordNonceMapper(rawResponse) {
  var response = JSON.parse(rawResponse);
  return {
    code: response.code,
    message: response.message,
    errors: response.errors,
    data: response.data && _objectSpread(_objectSpread({}, parseDataNonce(response.data)), {}, {
      resetToken: response.data.resetToken
    })
  };
};

var parseDataNonce = function parseDataNonce(data) {
  return {
    id: data.nonceId,
    key: data.nonceId,
    value: data.nonce,
    token: data.token
  };
};

/***/ }),

/***/ 27631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ UserBonusDetailsMapper; },
/* harmony export */   "gC": function() { return /* binding */ parseUserBonus; },
/* harmony export */   "wF": function() { return /* binding */ UserBonusMapper; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var config_types_bonus_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46391);
/* harmony import */ var config_types_bonus_userBonus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95793);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var UserBonusMapper = function UserBonusMapper(rawResponse) {
  var _response$data;

  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      items: (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.map(function (item) {
        return parseUserBonus(item);
      }).filter(function (item) {
        return item;
      })) || []
    }
  };
};
var UserBonusDetailsMapper = function UserBonusDetailsMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: response.data && parseUserBonus(response.data)
  };
};
var parseUserBonus = function parseUserBonus(apiBonus) {
  var bonus = _objectSpread({
    id: apiBonus.bonusId,
    apiStatus: apiBonus.status
  }, parseCommonBonus(apiBonus));

  var buildWageringConditionData = function buildWageringConditionData() {
    return _objectSpread(_objectSpread({}, parseWageringCondition(apiBonus)), {}, {
      currentWager: apiBonus === null || apiBonus === void 0 ? void 0 : apiBonus.currentRakeFeeAmount,
      targetWager: apiBonus === null || apiBonus === void 0 ? void 0 : apiBonus.rakeFeeAmount
    });
  };

  switch (apiBonus.bonusType) {
    case config_types_bonus_index__WEBPACK_IMPORTED_MODULE_1__/* .ApiBonusTypeEnums.DepositBonus */ .dj.DepositBonus:
      return new config_types_bonus_userBonus__WEBPACK_IMPORTED_MODULE_2__/* .DepositBonus */ .Jn(bonus, buildWageringConditionData());

    case config_types_bonus_index__WEBPACK_IMPORTED_MODULE_1__/* .ApiBonusTypeEnums.NoDepositBonus */ .dj.NoDepositBonus:
      return new config_types_bonus_userBonus__WEBPACK_IMPORTED_MODULE_2__/* .NoDepositBonus */ .Oh(bonus, buildWageringConditionData());

    default:
      return null;
  }
};

var parseCommonBonus = function parseCommonBonus(apiBonus) {
  return {
    condition: parseBonusCondition(apiBonus),
    info: parseBonusInfomation(apiBonus)
  };
};

var parseBonusCondition = function parseBonusCondition(apiBonus) {
  return {
    expiryDate: apiBonus.expiredTime
  };
};

var parseBonusInfomation = function parseBonusInfomation(apiBonus) {
  return {
    image: apiBonus.image,
    name: apiBonus.title || '',
    badge: apiBonus.badgeTitle || ''
  };
};

var parseWageringCondition = function parseWageringCondition(apiBonus) {
  return {
    minDeposit: apiBonus.minDeposit,
    rakeFeeRequirement: apiBonus.rakeFeeRequirement,
    activeDurationInDays: apiBonus.playthroughCompletionDuration
  };
};

/***/ }),

/***/ 29901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mapper_Mapper; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/config/constants/server.ts
var server = __webpack_require__(25920);
// EXTERNAL MODULE: ./src/services/mapper/Authenication.ts
var Authenication = __webpack_require__(44650);
// EXTERNAL MODULE: ./src/services/mapper/Bonus.ts
var Bonus = __webpack_require__(27631);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(25427);
// EXTERNAL MODULE: ./src/config/constants/network.ts
var network = __webpack_require__(17961);
// EXTERNAL MODULE: ./src/utils/network.ts
var utils_network = __webpack_require__(71961);
// EXTERNAL MODULE: ./src/config/constants/tokens/index.ts + 11 modules
var tokens = __webpack_require__(99289);
;// CONCATENATED MODULE: ./src/services/mapper/Meta.ts




var MetaDataMapper = function MetaDataMapper(rawResponse) {
  var response = JSON.parse(rawResponse);
  var data = response === null || response === void 0 ? void 0 : response.data;

  if (!response) {
    return {
      code: 'error',
      data: null
    };
  }

  var tokenUSD = {
    network: network/* ChainIdEnum.HPO */.Li.HPO,
    order: 100,
    token: tokens/* default */.Z[network/* ChainIdEnum.HPO */.Li.HPO].USD.code,
    contractAddress: ''
  };
  var tokenUSDB = {
    network: network/* ChainIdEnum.HPO */.Li.HPO,
    order: 100,
    token: tokens/* default */.Z[network/* ChainIdEnum.HPO */.Li.HPO].USDB.code,
    contractAddress: ''
  };
  var tokenInfoes = [tokenUSD, tokenUSDB];
  var networkIds = ['HPO'];
  data === null || data === void 0 ? void 0 : data.wallets.forEach(function (wallet) {
    var networkCode = (0,utils_network/* parseNetworkToApiPoker */.B$)(wallet.network);
    wallet.currencies.forEach(function (currency) {
      tokenInfoes.push({
        network: network/* ChainIdEnum */.Li[(0,utils/* formatApiNetworkField */.Mf)(networkCode, false)],
        order: 1,
        token: currency,
        contractAddress: (wallet === null || wallet === void 0 ? void 0 : wallet.address) || ''
      });
    });
    networkIds.push((0,utils/* formatApiNetworkField */.Mf)(networkCode, false));
  });
  return {
    code: response.code,
    data: {
      serverTime: ((data === null || data === void 0 ? void 0 : data.server_time) || 0) * 1000,
      networkIds: networkIds,
      tokenInfoes: tokenInfoes
    }
  };
};
var TokenInUsdPriceMapper = function TokenInUsdPriceMapper(rawResponse) {
  var response = JSON.parse(rawResponse);
  return response;
};
// EXTERNAL MODULE: ./src/services/mapper/utils.ts
var mapper_utils = __webpack_require__(77671);
;// CONCATENATED MODULE: ./src/services/mapper/Payment.ts




var parseUserBalanceItem = function parseUserBalanceItem(data) {
  return {
    amount: data.balance,
    currency: data.currency,
    network: network/* ChainIdEnum */.Li[(0,utils/* formatApiNetworkField */.Mf)("".concat(data.chain).concat(server/* DEV_MODE */.Sl ? ':TESTNET' : ''), false)]
  };
};
var parseUsdCurrencyItem = function parseUsdCurrencyItem(data) {
  return data.reduce(function (state, item) {
    state[item.currency] = {
      usd: item.price
    };
    return state;
  }, {});
};
var BalanceMapper = function BalanceMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!(response !== null && response !== void 0 && response.data)) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      balances: response.data.balances.map(parseUserBalanceItem),
      tokensPrice: parseUsdCurrencyItem(response.data.tokensPrice)
    }
  };
};
var TraditionalDepositMapper = function TraditionalDepositMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      address: response.data.address,
      minAmount: response.data.minAmount
    }
  };
};
var WithdrawFeeMapper = function WithdrawFeeMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      withdrawFee: response.data.fee
    }
  };
};
var PrepareTraditionalWithdrawMapper = function PrepareTraditionalWithdrawMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      token: response.data.token,
      expireTime: parseInt(response.data.expireTime, 10),
      nextResendTime: parseInt(response.data.nextResendTime, 10)
    }
  };
};
var PrepareWalletWithdrawMapper = function PrepareWalletWithdrawMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      acceptMessage: response.data.message,
      acceptMessageText: response.data.message,
      address: response.data.address
    }
  };
};
var WithdrawMapper = function WithdrawMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      ref: response.data.ref,
      createdAt: (0,mapper_utils/* parseTimeDate */.gS)(response.data.createdAt)
    }
  };
};
var WithdrawalTransactionMapper = function WithdrawalTransactionMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: response !== null && response !== void 0 && response.data ? (0,mapper_utils/* parseWithdrawalTransaction */.we)(response.data) : null
  };
};
var WithdrawalTransactionsMapper = function WithdrawalTransactionsMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      paging: response.data.paging,
      items: response.data.items && response.data.items.map(function (item) {
        return (0,mapper_utils/* parseWithdrawalTransaction */.we)(item);
      })
    }
  };
};
var DepositTransactionMapper = function DepositTransactionMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      paging: response.data.paging,
      items: response.data.items && response.data.items.map(function (item) {
        return (0,mapper_utils/* parseWithdrawalTransaction */.we)(item);
      })
    }
  };
};
var TransactionHistoryMapper = function TransactionHistoryMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      // paging: response.data.paging,
      items: response.data.txns && response.data.txns.map(function (item) {
        return (0,mapper_utils/* parseTransactionHistory */.DO)(item);
      })
    }
  };
};
var DepositTransactionsMapper = function DepositTransactionsMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      items: response.data && response.data.map(function (item) {
        return (0,mapper_utils/* parseDepositTransaction */.cd)(item);
      })
    }
  };
};
var QueryDepositByHashMapper = function QueryDepositByHashMapper(rawResponse) {
  var response = JSON.parse(rawResponse);

  if (!response) {
    return {
      code: 'network_error',
      data: null
    };
  }

  return {
    code: response.code,
    message: response.message,
    data: (response === null || response === void 0 ? void 0 : response.data) && {
      status: response.data.watch.status,
      depositInfo: response.data.deposit ? {
        currency: response.data.deposit.currency,
        network: network/* ChainIdEnum */.Li[(0,utils/* formatApiNetworkField */.Mf)(response.data.deposit.network)],
        value: response.data.deposit.amount,
        status: response.data.deposit.status
      } : null
    }
  };
};
;// CONCATENATED MODULE: ./src/services/mapper/ProfileMapper.ts

var UserProfileMapper = function UserProfileMapper(rawResponse) {
  var _response$data, _response$data2, _response$data3, _response$data4;

  var response = JSON.parse(rawResponse);
  if (!response) return {
    code: 'network_error',
    data: null
  };
  return {
    code: response.code,
    message: response.message,
    data: response.data && {
      address: response.data.address,
      referralCode: response.data.referralCode,
      referralsNumber: response.data.referralsNumber,
      referredBy: response.data.referredBy,
      socketId: response.data.socketId,
      uid: response.data.uID,
      preparedBonusId: ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.preparedBonusId) || null,
      userAvatar: ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.userAvatar) === '1' || !((_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.userAvatar) ? '/images/profile/avatar.png' : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.userAvatar,
      username: response.data.userName,
      balances: response.data.balances.map(parseUserBalanceItem)
    }
  };
};
;// CONCATENATED MODULE: ./src/services/mapper/Mapper.ts










var Mapper = /*#__PURE__*/function () {
  function Mapper() {
    var _defineProperty2;

    (0,classCallCheck/* default */.Z)(this, Mapper);

    (0,defineProperty/* default */.Z)(this, "_mapper", (_defineProperty2 = {}, (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.Meta */.zK.Meta, MetaDataMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.TokenUsdPrices */.zK.TokenUsdPrices, TokenInUsdPriceMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.WalletLoginPrepare */.zK.WalletLoginPrepare, Authenication/* PrepareSignMessageMapper */.E3), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.SignInByWallet */.zK.SignInByWallet, Authenication/* LoginResponseMapper */.J3), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.SignInByEmail */.zK.SignInByEmail, Authenication/* LoginResponseMapper */.J3), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.Refresh */.zK.Refresh, Authenication/* LoginResponseMapper */.J3), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.DeepLink */.zK.DeepLink, Authenication/* DeepLinkMapper */.v0), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.PrepareTraditionalLogin */.zK.PrepareTraditionalLogin, Authenication/* PasswordNonceResponseMapper */.y3), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.Register */.zK.Register, Authenication/* RegisterMapper */.mK), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.SignUpPrepare */.zK.SignUpPrepare, Authenication/* PasswordNonceResponseMapper */.y3), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.VerifyRegisterUser */.zK.VerifyRegisterUser, Authenication/* VerificationResponseMapper */.D8), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.VerifyResetPassword */.zK.VerifyResetPassword, Authenication/* ResetPasswordVerificationResponseMapper */.Cp), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.ValidateResetPassword */.zK.ValidateResetPassword, Authenication/* NewPasswordNonceMapper */.Cs), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.Balances */.zK.Balances, BalanceMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.TraditionalDeposit */.zK.TraditionalDeposit, TraditionalDepositMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.WithdrawFee */.zK.WithdrawFee, WithdrawFeeMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.PrepareTraditionalWithdraw */.zK.PrepareTraditionalWithdraw, PrepareTraditionalWithdrawMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.PrepareWalletWithdraw */.zK.PrepareWalletWithdraw, PrepareWalletWithdrawMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.WalletWithdraw */.zK.WalletWithdraw, WithdrawMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.TraditionalWithdraw */.zK.TraditionalWithdraw, WithdrawMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.WithdrawalTransaction */.zK.WithdrawalTransaction, WithdrawalTransactionMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.WithdrawalTransactions */.zK.WithdrawalTransactions, WithdrawalTransactionsMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.DepositTransaction */.zK.DepositTransaction, DepositTransactionMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.DepositTransactions */.zK.DepositTransactions, DepositTransactionsMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.QueryDepositByHash */.zK.QueryDepositByHash, QueryDepositByHashMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.TransactionHistory */.zK.TransactionHistory, TransactionHistoryMapper), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.UserBonuses */.zK.UserBonuses, Bonus/* UserBonusMapper */.wF), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.UserBonusDetails */.zK.UserBonusDetails, Bonus/* UserBonusDetailsMapper */.bp), (0,defineProperty/* default */.Z)(_defineProperty2, server/* APIEndpointEnum.Profile */.zK.Profile, UserProfileMapper), _defineProperty2));
  }

  (0,createClass/* default */.Z)(Mapper, [{
    key: "getMapper",
    value: function getMapper(url) {
      return this._mapper[url];
    }
  }]);

  return Mapper;
}();

var mapper = new Mapper();
/* harmony default export */ var mapper_Mapper = (mapper);

/***/ }),

/***/ 77671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ parseTransactionHistory; },
/* harmony export */   "cd": function() { return /* binding */ parseDepositTransaction; },
/* harmony export */   "gS": function() { return /* binding */ parseTimeDate; },
/* harmony export */   "tR": function() { return /* binding */ getErrorCodeByMessage; },
/* harmony export */   "we": function() { return /* binding */ parseWithdrawalTransaction; }
/* harmony export */ });
/* unused harmony export parseTimeNumber */
/* harmony import */ var config_constants_network__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17961);
/* harmony import */ var config_types_transaction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38004);
/* harmony import */ var services_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50330);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25427);




var parseWithdrawalTransaction = function parseWithdrawalTransaction(data) {
  return {
    id: data.ref,
    status: data.status === services_types__WEBPACK_IMPORTED_MODULE_2__/* .ApiStatusCode.Success */ .qf.Success ? config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionStatusEnum.Succeeded */ .Zc.Succeeded : config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionStatusEnum.Pending */ .Zc.Pending,
    txnHash: data.txnHash,
    value: data.value,
    createTime: parseTimeDate(data.createdAt),
    currency: data.currency,
    network: config_constants_network__WEBPACK_IMPORTED_MODULE_0__/* .ChainIdEnum */ .Li[(0,utils__WEBPACK_IMPORTED_MODULE_3__/* .formatApiNetworkField */ .Mf)(data.chain)],
    type: config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionTypeEnum.Withdraw */ .bL.Withdraw,
    fee: data.fee
  };
};
var parseDepositTransaction = function parseDepositTransaction(data) {
  return {
    id: data.ref,
    status: data.status === services_types__WEBPACK_IMPORTED_MODULE_2__/* .ApiStatusCode.Success */ .qf.Success ? config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionStatusEnum.Succeeded */ .Zc.Succeeded : config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionStatusEnum.Pending */ .Zc.Pending,
    txnHash: data.txnHash,
    value: data.value,
    createTime: parseTimeDate(data.createdAt),
    currency: data.currency,
    network: config_constants_network__WEBPACK_IMPORTED_MODULE_0__/* .ChainIdEnum */ .Li[(0,utils__WEBPACK_IMPORTED_MODULE_3__/* .formatApiNetworkField */ .Mf)(data.chain)],
    type: config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionTypeEnum.Deposit */ .bL.Deposit,
    fee: data.fee
  };
};
var parseTransactionHistory = function parseTransactionHistory(data) {
  return {
    status: data.status === services_types__WEBPACK_IMPORTED_MODULE_2__/* .ApiStatusCode.Success */ .qf.Success ? config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionStatusEnum.Succeeded */ .Zc.Succeeded : config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionStatusEnum.Pending */ .Zc.Pending,
    txnHash: data.txnHash,
    value: data.value,
    createTime: parseTimeDate(data.createdAt),
    currency: data.currency,
    network: config_constants_network__WEBPACK_IMPORTED_MODULE_0__/* .ChainIdEnum */ .Li[(0,utils__WEBPACK_IMPORTED_MODULE_3__/* .formatApiNetworkField */ .Mf)(data.chain)],
    type: data.txnType === 0 ? config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionTypeEnum.Deposit */ .bL.Deposit : config_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionTypeEnum.Withdraw */ .bL.Withdraw,
    fee: data.fee
  };
};
var parseTimeNumber = function parseTimeNumber(time) {
  return parseInt(time, 10) * 1000;
};
var parseTimeDate = function parseTimeDate(time) {
  return new Date(time).getTime();
};
var getErrorCodeByMessage = function getErrorCodeByMessage(response) {
  if (response.code === 'failed') {
    switch (response.message) {
      case 'The email address already existed':
        return 'error_data_exists';

      default:
        return response.code;
    }
  }
};

/***/ }),

/***/ 37850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": function() { return /* binding */ useConnectedSystem; },
/* harmony export */   "Jo": function() { return /* binding */ useListTokens; },
/* harmony export */   "KT": function() { return /* binding */ useTokenUsdPrice; },
/* harmony export */   "Wq": function() { return /* binding */ useIsInGame; },
/* harmony export */   "Yb": function() { return /* binding */ useListNetworks; },
/* harmony export */   "cl": function() { return /* binding */ useTokenSelected; },
/* harmony export */   "e_": function() { return /* binding */ useAllTokens; },
/* harmony export */   "yK": function() { return /* binding */ useTokenUsdPrices; }
/* harmony export */ });
/* unused harmony export useNetwork */
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27812);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);
/* harmony import */ var config_constants_network__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17961);
/* harmony import */ var config_constants_number__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34418);
/* harmony import */ var config_constants_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99289);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82813);
/* harmony import */ var utils_network__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71961);







 // INTERGRATE SOLANA
// export const useSolNetworkInfo = () => {
//   const networkIds = useAppSelector((state) => state.app.networkIds)
//   const solChain = networkIds?.find((chain) => chain === 'SOL_TESTNET' || chain === 'SOL')
//   return NETWORK_MAP[ChainIdEnum[solChain] || ChainIdEnum.SOL]
// }

var useTokenUsdPrices = function useTokenUsdPrices() {
  var tokens = useAllTokens();
  var tokenUsdPrices = (0,state__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .CG)(function (state) {
    return state.app.tokenUsdPrices;
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () {
    return tokenUsdPrices && tokens && tokens.length > 0 ? tokens.filter(function (token) {
      return token.coinGeckoInfo;
    }).reduce(function (result, token) {
      var _tokenUsdPrices$token, _token$coinGeckoInfo;

      result[token.code] = (_tokenUsdPrices$token = tokenUsdPrices[(_token$coinGeckoInfo = token.coinGeckoInfo) === null || _token$coinGeckoInfo === void 0 ? void 0 : _token$coinGeckoInfo.id]) === null || _tokenUsdPrices$token === void 0 ? void 0 : _tokenUsdPrices$token.usd;
      return result;
    }, {}) : {};
  }, [tokens, tokenUsdPrices]);
};
var useTokenUsdPrice = function useTokenUsdPrice(token) {
  var _tokenUsdPrices$token2;

  var tokenUsdPrices = (0,state__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .CG)(function (state) {
    return state.app.tokenUsdPrices;
  });
  return new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z((tokenUsdPrices === null || tokenUsdPrices === void 0 ? void 0 : (_tokenUsdPrices$token2 = tokenUsdPrices[token.code]) === null || _tokenUsdPrices$token2 === void 0 ? void 0 : _tokenUsdPrices$token2.usd) || config_constants_number__WEBPACK_IMPORTED_MODULE_2__/* .BIG_ZERO */ .HW);
};
var useListNetworks = function useListNetworks(filter) {
  var excludeChains = filter.excludeChains,
      selectChains = filter.selectChains;
  var networkIds = (0,state__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .CG)(function (state) {
    return state.app.networkIds;
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () {
    return networkIds === null || networkIds === void 0 ? void 0 : networkIds.filter(function (network) {
      return !selectChains || selectChains.includes(config_constants_network__WEBPACK_IMPORTED_MODULE_1__/* .ChainIdEnum */ .Li[network]);
    }).filter(function (network) {
      return !excludeChains || !excludeChains.includes(config_constants_network__WEBPACK_IMPORTED_MODULE_1__/* .ChainIdEnum */ .Li[network]);
    }).map(function (network) {
      return config_constants_network__WEBPACK_IMPORTED_MODULE_1__/* .NETWORK_MAP */ .mF[config_constants_network__WEBPACK_IMPORTED_MODULE_1__/* .ChainIdEnum */ .Li[network]];
    });
  }, [excludeChains, networkIds, selectChains]);
};
var useAllTokens = function useAllTokens() {
  var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return true;
  };
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var tokenInfoes = (0,state__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .CG)(function (state) {
    return state.app.tokenInfoes;
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () {
    return tokenInfoes === null || tokenInfoes === void 0 ? void 0 : tokenInfoes.map(function (tokenInfo) {
      var isExist = config_constants_tokens__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[tokenInfo.network] && config_constants_tokens__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[tokenInfo.network][tokenInfo.token];

      if (!isExist) {
        // logError(`token not exist at UI ${tokenInfo.token}-${tokenInfo.network} `, undefined);
        return null;
      }

      return isExist;
    }).filter(function (token) {
      return token;
    }).filter(function (token) {
      return condition(token);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [condition, tokenInfoes].concat((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(dependencies)));
};
var useListTokens = function useListTokens(networkId) {
  var tokenInfoes = useAllTokens(function (token) {
    return !networkId || token.network === networkId;
  }, [networkId]);
  return tokenInfoes;
};
var useNetwork = function useNetwork(chainId) {
  var _getNetworkInfo = getNetworkInfo(chainId),
      network = _getNetworkInfo.network,
      _native = _getNetworkInfo["native"];

  return useMemo(function () {
    return {
      network: network,
      "native": _native
    };
  }, [network, _native]);
};
var useTokenSelected = function useTokenSelected() {
  var selectToken = (0,state__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .CG)(function (state) {
    return state.app.selectToken;
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () {
    return selectToken && config_constants_tokens__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[selectToken.network] && config_constants_tokens__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[selectToken.network][selectToken.token];
  }, [selectToken]);
};
var useConnectedSystem = function useConnectedSystem() {
  var serverTime = (0,state__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .CG)(function (state) {
    return state.app.serverTime;
  });
  return !!serverTime;
};
var useIsInGame = function useIsInGame() {
  var isInGame = (0,state__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .CG)(function (state) {
    return state.app.isInGame;
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () {
    return isInGame;
  }, [isInGame]);
};

/***/ }),

/***/ 71581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gl": function() { return /* binding */ useAuthRefresh; },
/* harmony export */   "Pc": function() { return /* binding */ useUserInfo; },
/* harmony export */   "aC": function() { return /* binding */ useAuth; },
/* harmony export */   "aU": function() { return /* binding */ useLogout; },
/* harmony export */   "jN": function() { return /* binding */ useClientLogout; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55711);
/* harmony import */ var hooks_useActionQueryListener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66064);
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49279);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18132);
/* harmony import */ var services_AuthenticationService__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66475);
/* harmony import */ var services_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50330);
/* harmony import */ var state__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82813);
/* harmony import */ var state_app_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85089);
/* harmony import */ var utils_fingerprint__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44886);
/* harmony import */ var utils_sentry__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7737);
/* harmony import */ var utils_toastify__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7006);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3805);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var useLogout = function useLogout() {
  var deviceUid = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.app.deviceUid;
  });
  var clientLogout = useClientLogout();
  return (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)( /*#__PURE__*/(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
    var isLogout;
    return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return services_AuthenticationService__WEBPACK_IMPORTED_MODULE_6__/* ["default"].logout */ .Z.logout(deviceUid);

          case 2:
            isLogout = _context.sent;

            if ((isLogout === null || isLogout === void 0 ? void 0 : isLogout.code) === services_types__WEBPACK_IMPORTED_MODULE_7__/* .ApiStatusCode.Success */ .qf.Success) {
              clientLogout();
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [clientLogout, deviceUid]);
};
var useClientLogout = function useClientLogout() {
  var dispatch = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppDispatch */ .TL)();
  return (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)( /*#__PURE__*/(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
    return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.AccessToken */ .B.AccessToken);
            localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.RefreshToken */ .B.RefreshToken);
            localStorage.removeItem(config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .TokenKeyEnum.UserInfo */ .B.UserInfo);
            _context2.next = 5;
            return dispatch((0,_action__WEBPACK_IMPORTED_MODULE_12__/* .logout */ .kS)());

          case 5:
            _context2.next = 7;
            return dispatch((0,state_app_actions__WEBPACK_IMPORTED_MODULE_9__/* .setIsSigned */ .vX)({
              isSigned: false
            }));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [dispatch]);
};
var useAuthRefresh = function useAuthRefresh() {
  var dispatch = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppDispatch */ .TL)();
  var deviceUid = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.app.deviceUid;
  });

  var _useUserInfo = useUserInfo(),
      loginBy = _useUserInfo.loginBy,
      address = _useUserInfo.address;

  var logout = useClientLogout();
  var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_4__/* .useRouter */ .t)();
  var email = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.auth.email;
  });
  var wallet = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.auth.wallet;
  });

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var refresh = /*#__PURE__*/function () {
    var _ref3 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3() {
      var _result$data;

      var _deviceUid, result, msg, _result$data2;

      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (address) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              _deviceUid = deviceUid;

              if (_deviceUid) {
                _context3.next = 7;
                break;
              }

              _context3.next = 6;
              return (0,utils_fingerprint__WEBPACK_IMPORTED_MODULE_10__/* .getID */ .V)();

            case 6:
              _deviceUid = _context3.sent;

            case 7:
              _context3.next = 9;
              return services_AuthenticationService__WEBPACK_IMPORTED_MODULE_6__/* ["default"].refresh */ .Z.refresh(address, _deviceUid);

            case 9:
              result = _context3.sent;

              if (!(!result || result.code === 'network_error')) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", logout());

            case 12:
              if (!(!((_result$data = result.data) !== null && _result$data !== void 0 && _result$data.accessToken) || !(loginBy === config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .LoginMethod.Wallet */ .p.Wallet ? wallet : email))) {
                _context3.next = 21;
                break;
              }

              msg = 'Your session expired. Please login again';
              (0,utils_sentry__WEBPACK_IMPORTED_MODULE_15__/* .logError */ .H)(msg, {
                message: msg,
                tags: ['session_expired'],
                extra: {
                  errorCode: result === null || result === void 0 ? void 0 : result.code,
                  isLoginByWallet: loginBy === config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .LoginMethod.Wallet */ .p.Wallet,
                  wallet: wallet,
                  email: email,
                  deviceUid: deviceUid,
                  _deviceUid: _deviceUid
                }
              });
              utils_toastify__WEBPACK_IMPORTED_MODULE_11__/* .HunnyToast.warn */ .f.warn(t(msg));
              _context3.next = 18;
              return logout();

            case 18:
              router.push(_objectSpread(_objectSpread({}, router), {}, {
                query: _objectSpread(_objectSpread({}, router.query), {}, {
                  action: loginBy === config_constants_auth__WEBPACK_IMPORTED_MODULE_2__/* .LoginMethod.Wallet */ .p.Wallet ? hooks_useActionQueryListener__WEBPACK_IMPORTED_MODULE_3__/* .ActionQueryEnum.Login */ .Vt.Login : hooks_useActionQueryListener__WEBPACK_IMPORTED_MODULE_3__/* .ActionQueryEnum.LoginEmail */ .Vt.LoginEmail
                })
              }));
              _context3.next = 26;
              break;

            case 21:
              if (!deviceUid) {
                dispatch((0,state_app_actions__WEBPACK_IMPORTED_MODULE_9__/* .updateDeviceUid */ .Lg)({
                  deviceUid: _deviceUid
                }));
              }

              if (!(result !== null && result !== void 0 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && _result$data2.accessToken)) {
                _context3.next = 26;
                break;
              }

              dispatch((0,_action__WEBPACK_IMPORTED_MODULE_12__/* .updateAuthToken */ .xm)({
                accessToken: result.data.accessToken,
                refreshToken: result.data.refreshToken
              }));
              dispatch((0,state_app_actions__WEBPACK_IMPORTED_MODULE_9__/* .setIsSigned */ .vX)({
                isSigned: true,
                atTime: new Date().getTime()
              }));
              return _context3.abrupt("return", true);

            case 26:
              return _context3.abrupt("return", false);

            case 27:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function refresh() {
      return _ref3.apply(this, arguments);
    };
  }();

  return refresh;
};
var useAuth = function useAuth() {
  var _useUserInfo2 = useUserInfo(),
      loginBy = _useUserInfo2.loginBy,
      uid = _useUserInfo2.uid,
      username = _useUserInfo2.username,
      hasSession = _useUserInfo2.hasSession,
      accessToken = _useUserInfo2.accessToken,
      refreshToken = _useUserInfo2.refreshToken;

  var signedAtTime = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.app.signedAtTime;
  });
  var isSigned = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.app.isSigned;
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function () {
    return {
      isSigned: isSigned,
      username: username,
      uid: uid,
      loginBy: loginBy,
      hasSession: hasSession,
      signedAtTime: signedAtTime,
      accessToken: accessToken,
      refreshToken: refreshToken
    };
  }, [isSigned, username, uid, loginBy, hasSession, signedAtTime, accessToken, refreshToken]);
};
var useUserInfo = function useUserInfo() {
  var loginBy = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.auth.loginBy;
  });
  var uid = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.auth.uid;
  });
  var username = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.auth.username;
  });
  var address = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.auth.address;
  });
  var accessToken = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.auth.accessToken;
  });
  var refreshToken = (0,state__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function (state) {
    return state.auth.refreshToken;
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function () {
    return {
      username: username,
      uid: uid,
      loginBy: loginBy,
      address: address,
      hasSession: username && uid && address,
      accessToken: accessToken,
      refreshToken: refreshToken
    };
  }, [username, uid, loginBy, address, accessToken, refreshToken]);
};

/***/ }),

/***/ 2309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SL": function() { return /* binding */ useActivatedBonusesUpdater; },
  "GN": function() { return /* binding */ useDisplayBonusName; },
  "Jc": function() { return /* binding */ useUserBonus; }
});

// UNUSED EXPORTS: BonusActionTypeEnums, buildBonusName

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/config/types/bonus/index.ts
var types_bonus = __webpack_require__(46391);
// EXTERNAL MODULE: ./src/config/types/bonus/userBonus.ts
var userBonus = __webpack_require__(95793);
// EXTERNAL MODULE: ./src/hooks/useModal.ts
var useModal = __webpack_require__(13911);
// EXTERNAL MODULE: ./src/hooks/usePrivateSocket.ts + 2 modules
var usePrivateSocket = __webpack_require__(56600);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/services/BonusService.ts
var BonusService = __webpack_require__(68288);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var hooks = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./src/components/Modal/index.ts + 2 modules
var Modal = __webpack_require__(67498);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(89395);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx + 3 modules
var Image = __webpack_require__(15967);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx + 1 modules
var Text = __webpack_require__(50011);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 3 modules
var Trans = __webpack_require__(93955);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/hooks/usePlayGame.tsx
var usePlayGame = __webpack_require__(90963);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Payment/components/Deposit/DepositedActiveBonusModal.tsx














var DepositedActiveBonusModal = function DepositedActiveBonusModal(_ref) {
  var _bonus$info;

  var onDismiss = _ref.onDismiss,
      bonus = _ref.data.bonus;
  var handlePlayGame = (0,usePlayGame/* usePlayGame */.y)();
  var closeAllModal = (0,useModal/* useCloseAllModal */.F)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledModal, {
    onDismiss: onDismiss,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledModalBody, {
      borderRadius: "0px",
      height: "100%",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          width: "130px",
          height: "120px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/images/bonusCenter/gift-header-title.png",
            width: 300,
            height: 300
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          mt: "20px",
          fontWeight: "700",
          fontSize: "20px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Bonus Activated!"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
          fontSize: "14px",
          fontWeight: "400",
          color: "textSubtle",
          mt: "8px",
          textAlign: "center",
          maxWidth: "320px",
          marginX: "auto",
          lineHeight: "17.07px",
          children: ["Your bonus", /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "text",
            mx: "4px",
            bold: true,
            fontSize: "inherit",
            display: "inline !important",
            children: (bonus === null || bonus === void 0 ? void 0 : (_bonus$info = bonus.info) === null || _bonus$info === void 0 ? void 0 : _bonus$info.name) || ' '
          }), "has been activated"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        maxWidth: "290px",
        mx: "auto",
        width: "100%",
        mt: "24px",
        onClick: function onClick() {
          handlePlayGame();
          onDismiss();
          closeAllModal();
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          small: true,
          bold: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Check bonus"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        variant: "text",
        maxWidth: "290px",
        mx: "auto",
        width: "100%",
        mt: "4px",
        onClick: onDismiss,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          small: true,
          bold: true,
          color: "textSubtle",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Close"
          })
        })
      })]
    })
  });
};

var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
  displayName: "DepositedActiveBonusModal__StyledModal",
  componentId: "sc-vjrrbp-0"
})(["\n  padding: 24px;\n\n  ", " {\n    min-width: 360px !important;\n    max-width: 360px !important;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueries.sm;
});
var StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(Modal/* ModalBody */.fe).withConfig({
  displayName: "DepositedActiveBonusModal__StyledModalBody",
  componentId: "sc-vjrrbp-1"
})(["\n  overflow-y: unset !important;\n"]);
/* harmony default export */ var Deposit_DepositedActiveBonusModal = (DepositedActiveBonusModal);
// EXTERNAL MODULE: ./src/services/mapper/Bonus.ts
var Bonus = __webpack_require__(27631);
// EXTERNAL MODULE: ./src/state/bonus/actions.ts
var actions = __webpack_require__(37130);
;// CONCATENATED MODULE: ./src/state/bonus/hooks.ts















var useUserBonus = function useUserBonus() {
  var dispatch = (0,state/* useAppDispatch */.TL)();

  var _useAppSelector = (0,state/* useAppSelector */.CG)(function (state) {
    return state.bonus;
  }),
      bonuses = _useAppSelector.userBonuses,
      preparedBonusId = _useAppSelector.preparedBonusId;

  var fetchBonuses = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _result$data, _result$data3;

    var result, _result$data2;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return BonusService/* default.getUserBonuses */.Z.getUserBonuses(1, 10).call();

          case 2:
            result = _context.sent;

            if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.items) {
              dispatch((0,actions/* updateUserBonuses */.fh)({
                userBonuses: result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.items
              }));
            }

            return _context.abrupt("return", (result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.items) || []);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [dispatch]);
  return {
    bonuses: bonuses || [],
    fetchBonuses: fetchBonuses,
    preparedBonusId: preparedBonusId
  };
};
var useActivatedBonusesUpdater = function useActivatedBonusesUpdater() {
  var _useAuth = (0,hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned;

  var _useUserBonus = useUserBonus(),
      fetchBonuses = _useUserBonus.fetchBonuses;

  var socket = (0,usePrivateSocket/* usePrivateSocket */.G)();

  var _useModal = (0,useModal/* default */.Z)(Deposit_DepositedActiveBonusModal),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      presentDepositedActiveBonusModal = _useModal2[0];

  (0,react.useEffect)(function () {
    if (!isSigned || !socket) {
      return;
    }

    socket.on('DepositBonusActivated', /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (data) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                fetchBonuses();
                presentDepositedActiveBonusModal({
                  bonus: (0,Bonus/* parseUserBonus */.gC)(data)
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    return function () {
      if (socket) {
        socket.off('DepositBonusActivated');
      }
    };
  }, [fetchBonuses, isSigned, presentDepositedActiveBonusModal, socket]);
};
var BonusActionTypeEnums;

(function (BonusActionTypeEnums) {
  BonusActionTypeEnums["Deposit"] = "deposit";
  BonusActionTypeEnums["Active"] = "active";
  BonusActionTypeEnums["Register"] = "resgister";
  BonusActionTypeEnums["Use"] = "use";
  BonusActionTypeEnums["Play"] = "play";
  BonusActionTypeEnums["Claim"] = "claim";
})(BonusActionTypeEnums || (BonusActionTypeEnums = {}));

var buildBonusName = function buildBonusName(t, bonus) {
  if (!bonus) return ['', ''];

  if (bonus instanceof userBonus/* DepositBonus */.Jn || bonus instanceof types_bonus/* DepositCommonBonus */.FF) {
    return [t('{{percent}} on the deposit', {
      percent: "".concat(bonus.percent, "%")
    }), t('Deposit bonus')];
  } // if (bonus instanceof NoDepositBonus || bonus instanceof NoDepositCommonBonus) {
  //   return [
  //     t('Receive {{amount}} {{currency}}', {
  //       amount: bonus.bonusAmount?.amount.toString(),
  //       currency: bonus.bonusAmount?.token?.code,
  //     }),
  //     t('{{currency}} bonus', {
  //       currency: bonus.bonusAmount?.token?.code,
  //     }),
  //   ];
  // }


  return ['', ''];
};
var useDisplayBonusName = function useDisplayBonusName(bonus) {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return (0,react.useMemo)(function () {
    return buildBonusName(t, bonus);
  }, [bonus, t]);
};

/***/ }),

/***/ 57534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hv": function() { return /* binding */ useHandleFetchUserBalance; },
  "ZC": function() { return /* binding */ usePollUserBalances; },
  "yi": function() { return /* binding */ usePollUserProfile; },
  "P$": function() { return /* binding */ useProfileInfo; },
  "bH": function() { return /* binding */ useTokenAppBalance; },
  "w1": function() { return /* binding */ useTokenAppBalances; },
  "tW": function() { return /* binding */ useTokenWalletBalance; },
  "h7": function() { return /* binding */ useUpdateUserToken; }
});

// UNUSED EXPORTS: useTokenWalletBalances

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/config/constants/auth.ts
var auth = __webpack_require__(55711);
// EXTERNAL MODULE: ./src/hooks/useFetchUserProfile.tsx + 2 modules
var useFetchUserProfile = __webpack_require__(54040);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(58491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./src/state/app/actions.ts
var actions = __webpack_require__(85089);
// EXTERNAL MODULE: ./src/state/app/hooks.ts
var hooks = __webpack_require__(37850);
// EXTERNAL MODULE: ./src/state/auth/action.ts
var action = __webpack_require__(3805);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var auth_hooks = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/state/bonus/hooks.ts + 1 modules
var bonus_hooks = __webpack_require__(2309);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(25427);
// EXTERNAL MODULE: ./src/utils/infura.ts + 2 modules
var infura = __webpack_require__(90802);
// EXTERNAL MODULE: ./src/utils/requestHelper.ts
var requestHelper = __webpack_require__(75391);
// EXTERNAL MODULE: ./src/utils/token.ts
var token = __webpack_require__(69961);
// EXTERNAL MODULE: ./src/state/profile/actions.ts
var profile_actions = __webpack_require__(3176);
// EXTERNAL MODULE: ./src/services/PaymentService.ts
var PaymentService = __webpack_require__(92847);
;// CONCATENATED MODULE: ./src/state/profile/calls/fetchUserBalances.ts



var fetchUserBalances = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", PaymentService/* default.getBalances */.Z.getBalances().call());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchUserBalances() {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/state/profile/hooks.ts




















var useHandleFetchUserBalance = function useHandleFetchUserBalance() {
  var dispatch = (0,state/* useAppDispatch */.TL)();
  return (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var results;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchUserBalances();

          case 2:
            results = _context.sent;

            if (results !== null && results !== void 0 && results.data) {
              dispatch((0,profile_actions/* updateBalances */.J)({
                data: results.data.balances
              }));
              dispatch((0,actions/* updateTokenUsdPrices */.ux)({
                data: results.data.tokensPrice
              }));
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [dispatch]);
};
var usePollUserBalances = function usePollUserBalances() {
  var _useAuth = (0,auth_hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned;

  var handleFetchUserBalances = useHandleFetchUserBalance();
  (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function () {
    if (!isSigned) return;
    handleFetchUserBalances();
  }, [isSigned]); // useEffect(() => {
  //   if (!isSigned || !socket) {
  //     return;
  //   }
  //   socket.on('balance.changed', (data) => {
  //     const balance: BalanceResponse = {
  //       amount: data.after_balance,
  //       currency: data.currency,
  //       network: ChainIdEnum[formatApiNetworkField(data.network)],
  //     };
  //     dispatch(updateBalances({ data: [balance] }));
  //   });
  //   return () => {
  //     if (socket) {
  //       socket.off('balance.changed');
  //     }
  //   };
  // }, [isSigned, socket]);
};
var usePollUserProfile = function usePollUserProfile() {
  var dispatch = (0,state/* useAppDispatch */.TL)();

  var _useAuth2 = (0,auth_hooks/* useAuth */.aC)(),
      isSigned = _useAuth2.isSigned,
      loginBy = _useAuth2.loginBy;

  var fetchUserInfo = (0,useFetchUserProfile/* useFetchUserProfile */.Q)();

  var _useUserBonus = (0,bonus_hooks/* useUserBonus */.Jc)(),
      fetchBonuses = _useUserBonus.fetchBonuses;

  (0,react.useEffect)(function () {
    if (!isSigned) return;

    var fetch = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var result;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchUserInfo();

              case 2:
                result = _context2.sent;

                if (result) {
                  dispatch((0,action/* login */.x4)({
                    uid: result.uid,
                    username: result.username,
                    address: result.address,
                    email: loginBy === auth/* LoginMethod.Wallet */.p.Wallet ? '' : result.address
                  }));
                  fetchBonuses();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetch() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetch(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, fetchBonuses, fetchUserInfo, isSigned]);
};
var useUpdateUserToken = function useUpdateUserToken() {
  var dispatch = (0,state/* useAppDispatch */.TL)();
  var wallet = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth.wallet;
  });
  var supportedTokens = (0,hooks/* useListTokens */.Jo)();
  var selectedToken = (0,hooks/* useTokenSelected */.cl)();

  var _useAuth3 = (0,auth_hooks/* useAuth */.aC)(),
      isSigned = _useAuth3.isSigned;

  (0,react.useEffect)(function () {
    if (!isSigned || supportedTokens.length <= 0) return; // INTERGRATE SOLANA
    // if (wallet?.type === WalletType.SOL) {
    //   if (!selectedToken || !isSolToken(selectedToken)) {
    //     const token = supportedTokens.find(
    //       (token) => token.network === ChainIdEnum.SOL || token.network === ChainIdEnum.SOL_TESTNET,
    //     )
    //     dispatch(selectPlayBalance({ token }))
    //   }
    // } else {

    if (!selectedToken || (0,token/* isSolToken */.z)(selectedToken)) {
      dispatch((0,actions/* selectPlayBalance */.iZ)({
        token: supportedTokens[0]
      }));
    } // }
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isSigned, wallet]);
};
var useProfileInfo = function useProfileInfo() {
  var profile = (0,state/* useAppSelector */.CG)(function (state) {
    return state.profile;
  });
  return (0,react.useMemo)(function () {
    return profile;
  }, [profile]);
};
var useTokenWalletBalance = function useTokenWalletBalance(token, address) {
  var tokens = (0,react.useMemo)(function () {
    return [token];
  }, [token]);

  var _useTokenWalletBalanc = useTokenWalletBalances(tokens, address),
      _useTokenWalletBalanc2 = (0,slicedToArray/* default */.Z)(_useTokenWalletBalanc, 1),
      tokenBalance = _useTokenWalletBalanc2[0];

  return (0,react.useMemo)(function () {
    return tokenBalance;
  }, [tokenBalance]);
};
var useTokenWalletBalances = function useTokenWalletBalances(tokens, address) {
  var _useState = (0,react.useState)([]),
      tokenBalances = _useState[0],
      setTokenBalances = _useState[1];

  (0,react.useEffect)(function () {
    if (!tokens || !address) return;

    var fetch = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        var getTokenBalanceRequests, tokenBalances;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                getTokenBalanceRequests = tokens.map(function (token) {
                  return (0,infura/* getCurrencyBalance */.CP)(token, address);
                });
                _context3.next = 3;
                return (0,requestHelper/* forkjoinRequest */.Rm)(getTokenBalanceRequests);

              case 3:
                tokenBalances = _context3.sent;
                if (tokenBalances) setTokenBalances(tokenBalances);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetch() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetch();
    var interval = setInterval(fetch, 10000);
    return function () {
      clearInterval(interval);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokens, address]);
  return (0,react.useMemo)(function () {
    return tokenBalances;
  }, [tokenBalances]);
};
var useTokenAppBalance = function useTokenAppBalance(token) {
  var amounts = useTokenAppBalances([token]);
  return (0,react.useMemo)(function () {
    return amounts[0];
  }, [amounts]);
};
var useTokenAppBalances = function useTokenAppBalances(tokens) {
  var tokenBalances = (0,state/* useAppSelector */.CG)(function (state) {
    return state.profile.balances;
  });
  return (0,react.useMemo)(function () {
    if (!tokens) return [];
    return tokens.filter(function (token) {
      return token;
    }).map(function (token) {
      var tokenBalance = tokenBalances[(0,utils/* getBalanceTokenKey */.D$)(token.network, token.code)];
      return {
        amount: new bignumber/* default */.Z(tokenBalance || 0),
        token: token
      };
    });
  }, [tokenBalances, tokens]);
};

/***/ }),

/***/ 89030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YQ": function() { return /* binding */ useAddDepositTransaction; },
  "M2": function() { return /* binding */ useAddWithdrawTransaction; },
  "aA": function() { return /* binding */ usePollPendingTransaction; }
});

// UNUSED EXPORTS: useTransactionCodeWithdraw, useTransactionHashDeposit

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./src/components/Text/index.ts
var Text = __webpack_require__(19500);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 3 modules
var Trans = __webpack_require__(93955);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(79534);
// EXTERNAL MODULE: ./src/svgs/index.ts + 103 modules
var svgs = __webpack_require__(8400);
// EXTERNAL MODULE: ./src/theme/colors.ts
var colors = __webpack_require__(72959);
// EXTERNAL MODULE: ./src/theme/index.ts
var theme = __webpack_require__(57214);
// EXTERNAL MODULE: ./src/components/TokenLogo/index.tsx
var TokenLogo = __webpack_require__(62068);
// EXTERNAL MODULE: ./src/config/types/transaction.ts
var types_transaction = __webpack_require__(38004);
// EXTERNAL MODULE: ./src/config/constants/tokens/index.ts + 11 modules
var tokens = __webpack_require__(99289);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/TransactionToast/PendingTransaction.tsx
















var PendingTransaction = function PendingTransaction(_ref) {
  var transaction = _ref.transaction;
  var token = tokens/* default */.Z[transaction.network][transaction.currency];
  var displayAmount = (0,formatBalance/* getFullDisplayBalance */.NJ)(new bignumber/* default */.Z(transaction.value).minus(transaction.fee || 0), 0, 5);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    minWidth: "250px",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        mr: "12px",
        height: "100%",
        padding: "6px",
        border: "1px solid ".concat(colors/* colors.info */.O.info),
        background: "".concat(colors/* colors.info */.O.info, "33"),
        borderRadius: theme/* default.radii.tiny */.Z.radii.tiny,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.HourGlassIcon */.P.HourGlassIcon, {
          height: "24px",
          fill: colors/* colors.info */.O.info
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          color: "info",
          fontSize: "16px",
          bold: true,
          children: transaction.type === types_transaction/* TransactionTypeEnum.Deposit */.bL.Deposit ? /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Your Deposit processing"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Your withdrawal processing"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
          mt: "4px",
          alignItems: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TokenLogo/* default */.Z, {
            token: token,
            width: "20px"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
            ml: "6px",
            fontSize: "14px",
            children: [displayAmount, " ", token.name]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var TransactionToast_PendingTransaction = (PendingTransaction);
;// CONCATENATED MODULE: ./src/components/TransactionToast/CompletedTransaction.tsx
















var CompletedTransaction = function CompletedTransaction(_ref) {
  var transaction = _ref.transaction;
  var token = tokens/* default */.Z[transaction.network][transaction.currency];
  var displayAmount = (0,formatBalance/* getFullDisplayBalance */.NJ)(new bignumber/* default */.Z(transaction.value), 0, 5);
  var color = transaction.status === types_transaction/* TransactionStatusEnum.Succeeded */.Zc.Succeeded ? colors/* colors.success */.O.success : colors/* colors.error */.O.error;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    minWidth: "250px",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        mr: "12px",
        height: "100%",
        padding: "6px",
        border: "1px solid ".concat(color),
        background: "".concat(color, "33"),
        borderRadius: theme/* default.radii.tiny */.Z.radii.tiny,
        children: transaction.status === types_transaction/* TransactionStatusEnum.Succeeded */.Zc.Succeeded ? /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.SuccessCheckIcon */.P.SuccessCheckIcon, {
          height: "24px",
          fill: color
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.ClearIcon */.P.ClearIcon, {
          height: "24px",
          fill: color
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          color: "success",
          fontSize: "16px",
          bold: true,
          children: transaction.type === types_transaction/* TransactionTypeEnum.Deposit */.bL.Deposit ? /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Deposit confirmed!"
          }) : transaction.status === types_transaction/* TransactionStatusEnum.Succeeded */.Zc.Succeeded ? /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Withdraw compeleted!"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Withdraw failed!"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
          mt: "4px",
          alignItems: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TokenLogo/* default */.Z, {
            token: token,
            width: "20px"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
            ml: "6px",
            fontSize: "14px",
            children: [displayAmount, " ", token.name]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var TransactionToast_CompletedTransaction = (CompletedTransaction);
// EXTERNAL MODULE: ./src/hooks/usePrivateSocket.ts + 2 modules
var usePrivateSocket = __webpack_require__(56600);
// EXTERNAL MODULE: ./src/services/mapper/utils.ts
var utils = __webpack_require__(77671);
// EXTERNAL MODULE: ./src/services/PaymentService.ts
var services_PaymentService = __webpack_require__(92847);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var hooks = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/utils/toastify.tsx
var toastify = __webpack_require__(7006);
// EXTERNAL MODULE: ./src/utils/transaction.ts
var utils_transaction = __webpack_require__(54458);
// EXTERNAL MODULE: ./src/state/profile/hooks.ts + 1 modules
var profile_hooks = __webpack_require__(57534);
// EXTERNAL MODULE: ./src/state/transaction/action.ts
var action = __webpack_require__(77046);
;// CONCATENATED MODULE: ./src/state/transaction/hooks.tsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */















var usePollPendingTransaction = function usePollPendingTransaction() {
  var dispatch = (0,state/* useAppDispatch */.TL)();

  var _useAuth = (0,hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned,
      hasSession = _useAuth.hasSession;

  var handleFetchUserBalance = (0,profile_hooks/* useHandleFetchUserBalance */.Hv)();
  var toastIdsRef = (0,react.useRef)([]);
  var socket = (0,usePrivateSocket/* usePrivateSocket */.G)();
  var pendingWithdrawTransactionCode = (0,state/* useAppSelector */.CG)(function (state) {
    return state.transaction.pendingWithdrawTransactionCode || [];
  });
  var pendingDepositTransactionHash = (0,state/* useAppSelector */.CG)(function (state) {
    return state.transaction.pendingDepositTransactionHash;
  });
  (0,react.useEffect)(function () {
    if (!isSigned) {
      if (!hasSession && (pendingWithdrawTransactionCode.length || pendingDepositTransactionHash.length)) {
        dispatch((0,action/* clearPendingTransaction */.Fi)());
      }
    }
  }, [pendingWithdrawTransactionCode, pendingDepositTransactionHash, isSigned, hasSession, dispatch]); // TODO review it

  (0,react.useEffect)(function () {
    if (!isSigned) return;
    var newPendingWithdrawCodes = pendingWithdrawTransactionCode.filter(function (code) {
      return !toastIdsRef.current.includes(code);
    });

    if (newPendingWithdrawCodes.length) {
      newPendingWithdrawCodes.forEach( /*#__PURE__*/function () {
        var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(transaction) {
          var _response$data;

          var txnHash, response;
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  txnHash = transaction.txnHash;
                  _context.next = 3;
                  return services_PaymentService/* default.getWithdrawal */.Z.getWithdrawal(txnHash).call();

                case 3:
                  response = _context.sent;

                  if (response !== null && response !== void 0 && response.data && response.data.status === types_transaction/* TransactionStatusEnum.Pending */.Zc.Pending) {
                    handleFetchUserBalance();
                    (0,toastify/* showToast */.C)( /*#__PURE__*/(0,jsx_runtime.jsx)(TransactionToast_PendingTransaction, {
                      transaction: _objectSpread(_objectSpread({}, response.data), {}, {
                        fee: '0'
                      })
                    }), {
                      autoClose: false,
                      toastId: txnHash,
                      onClose: function onClose() {
                        dispatch((0,action/* removePendingWithdrawTransaction */.Ln)({
                          code: txnHash
                        }));
                      }
                    });
                  } else if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === types_transaction/* TransactionStatusEnum.Succeeded */.Zc.Succeeded) {
                    handleFetchUserBalance();
                    dispatch((0,action/* removePendingWithdrawTransaction */.Ln)({
                      code: txnHash
                    }));
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      toastIdsRef.current = [].concat((0,toConsumableArray/* default */.Z)(toastIdsRef.current), (0,toConsumableArray/* default */.Z)(newPendingWithdrawCodes));
    }
  }, [pendingWithdrawTransactionCode, isSigned, handleFetchUserBalance, dispatch]); // TODO review it

  (0,react.useEffect)(function () {
    if (!isSigned) return;
    var newPendingDepositHashs = pendingDepositTransactionHash.filter(function (hash) {
      return !toastIdsRef.current.includes(hash);
    });

    if (newPendingDepositHashs.length) {
      newPendingDepositHashs.forEach( /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(transaction) {
          var _response$data2;

          var txnHash, _getDepositHashInfo, hash, response;

          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  txnHash = transaction.txnHash;

                  if (txnHash) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt("return");

                case 3:
                  _getDepositHashInfo = (0,utils_transaction/* getDepositHashInfo */.y)(txnHash), hash = _getDepositHashInfo.hash;
                  _context2.next = 6;
                  return services_PaymentService/* default.getDeposit */.Z.getDeposit(hash).call();

                case 6:
                  response = _context2.sent;

                  if (response && !response.data) {
                    handleFetchUserBalance();
                    (0,toastify/* showToast */.C)( /*#__PURE__*/(0,jsx_runtime.jsx)(TransactionToast_PendingTransaction, {
                      transaction: transaction
                    }), {
                      autoClose: false,
                      toastId: txnHash,
                      onClose: function onClose() {
                        dispatch((0,action/* removePendingDepositTransaction */.b0)({
                          hash: txnHash
                        }));
                      }
                    });
                  } else if ((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.status) === types_transaction/* TransactionStatusEnum.Succeeded */.Zc.Succeeded) {
                    handleFetchUserBalance();
                    dispatch((0,action/* removePendingDepositTransaction */.b0)({
                      hash: txnHash
                    }));
                  }

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
      toastIdsRef.current = [].concat((0,toConsumableArray/* default */.Z)(toastIdsRef.current), (0,toConsumableArray/* default */.Z)(newPendingDepositHashs));
    }
  }, [pendingDepositTransactionHash, isSigned, handleFetchUserBalance, dispatch]);
  (0,react.useEffect)(function () {
    var removedPendingTxnCodes = toastIdsRef.current.filter(function (code) {
      return !pendingWithdrawTransactionCode.includes(code);
    });

    if (removedPendingTxnCodes.length) {
      removedPendingTxnCodes.forEach(function (code) {
        toastify/* HunnyToast.dismiss */.f.dismiss(code.txnHash);
      });
    }
  }, [pendingWithdrawTransactionCode]);
  (0,react.useEffect)(function () {
    var removedPendingDepositHash = toastIdsRef.current.filter(function (code) {
      return !pendingDepositTransactionHash.includes(code);
    });

    if (removedPendingDepositHash.length) {
      removedPendingDepositHash.forEach(function (hash) {
        toastify/* HunnyToast.dismiss */.f.dismiss(hash.txnHash);
      });
    }
  }, [pendingDepositTransactionHash]);
  (0,react.useEffect)(function () {
    if (!isSigned || !socket) {
      return;
    }

    socket.on('Withdrawal', function (data) {
      if (data) {
        var transaction = (0,utils/* parseWithdrawalTransaction */.we)(data);
        dispatch((0,action/* removePendingWithdrawTransaction */.Ln)({
          code: transaction.id.toString()
        }));
        handleFetchUserBalance();
        (0,toastify/* showToast */.C)( /*#__PURE__*/(0,jsx_runtime.jsx)(TransactionToast_CompletedTransaction, {
          transaction: transaction
        }), {}, 'success');
      }
    });
    return function () {
      if (socket) {
        socket.off('Withdrawal');
      }
    };
  }, [dispatch, handleFetchUserBalance, isSigned, socket]);
  (0,react.useEffect)(function () {
    if (!isSigned || !socket) {
      return;
    }

    socket.on('Deposit', function (data) {
      if (data) {
        var transaction = (0,utils/* parseDepositTransaction */.cd)(data);
        var token = tokens/* default */.Z[transaction.network][transaction.currency];
        dispatch((0,action/* removePendingDepositTransaction */.b0)({
          hash: (0,utils_transaction/* combineDepositHash */.U)(transaction.txnHash, token)
        }));
        handleFetchUserBalance();
        (0,toastify/* showToast */.C)( /*#__PURE__*/(0,jsx_runtime.jsx)(TransactionToast_CompletedTransaction, {
          transaction: transaction
        }), {}, 'success');
      }
    });
    return function () {
      if (socket) {
        socket.off('Deposit');
      }
    };
  }, [dispatch, handleFetchUserBalance, isSigned, socket]);
};
var useAddDepositTransaction = function useAddDepositTransaction() {
  var dispatch = (0,state/* useAppDispatch */.TL)();
  return (0,react.useCallback)(function (transaction, token, amount) {
    dispatch((0,action/* addPendingDepositTransaction */.wB)({
      id: transaction.blockNumber,
      status: types_transaction/* TransactionStatusEnum.Pending */.Zc.Pending,
      currency: token.code,
      txnHash: (0,utils_transaction/* combineDepositHash */.U)(transaction.hash, token),
      value: amount,
      createTime: Date.now(),
      network: token.network,
      type: types_transaction/* TransactionTypeEnum.Deposit */.bL.Deposit,
      fee: '0'
    }));
  }, [dispatch]);
};
var useAddWithdrawTransaction = function useAddWithdrawTransaction() {
  var dispatch = (0,state/* useAppDispatch */.TL)();
  return (0,react.useCallback)(function (txnCode, token, amount, fee) {
    dispatch((0,action/* addPendingWithdrawTransaction */.y9)({
      id: Date.now(),
      status: types_transaction/* TransactionStatusEnum.Pending */.Zc.Pending,
      currency: token.code,
      txnHash: txnCode,
      value: amount,
      createTime: Date.now(),
      network: token.network,
      type: types_transaction/* TransactionTypeEnum.Withdraw */.bL.Withdraw,
      fee: fee
    }));
  }, [dispatch]);
};
var useTransactionHashDeposit = function useTransactionHashDeposit() {
  var pendingDepositTransactionHash = useAppSelector(function (state) {
    return state.transaction.pendingDepositTransactionHash;
  });
  var dispatch = useAppDispatch();
  var handleFetchUserBalance = useHandleFetchUserBalance();
  var refFetching = useRef(null);
  useEffect(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                refFetching.current = true;
                _context4.next = 3;
                return Promise.all(pendingDepositTransactionHash.map( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(transaction) {
                    var _response$data3;

                    var txn, txnHash, status, _getDepositHashInfo2, hash, response;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            txn = _objectSpread({}, transaction);
                            txnHash = txn.txnHash, status = txn.status;

                            if (!(!txnHash || status === TransactionStatusEnum.Succeeded)) {
                              _context3.next = 4;
                              break;
                            }

                            return _context3.abrupt("return", txn);

                          case 4:
                            _getDepositHashInfo2 = getDepositHashInfo(txnHash), hash = _getDepositHashInfo2.hash;
                            _context3.next = 7;
                            return PaymentService.getDeposit(hash).call();

                          case 7:
                            response = _context3.sent;

                            if ((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.status) === TransactionStatusEnum.Succeeded) {
                              txn.status = TransactionStatusEnum.Succeeded;
                              handleFetchUserBalance();
                              dispatch(updateDepositPendingTransaction(txn));
                            } else {
                              txn.status = TransactionStatusEnum.Pending;
                            }

                            return _context3.abrupt("return", txn);

                          case 10:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 3:
                refFetching.current = false;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function fetch() {
        return _ref3.apply(this, arguments);
      };
    }();

    var pendingHash = pendingDepositTransactionHash.filter(function (txn) {
      return txn.status !== TransactionStatusEnum.Succeeded;
    });
    var intervalPending = null;

    if (pendingHash.length && !refFetching.current) {
      fetch();
      intervalPending = setInterval(fetch, 5000);
    } else {
      clearInterval(intervalPending);
    }

    return function () {
      clearInterval(intervalPending);
    };
  }, [dispatch, handleFetchUserBalance, pendingDepositTransactionHash]);
  return useMemo(function () {
    return {
      transaction: pendingDepositTransactionHash
    };
  }, [pendingDepositTransactionHash]);
};
var useTransactionCodeWithdraw = function useTransactionCodeWithdraw() {
  var pendingWithdrawTransactionCode = useAppSelector(function (state) {
    return state.transaction.pendingWithdrawTransactionCode;
  });
  var dispatch = useAppDispatch();
  var handleFetchUserBalance = useHandleFetchUserBalance();
  var refFetching = useRef(null);
  useEffect(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                refFetching.current = true;
                _context6.next = 3;
                return Promise.all(pendingWithdrawTransactionCode.map( /*#__PURE__*/function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(transaction) {
                    var _response$data4;

                    var txn, txnHash, status, response;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            txn = _objectSpread({}, transaction);
                            txnHash = txn.txnHash, status = txn.status;

                            if (!(!txnHash || status === TransactionStatusEnum.Succeeded)) {
                              _context5.next = 4;
                              break;
                            }

                            return _context5.abrupt("return", txn);

                          case 4:
                            _context5.next = 6;
                            return PaymentService.getWithdrawal(txnHash).call();

                          case 6:
                            response = _context5.sent;

                            if ((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.status) === TransactionStatusEnum.Succeeded) {
                              txn.status = TransactionStatusEnum.Succeeded;
                              handleFetchUserBalance();
                              dispatch(updateWithdrawPendingTransaction(txn));
                            } else {
                              txn.status = TransactionStatusEnum.Pending;
                            }

                            return _context5.abrupt("return", txn);

                          case 9:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x4) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 3:
                refFetching.current = false;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function fetch() {
        return _ref5.apply(this, arguments);
      };
    }();

    var pendingHash = pendingWithdrawTransactionCode.filter(function (txn) {
      return txn.status !== TransactionStatusEnum.Succeeded;
    });
    var intervalPending = null;

    if (pendingHash.length && !refFetching.current) {
      fetch();
      intervalPending = setInterval(fetch, 5000);
    } else {
      clearInterval(intervalPending);
    }

    return function () {
      clearInterval(intervalPending);
    };
  }, [dispatch, handleFetchUserBalance, pendingWithdrawTransactionCode]);
  return useMemo(function () {
    return {
      transaction: pendingWithdrawTransactionCode
    };
  }, [pendingWithdrawTransactionCode]);
};

/***/ }),

/***/ 59731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hunnyKeyframes */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57214);


var hunnyKeyframes = {
  fade: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t0% {\n\t\t\topacity: 0;\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t};\n\t"]),
  fadeOut: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t0% {\n\t\t\topacity: 1\n\t\t}\n\t\t100% {\n\t\t\topacity: 0\n\t\t}\n\t"]),
  zoom: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t0% {\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t\t100% {\n\t\t\ttransform: scale(1);\n\t\t};\n\t"]),
  grow: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t0% {\n\t\t\ttransform: translateY(20px);\t\n\t\t\topacity: 0;\n\t\t}\n\t\t100% {\n\t\t\ttransform: translateY(0px);\n\t\t\topacity: 1;\n\t\t};\n\t"]),
  slideX: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t0% {\n\t\t\ttransform: translateX(-90px);\t\n\t\t\topacity: 0.5;\n\t\t}\n\t\t100% {\n\t\t\ttransform: translateX(0px);\n\t\t\topacity: 1;\n\t\t};\n\t"]),
  slideTopToBottom: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t0% {\n\t\t\ttransform: translateY(-20px);\t\n\t\t\topacity: 0.5;\n\t\t}\n\t\t100% {\n\t\t\ttransform: translateY(0px);\n\t\t\topacity: 1;\n\t\t};\n\t"]),
  slideBottomToTop: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t0% {\n\t\t\ttransform: translateY(20px);\t\n\t\t\topacity: 0.5;\n\t\t}\n\t\t100% {\n\t\t\ttransform: translateY(0px);\n\t\t\topacity: 1;\n\t\t};\n\t"]),
  fullSlideRightToLeft: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t0% {\n\t\t\ttransform: translateX(100%);\t\n\t\t}\n\t\t100% {\n\t\t\ttransform: translateX(0);\t\n\t\t};\n\t"]),
  rotate: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t\t \t0% { \n    -webkit-transform: rotate(0deg);\n     transform: rotate(0deg);\n\t\t}\n\t\t100% { \n\t\t\t-webkit-transform: rotate(360deg); \n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t"]),
  dash: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t 0% {\n      stroke-dashoffset: 1000;\n    }\n    100% {\n      stroke-dashoffset: 0;\n    }\n\t"]),
  dashChecked: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t  0% {\n      stroke-dashoffset: -100;\n    }\n    100% {\n      stroke-dashoffset: 900;\n    }\n "]),
  ripple: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n  0% {\n    box-shadow: 0px 0px 0px 1px transparent;\n  }\n\n  50% { \n    box-shadow: 0px 0px 0px 2.5px ", ";\n  }\n\n  100% {\n    box-shadow: 0px 0px 0px 2.5px transparent;\n  } \n "], theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.primary */ .Z.colors.primary),
  slideOutFadeDown: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["\n\t0% {}\n\t100% {\n\t\topacity: 0;\n\t\ttransform: translateY(10px);\n\t}\n "])
};
/* harmony default export */ __webpack_exports__["Z"] = (hunnyKeyframes);

/***/ }),

/***/ 46030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uw": function() { return /* binding */ formatDisplayDateTime; },
/* harmony export */   "eC": function() { return /* binding */ getNextSeconds; },
/* harmony export */   "y2": function() { return /* binding */ generateTimeDisplay; }
/* harmony export */ });
/* unused harmony exports formatDisplayFullDateTime, formatDisplayTime, formatDisplayDate, isEqualDate, parseServerTime, monthNames, isPass */
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(170);

var formatDisplayDateTime = function formatDisplayDateTime(date) {
  var day = date.getDate().toString().padStart(2, '0');
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var year = date.getFullYear();
  var hour = date.getHours().toString().padStart(2, '0');
  var minute = date.getMinutes().toString().padStart(2, '0');
  return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hour, ":").concat(minute);
};
var formatDisplayFullDateTime = function formatDisplayFullDateTime(date) {
  var day = date.getDate().toString().padStart(2, '0');
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var year = date.getFullYear();
  var hour = date.getHours().toString().padStart(2, '0');
  var minute = date.getMinutes().toString().padStart(2, '0');
  var seconds = date.getSeconds().toString().padStart(2, '0');
  return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(seconds);
};
var formatDisplayTime = function formatDisplayTime(date) {
  var hour = date.getHours().toString().padStart(2, '0');
  var minute = date.getMinutes().toString().padStart(2, '0');
  return "".concat(hour, ":").concat(minute);
};
var formatDisplayDate = function formatDisplayDate(date) {
  var day = date.getDate().toString().padStart(2, '0');
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var year = date.getFullYear();
  var dateDisplay = "".concat(day, "/").concat(month, "/").concat(year);
  return dateDisplay;
};
var isEqualDate = function isEqualDate(date1, date2) {
  return date1.getMonth() === date2.getMonth() && date2.getDate() === date1.getDate() && date2.getFullYear() === date1.getFullYear();
};
var parseServerTime = function parseServerTime(time) {
  var parsedTime = new Date(time).getTime();
  return Math.floor(parsedTime / 1000);
};
var getNextSeconds = function getNextSeconds(second) {
  return Date.now() + second * 60 * 1000;
};
function generateTimeDisplay(to, serverTimeMargin) {
  var rightJustNow = new Date().getTime() + serverTimeMargin;
  var runway = to - rightJustNow;
  var stateObj = {
    days: Math.floor(runway / (1000 * 60 * 60 * 24)),
    hours: Math.floor(runway % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
    minutes: Math.floor(runway % (1000 * 60 * 60) / (1000 * 60)),
    seconds: Math.floor(runway % (1000 * 60) / 1000)
  };

  if (stateObj.days <= 0 && stateObj.hours <= 0 && stateObj.minutes <= 0 && stateObj.seconds <= 0) {
    return config_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_TIME */ .pj;
  }

  return stateObj;
}
var monthNames = [{
  code: '01',
  value: 'January'
}, {
  code: '02',
  value: 'February'
}, {
  code: '03',
  value: 'March'
}, {
  code: '04',
  value: 'April'
}, {
  code: '05',
  value: 'May'
}, {
  code: '06',
  value: 'June'
}, {
  code: '07',
  value: 'July'
}, {
  code: '08',
  value: 'August'
}, {
  code: '09',
  value: 'September'
}, {
  code: 10,
  value: 'October'
}, {
  code: 11,
  value: 'November'
}, {
  code: 12,
  value: 'December'
}];
var isPass = function isPass(dateTime) {
  var parsedDate = new Date(dateTime);
  return parsedDate.getTime() < Date.now();
};

/***/ }),

/***/ 44886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getID; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2226);



var Visitor;
function getID() {
  return _getID.apply(this, arguments);
}

function _getID() {
  _getID = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var getComponents, components;
    return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (Visitor) {
              _context.next = 8;
              break;
            }

            _context.next = 3;
            return (0,_fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_2__/* .prepareForSources */ .qC)(100);

          case 3:
            getComponents = (0,_fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_2__/* .loadSources */ .AW)(_fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_2__/* .sources */ .YI, {}, ['fontPreferences', 'screenFrame', 'screenResolution', 'sessionStorage', 'localStorage', 'indexedDB', 'openDatabase', 'cookiesEnabled']);
            _context.next = 6;
            return getComponents();

          case 6:
            components = _context.sent;
            Visitor = {
              components: components,
              visitorId: _fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hashComponents */ .ZP.hashComponents(components)
            };

          case 8:
            return _context.abrupt("return", Visitor.visitorId);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getID.apply(this, arguments);
}

/***/ }),

/***/ 79534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NJ": function() { return /* binding */ getFullDisplayBalance; },
/* harmony export */   "Qe": function() { return /* binding */ getDecimalAmount; },
/* harmony export */   "U4": function() { return /* binding */ getBalanceAmount; },
/* harmony export */   "mW": function() { return /* binding */ getBalanceNumber; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; }
/* harmony export */ });
/* unused harmony exports delineate, formatLocalisedCompactNumber */
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);
/* harmony import */ var config_constants_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34418);
/* eslint-disable default-param-last */


/**
 * Take a formatted amount, e.g. 15 BNB and convert it to full decimal value, e.g. 15000000000000000
 */

var getDecimalAmount = function getDecimalAmount(amount) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
  return new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(amount).times(config_constants_number__WEBPACK_IMPORTED_MODULE_1__/* .BIG_TEN.pow */ .xp.pow(decimals));
};
var getBalanceAmount = function getBalanceAmount(amount) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
  return new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(amount).dividedBy(config_constants_number__WEBPACK_IMPORTED_MODULE_1__/* .BIG_TEN.pow */ .xp.pow(decimals));
};
/**
 * This function is not really necessary but is used throughout the site.
 */

var getBalanceNumber = function getBalanceNumber(balance) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
  var parsedBalance = getBalanceAmount(balance, decimals).toNumber();
  return Number.isNaN(parsedBalance) ? 0 : parsedBalance;
};
function delineate(bnStr, decimalDigitTake) {
  var parts = bnStr.split('.');

  if (decimalDigitTake && parts[1]) {
    parts[1] = parts[1].substr(0, decimalDigitTake);
  }

  var formatDecimal = parts[1] && Number(parts[1]) && decimalDigitTake !== 0 ? ".".concat(parts[1]) : '';
  return parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + formatDecimal;
}
var getFullDisplayBalance = function getFullDisplayBalance(balance) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var displayDecimals = arguments.length > 2 ? arguments[2] : undefined;
  return delineate(getBalanceAmount(balance, decimals).toString(10), displayDecimals);
};
var formatNumber = function formatNumber(number) {
  var minPrecision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var maxPrecision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var options = {
    minimumFractionDigits: minPrecision,
    maximumFractionDigits: maxPrecision
  };
  return number.toLocaleString('en-En', options);
};
var formatLocalisedCompactNumber = function formatLocalisedCompactNumber(number) {
  return new Intl.NumberFormat('US-us', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumSignificantDigits: 2
  }).format(number);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (formatLocalisedCompactNumber)));

/***/ }),

/***/ 90802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dE": function() { return /* binding */ approve; },
  "_6": function() { return /* binding */ deposit; },
  "w_": function() { return /* binding */ estimateDepositFee; },
  "CP": function() { return /* binding */ getCurrencyBalance; },
  "f2": function() { return /* binding */ getTokenAllowance; }
});

// UNUSED EXPORTS: getHunnyPokerContract, getNativeWalletBalance, getTokenContract, getTokenWalletBalance

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 16 modules
var lib_esm = __webpack_require__(77294);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 2 modules
var units_lib_esm = __webpack_require__(35553);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
;// CONCATENATED MODULE: ./src/config/constants/abis/ERC20.json
var ERC20_namespaceObject = JSON.parse('{"Mt":[{"inputs":[{"internalType":"string","name":"name_","type":"string"},{"internalType":"string","name":"symbol_","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]}');
;// CONCATENATED MODULE: ./src/config/constants/abis/HunnyPoker.json
var HunnyPoker_namespaceObject = JSON.parse('{"M":[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Deposited","type":"event"},{"anonymous":false,"inputs":[],"name":"DisableWhitelist","type":"event"},{"anonymous":false,"inputs":[],"name":"EnableWhitelist","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"bool","name":"isPaused","type":"bool"}],"name":"PauseChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_address","type":"address"},{"indexed":false,"internalType":"bool","name":"whitelist","type":"bool"}],"name":"Whitelisted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Withdrawn","type":"event"},{"inputs":[],"name":"HUNNY","outputs":[{"internalType":"contract IBEP20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"bool","name":"disable","type":"bool"}],"name":"disableWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"isWhitelist","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lastPauseTime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"reception","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"recoverBEP20","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"reception","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"recoverBNB","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_paused","type":"bool"}],"name":"setPaused","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"},{"internalType":"bool","name":"_on","type":"bool"}],"name":"setWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"reception","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"receptions","type":"address[]"},{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"name":"withdrawMany","outputs":[],"stateMutability":"nonpayable","type":"function"}]}');
// EXTERNAL MODULE: ./node_modules/@ethersproject/providers/lib.esm/url-json-rpc-provider.js
var url_json_rpc_provider = __webpack_require__(93901);
// EXTERNAL MODULE: ./src/config/constants/number.ts
var number = __webpack_require__(34418);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(79534);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(7737);
// EXTERNAL MODULE: ./src/utils/requestHelper.ts
var requestHelper = __webpack_require__(75391);
// EXTERNAL MODULE: ./src/utils/token.ts
var utils_token = __webpack_require__(69961);
// EXTERNAL MODULE: ./src/utils/providers.ts
var providers = __webpack_require__(95396);
;// CONCATENATED MODULE: ./src/utils/infura.ts









 // import { PublicKey } from '@solana/web3.js'
// import { web3 } from '@project-serum/anchor'
// import { TOKEN_PROGRAM_ID } from 'config/constants/solanaConfig'
// INTERGRATE SOLANA
// import { AccountLayout } from '@solana/spl-token'





var getTokenContract = function getTokenContract(token, signer) {
  var rpcProvider = (0,providers/* getSimplerRpcProvider */.M3)(token.network);
  var signerOrProvider = signer !== null && signer !== void 0 ? signer : rpcProvider;
  return new lib_esm/* Contract */.CH(token.address, ERC20_namespaceObject.Mt, signerOrProvider);
};
var getHunnyPokerContract = function getHunnyPokerContract(address, signer) {
  return new lib_esm/* Contract */.CH(address, HunnyPoker_namespaceObject.M, signer);
};
var getNativeWalletBalance = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(chainId, userAddress) {
    var connection, balance;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            connection = (0,providers/* getSimplerRpcProvider */.M3)(chainId); // EVM network

            if (!(connection instanceof url_json_rpc_provider/* StaticJsonRpcProvider */.c)) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return connection.getBalance(userAddress);

          case 5:
            balance = _context.sent;
            return _context.abrupt("return", new bignumber/* default */.Z(balance.toString()));

          case 7:
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            (0,sentry/* logError */.H)('Fetch native token  balance failed', {
              message: _context.t0.message,
              extra: {
                chainId: chainId,
                address: userAddress
              }
            });
            return _context.abrupt("return", number/* BIG_ZERO */.HW);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function getNativeWalletBalance(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getTokenWalletBalance = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(token, userAddress) {
    var connection, contract, balance;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            connection = (0,providers/* getSimplerRpcProvider */.M3)(token.network); // EVM network

            if (!(connection instanceof url_json_rpc_provider/* StaticJsonRpcProvider */.c)) {
              _context2.next = 8;
              break;
            }

            contract = getTokenContract(token);
            _context2.next = 6;
            return contract.balanceOf(userAddress);

          case 6:
            balance = _context2.sent;
            return _context2.abrupt("return", new bignumber/* default */.Z(balance.toString()));

          case 8:
            _context2.next = 14;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            (0,sentry/* logError */.H)('Fetch token balance failed', {
              message: _context2.t0.message,
              extra: {
                token: token,
                address: userAddress
              }
            });
            return _context2.abrupt("return", number/* BIG_ZERO */.HW);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function getTokenWalletBalance(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var getCurrencyBalance = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(token, address) {
    var network, balance;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            network = token.network;
            balance = null;

            if (!token.isNative) {
              _context3.next = 8;
              break;
            }

            _context3.next = 5;
            return getNativeWalletBalance(network, address);

          case 5:
            balance = _context3.sent;
            _context3.next = 11;
            break;

          case 8:
            _context3.next = 10;
            return getTokenWalletBalance(token, address);

          case 10:
            balance = _context3.sent;

          case 11:
            return _context3.abrupt("return", {
              token: token,
              amount: (0,formatBalance/* getBalanceAmount */.U4)(balance, token.decimals)
            });

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getCurrencyBalance(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
var getTokenAllowance = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(token, owner, spender) {
    var contract, response, currentAllowance;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            contract = getTokenContract(token);
            _context4.next = 4;
            return contract.allowance(owner, spender);

          case 4:
            response = _context4.sent;
            currentAllowance = new bignumber/* default */.Z(response.toString());
            return _context4.abrupt("return", currentAllowance);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            (0,sentry/* logError */.H)("Fetching allowance failed ".concat(token.name, " ").concat(token.network), _context4.t0);
            return _context4.abrupt("return", new bignumber/* default */.Z(0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));

  return function getTokenAllowance(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
var approve = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(signer, token, spender) {
    var contract, tx, receipt;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            contract = getTokenContract(token, signer);
            _context5.prev = 1;
            _context5.next = 4;
            return contract.approve(spender, number/* UINT256_MAX.toString */.U8.toString(10));

          case 4:
            tx = _context5.sent;
            _context5.next = 7;
            return tx.wait();

          case 7:
            receipt = _context5.sent;

            if (!receipt.status) {
              _context5.next = 10;
              break;
            }

            return _context5.abrupt("return", receipt.transactionHash);

          case 10:
            return _context5.abrupt("return", null);

          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](1);
            (0,sentry/* logError */.H)("Approve token:".concat(token.name, " spender: ").concat(spender, " network: ").concat(token.network, " Failed"), _context5.t0);
            return _context5.abrupt("return", null);

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 13]]);
  }));

  return function approve(_x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
var deposit = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(signer, token, amount, contractAddress) {
    var nullAddress, contract, decimalAmount, tx;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            nullAddress = '0x0000000000000000000000000000000000000000';
            contract = getHunnyPokerContract(contractAddress, signer);
            decimalAmount = (0,formatBalance/* getDecimalAmount */.Qe)(new bignumber/* default */.Z(amount), token.decimals);
            _context6.prev = 3;
            _context6.next = 6;
            return contract.deposit(token.isNative ? nullAddress : token.address, decimalAmount.toString(10), {
              value: token.isNative ? decimalAmount.toString(10) : '0'
            });

          case 6:
            tx = _context6.sent;
            return _context6.abrupt("return", tx);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](3);
            (0,sentry/* logError */.H)("Deposit token:".concat(token.name, " network: ").concat(token.network, " Failed"), _context6.t0);
            return _context6.abrupt("return", null);

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[3, 10]]);
  }));

  return function deposit(_x13, _x14, _x15, _x16) {
    return _ref6.apply(this, arguments);
  };
}();
var estimateDepositFee = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(token, amount, contractAddress) {
    var provider, nullAddress, contract, decimalAmount, _yield$forkjoinReques, _yield$forkjoinReques2, gasPrice, gasUnits, transactionFee;

    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(token.isNative && (0,utils_token/* isSolToken */.z)(token))) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return", new bignumber/* default */.Z('0.00005'));

          case 2:
            provider = (0,providers/* getSimplerRpcProvider */.M3)(token.network);
            nullAddress = '0x0000000000000000000000000000000000000000';
            contract = getHunnyPokerContract(contractAddress, provider);
            decimalAmount = (0,formatBalance/* getDecimalAmount */.Qe)(new bignumber/* default */.Z(amount), token.decimals);
            _context7.prev = 6;
            _context7.next = 9;
            return (0,requestHelper/* forkjoinRequest */.Rm)([(0,providers/* getSimplerRpcProvider */.M3)(token.network).getGasPrice(), contract.estimateGas.deposit(token.isNative ? nullAddress : token.address, decimalAmount.toString(10), {
              value: token.isNative ? decimalAmount.toString(10) : '0'
            })]);

          case 9:
            _yield$forkjoinReques = _context7.sent;
            _yield$forkjoinReques2 = (0,slicedToArray/* default */.Z)(_yield$forkjoinReques, 2);
            gasPrice = _yield$forkjoinReques2[0];
            gasUnits = _yield$forkjoinReques2[1];
            transactionFee = gasPrice.mul(gasUnits);
            return _context7.abrupt("return", new bignumber/* default */.Z(units_lib_esm/* formatUnits */.bM(transactionFee, 'ether').toString()));

          case 17:
            _context7.prev = 17;
            _context7.t0 = _context7["catch"](6);
            (0,sentry/* logError */.H)("estimateDepositFee token:".concat(token.name, " network: ").concat(token.network, " Failed"), _context7.t0);
            return _context7.abrupt("return", null);

          case 21:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[6, 17]]);
  }));

  return function estimateDepositFee(_x17, _x18, _x19) {
    return _ref7.apply(this, arguments);
  };
}();

/***/ }),

/***/ 95396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M3": function() { return /* binding */ getSimplerRpcProvider; }
/* harmony export */ });
/* unused harmony exports SimpleRpcProvider, getRandomRpcFromList */
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var _ethersproject_providers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93901);
/* harmony import */ var config_constants_network__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17961);




 // import { clusterApiUrl } from '@solana/web3.js'
// import { web3 } from '@project-serum/anchor'
// INTERGRATE SOLANA
// import { WalletAdapterNetwork } from '@solana/wallet-adapter-base'

var SimpleRpcProvider = /*#__PURE__*/function () {
  function SimpleRpcProvider() {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, SimpleRpcProvider);
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SimpleRpcProvider, null, [{
    key: "get",
    value: function get(chainId) {
      if (!this._simpleRpcProviderMap[chainId]) {
        var _NETWORK_MAP$chainId;

        // if (chainId === ChainIdEnum.SOL_TESTNET || chainId === ChainIdEnum.SOL) {
        //   const endpoint =
        //     chainId === ChainIdEnum.SOL_TESTNET
        //       ? clusterApiUrl(WalletAdapterNetwork.Testnet)
        //       : 'https://solana-mainnet.g.alchemy.com/v2/JH7TEGB_ecM-SpBFtuimdmH2MrfC5-Tg'
        //   this._simpleRpcProviderMap[chainId] = new web3.Connection(endpoint)
        // } else {
        var rpcCollections = ((_NETWORK_MAP$chainId = config_constants_network__WEBPACK_IMPORTED_MODULE_0__/* .NETWORK_MAP */ .mF[chainId]) === null || _NETWORK_MAP$chainId === void 0 ? void 0 : _NETWORK_MAP$chainId.rpcCollections) || [];
        var selectedRpcUrl = getRandomRpcFromList(rpcCollections);
        this._simpleRpcProviderMap[chainId] = new _ethersproject_providers__WEBPACK_IMPORTED_MODULE_3__/* .StaticJsonRpcProvider */ .c(selectedRpcUrl); // }
      }

      return this._simpleRpcProviderMap[chainId];
    }
  }]);

  return SimpleRpcProvider;
}();

(0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SimpleRpcProvider, "_simpleRpcProviderMap", {});

var getRandomRpcFromList = function getRandomRpcFromList(rpcCollections) {
  if (rpcCollections.length) {
    var randomRpc = rpcCollections[Math.floor(Math.random() * 3)];
    if (randomRpc) return randomRpc;
    return rpcCollections[0];
  }

  return '';
};
var getSimplerRpcProvider = function getSimplerRpcProvider(chainId) {
  return SimpleRpcProvider.get(chainId);
};

/***/ }),

/***/ 75391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rm": function() { return /* binding */ forkjoinRequest; },
/* harmony export */   "Tc": function() { return /* binding */ transformHunnyRequest; }
/* harmony export */ });
/* unused harmony export enrichDataCollection */
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);



/* eslint-disable no-await-in-loop */
var forkjoinRequest = /*#__PURE__*/function () {
  var _ref = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(promises) {
    var result, index;
    return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            result = [];
            index = 0;

          case 2:
            if (!(index < promises.length)) {
              _context.next = 11;
              break;
            }

            _context.t0 = result;
            _context.next = 6;
            return promises[index];

          case 6:
            _context.t1 = _context.sent;

            _context.t0.push.call(_context.t0, _context.t1);

          case 8:
            index++;
            _context.next = 2;
            break;

          case 11:
            return _context.abrupt("return", result);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function forkjoinRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();
function enrichDataCollection(_x2, _x3, _x4) {
  return _enrichDataCollection.apply(this, arguments);
}

function _enrichDataCollection() {
  _enrichDataCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data, property, request) {
    var enrichRequest, _loop, index;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (data.length) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", null);

          case 2:
            enrichRequest = [];

            _loop = function _loop(index) {
              var fetch = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var dataItem, response;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          dataItem = data[index];
                          _context3.next = 3;
                          return request(dataItem);

                        case 3:
                          response = _context3.sent;
                          dataItem[property] = response;

                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function fetch() {
                  return _ref3.apply(this, arguments);
                };
              }();

              enrichRequest.push(fetch());
            };

            for (index = 0; index < data.length; index++) {
              _loop(index);
            }

            _context4.next = 7;
            return forkjoinRequest(enrichRequest);

          case 7:
            return _context4.abrupt("return", data);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _enrichDataCollection.apply(this, arguments);
}

function transformHunnyRequest(req, mapFn) {
  var call = /*#__PURE__*/function () {
    var _ref2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var result;
      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return req.call();

            case 2:
              result = _context2.sent;
              return _context2.abrupt("return", mapFn(result));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function call() {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    call: call,
    cancel: req.cancel
  };
}

/***/ }),

/***/ 7737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; }
/* harmony export */ });
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64487);


var assignError = function assignError(maybeError) {
  if (typeof maybeError === 'string') {
    return new Error(maybeError);
  }

  if (typeof maybeError === 'object') {
    var _maybeError$message;

    var error = new Error((_maybeError$message = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && _maybeError$message !== void 0 ? _maybeError$message : String(maybeError));

    if (maybeError !== null && maybeError !== void 0 && maybeError.stack) {
      error.stack = maybeError.stack;
    }

    if (maybeError !== null && maybeError !== void 0 && maybeError.code) {
      error.name = maybeError.code;
    }

    return error;
  }

  return maybeError;
};

var ENABLED_LOG = true;
var logError = function logError(desc, error) {
  if (ENABLED_LOG) {
    if (error instanceof Error) {
      (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb)(error);
    } else {
      (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb)(assignError(error), error);
    }
  }

  console.error("Logger: ".concat(desc), {
    error: error
  });
};

/***/ }),

/***/ 57430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ isEmail; },
/* harmony export */   "Kf": function() { return /* binding */ formatUsername; },
/* harmony export */   "dM": function() { return /* binding */ inputRegex; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; }
/* harmony export */ });
/* unused harmony exports isString, formatRoute */
/* eslint-disable no-useless-escape */

/* eslint-disable no-param-reassign */

/* eslint-disable prefer-regex-literals */

/* eslint-disable max-len */

/* eslint-disable no-control-regex */
var inputRegex = RegExp('^\\d*(?:\\\\[.])?\\d*$');
var escapeRegExp = function escapeRegExp(input) {
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}; /// Regex detection for email referrened by YUP

var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
var isString = function isString(value) {
  var type = typeof value;
  return type === 'string' || false;
};
var isEmail = function isEmail(value) {
  return String(value).toLowerCase().match(rEmail);
};
var formatRoute = function formatRoute(apiUrl, value) {
  return Object.keys(value).reduce(function (result, cur) {
    result = result.replaceAll("{{".concat(cur, "}}"), value[cur]);
    return result;
  }, apiUrl);
};
var formatUsername = function formatUsername(username) {
  if (!username) return '';
  if (isEmail(username)) return "".concat(username.slice(0, username.indexOf('@')));
  return "".concat(username.slice(0, 5), "...").concat(username.slice(-4));
};

/***/ }),

/***/ 7006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ showToast; },
/* harmony export */   "f": function() { return /* binding */ HunnyToast; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55704);
/* harmony import */ var components_Box_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26303);
/* harmony import */ var components_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19500);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40782);
/* harmony import */ var svgs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8400);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72959);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57214);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var toastContainerStyle = {
  backgroundColor: "".concat(theme_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors.inputAlt */ .O.inputAlt),
  borderRadius: "".concat(_theme__WEBPACK_IMPORTED_MODULE_7__/* ["default"].radii["default"] */ .Z.radii["default"]),
  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
};
function showToast(content, config) {
  var progressColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'info';
  return (0,react_toastify__WEBPACK_IMPORTED_MODULE_9__/* .toast */ .Am)(content, _objectSpread({
    style: toastContainerStyle,
    progressStyle: {
      height: 2,
      background: theme_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors */ .O[progressColor]
    },
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  }, config));
}

var ToastTemplate = function ToastTemplate(_ref) {
  var icon = _ref.icon,
      color = _ref.color,
      content = _ref.content,
      desc = _ref.desc;
  var Icon = (0,svgs__WEBPACK_IMPORTED_MODULE_5__/* .getIcon */ .q)(icon);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(components_Box_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      alignItems: "flex-start",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        width: "24px",
        height: "24px",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Icon, {
          width: "24px",
          height: "24px",
          fill: theme_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors */ .O[color]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(components_Box_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ml: "8px",
        mt: "4px",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          small: true,
          bold: true,
          color: color,
          children: content
        }), desc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          small: true,
          color: "textSubtle",
          mt: "6px",
          lineHeight: "1.05em",
          children: desc
        })]
      })]
    })
  });
};

var HunnyToast = {
  show: function show(content, desc, config) {
    return showToast( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ToastTemplate, {
      icon: "InfoIcon",
      color: "info",
      content: content,
      desc: desc
    }), config, 'info');
  },
  error: function error(content, desc, config) {
    return showToast( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ToastTemplate, {
      icon: "CloseCircleIcon",
      color: "error",
      content: content,
      desc: desc
    }), config, 'error');
  },
  success: function success(content, desc, config) {
    return showToast( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ToastTemplate, {
      icon: "SuccessIcon",
      color: "success",
      content: content,
      desc: desc
    }), config, 'success');
  },
  warn: function warn(content, desc, config) {
    return showToast( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ToastTemplate, {
      icon: "WarningIcon",
      color: "warning",
      content: content,
      desc: desc
    }), config, 'warning');
  },
  dismiss: function dismiss(toastId) {
    react_toastify__WEBPACK_IMPORTED_MODULE_9__/* .toast.dismiss */ .Am.dismiss(toastId);
  }
};

/***/ }),

/***/ 69961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ validateTokenBlackList; },
/* harmony export */   "z": function() { return /* binding */ isSolToken; }
/* harmony export */ });
/* harmony import */ var config_constants_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99289);

var isSolToken = function isSolToken(token) {
  // return token?.network === ChainIdEnum.SOL || token?.network === ChainIdEnum.SOL_TESTNET // INTERGRATE SOLANA
  return false;
};
var validateTokenBlackList = function validateTokenBlackList(token) {
  return token && !!config_constants_tokens__WEBPACK_IMPORTED_MODULE_0__/* .tokenBlackList.includes */ .B.includes(token);
};

/***/ }),

/***/ 54458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ combineDepositHash; },
/* harmony export */   "y": function() { return /* binding */ getDepositHashInfo; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16835);
/* harmony import */ var config_constants_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99289);


/* eslint-disable no-unsafe-optional-chaining */

var combineDepositHash = function combineDepositHash(hash, token) {
  return "".concat(hash, "__").concat(token.code, "__").concat(token.network);
};
var getDepositHashInfo = function getDepositHashInfo(combinedHash) {
  var _combinedHash$split = combinedHash === null || combinedHash === void 0 ? void 0 : combinedHash.split('__'),
      _combinedHash$split2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_combinedHash$split, 3),
      hash = _combinedHash$split2[0],
      tokenCode = _combinedHash$split2[1],
      network = _combinedHash$split2[2];

  return {
    hash: hash,
    token: config_constants_tokens__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[network][tokenCode]
  };
};

/***/ }),

/***/ 89484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ HunnyWalletConnectConnector; },
/* harmony export */   "BA": function() { return /* binding */ connectorsByName; },
/* harmony export */   "Rf": function() { return /* binding */ HunnyBscConnector; },
/* harmony export */   "av": function() { return /* binding */ getLibrary; },
/* harmony export */   "l": function() { return /* binding */ signMessage; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10748);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45959);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _binance_chain_bsc_connector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29831);
/* harmony import */ var _web3_react_injected_connector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30950);
/* harmony import */ var _web3_react_walletconnect_connector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83929);
/* harmony import */ var config_constants_network__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17961);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(170);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(241);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16441);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29251);
/* harmony import */ var _sentry__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7737);









var _connectorsByName;



function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable no-param-reassign */







var POLLING_INTERVAL = 12000;

var HunnyInjectedConnector = /*#__PURE__*/function (_InjectedConnector) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(HunnyInjectedConnector, _InjectedConnector);

  var _super = _createSuper(HunnyInjectedConnector);

  function HunnyInjectedConnector() {
    var _this;

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, HunnyInjectedConnector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_this), "name", config_constants__WEBPACK_IMPORTED_MODULE_7__/* .ConnectorNameEnum.Injected */ .Oh.Injected);

    return _this;
  }

  return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(HunnyInjectedConnector);
}(_web3_react_injected_connector__WEBPACK_IMPORTED_MODULE_4__/* .InjectedConnector */ ._k);

var HunnyBscConnector = /*#__PURE__*/function (_BscConnector) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(HunnyBscConnector, _BscConnector);

  var _super2 = _createSuper(HunnyBscConnector);

  function HunnyBscConnector() {
    var _this2;

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, HunnyBscConnector);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_this2), "name", config_constants__WEBPACK_IMPORTED_MODULE_7__/* .ConnectorNameEnum.BSC */ .Oh.BSC);

    return _this2;
  }

  return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(HunnyBscConnector);
}(_binance_chain_bsc_connector__WEBPACK_IMPORTED_MODULE_3__/* .BscConnector */ .vR);
var HunnyWalletConnectConnector = /*#__PURE__*/function (_WalletConnectConnect) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(HunnyWalletConnectConnector, _WalletConnectConnect);

  var _super3 = _createSuper(HunnyWalletConnectConnector);

  function HunnyWalletConnectConnector() {
    var _this3;

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, HunnyWalletConnectConnector);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_this3), "name", config_constants__WEBPACK_IMPORTED_MODULE_7__/* .ConnectorNameEnum.WalletConnect */ .Oh.WalletConnect);

    return _this3;
  }

  return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(HunnyWalletConnectConnector);
}(_web3_react_walletconnect_connector__WEBPACK_IMPORTED_MODULE_5__/* .WalletConnectConnector */ .zw);
var injected = new HunnyInjectedConnector({}); /// Connect wallet by QR Code

var walletconnect = new HunnyWalletConnectConnector({
  rpc: config_constants_network__WEBPACK_IMPORTED_MODULE_6__/* .WALLETCONNECT_SUPPORTED.reduce */ .Up.reduce(function (result, network) {
    result[network.chainId] = network.rpcCollections[0];
    return result;
  }, {}),
  bridge: 'https://walletconnect-bridge.hunny.finance/',
  supportedChainIds: config_constants_network__WEBPACK_IMPORTED_MODULE_6__/* .WALLETCONNECT_SUPPORTED.map */ .Up.map(function (item) {
    return item.chainId;
  }),
  qrcode: true
}); /// Connect

var bscConnector = new HunnyBscConnector({});
var connectorsByName = (_connectorsByName = {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_connectorsByName, config_constants__WEBPACK_IMPORTED_MODULE_7__/* .ConnectorNameEnum.Injected */ .Oh.Injected, injected), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_connectorsByName, config_constants__WEBPACK_IMPORTED_MODULE_7__/* .ConnectorNameEnum.WalletConnect */ .Oh.WalletConnect, walletconnect), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_connectorsByName, config_constants__WEBPACK_IMPORTED_MODULE_7__/* .ConnectorNameEnum.BSC */ .Oh.BSC, bscConnector), _connectorsByName);
var getLibrary = function getLibrary(provider) {
  var library = new ethers__WEBPACK_IMPORTED_MODULE_13__/* .Web3Provider */ .Q(provider);
  library.pollingInterval = POLLING_INTERVAL;
  library.mapProvider = provider;
  return library;
};
var signMessage = /*#__PURE__*/function () {
  var _ref = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(provider, account, message, callback) {
    var connectorID, _provider$provider, _yield$window$Binance, _signature, _provider$provider2, walletMeta, wcMessage, _signature2, signature;

    return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            connectorID = window.localStorage.getItem('connectorId');
            _context.prev = 1;

            if (!(window.BinanceChain && connectorID === config_constants__WEBPACK_IMPORTED_MODULE_7__/* .ConnectorNameEnum.BSC */ .Oh.BSC)) {
              _context.next = 9;
              break;
            }

            _context.next = 5;
            return window.BinanceChain.bnbSign(account, message);

          case 5:
            _yield$window$Binance = _context.sent;
            _signature = _yield$window$Binance.signature;
            callback(_signature, null);
            return _context.abrupt("return");

          case 9:
            if (!((_provider$provider = provider.provider) !== null && _provider$provider !== void 0 && _provider$provider.wc && connectorID === config_constants__WEBPACK_IMPORTED_MODULE_7__/* .ConnectorNameEnum.WalletConnect */ .Oh.WalletConnect)) {
              _context.next = 20;
              break;
            }

            walletMeta = (_provider$provider2 = provider.provider) === null || _provider$provider2 === void 0 ? void 0 : _provider$provider2.walletMeta;
            wcMessage = ethers__WEBPACK_IMPORTED_MODULE_15__/* .hexlify */ .Dv(ethers__WEBPACK_IMPORTED_MODULE_16__/* .toUtf8Bytes */ .Y0(message));
            /**
             * Salepal wallet sign PersonalMessage wrong!
             */

            if (!(walletMeta.url === 'https://www.isafepal.io' || walletMeta.name === 'SafePal Wallet')) {
              _context.next = 15;
              break;
            }

            provider.provider.send({
              method: 'eth_sign',
              params: [account, message],
              account: account
            }, function (err, result) {
              callback(result.result, err);
            });
            return _context.abrupt("return");

          case 15:
            _context.next = 17;
            return provider.provider.wc.signPersonalMessage([wcMessage, account]);

          case 17:
            _signature2 = _context.sent;
            callback(_signature2);
            return _context.abrupt("return");

          case 20:
            _context.next = 22;
            return provider.getSigner(account).signMessage(message);

          case 22:
            signature = _context.sent;
            callback(signature);
            _context.next = 30;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](1);
            (0,_sentry__WEBPACK_IMPORTED_MODULE_17__/* .logError */ .H)('EVM sign message', _context.t0);
            callback('', _context.t0);

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 26]]);
  }));

  return function signMessage(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 5730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export verificationErrorMessages */
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(19521);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(18132);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(93955);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89395);
/* harmony import */ var components_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19500);
/* harmony import */ var components_Box_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55704);
/* harmony import */ var svgs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8400);
/* harmony import */ var config_constants_formValidator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96584);
/* harmony import */ var hooks_useForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16145);
/* harmony import */ var components_FormControl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66938);
/* harmony import */ var components_FormControl_FormInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38097);
/* harmony import */ var components_Loader_CircleLoader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95322);
/* harmony import */ var config_types_validator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1872);
/* harmony import */ var hooks_useCountdown__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87625);
/* harmony import */ var hooks_useRequest__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89058);
/* harmony import */ var hooks_useIsomorphicEffect__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(58491);
/* harmony import */ var components_Loader_Dots__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46405);
/* harmony import */ var _ForgotPasswordModal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22404);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85893);



var _verificationErrorMes;























var verificationErrorMessages = (_verificationErrorMes = {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_verificationErrorMes, config_types_validator__WEBPACK_IMPORTED_MODULE_11__/* .ValidationError.Required */ .p.Required, 'Please provide verification code'), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_verificationErrorMes, config_types_validator__WEBPACK_IMPORTED_MODULE_11__/* .ValidationError.IncorrectLength */ .p.IncorrectLength, 'Please enter the 6-digits verification code'), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_verificationErrorMes, config_types_validator__WEBPACK_IMPORTED_MODULE_11__/* .ValidationError.InCorrect */ .p.InCorrect, 'Incorrect code'), (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_verificationErrorMes, config_types_validator__WEBPACK_IMPORTED_MODULE_11__/* .ValidationError.DataExpired */ .p.DataExpired, 'Your OTP is expired. Please resend new OTP'), _verificationErrorMes);

var EmailVerificationModal = function EmailVerificationModal(_ref) {
  var onDismiss = _ref.onDismiss,
      _ref$data = _ref.data,
      email = _ref$data.email,
      initialVerifiedResult = _ref$data.initialVerifiedResult,
      verifiedHunnyRequestFn = _ref$data.verifiedHunnyRequestFn,
      onSubmit = _ref$data.onSubmit;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_19__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var _useRequest = (0,hooks_useRequest__WEBPACK_IMPORTED_MODULE_13__/* .useRequest */ .Q)(),
      execute = _useRequest.execute;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      submiting = _useState[0],
      setSubmiting = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialVerifiedResult),
      verification = _useState2[0],
      setVerifiedResult = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      canResend = _useState3[0],
      setCanResend = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      requestingResend = _useState4[0],
      setRequestingResend = _useState4[1];

  (0,hooks_useIsomorphicEffect__WEBPACK_IMPORTED_MODULE_14__/* .useIsomorphicEffect */ .Y)(function () {
    setCanResend(false);
    setRequestingResend(false);
  }, [verification]);
  var resendCodeTextRef = (0,hooks_useCountdown__WEBPACK_IMPORTED_MODULE_12__/* .useCountDown */ .h)(verification === null || verification === void 0 ? void 0 : verification.nextResendTime, function (s, m) {
    return "".concat(s + m * 60);
  }, function () {
    setCanResend(true);
  });
  var expireTimeTextRef = (0,hooks_useCountdown__WEBPACK_IMPORTED_MODULE_12__/* .useCountDown */ .h)(verification === null || verification === void 0 ? void 0 : verification.expireTime, function (s, m) {
    return "".concat(m.toString().padStart(2, '0'), ":").concat(s.toString().padStart(2, '0'));
  });

  var _useForm = (0,hooks_useForm__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    code: {
      validators: [config_constants_formValidator__WEBPACK_IMPORTED_MODULE_6__/* ["default"].required */ .ZP.required, config_constants_formValidator__WEBPACK_IMPORTED_MODULE_6__/* ["default"].requiredLength */ .ZP.requiredLength(6)],
      value: ''
    }
  }),
      states = _useForm.states,
      controls = _useForm.controls,
      validateAll = _useForm.validateAll,
      isValid = _useForm.isValid;

  var handleResendCode = /*#__PURE__*/function () {
    var _ref2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var verification;
      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setRequestingResend(true);
              _context.next = 3;
              return execute(verifiedHunnyRequestFn());

            case 3:
              verification = _context.sent;

              if (verification) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              setVerifiedResult(verification);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleResendCode() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var isValid, data;
      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSubmiting(true);
              _context2.next = 3;
              return validateAll();

            case 3:
              isValid = _context2.sent;

              if (isValid) {
                _context2.next = 7;
                break;
              }

              setSubmiting(false);
              return _context2.abrupt("return");

            case 7:
              _context2.next = 9;
              return onSubmit(verification, states.code.value);

            case 9:
              data = _context2.sent;

              if ((data === null || data === void 0 ? void 0 : data.code) === 'error_auth_input') {
                controls.code.onErrorChanged([config_types_validator__WEBPACK_IMPORTED_MODULE_11__/* .ValidationError.InCorrect */ .p.InCorrect]);
              }

              if ((data === null || data === void 0 ? void 0 : data.code) === 'error_data_expired') {
                controls.code.onErrorChanged([config_types_validator__WEBPACK_IMPORTED_MODULE_11__/* .ValidationError.DataExpired */ .p.DataExpired]);
              }

              if (data.code === 'success') {
                onDismiss();
              }

              setSubmiting(false);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_ForgotPasswordModal__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
    onDismiss: onDismiss,
    label: t('Email Verification'),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledSubtleText, {
      fontWeight: "300",
      lineHeight: "20px",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
        children: "Please enter the 6-digits verification code that was sent to"
      }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("strong", {
        children: email
      }), ".", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
        children: "The code is valid for 10 minutes."
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_FormControl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      mt: "40px",
      state: states.code,
      label: t('Verification Code'),
      formatErrorMessage: function formatErrorMessage(e) {
        return verificationErrorMessages[e[0]];
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_FormControl_FormInput__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        control: controls.code,
        placeholder: t('Enter Code'),
        type: "text",
        name: "verification_code",
        size: 6,
        maxLength: 6,
        icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(svgs__WEBPACK_IMPORTED_MODULE_5__/* .Icons.PasswordIcon */ .P.PasswordIcon, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledSubtleText, {
      mt: "12px",
      fontSize: "14px",
      textAlign: "center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
        children: "Haven\u2019t recieves code"
      }), "?", ' ', canResend ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variant: "text",
        p: "0px !important",
        height: "auto !important",
        onClick: handleResendCode,
        disabled: requestingResend,
        children: requestingResend ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          fontSize: "14px",
          color: "textSubtle",
          bold: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Loader_Dots__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
              children: "Sending"
            })
          })
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          fontSize: "14px",
          color: "primary",
          bold: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
            children: "Resend now"
          })
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
          children: "Resend in"
        }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("span", {
          ref: resendCodeTextRef,
          children: "..."
        }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
          children: "seconds"
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      mt: ['24px', '24px', '40px'],
      disabled: !isValid || !states.code.value || submiting,
      onClick: handleSubmit,
      children: [submiting && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Box_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        mr: "12px",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Loader_CircleLoader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        bold: true,
        fontSize: "14px",
        color: submiting ? 'textSubtle' : 'text',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
          children: "Verify"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      mt: "60px",
      fontSize: "14px",
      color: "textSubtle",
      textAlign: "center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .c, {
        children: "Code will be expired in"
      }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("strong", {
        ref: expireTimeTextRef,
        children: "..."
      })]
    })]
  });
};

var StyledSubtleText = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)(components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
  color: 'textSubtle'
}).withConfig({
  displayName: "EmailVerificationModal__StyledSubtleText",
  componentId: "sc-mydu6p-0"
})(["\n  strong {\n    color: ", ";\n  }\n"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.text;
});
/* harmony default export */ __webpack_exports__["Z"] = (EmailVerificationModal);

/***/ }),

/***/ 22404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4730);
/* harmony import */ var components_Modal_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19521);
/* harmony import */ var components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1227);
/* harmony import */ var components_Modal_components_ModalBody__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23043);
/* harmony import */ var components_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67498);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57214);
/* harmony import */ var components_Button_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19784);
/* harmony import */ var svgs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8400);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


var _excluded = ["onDismiss", "label", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var ForgotPasswordModal = function ForgotPasswordModal(_ref) {
  var onDismiss = _ref.onDismiss,
      label = _ref.label,
      children = _ref.children,
      props = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledModal, _objectSpread(_objectSpread({
    onDismiss: onDismiss
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(components_Modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalHeader */ .xB, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_Button_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        ml: "24px",
        onClick: onDismiss,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(svgs__WEBPACK_IMPORTED_MODULE_8__/* .Icons.BackIcon */ .P.BackIcon, {
          width: "24px",
          height: "24px"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        scale: "xs",
        ml: "12px",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .Trans */ .c, {
          children: label
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_Modal_components_ModalBody__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      borderRadius: theme__WEBPACK_IMPORTED_MODULE_6__/* ["default"].radii.modal */ .Z.radii.modal,
      height: "100%",
      p: ['24px', '24px', '40px'],
      children: children
    })]
  }));
};

var StyledModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(components_Modal_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
  displayName: "ForgotPasswordModal__StyledModal",
  componentId: "sc-1ogq455-0"
})(["\n  ", " {\n    min-width: 440px !important;\n    max-width: 440px !important;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueries.sm;
});
/* harmony default export */ __webpack_exports__["Z"] = (ForgotPasswordModal);

/***/ }),

/***/ 43624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ views_Authentication; }
});

// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(89395);
// EXTERNAL MODULE: ./src/components/Heading/index.ts
var Heading = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/components/Modal/components/ModalBody.tsx
var ModalBody = __webpack_require__(23043);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx
var Modal = __webpack_require__(20458);
// EXTERNAL MODULE: ./src/components/Text/index.ts
var Text = __webpack_require__(19500);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useDetectKeyboardOpen.ts


var useDetectKeyboardOpen = function useDetectKeyboardOpen() {
  var minKeyboardHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState = (0,react.useState)(defaultValue),
      isKeyboardOpen = _useState[0],
      setIsKeyboardOpen = _useState[1];

  (0,react.useEffect)(function () {
    var listener = function listener() {
      if (!window) return;
      var newState = window.screen.height - minKeyboardHeight > window.visualViewport.height;

      if (isKeyboardOpen !== newState) {
        setIsKeyboardOpen(newState);
      } else {
        setIsKeyboardOpen(false);
      }
    };

    window.visualViewport.addEventListener('resize', listener, {
      passive: true
    });
    return function () {
      window.visualViewport.removeEventListener('resize', listener);
    };
  }, []);
  return (0,react.useMemo)(function () {
    return isKeyboardOpen;
  }, [isKeyboardOpen]);
};

/* harmony default export */ var hooks_useDetectKeyboardOpen = (useDetectKeyboardOpen);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 3 modules
var Trans = __webpack_require__(93955);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var hooks = __webpack_require__(71581);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/config/types/authentication.ts
var authentication = __webpack_require__(87876);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(59441);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/hooks/useComponentOnScreen.ts
var useComponentOnScreen = __webpack_require__(49082);
// EXTERNAL MODULE: ./src/hooks/useNextImage.ts
var useNextImage = __webpack_require__(7715);
// EXTERNAL MODULE: ./src/components/Image/StyledNextImage.tsx
var StyledNextImage = __webpack_require__(74053);
// EXTERNAL MODULE: ./src/components/Image/observerOptions.ts
var observerOptions = __webpack_require__(36379);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Image/BackgroundImage.tsx


var _excluded = ["src", "alt", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var BackgroundImage = function BackgroundImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useComponentOnScreen = (0,useComponentOnScreen/* default */.Z)(observerOptions/* default */.Z),
      isLoaded = _useComponentOnScreen.isLoaded,
      ref = _useComponentOnScreen.ref;

  var _useNextImage = (0,useNextImage/* default */.Z)(src),
      isNextImgSupport = _useNextImage.isNextImgSupport,
      imgProps = _useNextImage.imgProps;

  return isNextImgSupport ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, _objectSpread(_objectSpread({
    ref: ref,
    position: "relative"
  }, props), {}, {
    children: [isLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledNextImage/* default */.Z, _objectSpread({
      quality: 100,
      src: src,
      alt: alt || 'Hunny Play',
      priority: true,
      objectFit: "cover",
      layout: "fill"
    }, imgProps)), children]
  })) : /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWrapper, _objectSpread(_objectSpread({
    src: src,
    ref: ref
  }, props), {}, {
    children: children
  }));
};
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "BackgroundImage__StyledWrapper",
  componentId: "sc-10ld7cv-0"
})(["\n  background-image: url(", ");\n"], function (_ref2) {
  var src = _ref2.src;
  return src;
});
/* harmony default export */ var Image_BackgroundImage = (BackgroundImage);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Introduction.tsx










var Introduction = function Introduction(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    src: "/images/auth-background.png",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      mt: "20px",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
        width: 140,
        height: 20,
        alt: "hunny-logo",
        src: "/logo-text.png"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        mb: "8px",
        fontSize: ['16px'],
        textAlign: "center",
        fontWeight: "bold",
        lineHeight: "20px",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        width: "70%",
        fontFamily: "Montserrat",
        fontSize: ['12px'],
        fontWeight: 400,
        lineHeight: "16px",
        textAlign: "center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
          children: "The Most Engaging and Fun Poker Game on Chain!"
        })
      })]
    })]
  });
};
var Container = (0,styled_components_browser_esm/* default */.ZP)(Image_BackgroundImage).withConfig({
  displayName: "Introduction__Container",
  componentId: "sc-12xhhv8-0"
})(["\n  display: none;\n  box-sizing: border-box;\n  background-size: cover;\n  background-position: center center;\n  border-top-left-radius: ", ";\n  border-bottom-left-radius: ", ";\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 20px;\n  width: 100%;\n  height: 100%;\n\n  ", " {\n    display: flex;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.extraLarge;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.extraLarge;
}, function (_ref4) {
  var mediaQueries = _ref4.theme.mediaQueries;
  return mediaQueries.md;
});
var Content = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "Introduction__Content",
  componentId: "sc-12xhhv8-1"
})(["\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 10px;\n  line-height: 18px;\n  z-index: 1;\n\n  ", " {\n    padding: 20px 20px;\n  }\n"], function (_ref5) {
  var mediaQueries = _ref5.theme.mediaQueries;
  return mediaQueries.md;
});
/* harmony default export */ var components_Introduction = ((/* unused pure expression or super */ null && (Introduction)));
// EXTERNAL MODULE: ./src/components/Checkbox/index.tsx + 1 modules
var Checkbox = __webpack_require__(34812);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.ts
var useQueryParam = __webpack_require__(77059);
// EXTERNAL MODULE: ./src/hooks/useRouter.ts
var useRouter = __webpack_require__(49279);
;// CONCATENATED MODULE: ./src/hooks/useReferralCode.ts


var useReferralCode = function useReferralCode() {
  var _router$query, _router$query$join;

  var router = (0,useRouter/* useRouter */.t)();
  var hunnypokerRefCode = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : (_router$query$join = _router$query.join) === null || _router$query$join === void 0 ? void 0 : _router$query$join.toString();
  return (0,react.useMemo)(function () {
    return {
      refCode: hunnypokerRefCode
    };
  }, [hunnypokerRefCode]);
};
;// CONCATENATED MODULE: ./src/views/Authentication/components/ReferralCode.tsx


function ReferralCode_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ReferralCode_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ReferralCode_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ReferralCode_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var ReferralCode = function ReferralCode(props) {
  var _catchedRefCode$curre;

  var refCode = useReferralCode();
  var catchedRefCode = (0,react.useRef)(refCode);

  var _useQueryParam = (0,useQueryParam/* default */.Z)(),
      removeParam = _useQueryParam.removeParam,
      addParam = _useQueryParam.addParam;

  var handleToggleApplyReferral = function handleToggleApplyReferral() {
    if (refCode.refCode) {
      removeParam('join');
    } else {
      addParam('join', catchedRefCode.current.refCode);
    }
  };

  return ((_catchedRefCode$curre = catchedRefCode.current) === null || _catchedRefCode$curre === void 0 ? void 0 : _catchedRefCode$curre.refCode) && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledReferralContainer, ReferralCode_objectSpread(ReferralCode_objectSpread({
    onClick: handleToggleApplyReferral
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
      width: "18px",
      height: "18px",
      mr: "8px",
      value: !!refCode.refCode,
      onValueChanged: function onValueChanged() {}
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      color: "textTertiary",
      fontSize: "12px",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
        children: ["Applied referral code ", {
          referralCode: catchedRefCode.current.refCode
        }]
      })
    })]
  }));
};

var StyledReferralContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "ReferralCode__StyledReferralContainer",
  componentId: "sc-c7gst6-0"
})(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n"]);
/* harmony default export */ var components_ReferralCode = (ReferralCode);
// EXTERNAL MODULE: ./src/components/Tabs/index.tsx + 4 modules
var Tabs = __webpack_require__(40296);
// EXTERNAL MODULE: ./src/components/Tab/index.tsx
var Tab = __webpack_require__(45918);
;// CONCATENATED MODULE: ./src/views/Authentication/components/SwitchMethod.tsx


var SwitchMethod_excluded = ["method", "onMethodChange"];

function SwitchMethod_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SwitchMethod_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SwitchMethod_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SwitchMethod_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var SwitchMethod = function SwitchMethod(_ref) {
  var method = _ref.method,
      onMethodChange = _ref.onMethodChange,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, SwitchMethod_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, SwitchMethod_objectSpread(SwitchMethod_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
      value: method,
      onTagChanged: onMethodChange,
      indicator: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIndicator, {}),
      width: "100%",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTabContainer, {
        id: "switchview-wallet",
        value: authentication/* AuthModalMethodEnums.WEB3 */.h.WEB3,
        $active: method === authentication/* AuthModalMethodEnums.WEB3 */.h.WEB3,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          fontSize: "14px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Wallet"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTabContainer, {
        id: "switchview-email",
        value: authentication/* AuthModalMethodEnums.TRADITIONAL */.h.TRADITIONAL,
        $active: method === authentication/* AuthModalMethodEnums.TRADITIONAL */.h.TRADITIONAL,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          fontSize: "14px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Email"
          })
        })
      })]
    })
  }));
};

var StyledIndicator = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "SwitchMethod__StyledIndicator",
  componentId: "sc-1yxzj6u-0"
})(["\n  background: ", ";\n  border-radius: ", ";\n  height: 100%;\n  width: 100%;\n"], function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.colors.backgroundAlt3, "a0");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.small;
});
var StyledTabContainer = (0,styled_components_browser_esm/* default */.ZP)(Tab/* default */.Z).withConfig({
  displayName: "SwitchMethod__StyledTabContainer",
  componentId: "sc-1yxzj6u-1"
})(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 40px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n\n  width: 50%;\n\n  ", " {\n    z-index: 1;\n    transition: ", ";\n    color: ", ";\n    white-space: pre !important;\n  }\n\n  &:hover,\n  &:focus-visible {\n    ", " {\n      color: ", ";\n      white-space: pre !important;\n    }\n  }\n"], Text/* default */.Z, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transitions.fast;
}, function (_ref5) {
  var theme = _ref5.theme,
      $active = _ref5.$active;
  return $active ? "".concat(theme.colors.text, " !important") : theme.colors.textSubtle;
}, Text/* default */.Z, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.text;
});
/* harmony default export */ var components_SwitchMethod = (SwitchMethod);
;// CONCATENATED MODULE: ./src/views/Authentication/components/SwitchPage.tsx










var SwitchPage = function SwitchPage(_ref) {
  var _dataMapping;

  var presentedPage = _ref.presentedPage,
      onSwitchPage = _ref.onSwitchPage;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var dataMapping = (_dataMapping = {}, (0,defineProperty/* default */.Z)(_dataMapping, authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN, {
    // eslint-disable-next-line quotes, @typescript-eslint/quotes
    title: t("Don't have an account?"),
    onClick: function onClick() {
      return onSwitchPage(authentication/* AuthModalPageEnums.SIGN_UP */.i.SIGN_UP);
    },
    buttonTitle: t('Sign up')
  }), (0,defineProperty/* default */.Z)(_dataMapping, authentication/* AuthModalPageEnums.SIGN_UP */.i.SIGN_UP, {
    title: t('Already have an account?'),
    onClick: function onClick() {
      return onSwitchPage(authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN);
    },
    buttonTitle: t('Log in')
  }), _dataMapping);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SwitchPage_Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      fontSize: ['14px'],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
        children: dataMapping[presentedPage].title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SwitchPage_Content, {
      id: presentedPage === authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN ? 'footer-signup-text' : 'footer-login-text',
      onClick: dataMapping[presentedPage].onClick,
      ml: "5px",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonTitle, {
        children: dataMapping[presentedPage].buttonTitle
      })
    })]
  });
};

var StyledButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
  displayName: "SwitchPage__StyledButtonTitle",
  componentId: "sc-196bfd7-0"
})(["\n  color: ", ";\n  font-weight: 700;\n  font-size: 14px;\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
var SwitchPage_Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "SwitchPage__Container",
  componentId: "sc-196bfd7-1"
})(["\n  display: flex;\n  word-break: break-all;\n  white-space: pre;\n"]);
var SwitchPage_Content = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "SwitchPage__Content",
  componentId: "sc-196bfd7-2"
})(["\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.85;\n  }\n"]);
/* harmony default export */ var components_SwitchPage = (SwitchPage);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx + 1 modules
var Text_Text = __webpack_require__(50011);
// EXTERNAL MODULE: ./src/layout/Components/Column.tsx
var Column = __webpack_require__(64533);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Template.tsx



var Template_excluded = ["children"];

function Template_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Template_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Template_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Template_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Header = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Template__Header",
  componentId: "sc-6tyao3-0"
})(["\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  padding: 20px;\n\n  ", " {\n    border-bottom: none;\n    align-items: flex-end;\n  }\n\n  ", " {\n    padding: 0px 40px;\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.stroke;
}, function (_ref2) {
  var mediaQueries = _ref2.theme.mediaQueries;
  return mediaQueries.sm;
}, function (_ref3) {
  var mediaQueries = _ref3.theme.mediaQueries;
  return mediaQueries.md;
});
var Template_Content = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Template__Content",
  componentId: "sc-6tyao3-1"
})(["\n  margin: auto 0;\n  padding: 20px;\n\n  ", " {\n    min-width: 400px;\n  }\n\n  ", " {\n    padding: 32px 40px;\n  }\n"], function (_ref4) {
  var mediaQueries = _ref4.theme.mediaQueries;
  return mediaQueries.sm;
}, function (_ref5) {
  var mediaQueries = _ref5.theme.mediaQueries;
  return mediaQueries.md;
});
var Footer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Template__Footer",
  componentId: "sc-6tyao3-2"
})(["\n  height: 60px;\n  padding: 20px;\n\n  ", " {\n    padding: 0px 40px;\n  }\n"], function (_ref6) {
  var mediaQueries = _ref6.theme.mediaQueries;
  return mediaQueries.md;
});
var Template = function Template(_ref7) {
  var children = _ref7.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref7, Template_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Template_Container, Template_objectSpread(Template_objectSpread({}, rest), {}, {
    children: children.map(function (child) {
      return child;
    })
  }));
};
var ConditionAcccess = function ConditionAcccess(_ref8) {
  var props = (0,esm_extends/* default */.Z)({}, _ref8);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Column/* default */.ZP, Template_objectSpread(Template_objectSpread({
    flex: 1,
    justifyContent: "flex-start !important",
    maxWidth: ['100%', '', '80%', '100%'],
    mt: "16px"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      display: "inline",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
        as: "span",
        fontWeight: 500,
        fontSize: "12px",
        mr: "4px",
        lineHeight: "16px",
        color: "textTertiary",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
          children: "By accessing the site, I confirm that I am over 18 years old"
        })
      })
    })
  }));
};
var Template_Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "Template__Container",
  componentId: "sc-6tyao3-3"
})(["\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"]);
/* harmony default export */ var components_Template = ((/* unused pure expression or super */ null && (Template)));
// EXTERNAL MODULE: ./src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(58491);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./src/state/auth/action.ts
var action = __webpack_require__(3805);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/hooks/useForm.ts
var useForm = __webpack_require__(16145);
// EXTERNAL MODULE: ./src/config/constants/formValidator.ts
var formValidator = __webpack_require__(96584);
// EXTERNAL MODULE: ./src/components/FormControl/FormInput.tsx + 2 modules
var FormInput = __webpack_require__(38097);
// EXTERNAL MODULE: ./src/components/FormControl/index.tsx + 1 modules
var FormControl = __webpack_require__(66938);
// EXTERNAL MODULE: ./src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(19784);
;// CONCATENATED MODULE: ./src/hooks/useToggle.ts


function useToggle(defaultValue) {
  var _useState = (0,react.useState)(!!defaultValue),
      value = _useState[0],
      setValue = _useState[1];

  var toggle = (0,react.useCallback)(function () {
    return setValue(function (x) {
      return !x;
    });
  }, []);
  return [value, toggle, setValue];
}

/* harmony default export */ var hooks_useToggle = (useToggle);
// EXTERNAL MODULE: ./src/svgs/index.ts + 103 modules
var svgs = __webpack_require__(8400);
;// CONCATENATED MODULE: ./src/components/FormControl/FormInputPassword.tsx



var FormInputPassword_excluded = ["adornment", "control"];

function FormInputPassword_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FormInputPassword_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FormInputPassword_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FormInputPassword_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var FormInputPassword = function FormInputPassword(_ref) {
  var adornment = _ref.adornment,
      control = _ref.control,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, FormInputPassword_excluded);

  var _useToggle = hooks_useToggle(false),
      _useToggle2 = (0,slicedToArray/* default */.Z)(_useToggle, 2),
      toggle = _useToggle2[0],
      setToggle = _useToggle2[1];

  var passwordAdornment = control.value && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
    onClick: setToggle,
    children: toggle ? /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.EyeRevealIcon */.P.EyeRevealIcon, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.EyeIcon */.P.EyeIcon, {})
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPasswordInput, FormInputPassword_objectSpread({
    autoComplete: "on",
    adornment: passwordAdornment,
    control: control,
    type: toggle ? 'text' : 'password',
    name: "password",
    $showText: toggle || !control.value
  }, props));
};

var StyledPasswordInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
  displayName: "FormInputPassword__StyledPasswordInput",
  componentId: "sc-mtbtl5-0"
})(["\n  ", "\n"], function (_ref2) {
  var $showText = _ref2.$showText;
  return !$showText ? (0,styled_components_browser_esm/* css */.iv)(["\n          font-size: 16px;\n          font-family: Verdana;\n        "]) : '';
});
/* harmony default export */ var FormControl_FormInputPassword = (FormInputPassword);
// EXTERNAL MODULE: ./src/config/types/validator.ts
var validator = __webpack_require__(1872);
// EXTERNAL MODULE: ./src/components/OpenEffect/index.tsx
var OpenEffect = __webpack_require__(5790);
// EXTERNAL MODULE: ./src/components/Input/styled.tsx
var styled = __webpack_require__(9025);
;// CONCATENATED MODULE: ./src/hooks/useCallbackValueOnDestroy.ts


var useCallbackValueOnDestroy = function useCallbackValueOnDestroy(value, callback) {
  var valueRef = (0,react.useRef)(value);
  (0,react.useEffect)(function () {
    valueRef.current = value;
  }, [value]);
  (0,react.useEffect)(function () {
    return function () {
      callback(valueRef.current);
    };
  }, []);
};

/* harmony default export */ var hooks_useCallbackValueOnDestroy = (useCallbackValueOnDestroy);
// EXTERNAL MODULE: ./src/hooks/useModal.ts
var useModal = __webpack_require__(13911);
// EXTERNAL MODULE: ./src/hooks/useDebounceCallback.ts
var useDebounceCallback = __webpack_require__(47520);
// EXTERNAL MODULE: ./src/components/Loader/CircleLoader.tsx
var CircleLoader = __webpack_require__(95322);
// EXTERNAL MODULE: ./src/services/AuthenticationService.ts
var AuthenticationService = __webpack_require__(66475);
// EXTERNAL MODULE: ./src/utils/requestHelper.ts
var requestHelper = __webpack_require__(75391);
// EXTERNAL MODULE: ./src/hooks/useRequest.ts
var useRequest = __webpack_require__(89058);
// EXTERNAL MODULE: ./src/views/Authentication/components/Traditional/modals/EmailVerificationModal.tsx
var EmailVerificationModal = __webpack_require__(5730);
// EXTERNAL MODULE: ./src/views/Authentication/components/Traditional/modals/ForgotPasswordModal.tsx
var ForgotPasswordModal = __webpack_require__(22404);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(42474);
var crypto_browserify_default = /*#__PURE__*/__webpack_require__.n(crypto_browserify);
;// CONCATENATED MODULE: ./src/utils/auth.ts
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

var hashPassword = function hashPassword(plainTextPassword) {
  return crypto_browserify_default().createHash('sha512').update(plainTextPassword).digest('base64');
}; // Encrypt password from client side

var encryptPassword = function encryptPassword(hashPassword, key, iv) {
  try {
    // Create cipher with key and iv
    var cipher = crypto_browserify_default().createCipheriv('aes-128-gcm', key, iv); // Encrypt the plain text password

    var encrypted = Buffer.concat([cipher.update(hashPassword), cipher["final"]()]); // Get authentication tag and concatenate the iv, encrypted message

    var authTag = cipher.getAuthTag();
    var encryptedData = Buffer.concat([encrypted, authTag]);
    return encryptedData.toString('base64');
  } catch (e) {
    return null;
  }
};
var constructEncryptedPassword = function constructEncryptedPassword(plaintextPwd, nonce) {
  var hashedPassword = hashPassword(plaintextPwd + nonce.value); // plaintext password + nonce

  var encryptedPassword = encryptPassword(hashedPassword, nonce.key, nonce.token); // hashed password, nonceId, token

  return encryptedPassword;
};
// EXTERNAL MODULE: ./src/utils/toastify.tsx
var toastify = __webpack_require__(7006);
// EXTERNAL MODULE: ./src/config/constants/auth.ts
var auth = __webpack_require__(55711);
// EXTERNAL MODULE: ./src/hooks/useFetchUserProfile.tsx + 2 modules
var useFetchUserProfile = __webpack_require__(54040);
// EXTERNAL MODULE: ./src/state/app/actions.ts
var actions = __webpack_require__(85089);
// EXTERNAL MODULE: ./src/utils/fingerprint.ts
var fingerprint = __webpack_require__(44886);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Traditional/hooks.ts











var useSignInWithEmail = function useSignInWithEmail() {
  var dispatch = (0,state/* useAppDispatch */.TL)();
  var handleFetchUserProfile = (0,useFetchUserProfile/* useFetchUserProfile */.Q)();
  return (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(password, email) {
      var prepareResponse, deviceUid, response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AuthenticationService/* default.getTraditionalSignInPrepare */.Z.getTraditionalSignInPrepare(email).call();

            case 2:
              prepareResponse = _context.sent;

              if (prepareResponse !== null && prepareResponse !== void 0 && prepareResponse.data) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", {
                code: 'error'
              });

            case 5:
              _context.next = 7;
              return (0,fingerprint/* getID */.V)();

            case 7:
              deviceUid = _context.sent;
              _context.next = 10;
              return AuthenticationService/* default.signInByEmail */.Z.signInByEmail({
                deviceUid: deviceUid,
                email: email,
                password: constructEncryptedPassword(password, prepareResponse.data)
              });

            case 10:
              response = _context.sent;

              if ((response === null || response === void 0 ? void 0 : response.code) === 'success') {
                dispatch((0,actions/* updateDeviceUid */.Lg)({
                  deviceUid: deviceUid
                }));
                dispatch((0,action/* signedExecuteLogin */.Sv)({
                  loginBy: auth/* LoginMethod.Email */.p.Email,
                  wallet: null
                }));
                dispatch((0,actions/* setIsSigned */.vX)({
                  isSigned: true,
                  atTime: new Date().getTime()
                }));
                handleFetchUserProfile();
              }

              return _context.abrupt("return", response);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [dispatch, handleFetchUserProfile]);
};
;// CONCATENATED MODULE: ./src/views/Authentication/components/Traditional/modals/ResetPasswordFormModal.tsx



var _resetPasswordErrorMe;






















var resetPasswordErrorMessages = (_resetPasswordErrorMe = {}, (0,defineProperty/* default */.Z)(_resetPasswordErrorMe, validator/* ValidationError.Required */.p.Required, 'Please enter your password'), (0,defineProperty/* default */.Z)(_resetPasswordErrorMe, validator/* ValidationError.NotEqual */.p.NotEqual, 'Password does not match.'), _resetPasswordErrorMe);

var ResetPasswordFormModal = function ResetPasswordFormModal(_ref) {
  var onDismiss = _ref.onDismiss,
      _ref$data = _ref.data,
      email = _ref$data.email,
      nonce = _ref$data.nonce;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      submiting = _useState[0],
      setSubmiting = _useState[1];

  var signIn = useSignInWithEmail();

  var _useForm = (0,useForm/* default */.Z)({
    password: {
      validators: [formValidator/* default.required */.ZP.required, formValidator/* default.inputLength */.ZP.inputLength({
        min: 8
      }), formValidator/* default.requiredNumber */.ZP.requiredNumber, formValidator/* default.requiredUppercase */.ZP.requiredUppercase, formValidator/* default.blockCharaters */.ZP.blockCharaters([' '])],
      value: '',
      validateOnChange: true
    },
    confirmPassword: {
      formValidators: [formValidator/* default.equal */.ZP.equal('$password')],
      value: '',
      validateOnChange: true
    }
  }),
      states = _useForm.states,
      controls = _useForm.controls,
      validateAll = _useForm.validateAll,
      isValid = _useForm.isValid;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var isValid, submitRes, response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmiting(true);
              _context.next = 3;
              return validateAll();

            case 3:
              isValid = _context.sent;

              if (isValid) {
                _context.next = 7;
                break;
              }

              setSubmiting(false);
              return _context.abrupt("return");

            case 7:
              _context.next = 9;
              return AuthenticationService/* default.submitResetPassword */.Z.submitResetPassword({
                newPassword: constructEncryptedPassword(states.password.value, nonce),
                nonce: nonce,
                email: email
              });

            case 9:
              submitRes = _context.sent;

              if (!(submitRes.code === 'success')) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return signIn(states.password.value, email);

            case 13:
              response = _context.sent;

              if (response.code === 'success') {
                toastify/* HunnyToast.success */.f.success('Password reset successful', 'Awesome, you have successfully updated your password');
                onDismiss();
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgotPasswordModal/* default */.Z, {
    id: "",
    onDismiss: onDismiss,
    label: t('Reset Password'),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
        children: "Please enter your new password"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
      mt: "12px",
      state: states.password,
      label: t('Password'),
      formatErrorMessage: function formatErrorMessage(errors) {
        return t(resetPasswordErrorMessages[errors[0]]);
      },
      instructionConfig: [{
        message: t('Use at least 8 characters'),
        validationError: validator/* ValidationError.TooShort */.p.TooShort
      }, {
        message: t('Use 1 or more number'),
        validationError: validator/* ValidationError.RequiredNumber */.p.RequiredNumber
      }, {
        message: t('Use upper case characters'),
        validationError: validator/* ValidationError.RequiredUppercase */.p.RequiredUppercase
      }, {
        message: t('Password does not allow space'),
        validationError: validator/* ValidationError.IncorrectType */.p.IncorrectType
      }],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl_FormInputPassword, {
        control: controls.password,
        placeholder: t('Password'),
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.PasswordIcon */.P.PasswordIcon, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
      mt: "20px",
      state: states.confirmPassword,
      label: t('Confirm Password'),
      formatErrorMessage: function formatErrorMessage(errors) {
        return t(resetPasswordErrorMessages[errors[0]]);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl_FormInputPassword, {
        control: controls.confirmPassword,
        placeholder: t('Confirm Password'),
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.PasswordIcon */.P.PasswordIcon, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
      id: "submit-button",
      mt: ['24px', '24px', '40px'],
      disabled: !isValid || !states.password.value || submiting,
      onClick: handleSubmit,
      children: [submiting && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        mr: "12px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        bold: true,
        fontSize: "14px",
        color: submiting ? 'textSubtle' : 'text',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
          children: "Reset Password"
        })
      })]
    })]
  });
};

/* harmony default export */ var modals_ResetPasswordFormModal = (ResetPasswordFormModal);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Traditional/modals/PasswordRecoveryModal.tsx


























var emailErrorMessages = (0,defineProperty/* default */.Z)({}, validator/* ValidationError.Email */.p.Email, formValidator/* commomErrorMessage.Email */.UT.Email);

var buildEmailNotExistedFn = function buildEmailNotExistedFn(value) {
  var request = AuthenticationService/* default.getTraditionalSignUpPrepare */.Z.getTraditionalSignUpPrepare({
    email: value,
    referralCode: null
  });
  return (0,requestHelper/* transformHunnyRequest */.Tc)(request, function (res) {
    return !!(res !== null && res !== void 0 && res.data);
  });
};

var PasswordRecoveryModal = function PasswordRecoveryModal(_ref) {
  var onDismiss = _ref.onDismiss,
      _ref$data = _ref.data,
      email = _ref$data.email,
      switchSignUpPage = _ref$data.switchSignUpPage;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      submiting = _useState[0],
      setSubmiting = _useState[1];

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute;

  var _useModal = (0,useModal/* default */.Z)(EmailVerificationModal/* default */.Z),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      handlePresentEmailVerificationModal = _useModal2[0];

  var _useModal3 = (0,useModal/* default */.Z)(modals_ResetPasswordFormModal),
      _useModal4 = (0,slicedToArray/* default */.Z)(_useModal3, 1),
      handlePresentResetPasswordModal = _useModal4[0];

  var _useForm = (0,useForm/* default */.Z)({
    email: {
      validators: [formValidator/* default.email */.ZP.email, formValidator/* default.existEmail */.ZP.existEmail(buildEmailNotExistedFn)],
      value: email
    }
  }),
      states = _useForm.states,
      controls = _useForm.controls,
      validateAll = _useForm.validateAll,
      isValid = _useForm.isValid;

  var formatErrorMessage = function formatErrorMessage(errors) {
    if (errors[0] === validator/* ValidationError.EmailNotExist */.p.EmailNotExist) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
        children: ["Email not registered. Please enter a different email or", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          id: "footer-signup",
          color: "primary",
          display: "inline",
          fontSize: "12px",
          bold: true,
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick() {
            switchSignUpPage(states.email.value);
            onDismiss();
          },
          children: "Sign up"
        }), ' ', "new account."]
      });
    }

    return t(emailErrorMessages[errors[0]]);
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var isValid, verification;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSubmiting(true);
              _context2.next = 3;
              return validateAll();

            case 3:
              isValid = _context2.sent;

              if (isValid) {
                _context2.next = 7;
                break;
              }

              setSubmiting(false);
              return _context2.abrupt("return");

            case 7:
              _context2.next = 9;
              return execute(AuthenticationService/* default.verifyResetPassword */.Z.verifyResetPassword(states.email.value));

            case 9:
              verification = _context2.sent;

              if (verification !== null && verification !== void 0 && verification.data) {
                _context2.next = 13;
                break;
              }

              setSubmiting(false); // TODO Show error

              return _context2.abrupt("return");

            case 13:
              handlePresentEmailVerificationModal({
                email: states.email.value,
                initialVerifiedResult: verification.data,
                verifiedHunnyRequestFn: function verifiedHunnyRequestFn() {
                  return (0,requestHelper/* transformHunnyRequest */.Tc)(AuthenticationService/* default.verifyResetPassword */.Z.verifyResetPassword(states.email.value), function (res) {
                    return res === null || res === void 0 ? void 0 : res.data;
                  });
                },
                onSubmit: function () {
                  var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(verification, otp) {
                    var passwordNonce;
                    return regenerator_default().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return AuthenticationService/* default.validateResetPassword */.Z.validateResetPassword(states.email.value, {
                              token: verification.token,
                              otp: otp
                            });

                          case 2:
                            passwordNonce = _context.sent;

                            if (passwordNonce !== null && passwordNonce !== void 0 && passwordNonce.data) {
                              handlePresentResetPasswordModal({
                                nonce: passwordNonce.data,
                                email: states.email.value
                              });
                            }

                            return _context.abrupt("return", passwordNonce);

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function onSubmit(_x, _x2) {
                    return _onSubmit.apply(this, arguments);
                  }

                  return onSubmit;
                }()
              });
              onDismiss();

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgotPasswordModal/* default */.Z, {
    id: "popup-resetpassword",
    onDismiss: onDismiss,
    label: t('Reset Password'),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
        children: "Please enter your email"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
      mt: "20px",
      state: states.email,
      label: t('Email'),
      formatErrorMessage: formatErrorMessage,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
        control: controls.email,
        placeholder: t('Email'),
        type: "email",
        name: "email",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.EmailIcon */.P.EmailIcon, {}),
        adornment: states.email.isValidating ? /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          className: "hide-when-focus",
          height: "20px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
        }) : null
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
      id: "submit-button",
      mt: ['24px', '24px', '40px'],
      disabled: !isValid || !states.email.value || submiting,
      onClick: handleSubmit,
      children: [submiting && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        mr: "12px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        bold: true,
        fontSize: "14px",
        color: submiting ? 'textSubtle' : 'text',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
          children: "Reset Password"
        })
      })]
    })]
  });
};

/* harmony default export */ var modals_PasswordRecoveryModal = (PasswordRecoveryModal);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Traditional/TraditionalLoginForm.tsx




var _email, _password;



























var loginFormErrorMessages = {
  email: (_email = {}, (0,defineProperty/* default */.Z)(_email, validator/* ValidationError.Email */.p.Email, formValidator/* commomErrorMessage.Email */.UT.Email), (0,defineProperty/* default */.Z)(_email, validator/* ValidationError.Required */.p.Required, 'Please enter your email'), _email),
  password: (_password = {}, (0,defineProperty/* default */.Z)(_password, validator/* ValidationError.Required */.p.Required, 'Please enter your password'), (0,defineProperty/* default */.Z)(_password, validator/* ValidationError.WrongPassword */.p.WrongPassword, 'Incorrect password'), _password)
};

var TraditionalLoginForm = function TraditionalLoginForm(_ref) {
  var initialEmail = _ref.initialEmail,
      saveEmail = _ref.saveEmail,
      setPage = _ref.setPage;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var signIn = useSignInWithEmail();
  var debounceCallback = (0,useDebounceCallback/* default */.Z)();

  var _useState = (0,react.useState)(false),
      submiting = _useState[0],
      setSubmiting = _useState[1];

  var _useModal = (0,useModal/* default */.Z)(modals_PasswordRecoveryModal),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      handlePresentPasswordRecoveryModal = _useModal2[0];

  var _useForm = (0,useForm/* default */.Z)({
    email: {
      validators: [formValidator/* default.required */.ZP.required, formValidator/* default.email */.ZP.email],
      value: ''
    },
    password: {
      validators: [formValidator/* default.required */.ZP.required],
      value: ''
    }
  }),
      states = _useForm.states,
      controls = _useForm.controls,
      validateAll = _useForm.validateAll,
      isValid = _useForm.isValid;

  (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function () {
    debounceCallback(function () {
      controls.email.onValueChanged(initialEmail);
    }, 150);
  }, [initialEmail]);
  hooks_useCallbackValueOnDestroy(states.email.value, saveEmail);

  var formatEmailErrorMessage = function formatEmailErrorMessage(errors) {
    if (errors[0] === validator/* ValidationError.EmailNotExist */.p.EmailNotExist) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
        children: ["This email does not exist. Please enter a different email or", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          color: "primary",
          display: "inline",
          fontSize: "12px",
          bold: true,
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick() {
            setPage(authentication/* AuthModalPageEnums.SIGN_UP */.i.SIGN_UP);
          },
          children: "Sign up"
        }), ' ', "new account."]
      });
    }

    return t(loginFormErrorMessages.email[errors[0]]);
  };

  var handleSignIn = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var isValid, data;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmiting(true);
              _context.next = 3;
              return validateAll();

            case 3:
              isValid = _context.sent;

              if (isValid) {
                _context.next = 7;
                break;
              }

              setSubmiting(false);
              return _context.abrupt("return");

            case 7:
              _context.next = 9;
              return signIn(states.password.value, states.email.value);

            case 9:
              data = _context.sent;
              setSubmiting(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSignIn() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(OpenEffect/* default */.Z, {
    openType: "slideBottomToTop",
    duration: 0.5,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      as: "form",
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        handleSignIn();
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormControl, {
        state: states.email,
        label: t('Email'),
        formatErrorMessage: formatEmailErrorMessage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
          control: controls.email,
          placeholder: t('Email'),
          type: "email",
          name: "email",
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.EmailIcon */.P.EmailIcon, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormControl, {
        mt: "12px",
        state: states.password,
        label: t('Password'),
        formatErrorMessage: function formatErrorMessage(errors) {
          return t(loginFormErrorMessages.password[errors[0]]);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl_FormInputPassword, {
          control: controls.password,
          placeholder: t('Password'),
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.PasswordIcon */.P.PasswordIcon, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledForgotPasswordText, {
        fontSize: "12px",
        color: "primary",
        mt: "8px",
        id: "forgotpassword-text",
        onClick: function onClick() {
          handlePresentPasswordRecoveryModal({
            email: states.email.value,
            switchSignUpPage: function switchSignUpPage(draftEmail) {
              controls.email.onValueChanged(draftEmail);
              setTimeout(function () {
                setPage(authentication/* AuthModalPageEnums.SIGN_UP */.i.SIGN_UP);
              });
            }
          });
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
          children: "Forgot Password?"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        type: "submit",
        disabled: !isValid || submiting,
        width: "100%",
        mt: "24px",
        onClick: handleSignIn,
        id: "login-submit-button",
        children: [submiting && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mr: "12px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          bold: true,
          fontSize: "14px",
          color: submiting ? 'textSubtle' : 'text',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Log in"
          })
        })]
      })]
    })
  });
};

var StyledFormControl = (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
  displayName: "TraditionalLoginForm__StyledFormControl",
  componentId: "sc-17jl6qe-0"
})(["\n  ", "\n"], function (_ref3) {
  var state = _ref3.state,
      theme = _ref3.theme;
  return state.errors.length === 0 && state.isDirty ? "\n     ".concat(styled/* InputContainer */.fv, " {\n        background-color: transparent !important;\n        border-color: ").concat(theme.colors.strokeAlt, " !important;\n      }\n    ") : '';
});
var StyledForgotPasswordText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
  displayName: "TraditionalLoginForm__StyledForgotPasswordText",
  componentId: "sc-17jl6qe-1"
})(["\n  text-decoration: underline;\n  cursor: pointer;\n"]);
/* harmony default export */ var Traditional_TraditionalLoginForm = (TraditionalLoginForm);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Traditional/CheckCondition.tsx


var CheckCondition_excluded = ["value", "onValueChanged"];

function CheckCondition_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CheckCondition_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CheckCondition_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CheckCondition_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CheckCondition = function CheckCondition(_ref) {
  var value = _ref.value,
      onValueChanged = _ref.onValueChanged,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, CheckCondition_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Column/* default */.ZP, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        mr: "12px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, CheckCondition_objectSpread({
          width: "18px",
          height: "18px",
          value: value,
          onValueChanged: onValueChanged
        }, props))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        style: {
          display: 'inline'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          as: "span",
          fontWeight: 500,
          fontSize: "12px",
          lineHeight: "16px",
          color: "textTertiary",
          mr: "4px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "I confirm that I am over 18 years old"
          })
        })
      })]
    })
  });
};

/* harmony default export */ var Traditional_CheckCondition = (CheckCondition);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Traditional/TraditionalSignUpForm.tsx




var TraditionalSignUpForm_email;



function TraditionalSignUpForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TraditionalSignUpForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TraditionalSignUpForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TraditionalSignUpForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





































var signupFormErrorMessages = {
  email: (TraditionalSignUpForm_email = {}, (0,defineProperty/* default */.Z)(TraditionalSignUpForm_email, validator/* ValidationError.Required */.p.Required, 'Please enter your email'), (0,defineProperty/* default */.Z)(TraditionalSignUpForm_email, validator/* ValidationError.Email */.p.Email, formValidator/* commomErrorMessage.Email */.UT.Email), TraditionalSignUpForm_email),
  password: (0,defineProperty/* default */.Z)({}, validator/* ValidationError.Required */.p.Required, 'Please enter your password'),
  isConfirmedTerms: (0,defineProperty/* default */.Z)({}, validator/* ValidationError.NotChecked */.p.NotChecked, 'Please read and agree to the terms of service.')
};

var buildRegisterEmailExistedFn = function buildRegisterEmailExistedFn(value) {
  var request = AuthenticationService/* default.getTraditionalSignUpPrepare */.Z.getTraditionalSignUpPrepare({
    email: value,
    referralCode: null
  });
  return (0,requestHelper/* transformHunnyRequest */.Tc)(request, function (res) {
    return !!(res && !res.data);
  });
};

var TraditionalSignUpForm = function TraditionalSignUpForm(_ref) {
  var saveEmail = _ref.saveEmail,
      initialEmail = _ref.initialEmail,
      setPage = _ref.setPage,
      onClose = _ref.onClose;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute;

  var debounceCallback = (0,useDebounceCallback/* default */.Z)();

  var _useModal = (0,useModal/* default */.Z)(EmailVerificationModal/* default */.Z),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      handlePresentEmailVerificationModal = _useModal2[0];

  var dispatch = (0,state/* useAppDispatch */.TL)();
  var refCode = useReferralCode();

  var _useState = (0,react.useState)(false),
      submiting = _useState[0],
      setSubmiting = _useState[1];

  var _useForm = (0,useForm/* default */.Z)({
    email: {
      validators: [formValidator/* default.required */.ZP.required, formValidator/* default.email */.ZP.email, formValidator/* default.uniqueEmail */.ZP.uniqueEmail(buildRegisterEmailExistedFn)],
      value: ''
    },
    password: {
      validators: [formValidator/* default.required */.ZP.required, formValidator/* default.inputLength */.ZP.inputLength({
        min: 8
      }), formValidator/* default.requiredNumber */.ZP.requiredNumber, formValidator/* default.requiredUppercase */.ZP.requiredUppercase, formValidator/* default.blockCharaters */.ZP.blockCharaters([' '])],
      value: '',
      validateOnChange: true
    },
    isConfirmedTerms: {
      validators: [formValidator/* default.checked */.ZP.checked],
      value: true,
      validateOnChange: true
    }
  }),
      states = _useForm.states,
      controls = _useForm.controls,
      validateAll = _useForm.validateAll,
      isValid = _useForm.isValid;

  (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function () {
    debounceCallback(function () {
      controls.email.onValueChanged(initialEmail);
    }, 200);
  }, [initialEmail]);
  hooks_useCallbackValueOnDestroy(states.email.value, saveEmail);

  var formatEmailErrorMessage = function formatEmailErrorMessage(errors) {
    if (errors[0] === validator/* ValidationError.EmailDuplicate */.p.EmailDuplicate) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
          children: "This email is already in use. Please enter a different email or"
        }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          color: "primary",
          display: "inline",
          fontSize: "12px",
          bold: true,
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick() {
            setPage(authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN);
          },
          id: "link-to-tab-login",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Log in"
          })
        }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
          children: "to continue"
        })]
      });
    }

    return t(signupFormErrorMessages.email[errors[0]]);
  };

  var buidHandleVerifiedValidFn = function buidHandleVerifiedValidFn(passwordNonce) {
    return /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(verification, code) {
        var _result$data;

        var deviceUid, params, result;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,fingerprint/* getID */.V)();

              case 2:
                deviceUid = _context.sent;
                params = {
                  email: states.email.value,
                  password: constructEncryptedPassword(states.password.value, passwordNonce),
                  deviceUid: deviceUid,
                  verification: TraditionalSignUpForm_objectSpread(TraditionalSignUpForm_objectSpread({}, verification), {}, {
                    otp: code
                  }),
                  referralCode: refCode.refCode
                };
                _context.next = 6;
                return AuthenticationService/* default.registerEmail */.Z.registerEmail(params);

              case 6:
                result = _context.sent;

                if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.accessToken) {
                  dispatch((0,actions/* updateDeviceUid */.Lg)({
                    deviceUid: deviceUid
                  }));
                  dispatch((0,action/* signedExecuteLogin */.Sv)({
                    loginBy: auth/* LoginMethod.Email */.p.Email
                  }));
                  dispatch((0,action/* updateAuthToken */.xm)({
                    accessToken: result.data.accessToken,
                    refreshToken: result.data.refreshToken
                  }));
                  dispatch((0,actions/* setIsSigned */.vX)({
                    isSigned: true,
                    atTime: new Date().getTime()
                  }));
                  if (onClose) onClose();
                }

                return _context.abrupt("return", result);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  var handleRegister = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var isValid, _yield$forkjoinReques, _yield$forkjoinReques2, verification, passwordNonce;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSubmiting(true);
              _context2.next = 3;
              return validateAll();

            case 3:
              isValid = _context2.sent;

              if (isValid) {
                _context2.next = 7;
                break;
              }

              setSubmiting(false);
              return _context2.abrupt("return");

            case 7:
              _context2.next = 9;
              return (0,requestHelper/* forkjoinRequest */.Rm)([execute(AuthenticationService/* default.verifyRegisterEmail */.Z.verifyRegisterEmail(states.email.value)), execute(AuthenticationService/* default.getTraditionalSignUpPrepare */.Z.getTraditionalSignUpPrepare({
                email: states.email.value,
                referralCode: null
              }))]);

            case 9:
              _yield$forkjoinReques = _context2.sent;
              _yield$forkjoinReques2 = (0,slicedToArray/* default */.Z)(_yield$forkjoinReques, 2);
              verification = _yield$forkjoinReques2[0];
              passwordNonce = _yield$forkjoinReques2[1];

              if (!(!(verification !== null && verification !== void 0 && verification.data) || !passwordNonce.data)) {
                _context2.next = 16;
                break;
              }

              setSubmiting(false); // Show error

              return _context2.abrupt("return");

            case 16:
              handlePresentEmailVerificationModal({
                email: states.email.value,
                initialVerifiedResult: verification.data,
                verifiedHunnyRequestFn: function verifiedHunnyRequestFn() {
                  return (0,requestHelper/* transformHunnyRequest */.Tc)(AuthenticationService/* default.verifyRegisterEmail */.Z.verifyRegisterEmail(states.email.value), function (res) {
                    return res === null || res === void 0 ? void 0 : res.data;
                  });
                },
                onSubmit: buidHandleVerifiedValidFn(passwordNonce.data)
              });
              setSubmiting(false);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRegister() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(OpenEffect/* default */.Z, {
    openType: "slideBottomToTop",
    duration: 0.5,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      as: "form",
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        handleRegister();
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TraditionalSignUpForm_StyledFormControl, {
        state: states.email,
        label: t('Email'),
        formatErrorMessage: formatEmailErrorMessage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
          control: controls.email,
          placeholder: t('Email'),
          type: "email",
          name: "email",
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.EmailIcon */.P.EmailIcon, {}),
          adornment: states.email.isValidating ? /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: "hide-when-focus",
            height: "20px",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
          }) : null
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TraditionalSignUpForm_StyledFormControl, {
        mt: "12px",
        state: states.password,
        label: t('Password'),
        formatErrorMessage: function formatErrorMessage(errors) {
          return t(signupFormErrorMessages.password[errors[0]]);
        },
        instructionConfig: [{
          message: t('Use at least 8 characters'),
          validationError: validator/* ValidationError.TooShort */.p.TooShort
        }, {
          message: t('Use 1 or more number'),
          validationError: validator/* ValidationError.RequiredNumber */.p.RequiredNumber
        }, {
          message: t('Use upper case characters'),
          validationError: validator/* ValidationError.RequiredUppercase */.p.RequiredUppercase
        }, {
          message: t('Password does not allow space'),
          validationError: validator/* ValidationError.IncorrectType */.p.IncorrectType
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl_FormInputPassword, {
          control: controls.password,
          placeholder: t('Password'),
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.PasswordIcon */.P.PasswordIcon, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        type: "submit",
        id: "signup-submit-button",
        disabled: !isValid || submiting,
        width: "100%",
        my: "24px",
        onClick: handleRegister,
        children: [submiting && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mr: "12px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          bold: true,
          fontSize: "14px",
          color: submiting ? 'textSubtle' : 'text',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
            children: "Create Account"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Traditional_CheckCondition, TraditionalSignUpForm_objectSpread({}, controls.isConfirmedTerms))
      })]
    })
  });
};

var TraditionalSignUpForm_StyledFormControl = (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
  displayName: "TraditionalSignUpForm__StyledFormControl",
  componentId: "sc-y381eg-0"
})(["\n  ", "\n"], function (_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme;
  return state.errors.length === 0 && state.isDirty && !state.isValidating ? (0,styled_components_browser_esm/* css */.iv)(["\n          ", " {\n            background-color: transparent !important;\n            border-color: ", " !important;\n          }\n        "], styled/* InputContainer */.fv, theme.colors.success) : '';
});
/* harmony default export */ var Traditional_TraditionalSignUpForm = (TraditionalSignUpForm);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Traditional/index.tsx


var Traditional_excluded = ["page", "setPage", "hide", "onClose"];

function Traditional_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Traditional_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Traditional_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Traditional_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var TraditionalAuth = function TraditionalAuth(_ref) {
  var page = _ref.page,
      setPage = _ref.setPage,
      hide = _ref.hide,
      onClose = _ref.onClose,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Traditional_excluded);

  var dispatch = (0,state/* useAppDispatch */.TL)();
  var previousUserEmail = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth.email;
  });

  var _useState = (0,react.useState)(previousUserEmail),
      draftEmail = _useState[0],
      setDraftEmail = _useState[1];

  (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function () {
    if (previousUserEmail) {
      dispatch((0,action/* removeEmail */.E9)());
    }
  }, []);
  return !hide && /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, Traditional_objectSpread(Traditional_objectSpread({}, props), {}, {
    children: [page === authentication/* AuthModalPageEnums.SIGN_UP */.i.SIGN_UP && /*#__PURE__*/(0,jsx_runtime.jsx)(Traditional_TraditionalSignUpForm, {
      onClose: onClose,
      saveEmail: setDraftEmail,
      initialEmail: draftEmail,
      setPage: setPage
    }), page === authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN && /*#__PURE__*/(0,jsx_runtime.jsx)(Traditional_TraditionalLoginForm, {
      saveEmail: setDraftEmail,
      initialEmail: draftEmail,
      setPage: setPage
    })]
  }));
};

/* harmony default export */ var Traditional = (TraditionalAuth);
// EXTERNAL MODULE: ./src/components/Box/Grid.tsx
var Grid = __webpack_require__(65969);
// EXTERNAL MODULE: ./src/config/constants/wallet.ts
var wallet = __webpack_require__(34798);
// EXTERNAL MODULE: ./src/hooks/useWalletAccount.ts
var useWalletAccount = __webpack_require__(66015);
// EXTERNAL MODULE: ./src/theme/keyframes.ts
var keyframes = __webpack_require__(59731);
// EXTERNAL MODULE: ./src/hooks/useConnectWallet.ts
var useConnectWallet = __webpack_require__(97379);
;// CONCATENATED MODULE: ./src/views/Authentication/components/WalletCard.tsx



var WalletCard_excluded = ["wallet", "onSelect"];

function WalletCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletCard_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var WalletCard = function WalletCard(_ref) {
  var wallet = _ref.wallet,
      onSelect = _ref.onSelect,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, WalletCard_excluded);

  var walletConnector = (0,useConnectWallet/* useConnectWallet */.O)();
  var Icon = (0,svgs/* getIcon */.q)(wallet.icon);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, WalletCard_objectSpread(WalletCard_objectSpread({}, props), {}, {
    onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var result;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return walletConnector[wallet.type].connect(wallet.adapter);

            case 2:
              result = _context.sent;
              if (result) onSelect(wallet);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      fontSize: "12px",
      fontWeight: "500",
      children: wallet.name
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      width: "28px"
    })]
  }));
};

var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "WalletCard__StyledContainer",
  componentId: "sc-oqqvyf-0"
})(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n\n  max-height: 46px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 100px;\n  box-sizing: border-box;\n  cursor: pointer;\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.backgroundAlt3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.backgroundAlt3;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
/* harmony default export */ var components_WalletCard = (WalletCard);
// EXTERNAL MODULE: ./src/components/Modal/index.ts + 2 modules
var components_Modal = __webpack_require__(67498);
// EXTERNAL MODULE: ./src/hooks/useSignMessage.ts
var useSignMessage = __webpack_require__(69176);
// EXTERNAL MODULE: ./src/layout/Components/Row.tsx
var Row = __webpack_require__(78360);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(25427);
// EXTERNAL MODULE: ./src/utils/web3React.ts
var web3React = __webpack_require__(89484);
;// CONCATENATED MODULE: ./src/utils/trackingWallet.ts





var getWalletByName = function getWalletByName(name) {
  var _WALLET_INFO$find;

  return (_WALLET_INFO$find = wallet/* WALLET_INFO.find */.I.find(function (wallet) {
    return wallet.name.toUpperCase() === name.toUpperCase();
  })) === null || _WALLET_INFO$find === void 0 ? void 0 : _WALLET_INFO$find.name;
};

var getNameWalletByConnectedEthereum = function getNameWalletByConnectedEthereum() {
  var _window = window,
      ethereum = _window.ethereum;

  switch (true) {
    case ethereum === null || ethereum === void 0 ? void 0 : ethereum.isTokenPocket:
      return 'TokenPocket';

    case ethereum === null || ethereum === void 0 ? void 0 : ethereum.isSafePal:
      return 'SafePal';

    case ethereum === null || ethereum === void 0 ? void 0 : ethereum.isMathWallet:
      return 'MathWallet';

    case ethereum === null || ethereum === void 0 ? void 0 : ethereum.isCoin98:
      return 'Coin98';

    case (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isBitEthereum) || (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isBitKeep) || (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isBitKeepChrome):
      return 'BitKeep';

    case (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isTrustWallet) || (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isTrust):
      return 'TrustWallet';

    default:
      return 'Metamask';
  }
};

var getNameWalletByConnectedWalletConnect = function getNameWalletByConnectedWalletConnect() {
  var storageWalletConnect = JSON.parse(localStorage.getItem('walletconnect') || '{}');

  if (storageWalletConnect !== null && storageWalletConnect !== void 0 && storageWalletConnect.peerMeta) {
    var nameofPeerMeta = storageWalletConnect === null || storageWalletConnect === void 0 ? void 0 : storageWalletConnect.peerMeta.name;
    var walletName = getWalletByName(nameofPeerMeta);
    return walletName || 'WalletConnect - Unknown';
  }

  return 'WalletConnect - Unknown';
};

var getNameWalletByConnectedBSC = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _window2, _window2$BinanceChain;

    var isConnected;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$BinanceChain = _window2.BinanceChain) === null || _window2$BinanceChain === void 0 ? void 0 : _window2$BinanceChain.isConnected();

          case 2:
            isConnected = _context.sent;

            if (!isConnected) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", 'Binance Wallet');

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getNameWalletByConnectedBSC() {
    return _ref.apply(this, arguments);
  };
}();

var getTrackingWalletName = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(wallet) {
    var isWalletConnect, isBSC;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isWalletConnect = wallet.adapter instanceof web3React/* HunnyWalletConnectConnector */.Ax;
            isBSC = wallet.adapter instanceof web3React/* HunnyBscConnector */.Rf;

            if (!isWalletConnect) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", getNameWalletByConnectedWalletConnect());

          case 4:
            if (!isBSC) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", getNameWalletByConnectedBSC());

          case 6:
            return _context2.abrupt("return", getNameWalletByConnectedEthereum());

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getTrackingWalletName(_x) {
    return _ref2.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/views/Authentication/components/Wallet/SignWallet.tsx






























var SignWalletModal = function SignWalletModal(_ref) {
  var data = _ref.data,
      onDismiss = _ref.onDismiss;
  var wallet = data.wallet;
  var refCode = useReferralCode();
  var accounts = (0,useWalletAccount/* default */.Z)();

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute;

  var signMessage = (0,useSignMessage/* default */.Z)(wallet.type);

  var _useState = (0,react.useState)(false),
      signing = _useState[0],
      setSigning = _useState[1];

  var _useAuth = (0,hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned;

  var dispatch = (0,state/* useAppDispatch */.TL)();
  var address = accounts[wallet.type];
  (0,react.useEffect)(function () {
    if (!address || isSigned) {
      onDismiss();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [address, wallet, isSigned]);

  var handleSignWallet = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _result$data;

      var _yield$execute, _yield$execute$data, acceptMessageText, acceptMessage, messageSignature, deviceUid, params, result, walletTracked;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSigning(true); // TODO check type error

              _context.next = 3;
              return execute(AuthenticationService/* default.getMessageToWalletSign */.Z.getMessageToWalletSign({
                address: address,
                walletType: wallet.type
              }));

            case 3:
              _yield$execute = _context.sent;
              _yield$execute$data = _yield$execute.data;
              acceptMessageText = _yield$execute$data.acceptMessageText;
              acceptMessage = _yield$execute$data.acceptMessage;
              _context.next = 9;
              return signMessage(acceptMessageText);

            case 9:
              messageSignature = _context.sent;

              if (messageSignature) {
                _context.next = 13;
                break;
              }

              setSigning(false);
              return _context.abrupt("return");

            case 13:
              _context.next = 15;
              return (0,fingerprint/* getID */.V)();

            case 15:
              deviceUid = _context.sent;
              params = {
                deviceUid: deviceUid,
                address: address,
                messageSignature: messageSignature,
                acceptMessage: acceptMessage
              };
              params.referralCode = refCode.refCode;
              _context.next = 20;
              return AuthenticationService/* default.signInByWallet */.Z.signInByWallet(params);

            case 20:
              result = _context.sent;

              if (!((_result$data = result.data) !== null && _result$data !== void 0 && _result$data.accessToken)) {
                _context.next = 29;
                break;
              }

              _context.next = 24;
              return getTrackingWalletName(wallet);

            case 24:
              walletTracked = _context.sent;
              dispatch((0,action/* updateAuthToken */.xm)({
                accessToken: result.data.accessToken,
                refreshToken: result.data.refreshToken
              }));
              dispatch((0,actions/* updateDeviceUid */.Lg)({
                deviceUid: deviceUid
              }));
              dispatch((0,action/* signedExecuteLogin */.Sv)({
                loginBy: auth/* LoginMethod.Wallet */.p.Wallet,
                wallet: {
                  name: wallet.name,
                  type: wallet.type,
                  connectorId: wallet.adapter.name,
                  address: address,
                  trackingName: walletTracked
                }
              }));
              dispatch((0,actions/* setIsSigned */.vX)({
                isSigned: true,
                atTime: new Date().getTime()
              }));

            case 29:
              setSigning(false);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSignWallet() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledModal, {
    id: "popup-signwallet",
    onDismiss: onDismiss,
    p: "0 !important",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ModalBody/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        p: "40px 34px",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
          alignItems: "center",
          flexDirection: "column",
          children: [signing ? /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            alt: "join",
            width: 80,
            height: 80,
            src: "/images/signing.png"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            alt: "join",
            width: 80,
            height: 80,
            src: "/images/join.png"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            bold: true,
            fontSize: "18px",
            lineHeight: "24px",
            mt: "16px",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
              children: "Signing with this address: "
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            bold: true,
            fontSize: "18px",
            mt: "2px",
            children: (0,utils/* shortedAddress */.WI)(address)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "textSubtle",
            fontSize: "14px",
            mt: "28px",
            textAlign: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
              children: "You need to sign a message on your wallet to prove ownership of the address you are connected with."
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
            id: "signmessage-button",
            width: "100%",
            mt: "40px",
            onClick: handleSignWallet,
            disabled: signing,
            children: signing ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowMiddle */._B, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: "8px",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                children: "Waiting for Signature"
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
              children: "Sign Message"
            })
          })]
        })
      })
    })
  });
};

var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(components_Modal/* default */.ZP).withConfig({
  displayName: "SignWallet__StyledModal",
  componentId: "sc-gqkkhk-0"
})(["\n  ", " {\n    min-width: 440px !important;\n    max-width: 440px !important;\n  }\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.sm;
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "SignWallet__StyledButton",
  componentId: "sc-gqkkhk-1"
})(["\n  font-size: 12px;\n  font-weight: bold;\n\n  &:disabled {\n    background-color: ", ";\n  }\n"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primaryDisabled;
});
/* harmony default export */ var SignWallet = (SignWalletModal);
;// CONCATENATED MODULE: ./src/views/Authentication/components/Wallet/index.tsx


















var SignWithWallet = function SignWithWallet(_ref) {
  var isShowMore = _ref.isShowMore,
      page = _ref.page;
  var displayWallets = isShowMore ? wallet/* WALLET_INFO */.I : wallet/* WALLET_INFO.slice */.I.slice(0, 10);

  var _useState = (0,react.useState)(true),
      isConfirmed = _useState[0],
      setIsConfirmed = _useState[1];

  var accounts = (0,useWalletAccount/* default */.Z)();

  var _useState2 = (0,react.useState)(null),
      selectedWallet = _useState2[0],
      setSelectedWallet = _useState2[1];

  var _useModal = (0,useModal/* default */.Z)(SignWallet),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      handlePresent = _useModal2[0];

  (0,react.useEffect)(function () {
    if (!selectedWallet || !accounts[selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.type]) {
      return;
    }

    setSelectedWallet(null);
    handlePresent({
      wallet: selectedWallet
    });
  }, [accounts, handlePresent, selectedWallet]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    $more: isShowMore,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(WrapListWallet, {
      confirmed: isConfirmed,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(WrapGridWallet, {
        $more: isShowMore,
        children: displayWallets.map(function (wallet) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(components_WalletCard, {
            id: "wallet-select",
            wallet: wallet,
            onSelect: isConfirmed ? setSelectedWallet : function () {}
          }, wallet.name);
        })
      })
    }), page === authentication/* AuthModalPageEnums.SIGN_UP */.i.SIGN_UP ? /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      mt: "24px",
      height: "50px",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Traditional_CheckCondition, {
        value: Boolean(isConfirmed),
        onValueChanged: setIsConfirmed
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ConditionAcccess, {})]
  });
};

var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Column/* default */.ZP).withConfig({
  displayName: "Wallet__Wrapper",
  componentId: "sc-185x1ll-0"
})(["\n  max-height: 100%;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n"]);
var WrapListWallet = (0,styled_components_browser_esm/* default */.ZP)(Column/* default */.ZP).withConfig({
  displayName: "Wallet__WrapListWallet",
  componentId: "sc-185x1ll-1"
})(["\n  overflow: hidden;\n  box-sizing: border-box;\n  border-bottom: 1px solid ", ";\n  padding-bottom: 10px;\n  position: relative;\n\n  ", ";\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.stroke;
}, function (_ref3) {
  var confirmed = _ref3.confirmed;
  return !confirmed && (0,styled_components_browser_esm/* css */.iv)(["\n      opacity: 0.4;\n\n      &:after {\n        content: ' ';\n        position: absolute;\n        top: 0;\n        left: 0;\n        user-select: none;\n        width: 100%;\n        height: 100%;\n      }\n    "]);
});
var WrapGridWallet = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z).attrs({
  gridTemplateColumns: ['1fr 1fr'],
  gridGap: '10px'
}).withConfig({
  displayName: "Wallet__WrapGridWallet",
  componentId: "sc-185x1ll-2"
})(["\n  animation: ", " 0.5s ease-out\n    forwards;\n  margin-right: -12px;\n  padding-right: 12px;\n  overflow-y: scroll;\n\n  ::-webkit-scrollbar {\n    width: 2px !important;\n  }\n"], function (_ref4) {
  var $more = _ref4.$more;
  return $more ? keyframes/* default.slideTopToBottom */.Z.slideTopToBottom : keyframes/* default.slideBottomToTop */.Z.slideBottomToTop;
});
/* harmony default export */ var Wallet = (SignWithWallet);
;// CONCATENATED MODULE: ./src/views/Authentication/index.tsx























var Authentication = function Authentication(_ref) {
  var onDismiss = _ref.onDismiss,
      _ref$data = _ref.data,
      page = _ref$data.page,
      method = _ref$data.method;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isKeyboardOpen = hooks_useDetectKeyboardOpen();

  var _useAuth = (0,hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned;

  var _useState = (0,react.useState)(page || authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN),
      currentPage = _useState[0],
      setCurrentPage = _useState[1];

  var _useState2 = (0,react.useState)(method || authentication/* AuthModalMethodEnums.WEB3 */.h.WEB3),
      currentMethod = _useState2[0],
      setCurrentMethod = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isShowMoreWallet = _useState3[0],
      setIsShowMoreWallet = _useState3[1];

  var isLoginPage = currentPage === authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN;
  var title = t('Welcome to our community');
  (0,react.useEffect)(function () {
    if (isSigned) {
      onDismiss();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isSigned]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Authentication_Container, {
    id: "popup-authen",
    onDismiss: onDismiss,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ModalBody/* default */.Z, {
      height: "100%",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        height: "100%",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Introduction, {
          title: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MainContent, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Template, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "md",
                children: isLoginPage ? /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                  children: "Log in"
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                  children: "Sign up"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "button-cancel",
                variant: "text",
                display: ['flex', 'flex', 'none'],
                onClick: onDismiss,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "textSubtle",
                  fontSize: "14px",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                    children: "Cancel"
                  })
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
              children: [!isShowMoreWallet && /*#__PURE__*/(0,jsx_runtime.jsx)(components_SwitchMethod, {
                mb: "24px",
                method: currentMethod,
                onMethodChange: setCurrentMethod
              }), !(currentPage === authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN && currentMethod === authentication/* AuthModalMethodEnums.TRADITIONAL */.h.TRADITIONAL) && /*#__PURE__*/(0,jsx_runtime.jsx)(components_ReferralCode, {
                mb: "20px"
              }), currentMethod === authentication/* AuthModalMethodEnums.WEB3 */.h.WEB3 && /*#__PURE__*/(0,jsx_runtime.jsx)(Wallet, {
                page: currentPage,
                isShowMore: isShowMoreWallet,
                setShowMore: setIsShowMoreWallet
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Traditional, {
                page: currentPage,
                hide: currentMethod !== authentication/* AuthModalMethodEnums.TRADITIONAL */.h.TRADITIONAL,
                setPage: setCurrentPage,
                onClose: onDismiss
              })]
            }), !isKeyboardOpen && !isShowMoreWallet && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFooter, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_SwitchPage, {
                presentedPage: currentPage,
                onSwitchPage: setCurrentPage
              })
            })]
          })
        })]
      })
    })
  });
};

var StyledContent = (0,styled_components_browser_esm/* default */.ZP)(Template_Content).withConfig({
  displayName: "Authentication__StyledContent",
  componentId: "sc-9yl2s1-0"
})(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  height: 100%;\n  flex: 1 1;\n  overflow: overlay;\n"]);
var StyledFooter = (0,styled_components_browser_esm/* default */.ZP)(Footer).withConfig({
  displayName: "Authentication__StyledFooter",
  componentId: "sc-9yl2s1-1"
})(["\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n"]);
var Authentication_Container = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
  displayName: "Authentication__Container",
  componentId: "sc-9yl2s1-2"
})(["\n  box-sizing: border-box;\n  overflow: hidden;\n  border-radius: 0px;\n  padding: 0;\n  width: 100%;\n  height: var(--screen-height);\n\n  max-width: unset !important;\n\n  .modal-closebutton {\n    pointer-events: none;\n    display: none;\n    top: 24px;\n  }\n\n  ", " {\n    max-height: 715px !important;\n    min-height: 715px !important;\n    max-width: 512px !important;\n    border-radius: ", ";\n\n    .modal-closebutton {\n      pointer-events: auto;\n      display: flex;\n      z-index: 1;\n    }\n  }\n\n  ", " {\n    min-width: 800px;\n  }\n"], function (_ref2) {
  var mediaQueries = _ref2.theme.mediaQueries;
  return mediaQueries.sm;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.extraLarge;
}, function (_ref4) {
  var mediaQueries = _ref4.theme.mediaQueries;
  return mediaQueries.md;
});
var MainContent = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Authentication__MainContent",
  componentId: "sc-9yl2s1-3"
})(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  margin-left: 0;\n  box-sizing: border-box;\n  position: relative;\n  overflow: auto;\n\n  ", " {\n    max-width: 57%;\n    min-width: 57%;\n\n    overflow: hidden;\n    margin-left: -15px;\n    border-radius: ", ";\n    background: ", ";\n  }\n"], function (_ref5) {
  var mediaQueries = _ref5.theme.mediaQueries;
  return mediaQueries.md;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.radii.extraLarge;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.modalBackground;
});
/* harmony default export */ var views_Authentication = (Authentication);

/***/ }),

/***/ 21947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ emptyBonus; },
/* harmony export */   "h": function() { return /* binding */ useWaitingDepositToActiveBonus; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27812);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config_types_bonus_userBonus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95793);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var services_BonusService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68288);
/* harmony import */ var state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82813);
/* harmony import */ var state_auth_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71581);
/* harmony import */ var state_bonus_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37130);
/* harmony import */ var state_bonus_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2309);










var emptyBonus = {
  id: 0
};
var useWaitingDepositToActiveBonus = function useWaitingDepositToActiveBonus() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      bonuses = _useState[0],
      setBonuses = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(emptyBonus),
      selectedBonus = _useState2[0],
      setSelectedBonus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isSelectedBonusExpired = _useState3[0],
      setIsSelectedBonusExpired = _useState3[1];

  var _useUserBonus = (0,state_bonus_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useUserBonus */ .Jc)(),
      preparedBonusId = _useUserBonus.preparedBonusId;

  var dispatch = (0,state__WEBPACK_IMPORTED_MODULE_4__/* .useAppDispatch */ .TL)();
  var currentSelectedBonusRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(emptyBonus);

  var _useAuth = (0,state_auth_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)(),
      hasSession = _useAuth.hasSession;

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _response$data;

        var response, bonuses, filterBonusDeposit, selectedBonus;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return services_BonusService__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserBonuses */ .Z.getUserBonuses().call();

              case 2:
                response = _context.sent;
                bonuses = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.items) || [];
                filterBonusDeposit = bonuses.filter(function (bonus) {
                  return bonus instanceof config_types_bonus_userBonus__WEBPACK_IMPORTED_MODULE_1__/* .DepositBonus */ .Jn;
                });
                if (filterBonusDeposit.length > 0) setBonuses([emptyBonus].concat((0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(filterBonusDeposit)));else setBonuses([]);
                selectedBonus = filterBonusDeposit.find(function (bonus) {
                  return bonus.id === preparedBonusId;
                });
                currentSelectedBonusRef.current = selectedBonus || emptyBonus;
                setSelectedBonus(selectedBonus || emptyBonus);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetch() {
        return _ref.apply(this, arguments);
      };
    }();

    if (hasSession) {
      fetch();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [hasSession]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (!selectedBonus.id) {
      setIsSelectedBonusExpired(false);
      return;
    }

    setIsSelectedBonusExpired(selectedBonus.condition.isExpired);
    var interval = setInterval(function () {
      return setIsSelectedBonusExpired(selectedBonus.condition.isExpired);
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [selectedBonus]);

  var handleSelectedBonus = /*#__PURE__*/function () {
    var _ref2 = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(bonus) {
      var isSuccess;
      return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(bonus.id === selectedBonus.id)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", false);

            case 2:
              setSelectedBonus(bonus);
              _context2.next = 5;
              return services_BonusService__WEBPACK_IMPORTED_MODULE_3__/* ["default"].prepareDepositBonus */ .Z.prepareDepositBonus(bonus.id);

            case 5:
              isSuccess = _context2.sent;

              if (isSuccess) {
                currentSelectedBonusRef.current = bonus;
                dispatch((0,state_bonus_actions__WEBPACK_IMPORTED_MODULE_6__/* .updatePreparedBonusId */ .H1)(bonus.id));
              } else {
                setSelectedBonus(currentSelectedBonusRef.current);
              }

              return _context2.abrupt("return", isSuccess);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSelectedBonus(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    bonuses: bonuses,
    handleSelectedBonus: handleSelectedBonus,
    selectedBonus: selectedBonus,
    isSelectedBonusExpired: isSelectedBonusExpired
  };
};

/***/ }),

/***/ 9242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ PaymentPageEnums; },
  "Z": function() { return /* binding */ views_Payment; }
});

// EXTERNAL MODULE: ./src/components/Modal/index.ts + 2 modules
var Modal = __webpack_require__(67498);
// EXTERNAL MODULE: ./src/components/Tab/index.tsx
var Tab = __webpack_require__(45918);
// EXTERNAL MODULE: ./src/components/Tabs/index.tsx + 4 modules
var Tabs = __webpack_require__(40296);
// EXTERNAL MODULE: ./src/components/Text/index.ts
var components_Text = __webpack_require__(19500);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/svgs/index.ts + 103 modules
var svgs = __webpack_require__(8400);
// EXTERNAL MODULE: ./src/theme/index.ts
var theme = __webpack_require__(57214);
// EXTERNAL MODULE: ./src/theme/colors.ts
var colors = __webpack_require__(72959);
// EXTERNAL MODULE: ./src/layout/Components/Column.tsx
var Column = __webpack_require__(64533);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 3 modules
var es_Trans = __webpack_require__(93955);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Payment/components/TabLabel.tsx








var TabLabel = function TabLabel(_ref) {
  var Icon = _ref.Icon,
      label = _ref.label;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTabLabel, {
    children: [Icon, /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      fontSize: "14px",
      ml: "4px",
      fontWeight: 600,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
        children: label
      })
    })]
  });
};

var StyledTabLabel = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "TabLabel__StyledTabLabel",
  componentId: "sc-zcy6ut-0"
})(["\n  color: ", ";\n  align-items: center;\n  justify-content: center;\n  display: flex;\n"], function (_ref2) {
  var colors = _ref2.theme.colors;
  return colors.text;
});
/* harmony default export */ var components_TabLabel = (TabLabel);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./src/components/OpenEffect/index.tsx
var OpenEffect = __webpack_require__(5790);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./src/components/Text/TextError.tsx


var _excluded = ["message"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var TextError = function TextError(_ref) {
  var message = _ref.message,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWrapper, _objectSpread(_objectSpread({
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "bold",
    textAlign: "center"
  }, props), {}, {
    children: message
  }));
};

var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
  displayName: "TextError__StyledWrapper",
  componentId: "sc-13w6b4m-0"
})(["\n  max-width: 300px;\n  padding: 12px;\n  border-radius: ", ";\n  background: ", "47;\n  color: ", ";\n  border: 1px solid ", ";\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.error;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.error;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.error;
});
/* harmony default export */ var Text_TextError = (TextError);
// EXTERNAL MODULE: ./src/config/constants/auth.ts
var auth = __webpack_require__(55711);
// EXTERNAL MODULE: ./src/config/constants/network.ts
var constants_network = __webpack_require__(17961);
// EXTERNAL MODULE: ./src/config/constants/tokens/index.ts + 11 modules
var tokens = __webpack_require__(99289);
// EXTERNAL MODULE: ./src/hooks/useModal.ts
var useModal = __webpack_require__(13911);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./src/state/app/hooks.ts
var hooks = __webpack_require__(37850);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var auth_hooks = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/utils/infura.ts + 2 modules
var infura = __webpack_require__(90802);
// EXTERNAL MODULE: ./src/utils/token.ts
var utils_token = __webpack_require__(69961);
// EXTERNAL MODULE: ./src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(12842);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx
var Modal_Modal = __webpack_require__(20458);
;// CONCATENATED MODULE: ./src/components/EmptyContent/index.tsx


var EmptyContent_excluded = ["suffixIcon", "prefixIcon", "content"];

function EmptyContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EmptyContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EmptyContent_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EmptyContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var EmptyContent = function EmptyContent(_ref) {
  var suffixIcon = _ref.suffixIcon,
      prefixIcon = _ref.prefixIcon,
      content = _ref.content,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, EmptyContent_excluded);

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, EmptyContent_objectSpread(EmptyContent_objectSpread({
    alignItems: "center"
  }, props), {}, {
    children: [suffixIcon || null, typeof content === 'string' ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      fontSize: "14px",
      color: "textSubtle",
      bold: true,
      mx: 1,
      children: t(content)
    }) : content, prefixIcon || null]
  }));
};

/* harmony default export */ var components_EmptyContent = (EmptyContent);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./src/hooks/useRequest.ts
var useRequest = __webpack_require__(89058);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(25427);
// EXTERNAL MODULE: ./src/utils/requestHelper.ts
var requestHelper = __webpack_require__(75391);
;// CONCATENATED MODULE: ./src/components/HunnyLazyList/HunnyLazyList.tsx














var HunnyLazyList = function HunnyLazyList(_ref) {
  var Item = _ref.Item,
      request = _ref.request,
      Loader = _ref.Loader,
      limit = _ref.limit,
      _ref$uniqueKey = _ref.uniqueKey,
      uniqueKey = _ref$uniqueKey === void 0 ? 'id' : _ref$uniqueKey,
      noContent = _ref.noContent;

  var _useState = (0,react.useState)(null),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isLoadMore = _useState2[0],
      setIsLoadMore = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      isTriggerLoad = _useState4[0],
      setIsTriggerLoad = _useState4[1];

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute,
      cancelAllRequest = _useRequest.cancelAllRequest;

  (0,react.useEffect)(function () {
    setData(null);
    cancelAllRequest();
    setIsTriggerLoad({});
  }, [request]);
  (0,react.useEffect)(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _response;

        var response, _offset, _yield$forkjoinReques, _yield$forkjoinReques2, res;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsLoading(true);

                if (!(typeof request === 'function')) {
                  _context.next = 9;
                  break;
                }

                _offset = data ? data.length * limit : 0;
                _context.next = 5;
                return (0,requestHelper/* forkjoinRequest */.Rm)([execute(request(_offset, limit)), (0,utils/* delayed */.A8)(500)]);

              case 5:
                _yield$forkjoinReques = _context.sent;
                _yield$forkjoinReques2 = (0,slicedToArray/* default */.Z)(_yield$forkjoinReques, 1);
                res = _yield$forkjoinReques2[0];
                response = res;

              case 9:
                if ((_response = response) !== null && _response !== void 0 && _response.data && response.data.items.length) {
                  setData([].concat((0,toConsumableArray/* default */.Z)(data || []), [response.data.items]));
                  setIsLoadMore(response.data.items.length === limit);
                } else {
                  if (!data) {
                    setData([]);
                  }

                  setIsLoadMore(false);
                }

                setIsLoading(false);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetch() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (isTriggerLoad !== null) fetch();
  }, [isTriggerLoad]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!isLoading && data && !data.length && noContent && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      color: "textSubtle",
      children: noContent
    }), data === null || data === void 0 ? void 0 : data.map(function (pageData, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ItemList, {
        data: pageData,
        Item: Item,
        uniqueKey: uniqueKey
      }, "lazy-item-list-".concat(index.toString()));
    }), isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: Loader
    }), !isLoading && isLoadMore && data && data.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
      height: 100,
      offset: 0,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoadMoreTrigger, {
        setIsTriggerLoad: setIsTriggerLoad
      })
    })]
  });
};

var ItemList = /*#__PURE__*/react.memo(function (_ref3) {
  var data = _ref3.data,
      Item = _ref3.Item,
      uniqueKey = _ref3.uniqueKey;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: data.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
        item: item
      }, item[uniqueKey]);
    })
  });
});
var LoadMoreTrigger = /*#__PURE__*/react.memo(function (_ref4) {
  var setIsTriggerLoad = _ref4.setIsTriggerLoad;
  (0,react.useEffect)(function () {
    setIsTriggerLoad({});
  }, []);
  return null;
});
/* harmony default export */ var HunnyLazyList_HunnyLazyList = (HunnyLazyList);
// EXTERNAL MODULE: ./src/services/PaymentService.ts
var PaymentService = __webpack_require__(92847);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(44785);
// EXTERNAL MODULE: ./src/components/Skeleton/index.tsx + 2 modules
var Skeleton = __webpack_require__(98034);
// EXTERNAL MODULE: ./src/components/TokenLogo/index.tsx
var TokenLogo = __webpack_require__(62068);
// EXTERNAL MODULE: ./src/config/types/transaction.ts
var types_transaction = __webpack_require__(38004);
// EXTERNAL MODULE: ./src/layout/Components/Row.tsx
var Row = __webpack_require__(78360);
// EXTERNAL MODULE: ./src/utils/dateHelper.ts
var dateHelper = __webpack_require__(46030);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
;// CONCATENATED MODULE: ./src/components/Table/Table.tsx


var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
  displayName: "Table",
  componentId: "sc-1dsgjm0-0"
})(["\n  max-width: 100%;\n  width: 100%;\n\n  ", "\n"], index_esm/* space */.Dh);
var TableBody = styled_components_browser_esm/* default.tbody.withConfig */.ZP.tbody.withConfig({
  displayName: "Table__TableBody",
  componentId: "sc-1dsgjm0-1"
})(["\n  & tr {\n    td {\n      vertical-align: middle;\n    }\n  }\n"]);

/* harmony default export */ var Table_Table = ((/* unused pure expression or super */ null && (Table)));
;// CONCATENATED MODULE: ./src/components/Table/TableCell.tsx


var TableCell_excluded = ["children", "width", "colSpan"];

function TableCell_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TableCell_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TableCell_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TableCell_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Td = function Td(_ref) {
  var children = _ref.children,
      width = _ref.width,
      colSpan = _ref.colSpan,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, TableCell_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTd, {
    style: {
      width: width
    },
    colSpan: colSpan,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCell, TableCell_objectSpread(TableCell_objectSpread({}, props), {}, {
      width: "100%",
      children: children
    }))
  });
};

var StyledCell = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "TableCell__StyledCell",
  componentId: "sc-1ga2ckf-0"
})(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-left: 12px;\n  border-left: ", ";\n  border-right: ", ";\n"], function (_ref2) {
  var colors = _ref2.theme.colors;
  return "0.25px solid ".concat(colors.stroke);
}, function (_ref3) {
  var colors = _ref3.theme.colors;
  return "0.25px solid ".concat(colors.stroke);
});
var StyledTd = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
  displayName: "TableCell__StyledTd",
  componentId: "sc-1ga2ckf-1"
})(["\n  &:first-child ", ":not(.loader) {\n    border-right: none;\n  }\n\n  &:last-child ", ":not(.loader) {\n    border-left: none;\n  }\n"], StyledCell, StyledCell);
/* harmony default export */ var TableCell = ((0,styled_components_browser_esm/* default */.ZP)(Td).withConfig({
  displayName: "TableCell",
  componentId: "sc-1ga2ckf-2"
})([""]));
;// CONCATENATED MODULE: ./src/components/Table/TableHeader.tsx


var TableHeader_excluded = ["children", "width"];

function TableHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TableHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TableHeader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TableHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var TableHeader = function TableHeader(_ref) {
  var children = _ref.children,
      width = _ref.width,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, TableHeader_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTh, {
    width: width,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHeader, TableHeader_objectSpread(TableHeader_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

var StyledHeader = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "TableHeader__StyledHeader",
  componentId: "sc-vv88h3-0"
})(["\n  display: flex;\n  align-items: center;\n  background: ", ";\n"], function (_ref2) {
  var colors = _ref2.theme.colors;
  return colors.normal;
});
var StyledTh = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
  displayName: "TableHeader__StyledTh",
  componentId: "sc-vv88h3-1"
})(["\n  width: ", ";\n\n  &:first-child ", " {\n    border-top-left-radius: ", ";\n  }\n\n  &:last-child ", " {\n    border-top-right-radius: ", ";\n  }\n"], function (_ref3) {
  var width = _ref3.width;
  return width;
}, StyledHeader, function (_ref4) {
  var radii = _ref4.theme.radii;
  return radii["default"];
}, StyledHeader, function (_ref5) {
  var radii = _ref5.theme.radii;
  return radii["default"];
});
/* harmony default export */ var Table_TableHeader = ((0,styled_components_browser_esm/* default */.ZP)(TableHeader).withConfig({
  displayName: "TableHeader",
  componentId: "sc-vv88h3-2"
})([""]));
;// CONCATENATED MODULE: ./src/components/Table/TableRow.tsx


var TableRow = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
  displayName: "TableRow",
  componentId: "sc-1kk6l5p-0"
})(["\n  width: 100%;\n  border-top: ", ";\n\n  &:last-child {\n    ", " {\n      border-bottom: ", ";\n    }\n\n    td:first-child ", " {\n      border-bottom-left-radius: ", ";\n    }\n\n    td:last-child ", " {\n      border-bottom-right-radius: ", ";\n    }\n  }\n"], function (_ref) {
  var colors = _ref.theme.colors;
  return "0.25px solid ".concat(colors.stroke);
}, TableCell, function (_ref2) {
  var colors = _ref2.theme.colors;
  return "0.25px solid ".concat(colors.stroke);
}, TableCell, function (_ref3) {
  var radii = _ref3.theme.radii;
  return radii["default"];
}, TableCell, function (_ref4) {
  var radii = _ref4.theme.radii;
  return radii["default"];
});
/* harmony default export */ var Table_TableRow = (TableRow);
;// CONCATENATED MODULE: ./src/views/HistoryTransaction/TableTransaction/index.tsx


var TableTransaction_excluded = ["status"];

function TableTransaction_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TableTransaction_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TableTransaction_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TableTransaction_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var HEIGHT_ROW = 52;
var StyledTableCell = (0,styled_components_browser_esm/* default */.ZP)(TableCell).withConfig({
  displayName: "TableTransaction__StyledTableCell",
  componentId: "sc-16y7taf-0"
})(["\n  border: none !important;\n"]);
var StyledTableRow = (0,styled_components_browser_esm/* default */.ZP)(Table_TableRow).withConfig({
  displayName: "TableTransaction__StyledTableRow",
  componentId: "sc-16y7taf-1"
})(["\n  border: none !important;\n  border-radius: ", ";\n\n  &:nth-child(2n + ", ") {\n    td {\n      background: rgba(29, 37, 51, 0.6);\n    }\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.radii.tiny;
}, function (_ref2) {
  var startAt = _ref2.startAt;
  return startAt || 2;
});
var StyledTableBody = (0,styled_components_browser_esm/* default */.ZP)(TableBody).withConfig({
  displayName: "TableTransaction__StyledTableBody",
  componentId: "sc-16y7taf-2"
})([""]);
var StyledTableHeader = (0,styled_components_browser_esm/* default */.ZP)(Table_TableHeader).withConfig({
  displayName: "TableTransaction__StyledTableHeader",
  componentId: "sc-16y7taf-3"
})(["\n  background: transparent;\n"]);
var TableHeaderValue = function TableHeaderValue(_ref3) {
  var key = _ref3.key,
      width = _ref3.width,
      label = _ref3.label;
  return /*#__PURE__*/_jsx(StyledTableHeader, {
    padding: 16,
    width: width,
    children: /*#__PURE__*/_jsx(Text, {
      textAlign: "left",
      fontSize: "14px",
      color: "textSubtle",
      fontWeight: 700,
      children: /*#__PURE__*/_jsx(Trans, {
        children: label
      })
    })
  }, key);
};
var StyledValueTable = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
  displayName: "TableTransaction__StyledValueTable",
  componentId: "sc-16y7taf-4"
})(["\n  font-weight: 300;\n  color: ", ";\n  font-size: 14px;\n  word-break: break-all;\n  text-align: right;\n"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.textTertiary;
});
var TransactionStatus = function TransactionStatus(_ref5) {
  var status = _ref5.status,
      props = (0,objectWithoutProperties/* default */.Z)(_ref5, TableTransaction_excluded);

  var isPending = [types_transaction/* TransactionStatusEnum.Pending */.Zc.Pending, types_transaction/* TransactionStatusEnum.InBatch */.Zc.InBatch, types_transaction/* TransactionStatusEnum.Reviewing */.Zc.Reviewing].includes(status);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: isPending ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, TableTransaction_objectSpread(TableTransaction_objectSpread({
      color: "info",
      fontSize: "14px"
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
        children: "Pending"
      })
    })) : status === types_transaction/* TransactionStatusEnum.Succeeded */.Zc.Succeeded ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, TableTransaction_objectSpread(TableTransaction_objectSpread({
      color: "success",
      fontSize: "14px"
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
        children: "Success"
      })
    })) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, TableTransaction_objectSpread(TableTransaction_objectSpread({
      color: "error",
      fontSize: "14px"
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
        children: "Expired"
      })
    }))
  });
};
;// CONCATENATED MODULE: ./src/views/HistoryTransaction/HistoryTransactionListItem.tsx

















var HistoryTransactionListLoader = function HistoryTransactionListLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
      mb: "16px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          color: "textSubtle",
          fontSize: "14px",
          mr: 2,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: 60,
            height: 5
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          width: 60,
          height: 5
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: "30%",
        height: 5
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
      mb: "16px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          color: "textSubtle",
          fontSize: "14px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Amount"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          width: 75,
          height: 5
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: "30%",
        height: 5
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
      mb: "16px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        color: "textSubtle",
        fontSize: "14px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Fee"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: "30%",
        height: 5
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        color: "textSubtle",
        fontSize: "14px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Hash"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: "30%",
        height: 5
      })]
    })]
  });
};

var DepositTransactionListITem = function DepositTransactionListITem(_ref) {
  var _configTokens$transac;

  var transaction = _ref.transaction;
  var token = (_configTokens$transac = tokens/* default */.Z[transaction.network]) === null || _configTokens$transac === void 0 ? void 0 : _configTokens$transac[transaction.currency];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
      mb: "16px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          color: "textSubtle",
          fontSize: "14px",
          mr: 2,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: types_transaction/* TransactionTypeEnum */.bL[transaction.type]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransactionStatus, {
          status: transaction.status
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledValueTable, {
        children: (0,dateHelper/* formatDisplayDateTime */.Uw)(new Date(transaction.createTime))
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
      mb: "16px",
      alignItems: "flex-start",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          color: "textSubtle",
          fontSize: "14px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Amount"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
          color: "textSubtle",
          fontSize: "14px",
          ml: 1,
          children: ["(", token.name, ")"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        alignItems: "flex-end",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
          alignItems: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TokenLogo/* default */.Z, {
            token: token,
            size: 24
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledValueTable, {
            ml: 2,
            children: transaction.value
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
      mb: "16px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        color: "textSubtle",
        fontSize: "14px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Fee"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledValueTable, {
        children: transaction.fee ? transaction.fee : '_'
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        color: "textSubtle",
        fontSize: "14px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Hash"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: transaction.txnHash,
        external: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHash, {
          children: transaction.txnHash ? (0,utils/* shortedAddress */.WI)(transaction.txnHash) : '_'
        })
      })]
    })]
  });
};

var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "HistoryTransactionListItem__StyledContainer",
  componentId: "sc-11uwdxz-0"
})(["\n  border-radius: ", ";\n  background: ", ";\n\n  padding: 12px;\n\n  ", " {\n    padding: 24px;\n  }\n\n  margin-bottom: 12px;\n"], function (_ref2) {
  var radii = _ref2.theme.radii;
  return radii.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.backgroundAlt7;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mediaQueries.sm;
});
var StyledHash = (0,styled_components_browser_esm/* default */.ZP)(StyledValueTable).withConfig({
  displayName: "HistoryTransactionListItem__StyledHash",
  componentId: "sc-11uwdxz-1"
})(["\n  text-decoration: underline;\n  margin-left: 2.5px;\n"]);
/* harmony default export */ var HistoryTransactionListItem = (DepositTransactionListITem);
;// CONCATENATED MODULE: ./src/views/HistoryTransaction/HistoryTransactionList.tsx











var LazyHistoryItem = function LazyHistoryItem(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HistoryTransactionListItem, {
    transaction: item
  });
};

var DepositTransactionList = function DepositTransactionList() {
  var _useAuth = (0,auth_hooks/* useAuth */.aC)(),
      hasSession = _useAuth.hasSession,
      isSigned = _useAuth.isSigned;

  var request = (0,react.useCallback)(function (offset, limit) {
    return PaymentService/* default.getTransactionHistory */.Z.getTransactionHistory(offset + 1, limit);
  }, []);
  return hasSession ? /*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
    flexDirection: "column",
    className: "hunny-lazy-list",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(HunnyLazyList_HunnyLazyList, {
      Item: LazyHistoryItem,
      Loader: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HistoryTransactionListLoader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HistoryTransactionListLoader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HistoryTransactionListLoader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HistoryTransactionListLoader, {})]
      }),
      request: isSigned ? request : null,
      limit: 12,
      noContent: /*#__PURE__*/(0,jsx_runtime.jsx)(components_EmptyContent, {
        width: "100%",
        height: "100%",
        minHeight: "300px",
        alignItems: "center",
        justifyContent: "center",
        content: "No transaction to show"
      })
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_EmptyContent, {
    justifyContent: "center",
    content: "No transaction to show"
  });
};

/* harmony default export */ var HistoryTransactionList = (DepositTransactionList);
;// CONCATENATED MODULE: ./src/views/HistoryTransaction/index.tsx











var HistoryTransaction = function HistoryTransaction(_ref) {
  var onDismiss = _ref.onDismiss;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledModal, {
    onDismiss: onDismiss,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* ModalHeader */.xB, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
        scale: "xs",
        ml: "12px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Transaction History"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* ModalBody */.fe, {
      overflowY: "auto",
      borderTopLeftRadius: theme/* default.radii.default */.Z.radii["default"],
      borderTopRightRadius: theme/* default.radii.default */.Z.radii["default"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTransactionList, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(HistoryTransactionList, {})
      })
    })]
  });
};

var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal_Modal/* default */.Z).withConfig({
  displayName: "HistoryTransaction__StyledModal",
  componentId: "sc-164wn87-0"
})(["\n  padding: 0;\n\n  box-sizing: border-box;\n\n  background: ", ";\n  min-height: 85vh;\n\n  overflow-y: hidden;\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n\n  & .modal-closebutton {\n    right: 12px;\n    top: 24px;\n  }\n\n  ", " {\n    min-width: 420px;\n    max-width: 420px;\n    min-height: 576px;\n    border-radius: ", ";\n  }\n"], function (_ref2) {
  var colors = _ref2.theme.colors;
  return colors.modalBackground;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.large;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radii.large;
}, function (_ref5) {
  var mediaQueries = _ref5.theme.mediaQueries;
  return mediaQueries.sm;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.radii.large;
});
var StyledTransactionList = (0,styled_components_browser_esm/* default */.ZP)(Modal/* ModalBody */.fe).withConfig({
  displayName: "HistoryTransaction__StyledTransactionList",
  componentId: "sc-164wn87-1"
})(["\n  overflow-y: scroll;\n  padding: 24px 0;\n\n  max-height: 75vh;\n\n  ", " {\n    max-height: 516px;\n  }\n  height: calc(100% - 48px);\n\n  box-sizing: border-box;\n"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.mediaQueries.sm;
});
/* harmony default export */ var views_HistoryTransaction = (HistoryTransaction);
// EXTERNAL MODULE: ./src/components/Heading/index.ts
var components_Heading = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/theme/keyframes.ts
var keyframes = __webpack_require__(59731);
// EXTERNAL MODULE: ./src/config/types/authentication.ts
var authentication = __webpack_require__(87876);
// EXTERNAL MODULE: ./src/views/Authentication/index.tsx + 23 modules
var Authentication = __webpack_require__(43624);
;// CONCATENATED MODULE: ./src/hooks/useAuthenticationModal.ts






var useAuthenticationModal = function useAuthenticationModal() {
  // const { previousLoginBy } = useSuggestedLogin();
  var _useModal = (0,useModal/* default */.Z)(Authentication/* default */.Z),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 2),
      onPresentModal = _useModal2[0],
      onDismissModal = _useModal2[1];

  var handlePresentModal = (0,react.useCallback)(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        page = _ref.page,
        method = _ref.method;

    var loginMethod = method || authentication/* AuthModalMethodEnums.WEB3 */.h.WEB3;
    onPresentModal({
      page: page,
      method: loginMethod
    });
  }, [onPresentModal]);
  return [handlePresentModal, onDismissModal];
};

/* harmony default export */ var hooks_useAuthenticationModal = (useAuthenticationModal);
// EXTERNAL MODULE: ./src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(19784);
;// CONCATENATED MODULE: ./src/views/QueryDeposit/components/ExternalQueryInstruction.tsx







var ExternalQueryInstruction = function ExternalQueryInstruction() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OpenEffect/* default */.Z, {
    openType: "grow",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      background: "rgba(255, 255, 255, 0.04)",
      borderRadius: theme/* default.radii.small */.Z.radii.small,
      py: 20,
      px: 12,
      mt: 20,
      maxWidth: 445,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        fontSize: "14px",
        color: "textSubtle",
        lineHeight: 1.5,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "If your transaction status is pending/failed on the other platform, please contact the other platform for more information. We are unable to retrieve assets that have not reached our platform."
        })
      })
    })
  });
};

/* harmony default export */ var components_ExternalQueryInstruction = (ExternalQueryInstruction);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(89395);
// EXTERNAL MODULE: ./src/components/FormControl/styled.tsx
var styled = __webpack_require__(92644);
// EXTERNAL MODULE: ./src/components/Input/styled.tsx
var Input_styled = __webpack_require__(9025);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(59441);
// EXTERNAL MODULE: ./src/components/Select/index.tsx + 2 modules
var Select = __webpack_require__(88796);
// EXTERNAL MODULE: ./src/hooks/useDebounceCallback.ts
var useDebounceCallback = __webpack_require__(47520);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(58491);
// EXTERNAL MODULE: ./src/components/Loader/CircleLoader.tsx
var CircleLoader = __webpack_require__(95322);
// EXTERNAL MODULE: ./src/config/constants/number.ts
var number = __webpack_require__(34418);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(79534);
;// CONCATENATED MODULE: ./src/components/TokenSelect/TokenSelectItem.tsx














var TokenSelectItem = function TokenSelectItem(_ref) {
  var _ref$item = _ref.item,
      token = _ref$item.token,
      amountRequest = _ref$item.amountRequest;

  var _useState = (0,react.useState)(null),
      amount = _useState[0],
      setAmount = _useState[1];

  (0,react.useEffect)(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var amount;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return amountRequest;

              case 2:
                amount = _context.sent;
                setAmount(amount);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetch() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetch();
  }, [amountRequest]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledActiveToken, {
    id: "token-select-item",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: token.logo,
        width: 24,
        height: 24
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        fontSize: "14px",
        fontWeight: "bold",
        color: "textSubtle",
        ml: "10px",
        children: token.name
      })]
    }), amountRequest && amount !== number/* BIG_ZERO */.HW && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      fontSize: "14px",
      fontWeight: "bold",
      color: "textSubtle",
      children: amount ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,formatBalance/* getFullDisplayBalance */.NJ)(amount)
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
    })]
  });
};

var StyledActiveToken = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "TokenSelectItem__StyledActiveToken",
  componentId: "sc-1wb6kkf-0"
})(["\n  width: 100%;\n\n  justify-content: space-between;\n  align-items: center;\n"]);
/* harmony default export */ var TokenSelect_TokenSelectItem = (TokenSelectItem);
;// CONCATENATED MODULE: ./src/components/TokenSelect/index.tsx

















var TokenSelect = function TokenSelect(_ref) {
  var options = _ref.options,
      onTokenChange = _ref.onTokenChange,
      fetchTokenBalanceFn = _ref.fetchTokenBalanceFn,
      value = _ref.value,
      disabled = _ref.disabled,
      dropdownContentProps = _ref.dropdownContentProps;

  var _useState = (0,react.useState)([]),
      parsedOptions = _useState[0],
      setParsedOptions = _useState[1];

  var isFetchedBalanceRef = (0,react.useRef)(null);
  var debounce = (0,useDebounceCallback/* default */.Z)();
  var prices = (0,hooks/* useTokenUsdPrices */.yK)();
  (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function () {
    var parsedOptions = options.map(function (token) {
      return {
        token: token,
        amountRequest: null
      };
    });
    setParsedOptions(parsedOptions);
  }, [options]);
  var fetchBalance = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var parsedOptions, amounts, sortedOptions;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (fetchTokenBalanceFn) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            debounce(function () {
              isFetchedBalanceRef.current = false;
            }, 2000);

            if (!isFetchedBalanceRef.current) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            isFetchedBalanceRef.current = true;
            parsedOptions = options.map(function (token) {
              return {
                token: token,
                amountRequest: fetchTokenBalanceFn(token)
              };
            });
            setParsedOptions(parsedOptions);
            _context.next = 10;
            return (0,requestHelper/* forkjoinRequest */.Rm)(parsedOptions.map(function (options) {
              return options.amountRequest;
            }));

          case 10:
            amounts = _context.sent;
            sortedOptions = parsedOptions.map(function (option, index) {
              return {
                option: option,
                amount: amounts[index]
              };
            }).sort(function (option1, option2) {
              return option2.amount.times(prices[option2.option.token.code]).minus(option1.amount.times(prices[option1.option.token.code])).toNumber();
            });
            setParsedOptions(sortedOptions.map(function (option) {
              return option.option;
            }));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [debounce, fetchTokenBalanceFn, options, prices]);

  var handleSelectToken = function handleSelectToken(option) {
    onTokenChange(option.token);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSelectContainer, {
    width: "100%",
    $disabled: disabled,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
      disabled: disabled,
      options: parsedOptions,
      onSelect: handleSelectToken,
      OptionItemComponent: TokenSelect_TokenSelectItem,
      dropdownContentProps: dropdownContentProps,
      onSelectOpen: fetchBalance,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TokenSelect_StyledActiveToken, {
        id: "token-selected",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
          alignItems: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: value.logo,
            width: 24,
            height: 24
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
            fontSize: "14px",
            fontWeight: "bold",
            color: "textSubtle",
            ml: "10px",
            children: value.name
          })]
        })
      })
    })
  });
};

var StyledSelectContainer = (0,styled_components_browser_esm/* default */.ZP)(Input_styled/* InputContainer */.fv).withConfig({
  displayName: "TokenSelect__StyledSelectContainer",
  componentId: "sc-1cukrqk-0"
})(["\n  box-sizing: border-box;\n  overflow: inherit;\n\n  border-radius: ", ";\n  border: 1px solid ", ";\n\n  background-color: 'transparent';\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.small;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.stroke;
});
var TokenSelect_StyledActiveToken = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "TokenSelect__StyledActiveToken",
  componentId: "sc-1cukrqk-1"
})(["\n  padding: ", ";\n\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n\n  padding: 12px;\n"], function (_ref5) {
  var spacing = _ref5.theme.spacing;
  return "".concat(spacing[1], "px");
});
/* harmony default export */ var components_TokenSelect = (TokenSelect);
// EXTERNAL MODULE: ./src/config/constants/formValidator.ts
var formValidator = __webpack_require__(96584);
;// CONCATENATED MODULE: ./src/config/constants/transactions.ts
var TransactionPageEnums;

(function (TransactionPageEnums) {
  TransactionPageEnums["Deposit"] = "deposit";
  TransactionPageEnums["Withdraw"] = "withdraw";
  TransactionPageEnums["Reward"] = "reward";
  TransactionPageEnums["Bonus"] = "bonus";
  TransactionPageEnums["Swap"] = "swap";
})(TransactionPageEnums || (TransactionPageEnums = {}));

var TransactionPages = [{
  content: 'Deposit',
  value: TransactionPageEnums.Deposit
}, {
  content: 'Withdraw',
  value: TransactionPageEnums.Withdraw
}, {
  content: 'Reward',
  value: TransactionPageEnums.Reward
}, {
  content: 'Bonus',
  value: TransactionPageEnums.Bonus
}, {
  content: 'Swap',
  value: TransactionPageEnums.Swap
}];
var QUERY_TRANSACTION_INTERVAL = 5000;
var TransactionReceiptStatusEnum;

(function (TransactionReceiptStatusEnum) {
  TransactionReceiptStatusEnum[TransactionReceiptStatusEnum["SUCCESS"] = 1] = "SUCCESS";
  TransactionReceiptStatusEnum[TransactionReceiptStatusEnum["FAILED"] = 0] = "FAILED";
})(TransactionReceiptStatusEnum || (TransactionReceiptStatusEnum = {}));

var QueryDepositStatusEnums;

(function (QueryDepositStatusEnums) {
  QueryDepositStatusEnums[QueryDepositStatusEnums["Init"] = 1] = "Init";
  QueryDepositStatusEnums[QueryDepositStatusEnums["ScanFailed"] = -2] = "ScanFailed";
  QueryDepositStatusEnums[QueryDepositStatusEnums["InvalidData"] = -3] = "InvalidData";
  QueryDepositStatusEnums[QueryDepositStatusEnums["InvalidMinimumFee"] = -4] = "InvalidMinimumFee";
  QueryDepositStatusEnums[QueryDepositStatusEnums["Success"] = 10] = "Success";
})(QueryDepositStatusEnums || (QueryDepositStatusEnums = {}));
// EXTERNAL MODULE: ./src/config/types/validator.ts
var validator = __webpack_require__(1872);
// EXTERNAL MODULE: ./src/utils/providers.ts
var providers = __webpack_require__(95396);
// EXTERNAL MODULE: ./src/utils/toastify.tsx
var toastify = __webpack_require__(7006);
;// CONCATENATED MODULE: ./src/components/NetworkSelect/NetworkSelectItem.tsx








var NetworkSelectItem = function NetworkSelectItem(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledActiveNetwork, {
    id: "network-select-item",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
      src: item === null || item === void 0 ? void 0 : item.networkInfo.icon,
      width: 24,
      height: 24
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      fontSize: "14px",
      fontWeight: "bold",
      color: "textSubtle",
      ml: "10px",
      children: item === null || item === void 0 ? void 0 : item.networkInfo.shortName
    })]
  });
};

var StyledActiveNetwork = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "NetworkSelectItem__StyledActiveNetwork",
  componentId: "sc-o2z6pg-0"
})(["\n  width: 100%;\n\n  align-items: center;\n"]);
/* harmony default export */ var NetworkSelect_NetworkSelectItem = (NetworkSelectItem);
;// CONCATENATED MODULE: ./src/components/NetworkSelect/index.tsx







var NetworkSelect = function NetworkSelect(_ref) {
  var options = _ref.options,
      onNetworkChange = _ref.onNetworkChange,
      value = _ref.value,
      dropdownContentProps = _ref.dropdownContentProps,
      disabled = _ref.disabled;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NetworkSelect_StyledSelectContainer, {
    width: "100%",
    $disabled: disabled,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
      disabled: disabled,
      options: options,
      onSelect: onNetworkChange,
      OptionItemComponent: NetworkSelect_NetworkSelectItem,
      dropdownContentProps: dropdownContentProps,
      id: "network-selected",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NetworkSelect_StyledActiveNetwork, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NetworkSelect_NetworkSelectItem, {
          item: value
        })
      })
    })
  });
};

var NetworkSelect_StyledSelectContainer = (0,styled_components_browser_esm/* default */.ZP)(Input_styled/* InputContainer */.fv).withConfig({
  displayName: "NetworkSelect__StyledSelectContainer",
  componentId: "sc-13zydl7-0"
})(["\n  position: static;\n  box-sizing: border-box;\n  overflow: initial;\n\n  width: 100%;\n\n  border-radius: ", ";\n  border: 1px solid ", ";\n  background-color: 'transparent';\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.stroke;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.strokeAlt;
});
var NetworkSelect_StyledActiveNetwork = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "NetworkSelect__StyledActiveNetwork",
  componentId: "sc-13zydl7-1"
})(["\n  padding: ", ";\n\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n\n  padding: 12px;\n"], function (_ref5) {
  var spacing = _ref5.theme.spacing;
  return "".concat(spacing[1], "px");
});
/* harmony default export */ var components_NetworkSelect = (NetworkSelect);
// EXTERNAL MODULE: ./src/utils/network.ts
var utils_network = __webpack_require__(71961);
// EXTERNAL MODULE: ./src/components/Loader/Dots.tsx
var Dots = __webpack_require__(46405);
;// CONCATENATED MODULE: ./src/views/QueryDeposit/components/InternalQueryDepositResult.tsx
















var InternalQueryDepositResult = function InternalQueryDepositResult(_ref) {
  var _configTokens$info$de, _NETWORK_MAP$token$ne, _NETWORK_MAP$token$ne2;

  var info = _ref.info,
      isFetching = _ref.isFetching;
  var token = (_configTokens$info$de = tokens/* default */.Z[info === null || info === void 0 ? void 0 : info.depositInfo.network]) === null || _configTokens$info$de === void 0 ? void 0 : _configTokens$info$de[info === null || info === void 0 ? void 0 : info.depositInfo.currency];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    my: 32,
    children: [isFetching ? /*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
      alignItems: "center",
      width: "100%",
      justifyContent: "center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        fontSize: "14px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dots/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Finding your deposit"
          })
        })
      })
    }) : null, !isFetching && info && /*#__PURE__*/(0,jsx_runtime.jsx)(OpenEffect/* default */.Z, {
      openType: "grow",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        py: 20,
        px: 15,
        background: theme/* default.colors.backgroundAlt */.Z.colors.backgroundAlt,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          children: [(info === null || info === void 0 ? void 0 : info.depositInfo.status) === types_transaction/* TransactionStatusEnum.Succeeded */.Zc.Succeeded && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
            fontSize: "16",
            color: "success",
            mb: 2,
            bold: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Deposit successful"
            })
          }), (info === null || info === void 0 ? void 0 : info.depositInfo.status) === types_transaction/* TransactionStatusEnum.Pending */.Zc.Pending && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
            fontSize: "16",
            color: "info",
            mb: 2,
            bold: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Deposit Pending"
            })
          }), (info === null || info === void 0 ? void 0 : info.depositInfo.status) === types_transaction/* TransactionStatusEnum.Failed */.Zc.Failed && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
            fontSize: "16",
            color: "error",
            mb: 2,
            bold: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Deposit Expired"
            })
          })]
        }), (info === null || info === void 0 ? void 0 : info.status) === QueryDepositStatusEnums.Success && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [' ', /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "space-between",
            alignItems: "center",
            mt: 4,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
              fontSize: "14px",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                children: "Coin"
              }), "/", /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                children: "Token"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
              fontSize: "14px",
              bold: true,
              children: token === null || token === void 0 ? void 0 : token.name
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "space-between",
            alignItems: "center",
            my: 2,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
              fontSize: "14px",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                children: "Amount"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
              alignItems: "center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                fontSize: "14px",
                mr: 2,
                bold: true,
                children: info === null || info === void 0 ? void 0 : info.depositInfo.value
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TokenLogo/* default */.Z, {
                token: token,
                size: 25
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "space-between",
            alignItems: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
              fontSize: "14px",
              textTransform: "capitalize",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                children: "network"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
              fontSize: "14px",
              mr: 2,
              bold: true,
              children: (_NETWORK_MAP$token$ne = constants_network/* NETWORK_MAP */.mF[token === null || token === void 0 ? void 0 : token.network]) === null || _NETWORK_MAP$token$ne === void 0 ? void 0 : (_NETWORK_MAP$token$ne2 = _NETWORK_MAP$token$ne.networkInfo) === null || _NETWORK_MAP$token$ne2 === void 0 ? void 0 : _NETWORK_MAP$token$ne2.displayName
            })]
          })]
        }), [QueryDepositStatusEnums.InvalidData, QueryDepositStatusEnums.InvalidMinimumFee, QueryDepositStatusEnums.ScanFailed].includes(info === null || info === void 0 ? void 0 : info.status) && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          maxWidth: 415,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
            fontSize: "14px",
            color: "textSubtle",
            children: [info.status === QueryDepositStatusEnums.InvalidData && /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Sorry! This is an invalid TxID/TxHash. Please double check on blockchain explorer. If your deposit is confirmed in the blockchain, you can contact our Support with your deposit info so we can help."
            }), info.status === QueryDepositStatusEnums.ScanFailed && /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Sorry! Something went wrong. Please try again later."
            }), info.status === QueryDepositStatusEnums.InvalidMinimumFee && /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "The deposit amount is less than the minimum amount requirement to be credited."
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var components_InternalQueryDepositResult = (InternalQueryDepositResult);
;// CONCATENATED MODULE: ./src/views/QueryDeposit/components/InternalQueryDeposit.tsx




function InternalQueryDeposit_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InternalQueryDeposit_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternalQueryDeposit_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternalQueryDeposit_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





























var TransactionHashInputErrorMessages = (0,defineProperty/* default */.Z)({}, validator/* ValidationError.Required */.p.Required, 'Transaction hash is required');

var InternalQueryDeposit = function InternalQueryDeposit() {
  var _useAuth = (0,auth_hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned;

  var _useAppSelector = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth;
  }),
      wallet = _useAppSelector.wallet;

  var isSolNetwork = false; // wallet?.type === WalletType.SOL;

  var currentToken = (0,hooks/* useTokenSelected */.cl)();
  var tokens = (0,hooks/* useAllTokens */.e_)(function (token) {
    return isSolNetwork ? (0,utils_token/* isSolToken */.z)(token) : !(0,utils_token/* isSolToken */.z)(token);
  }, [wallet]);
  var networks = (0,react.useMemo)(function () {
    return tokens.map(function (token) {
      return constants_network/* NETWORK_MAP */.mF[token.network];
    }).filter(function (v, i, a) {
      return a.indexOf(v) === i;
    });
  }, [tokens]);

  var _useState = (0,react.useState)(null),
      selectedToken = _useState[0],
      setSelectedToken = _useState[1];

  var _useState2 = (0,react.useState)(null),
      chainId = _useState2[0],
      setChainId = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      transactionHashInput = _useState3[0],
      setTransactionHashInput = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isIntervalQuery = _useState4[0],
      setIsIntervalQuery = _useState4[1];

  var _useState5 = (0,react.useState)(-1),
      subscribeDepositId = _useState5[0],
      setSubscribeDepositId = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      submiting = _useState6[0],
      setSubmiting = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      depositInfo = _useState7[0],
      setDepositInfo = _useState7[1];

  var network = (0,react.useMemo)(function () {
    return constants_network/* NETWORK_MAP */.mF[chainId];
  }, [chainId]);

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute;

  var _useState8 = (0,react.useState)([]),
      errors = _useState8[0],
      setErrors = _useState8[1];

  (0,react.useEffect)(function () {
    if (!selectedToken && currentToken && (isSolNetwork ? (0,utils_token/* isSolToken */.z)(currentToken) : !(0,utils_token/* isSolToken */.z)(currentToken))) {
      setSelectedToken(currentToken);
      setChainId(currentToken.network);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [currentToken, selectedToken]);
  (0,react.useEffect)(function () {
    if (!isSigned) {
      setSelectedToken(null);
      setChainId(null);
    }
  }, [isSigned]);
  (0,react.useEffect)(function () {
    if (isIntervalQuery) {
      var timer = setInterval(function () {
        handleQueryDeposit(subscribeDepositId);
      }, QUERY_TRANSACTION_INTERVAL);
      return function () {
        return clearInterval(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isIntervalQuery, subscribeDepositId]);

  var handleQueryDeposit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(subscribeDepositId) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return execute(PaymentService/* default.queryDepositByHash */.Z.queryDepositByHash(subscribeDepositId));

            case 2:
              response = _context.sent;

              if (response.data) {
                setDepositInfo(InternalQueryDeposit_objectSpread(InternalQueryDeposit_objectSpread({}, response.data), {}, {
                  txnHash: transactionHashInput
                }));

                if (response.data.status !== QueryDepositStatusEnums.Init) {
                  setIsIntervalQuery(false);
                }
              } else {
                toastify/* HunnyToast.error */.f.error(response.message);
                setIsIntervalQuery(false);
              }

              setSubmiting(false);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleQueryDeposit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSubscribeDeposit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var provider, txnReceiptResponse, response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setDepositInfo(null);

              if (transactionHashInput) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              setSubmiting(true);
              provider = (0,providers/* getSimplerRpcProvider */.M3)(selectedToken.network);

              if ((0,utils_token/* isSolToken */.z)(selectedToken)) {
                _context2.next = 17;
                break;
              }

              _context2.prev = 6;
              _context2.next = 9;
              return provider.getTransactionReceipt(transactionHashInput);

            case 9:
              txnReceiptResponse = _context2.sent;
              _context2.next = 17;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](6);
              toastify/* HunnyToast.error */.f.error(t('Your transaction hash is invalid'));
              setSubmiting(false);
              return _context2.abrupt("return");

            case 17:
              if (!(txnReceiptResponse && txnReceiptResponse.status === TransactionReceiptStatusEnum.SUCCESS || (0,utils_token/* isSolToken */.z)(selectedToken))) {
                _context2.next = 24;
                break;
              }

              _context2.next = 20;
              return PaymentService/* default.subscribeDepositByHash */.Z.subscribeDepositByHash(selectedToken.code, selectedToken.network, transactionHashInput);

            case 20:
              response = _context2.sent;

              if (response.data) {
                setSubscribeDepositId(response.data.id);
                handleQueryDeposit(response.data.id);
                setIsIntervalQuery(true);
              }

              _context2.next = 25;
              break;

            case 24:
              toastify/* HunnyToast.error */.f.error(t('Sorry, We are unable to locate this TxnHash'));

            case 25:
              setSubmiting(false);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 12]]);
    }));

    return function handleSubscribeDeposit() {
      return _ref2.apply(this, arguments);
    };
  }();

  return selectedToken && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OpenEffect/* default */.Z, {
      openType: "grow",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        mt: 42,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styled/* StyledControlContainer */.l, {
          state: null,
          mt: "10px",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputLabel */.AZ, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Select Network"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_NetworkSelect, {
            options: networks,
            value: network,
            onNetworkChange: function onNetworkChange(network) {
              var _getNetworkInfo = (0,utils_network/* getNetworkInfo */.yj)(network.chainId),
                  _native = _getNetworkInfo["native"];

              setSelectedToken(_native);
              setChainId(network.chainId);
            },
            dropdownContentProps: {
              maxHeight: '200px !important'
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styled/* StyledControlContainer */.l, {
          state: null,
          mt: "16px",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputLabel */.AZ, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Select Coin"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_TokenSelect, {
            value: selectedToken,
            onTokenChange: setSelectedToken,
            options: tokens.filter(function (token) {
              return token.network === network.chainId;
            }),
            dropdownContentProps: {
              maxHeight: '200px !important'
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          mt: 20,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputLabel */.AZ, {
            fontSize: "12px",
            color: "textSubtle",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Enter TxID/TxHash"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputContainer */.fv, {
            py: 16,
            pl: 2,
            mt: 10,
            mb: 10,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* StyledInput */.Fy, {
              value: transactionHashInput,
              onValueChanged: setTransactionHashInput,
              placeholder: t('Enter TxID/TxHash'),
              onErrorChanged: setErrors,
              validators: [formValidator/* default.required */.ZP.required]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputMessage */.LK, {
            color: "error",
            textAlign: "right",
            children: errors.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: TransactionHashInputErrorMessages[errors[0]]
            }) : null
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          disabled: !transactionHashInput || submiting,
          width: "100%",
          mt: 30,
          onClick: handleSubscribeDeposit,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
            fontSize: "14px",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Check"
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_InternalQueryDepositResult, {
      info: depositInfo,
      isFetching: submiting
    })]
  });
};

/* harmony default export */ var components_InternalQueryDeposit = (InternalQueryDeposit);
;// CONCATENATED MODULE: ./src/views/QueryDeposit/index.tsx


















var QueryViewEnums;

(function (QueryViewEnums) {
  QueryViewEnums[QueryViewEnums["Failed"] = 0] = "Failed";
  QueryViewEnums[QueryViewEnums["Completed"] = 1] = "Completed";
})(QueryViewEnums || (QueryViewEnums = {}));

var QueryDeposit = function QueryDeposit(_ref) {
  var onDismiss = _ref.onDismiss;

  var _useState = (0,react.useState)(null),
      view = _useState[0],
      setView = _useState[1];

  var _useAuth = (0,auth_hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned;

  (0,react.useEffect)(function () {
    if (!isSigned) setView(null);
  }, [isSigned]);

  var _useAuthenticationMod = hooks_useAuthenticationModal(),
      _useAuthenticationMod2 = (0,slicedToArray/* default */.Z)(_useAuthenticationMod, 1),
      onPresentLoginModal = _useAuthenticationMod2[0];

  var handleSelectQueryDeposit = function handleSelectQueryDeposit(view) {
    if (!isSigned) return onPresentLoginModal({
      page: authentication/* AuthModalPageEnums.LOG_IN */.i.LOG_IN
    });
    setView(view);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal_Modal/* default */.Z, {
    onDismiss: onDismiss,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* ModalHeader */.xB, {
      p: ['12px', '', '24px'],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Heading/* default */.Z, {
        children: "Query Deposit"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* ModalBody */.fe, {
      overflowY: "scroll",
      maxHeight: "90vh",
      minHeight: "300px",
      p: ['12px', '', '24px'],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mt: "12px",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Heading/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Check the Deposit that Hasn't Arrived"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          fontSize: "14px",
          mt: 22,
          mb: 27,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "What is the transaction status on explorer or withdrawal platform?"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
            mb: "12px",
            onClick: function onClick() {
              return handleSelectQueryDeposit(QueryViewEnums.Completed);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledRadioButton, {
              $active: view === QueryViewEnums.Completed,
              onClick: function onClick() {
                return handleSelectQueryDeposit(QueryViewEnums.Completed);
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
              position: "relative",
              ml: "8px",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                fontSize: "14px",
                bold: view === QueryViewEnums.Completed,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                  children: "Success"
                }), " / ", /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                  children: "Completed"
                })]
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
            onClick: function onClick() {
              return handleSelectQueryDeposit(QueryViewEnums.Failed);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledRadioButton, {
              $active: view === QueryViewEnums.Failed,
              onClick: function onClick() {
                return handleSelectQueryDeposit(QueryViewEnums.Failed);
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
              position: "relative",
              ml: "8px",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                fontSize: "14px",
                bold: view === QueryViewEnums.Failed,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                  children: "Pending"
                }), " / ", /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                  children: "Failed"
                })]
              })
            })]
          })]
        }), isSigned && /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          maxWidth: 512,
          children: [view === QueryViewEnums.Completed && /*#__PURE__*/(0,jsx_runtime.jsx)(components_InternalQueryDeposit, {}), view === QueryViewEnums.Failed && /*#__PURE__*/(0,jsx_runtime.jsx)(components_ExternalQueryInstruction, {})]
        })]
      })
    })]
  });
};

var StyledRadioButton = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "QueryDeposit__StyledRadioButton",
  componentId: "sc-qvrcxv-0"
})(["\n  width: 24px;\n  height: 24px;\n  position: relative;\n\n  cursor: pointer;\n\n  border-radius: 50%;\n  border: ", ";\n\n  transition: ", ";\n  animation: ", " 1s linear;\n\n  &:hover {\n    transform: scale(1.1);\n  }\n\n  &:before {\n    content: '';\n    position: absolute;\n\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    width: 75%;\n    height: 75%;\n\n    border-radius: 50%;\n    background: ", ";\n  }\n"], function (_ref2) {
  var colors = _ref2.theme.colors,
      $active = _ref2.$active;
  return "2px solid ".concat($active ? colors.primary : colors.text);
}, function (_ref3) {
  var transitions = _ref3.theme.transitions;
  return transitions.fast;
}, function (_ref4) {
  var $active = _ref4.$active;
  return $active ? keyframes/* default.ripple */.Z.ripple : null;
}, function (_ref5) {
  var $active = _ref5.$active,
      colors = _ref5.theme.colors;
  return $active ? colors.primary : 'transparent';
});
/* harmony default export */ var views_QueryDeposit = (QueryDeposit);
;// CONCATENATED MODULE: ./src/views/QueryDeposit/useQueryDepositModal.ts




var useQueryDepositModal = function useQueryDepositModal() {
  var _useModal = (0,useModal/* default */.Z)(views_QueryDeposit),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      onPresent = _useModal2[0];

  return (0,react.useMemo)(function () {
    return {
      onPresentQueryDeposit: onPresent
    };
  }, [onPresent]);
};
;// CONCATENATED MODULE: ./src/views/Payment/components/PaymentTokenSelect.tsx



var PaymentTokenSelect_excluded = ["onTokenSelect", "token", "disabled", "networks", "fetchTokenBalanceFn", "dropdownHeight"];

function PaymentTokenSelect_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PaymentTokenSelect_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentTokenSelect_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentTokenSelect_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var PaymentTokenSelect = function PaymentTokenSelect(_ref) {
  var onTokenSelect = _ref.onTokenSelect,
      token = _ref.token,
      disabled = _ref.disabled,
      networks = _ref.networks,
      fetchTokenBalanceFn = _ref.fetchTokenBalanceFn,
      _ref$dropdownHeight = _ref.dropdownHeight,
      dropdownHeight = _ref$dropdownHeight === void 0 ? '200px' : _ref$dropdownHeight,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, PaymentTokenSelect_excluded);

  // const wallet = useAppSelector((state) => state.auth.wallet);
  // const tokenInfoes = useAppSelector((state) => state.app.tokenInfoes);
  // INTERGRATE SOLANA
  // const fallbackNetwork = useMemo(() => {
  //   return tokenInfoes.find((token) =>
  //     wallet?.type === WalletType.SOL
  //       ? token.network === ChainIdEnum.SOL || token.network === ChainIdEnum.SOL_TESTNET
  //       : token,
  //   )?.network;
  // }, []);
  // const initialNetwork = token.network === ChainIdEnum.HPN ? fallbackNetwork : token.network;
  var _useState = (0,react.useState)(token.network),
      chainId = _useState[0],
      setChainId = _useState[1];

  var network = (0,react.useMemo)(function () {
    return constants_network/* NETWORK_MAP */.mF[chainId];
  }, [chainId]);
  var listToken = (0,hooks/* useListTokens */.Jo)(chainId);
  var parsedListToken = (0,react.useMemo)(function () {
    return (0,toConsumableArray/* default */.Z)(listToken);
  }, [listToken]);

  var handleSelectNetwork = function handleSelectNetwork(network) {
    setChainId(network.chainId);

    var _getNetworkInfo = (0,utils_network/* getNetworkInfo */.yj)(network.chainId),
        _native = _getNetworkInfo["native"];

    onTokenSelect(_native);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, PaymentTokenSelect_objectSpread(PaymentTokenSelect_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styled/* StyledControlContainer */.l, {
      state: null,
      mt: "10px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputLabel */.AZ, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Select Network"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_NetworkSelect, {
        disabled: disabled,
        options: networks,
        value: network,
        onNetworkChange: handleSelectNetwork,
        dropdownContentProps: {
          maxHeight: "".concat(dropdownHeight, " !important")
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styled/* StyledControlContainer */.l, {
      state: null,
      mt: "16px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputLabel */.AZ, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Select Coin"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_TokenSelect, {
        disabled: disabled,
        value: token,
        onTokenChange: function onTokenChange(token) {
          return onTokenSelect(token);
        },
        fetchTokenBalanceFn: fetchTokenBalanceFn,
        options: parsedListToken,
        dropdownContentProps: {
          maxHeight: "".concat(dropdownHeight, " !important")
        }
      })]
    })]
  }));
};

/* harmony default export */ var components_PaymentTokenSelect = (PaymentTokenSelect);
// EXTERNAL MODULE: ./src/utils/stringHelper.ts
var stringHelper = __webpack_require__(57430);
;// CONCATENATED MODULE: ./src/components/Input/NumericalInput.tsx


var NumericalInput_excluded = ["value", "onValueChanged"];

function NumericalInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NumericalInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NumericalInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NumericalInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var NumericalInput = function NumericalInput(_ref) {
  var value = _ref.value,
      onValueChanged = _ref.onValueChanged,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, NumericalInput_excluded);

  var enforcer = function enforcer(nextUserInput) {
    if (nextUserInput === '' || stringHelper/* inputRegex.test */.dM.test((0,stringHelper/* escapeRegExp */.hr)(nextUserInput))) {
      onValueChanged(nextUserInput);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* StyledInput */.Fy, NumericalInput_objectSpread(NumericalInput_objectSpread({}, props), {}, {
    value: value,
    inputMode: "decimal",
    type: "text",
    minLength: 1,
    maxLength: 48,
    pattern: "^[0-9]*[.,]?[0-9]*$",
    autoFocus: true,
    onValueChanged: function onValueChanged(value) {
      // replace commas with periods, because we exclusively uses period as the decimal separator
      enforcer(value.replace(/,/g, '.'));
    }
  }));
};

/* harmony default export */ var Input_NumericalInput = (NumericalInput);
;// CONCATENATED MODULE: ./src/components/TokenInput/index.tsx



var TokenInput_excluded = ["token", "value", "placeholder", "onValueChanged", "onErrorChanged", "max", "disabled", "errors", "autoFocus", "validators", "tabIndex", "getFee"];

function TokenInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TokenInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TokenInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TokenInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var TokenInput = function TokenInput(_ref) {
  var token = _ref.token,
      value = _ref.value,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      onValueChanged = _ref.onValueChanged,
      onErrorChanged = _ref.onErrorChanged,
      max = _ref.max,
      disabled = _ref.disabled,
      errors = _ref.errors,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$validators = _ref.validators,
      validators = _ref$validators === void 0 ? [] : _ref$validators,
      tabIndex = _ref.tabIndex,
      getFee = _ref.getFee,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, TokenInput_excluded);

  var _useState = (0,react.useState)(false),
      fetchingFee = _useState[0],
      setFetchingFee = _useState[1];

  var handleFillMaxBalance = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var fee;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fee = number/* BIG_ZERO */.HW;

              if (!getFee) {
                _context.next = 7;
                break;
              }

              setFetchingFee(true);
              _context.next = 5;
              return getFee();

            case 5:
              fee = _context.sent;
              setFetchingFee(false);

            case 7:
              if (max.gt(fee.multipliedBy(3))) {
                onValueChanged(max.minus(fee.multipliedBy(3)).toString(10));
              } else {
                onValueChanged(max.toNumber().toString());
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFillMaxBalance() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Input_styled/* InputContainer */.fv, TokenInput_objectSpread(TokenInput_objectSpread({
    id: "token-input"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTokenInput, {
      tabIndex: tabIndex,
      value: value,
      validators: validators,
      onValueChanged: onValueChanged,
      onErrorChanged: onErrorChanged,
      validateOnchange: true,
      placeholder: placeholder
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      alignItems: "center",
      p: "15px 20px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        mr: "20px",
        color: "textAlt",
        children: token === null || token === void 0 ? void 0 : token.name
      }), !disabled && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledMaxField, {
          id: "max-button",
          onClick: function onClick() {
            return !fetchingFee && handleFillMaxBalance();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
            textTransform: "uppercase",
            color: "textHighlight",
            fontSize: "14px",
            fontWeight: "700",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "MAX"
            })
          })
        })
      })]
    })]
  }));
};

var StyledMaxField = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "TokenInput__StyledMaxField",
  componentId: "sc-1j33jq8-0"
})(["\n  cursor: pointer;\n"]);
var StyledTokenInput = (0,styled_components_browser_esm/* default */.ZP)(Input_NumericalInput).withConfig({
  displayName: "TokenInput__StyledTokenInput",
  componentId: "sc-1j33jq8-1"
})(["\n  text-align: right;\n  height: auto !important;\n  font-size: 24px;\n  color: ", ";\n"], function (_ref3) {
  var colors = _ref3.theme.colors;
  return colors.text;
});
/* harmony default export */ var components_TokenInput = (TokenInput);
;// CONCATENATED MODULE: ./src/hooks/useDepositFee.ts






function useDepositFee(token) {
  var tokenInfoes = (0,state/* useAppSelector */.CG)(function (state) {
    return state.app.tokenInfoes;
  });
  var tokenDepositInfo = (0,react.useMemo)(function () {
    var _tokenInfoes$find;

    if (!token) return null;
    var spender = (_tokenInfoes$find = tokenInfoes.find(function (tokenInfo) {
      return tokenInfo.network === token.network && tokenInfo.token === token.code;
    })) === null || _tokenInfoes$find === void 0 ? void 0 : _tokenInfoes$find.contractAddress;
    if (!spender) return null;
    return {
      spender: spender,
      token: token
    };
  }, [token, tokenInfoes]);
  var estimateFee = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var fee;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,infura/* estimateDepositFee */.w_)(tokenDepositInfo.token, '1', tokenDepositInfo.spender);

          case 2:
            fee = _context.sent;
            return _context.abrupt("return", fee);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [tokenDepositInfo]);
  return estimateFee;
}

/* harmony default export */ var hooks_useDepositFee = (useDepositFee);
// EXTERNAL MODULE: ./src/hooks/useForm.ts
var useForm = __webpack_require__(16145);
// EXTERNAL MODULE: ./src/state/profile/hooks.ts + 1 modules
var profile_hooks = __webpack_require__(57534);
// EXTERNAL MODULE: ./src/utils/transaction.ts
var utils_transaction = __webpack_require__(54458);
// EXTERNAL MODULE: ./src/state/transaction/hooks.tsx + 2 modules
var transaction_hooks = __webpack_require__(89030);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js + 1 modules
var core_esm = __webpack_require__(34713);
// EXTERNAL MODULE: ./node_modules/@web3-react/walletconnect-connector/dist/walletconnect-connector.esm.js
var walletconnect_connector_esm = __webpack_require__(83929);
// EXTERNAL MODULE: ./src/components/Modal/components/ModalBody.tsx
var ModalBody = __webpack_require__(23043);
;// CONCATENATED MODULE: ./src/components/ConfirmationModal/ConfirmationLayoutModal.tsx


var ConfirmationLayoutModal_excluded = ["onDismiss", "children"];

function ConfirmationLayoutModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ConfirmationLayoutModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ConfirmationLayoutModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ConfirmationLayoutModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var ConfirmationLayoutModal = function ConfirmationLayoutModal(_ref) {
  var onDismiss = _ref.onDismiss,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, ConfirmationLayoutModal_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmationLayoutModal_StyledModal, ConfirmationLayoutModal_objectSpread(ConfirmationLayoutModal_objectSpread({
    onDismiss: onDismiss
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledModalBody, {
      borderRadius: "0px",
      height: "100%",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          width: "120px",
          height: "120px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/images/confirmation.png",
            width: 300,
            height: 300
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          mt: "20px",
          fontWeight: "700",
          fontSize: "20px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Confirmation"
          })
        })]
      }), children]
    })
  }));
};

var ConfirmationLayoutModal_StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal_Modal/* default */.Z).withConfig({
  displayName: "ConfirmationLayoutModal__StyledModal",
  componentId: "sc-bdkc0v-0"
})(["\n  padding: 24px;\n\n  ", " {\n    min-width: 420px !important;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueries.sm;
});
var StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(ModalBody/* default */.Z).withConfig({
  displayName: "ConfirmationLayoutModal__StyledModalBody",
  componentId: "sc-bdkc0v-1"
})(["\n  overflow-y: unset !important;\n"]);
/* harmony default export */ var ConfirmationModal_ConfirmationLayoutModal = (ConfirmationLayoutModal);
;// CONCATENATED MODULE: ./src/components/ConfirmationModal/index.tsx










var ConfirmationModal = function ConfirmationModal(_ref) {
  var onDismiss = _ref.onDismiss,
      _ref$data = _ref.data,
      onAccept = _ref$data.onAccept,
      _ref$data$onCancel = _ref$data.onCancel,
      onCancel = _ref$data$onCancel === void 0 ? function () {} : _ref$data$onCancel,
      content = _ref$data.content,
      _ref$data$cancelButto = _ref$data.cancelButtonContent,
      cancelButtonContent = _ref$data$cancelButto === void 0 ? 'Cancel' : _ref$data$cancelButto,
      _ref$data$acceptButto = _ref$data.acceptButtonContent,
      acceptButtonContent = _ref$data$acceptButto === void 0 ? 'Yes' : _ref$data$acceptButto;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConfirmationModal_ConfirmationLayoutModal, {
    onDismiss: onDismiss,
    children: [typeof content === 'string' ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      mt: "8px",
      fontSize: "12px",
      color: "textSubtle",
      textAlign: "center",
      maxWidth: "320px",
      marginX: "auto",
      lineHeight: "14.5px",
      children: t(content)
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      mt: "8px",
      fontSize: "12px",
      color: "textSubtle",
      textAlign: "center",
      maxWidth: "320px",
      marginX: "auto",
      lineHeight: "14.5px",
      children: content
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      maxWidth: "250px",
      marginX: "auto",
      width: "100%",
      mt: "40px",
      onClick: function onClick() {
        onAccept();
        onDismiss();
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        small: true,
        bold: true,
        children: t(acceptButtonContent)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      variant: "text",
      maxWidth: "250px",
      marginX: "auto",
      width: "100%",
      mt: "4px",
      onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return onCancel();

              case 2:
                onDismiss();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        small: true,
        color: "textSubtle",
        children: t(cancelButtonContent)
      })
    })]
  });
};

/* harmony default export */ var components_ConfirmationModal = (ConfirmationModal);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(170);
// EXTERNAL MODULE: ./src/config/constants/wallet.ts
var constants_wallet = __webpack_require__(34798);
// EXTERNAL MODULE: ./src/hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(42705);
;// CONCATENATED MODULE: ./src/hooks/useApproveDepositContract.ts








function useApproveDepositContract(token) {
  var _useWeb3React = (0,core_esm/* useWeb3React */.Ge)(),
      library = _useWeb3React.library,
      account = _useWeb3React.account;

  var _useState = (0,react.useState)(constants/* FetchingStatus.Unknown */._u.Unknown),
      approveProcess = _useState[0],
      setApproveProcess = _useState[1];

  var tokenInfoes = (0,state/* useAppSelector */.CG)(function (state) {
    return state.app.tokenInfoes;
  });
  var tokenDepositInfo = (0,react.useMemo)(function () {
    var _tokenInfoes$find;

    if (!token) return null;
    var spender = (_tokenInfoes$find = tokenInfoes.find(function (tokenInfo) {
      return tokenInfo.network === token.network && tokenInfo.token === token.code;
    })) === null || _tokenInfoes$find === void 0 ? void 0 : _tokenInfoes$find.contractAddress;
    if (!spender) return null;
    return {
      spender: spender,
      token: token
    };
  }, [token, tokenInfoes]);
  (0,react.useEffect)(function () {
    setApproveProcess(constants/* FetchingStatus.Unknown */._u.Unknown);
  }, [tokenDepositInfo]);
  var approveToken = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var hash;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (tokenDepositInfo) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            if (!tokenDepositInfo.token.isNative) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", null);

          case 4:
            setApproveProcess(constants/* FetchingStatus.Fetching */._u.Fetching);
            _context.next = 7;
            return (0,infura/* approve */.dE)(library.getSigner(account), tokenDepositInfo.token, tokenDepositInfo.spender);

          case 7:
            hash = _context.sent;
            setApproveProcess(constants/* FetchingStatus.Fetched */._u.Fetched);
            return _context.abrupt("return", hash);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [account, library, tokenDepositInfo]);
  return {
    approve: approveToken,
    approveProcess: approveProcess
  };
}

/* harmony default export */ var hooks_useApproveDepositContract = (useApproveDepositContract);
// EXTERNAL MODULE: ./src/hooks/useConnectWallet.ts
var useConnectWallet = __webpack_require__(97379);
;// CONCATENATED MODULE: ./src/hooks/useDeposit.ts


// INTERGRATE SOLANA
// import { WalletContextState, useWallet } from '@solana/wallet-adapter-react'





function useDeposit(token) {
  var _useWeb3React = (0,core_esm/* useWeb3React */.Ge)(),
      library = _useWeb3React.library,
      evmAccount = _useWeb3React.account;

  var _useState = (0,react.useState)(false),
      submiting = _useState[0],
      setSubmiting = _useState[1]; // const solanaWallet: WalletContextState = useWallet()


  var tokenInfoes = (0,state/* useAppSelector */.CG)(function (state) {
    return state.app.tokenInfoes;
  });
  var tokenDepositInfo = (0,react.useMemo)(function () {
    var _tokenInfoes$find;

    if (!token) return null;
    var spender = (_tokenInfoes$find = tokenInfoes.find(function (tokenInfo) {
      return tokenInfo.network === token.network && tokenInfo.token === token.code;
    })) === null || _tokenInfoes$find === void 0 ? void 0 : _tokenInfoes$find.contractAddress;
    if (!spender) return null;
    return {
      spender: spender,
      token: token
    };
  }, [token, tokenInfoes]);
  var depositEvm = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(value) {
      var hash;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,infura/* deposit */._6)(library.getSigner(evmAccount), tokenDepositInfo.token, value, tokenDepositInfo.spender);

            case 2:
              hash = _context.sent;
              return _context.abrupt("return", hash);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [tokenDepositInfo, library, evmAccount]); // const depositSolana = useCallback(
  //   async (value: string) => {
  //     const hash = await depositSolToken(tokenDepositInfo.token, value, solanaWallet)
  //     return hash
  //   },
  //   [tokenDepositInfo, solanaWallet],
  // )

  var deposit = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(value) {
      var depositFn, hash;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // const depositFn = isSolToken(tokenDepositInfo.token) ? depositSolana : depositEvm
              depositFn = depositEvm;
              setSubmiting(true);
              _context2.next = 4;
              return depositFn(value);

            case 4:
              hash = _context2.sent;
              setSubmiting(false);
              return _context2.abrupt("return", hash);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [depositEvm]);
  return {
    deposit: deposit,
    submiting: submiting
  };
}

/* harmony default export */ var hooks_useDeposit = (useDeposit);
;// CONCATENATED MODULE: ./src/hooks/useDepositTokenAllowance.ts









function useDepositTokenAllowance(token) {
  var _useWeb3React = (0,core_esm/* useWeb3React */.Ge)(),
      account = _useWeb3React.account;

  var _useState = (0,react.useState)(false),
      fetching = _useState[0],
      setFetching = _useState[1];

  var _useState2 = (0,react.useState)(number/* UINT256_MAX */.U8),
      allowance = _useState2[0],
      setAllowance = _useState2[1];

  var tokenInfoes = (0,state/* useAppSelector */.CG)(function (state) {
    return state.app.tokenInfoes;
  });
  var tokenDepositInfo = (0,react.useMemo)(function () {
    var _tokenInfoes$find;

    if (!token) return null;
    var spender = (_tokenInfoes$find = tokenInfoes.find(function (tokenInfo) {
      return tokenInfo.network === token.network && tokenInfo.token === token.code;
    })) === null || _tokenInfoes$find === void 0 ? void 0 : _tokenInfoes$find.contractAddress;
    if (!spender) return null;
    return {
      spender: spender,
      token: token
    };
  }, [token, tokenInfoes]);
  var refresh = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var allowance;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!tokenDepositInfo.token.isNative) {
              _context.next = 3;
              break;
            }

            setAllowance(number/* UINT256_MAX */.U8);
            return _context.abrupt("return");

          case 3:
            if (!(0,utils_token/* isSolToken */.z)(tokenDepositInfo.token)) {
              _context.next = 6;
              break;
            }

            setAllowance(number/* UINT256_MAX */.U8);
            return _context.abrupt("return");

          case 6:
            setFetching(true);
            _context.next = 9;
            return (0,infura/* getTokenAllowance */.f2)(tokenDepositInfo.token, account, tokenDepositInfo.spender);

          case 9:
            allowance = _context.sent;
            setAllowance(allowance);
            setFetching(true);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [account, tokenDepositInfo]);
  (0,react.useEffect)(function () {
    if (!tokenDepositInfo) return;
    refresh();
  }, [refresh, tokenDepositInfo]);
  return {
    allowance: allowance,
    fetching: fetching,
    refresh: refresh
  };
}

/* harmony default export */ var hooks_useDepositTokenAllowance = (useDepositTokenAllowance);
// EXTERNAL MODULE: ./src/hooks/useWalletAccount.ts
var useWalletAccount = __webpack_require__(66015);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(7737);
;// CONCATENATED MODULE: ./src/utils/wallet.ts




var setupNetwork = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(chainId, library) {
    var network, chainName, rpcUrls, blockExplorerUrls, provider;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            network = constants_network/* NETWORK_MAP */.mF[chainId];

            if (network) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            chainName = network.networkInfo.displayName;
            rpcUrls = network.rpcCollections;
            blockExplorerUrls = [network.blockExplorerUrls];
            provider = (library === null || library === void 0 ? void 0 : library.provider) || window.ethereum;

            if (!provider) {
              _context.next = 31;
              break;
            }

            if (!(chainId && provider)) {
              _context.next = 29;
              break;
            }

            _context.prev = 9;
            _context.next = 12;
            return provider.request({
              method: 'wallet_switchEthereumChain',
              params: [{
                chainId: "0x".concat(chainId.toString(16))
              }]
            });

          case 12:
            return _context.abrupt("return", true);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](9);

            if (!((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.code) === 4902)) {
              _context.next = 28;
              break;
            }

            _context.prev = 18;
            _context.next = 21;
            return provider.request({
              method: 'wallet_addEthereumChain',
              params: [{
                chainId: "0x".concat((chainId === null || chainId === void 0 ? void 0 : chainId.toString(16)) || 0),
                chainName: chainName,
                nativeCurrency: {
                  name: network.networkInfo["native"].name,
                  symbol: network.networkInfo["native"].name,
                  decimals: network.networkInfo["native"].decimals
                },
                rpcUrls: rpcUrls,
                blockExplorerUrls: blockExplorerUrls
              }]
            });

          case 21:
            return _context.abrupt("return", true);

          case 24:
            _context.prev = 24;
            _context.t1 = _context["catch"](18);
            (0,sentry/* logError */.H)('Failed to setup the network in Metamask:', _context.t1);
            return _context.abrupt("return", false);

          case 28:
            return _context.abrupt("return", false);

          case 29:
            _context.next = 33;
            break;

          case 31:
            // eslint-disable-next-line quotes, @typescript-eslint/quotes
            console.error("Can't setup the network on metamask because window.ethereum is undefined");
            return _context.abrupt("return", false);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 15], [18, 24]]);
  }));

  return function setupNetwork(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./src/views/Payment/components/Deposit/hooks.ts
var Deposit_hooks = __webpack_require__(21947);
;// CONCATENATED MODULE: ./src/views/Payment/components/Deposit/DepositButton.tsx




var DepositButton_excluded = ["selectedToken", "validateAll", "onStart", "loading", "value", "selectedBonus", "onSucceed", "onFailed", "handleSelectedBonus", "disabled"];

function DepositButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DepositButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DepositButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DepositButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* eslint-disable max-len */




































var DepositButton = function DepositButton(_ref) {
  var selectedToken = _ref.selectedToken,
      validateAll = _ref.validateAll,
      onStart = _ref.onStart,
      loading = _ref.loading,
      value = _ref.value,
      selectedBonus = _ref.selectedBonus,
      onSucceed = _ref.onSucceed,
      onFailed = _ref.onFailed,
      handleSelectedBonus = _ref.handleSelectedBonus,
      disabled = _ref.disabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, DepositButton_excluded);

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var priceInUsd = (0,hooks/* useTokenUsdPrice */.KT)(selectedToken);
  var walletConnector = (0,useConnectWallet/* useConnectWallet */.O)();

  var _useAppSelector = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth;
  }),
      wallet = _useAppSelector.wallet;

  var walletInfo = (0,react.useMemo)(function () {
    return wallet && constants_wallet/* WALLET_INFO.find */.I.find(function (item) {
      return item.name === wallet.name && item.type === wallet.type;
    });
  }, [wallet]);

  var _useWeb3React = (0,core_esm/* useWeb3React */.Ge)(),
      chainId = _useWeb3React.chainId;

  var accounts = (0,useWalletAccount/* default */.Z)();
  var account = accounts[wallet === null || wallet === void 0 ? void 0 : wallet.type];
  var isWrongAddress = account !== wallet.address;
  var isWrongNetwork = chainId !== selectedToken.network; // const isWrongNetwork = walletInfo.type !== WalletType.SOL && chainId != selectedToken.network;

  var _useDepositTokenAllow = hooks_useDepositTokenAllowance(!isWrongNetwork && !isWrongAddress && selectedToken),
      allowance = _useDepositTokenAllow.allowance,
      refresh = _useDepositTokenAllow.refresh;

  var isApproved = value ? allowance === null || allowance === void 0 ? void 0 : allowance.gte((0,formatBalance/* getDecimalAmount */.Qe)(value, selectedToken.decimals)) : allowance === null || allowance === void 0 ? void 0 : allowance.gt(0);

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      recordEvent = _useAnalytics.recordEvent;

  var _useApproveDepositCon = hooks_useApproveDepositContract(selectedToken),
      approve = _useApproveDepositCon.approve,
      approveProcess = _useApproveDepositCon.approveProcess;

  var _useDeposit = hooks_useDeposit(selectedToken),
      deposit = _useDeposit.deposit,
      submiting = _useDeposit.submiting;

  var _useState = (0,react.useState)(false),
      isSwichingNetwork = _useState[0],
      setIsSwichingNetwork = _useState[1];

  var _useModal = (0,useModal/* default */.Z)(components_ConfirmationModal),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      presentConfirmModal = _useModal2[0];

  var handleSwitchNetwork = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSwichingNetwork(true);
              _context.next = 3;
              return setupNetwork(selectedToken.network)["catch"](function () {});

            case 3:
              setIsSwichingNetwork(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSwitchNetwork() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleApproval = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var hash;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return approve();

            case 2:
              hash = _context2.sent;

              if (hash) {
                refresh();
                toastify/* HunnyToast.success */.f.success(t('Approve {{token}} successfully!', {
                  token: selectedToken.code
                }));
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleApproval() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleDeposit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
      var isValid, _deposit;

      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return validateAll();

            case 2:
              isValid = _context5.sent;

              if (isValid) {
                _context5.next = 5;
                break;
              }

              return _context5.abrupt("return");

            case 5:
              _deposit = /*#__PURE__*/function () {
                var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
                  var hash;
                  return regenerator_default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (onStart) onStart();
                          _context3.next = 3;
                          return deposit(value);

                        case 3:
                          hash = _context3.sent;

                          if (hash) {
                            recordEvent('deposit', (0,defineProperty/* default */.Z)({}, constants_network/* ChainIdEnum */.Li[selectedToken.network], selectedToken.name));
                            onSucceed(hash);
                          } else if (onFailed) onFailed();

                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function _deposit() {
                  return _ref5.apply(this, arguments);
                };
              }();

              if (selectedBonus.id && selectedBonus.minDepositBigAmount.gt(priceInUsd.multipliedBy(value))) {
                presentConfirmModal({
                  onAccept: function onAccept() {},
                  onCancel: function () {
                    var _onCancel = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
                      return regenerator_default().wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return handleSelectedBonus(Deposit_hooks/* emptyBonus */.Z);

                            case 2:
                              _deposit();

                            case 3:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));

                    function onCancel() {
                      return _onCancel.apply(this, arguments);
                    }

                    return onCancel;
                  }(),
                  content: t('The min deposit amount to activate your selected bonus is {{value}} {{token}}. If you want to deposit a lower amount, please choose the “Without Bonus” option', {
                    value: (0,formatBalance/* getFullDisplayBalance */.NJ)(selectedBonus.minDepositBigAmount.dividedBy(priceInUsd), 0, 6),
                    token: selectedToken.code
                  }),
                  acceptButtonContent: t('Input other amount'),
                  cancelButtonContent: t('Deposit without bonus')
                });
              } else {
                _deposit();
              }

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleDeposit() {
      return _ref4.apply(this, arguments);
    };
  }();

  if (!account) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, DepositButton_objectSpread(DepositButton_objectSpread({}, props), {}, {
      onClick: function onClick() {
        walletConnector[wallet.type].connect(walletInfo.adapter);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        bold: true,
        fontSize: "14px",
        color: submiting ? 'textSubtle' : 'text',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Connect Wallet"
        })
      })
    }));
  }

  if (isWrongAddress) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, DepositButton_objectSpread(DepositButton_objectSpread({
        alignItems: "center",
        border: "1px solid ".concat(colors/* colors.warning */.O.warning),
        padding: "12px",
        borderRadius: theme/* default.radii.small */.Z.radii.small
      }, props), {}, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mr: "12px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.WarningIcon */.P.WarningIcon, {
            width: "24px",
            fill: colors/* colors.warning */.O.warning
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          bold: true,
          fontSize: "12px",
          color: "warning",
          textAlign: "center",
          lineHeight: "16px",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(es_Trans/* Trans */.c, {
            children: ["It seems your wallet connected is active different address, please switch to account", ' ', {
              account: (0,stringHelper/* formatUsername */.Kf)(wallet.address)
            }]
          })
        })]
      })), walletInfo.adapter instanceof walletconnect_connector_esm/* WalletConnectConnector */.zw && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "12px",
        width: "100%",
        onClick: function onClick() {
          walletConnector[wallet.type].connect(walletInfo.adapter);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          bold: true,
          fontSize: "14px",
          color: submiting ? 'textSubtle' : 'text',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Switch account"
          })
        })
      })]
    });
  }

  if (isWrongNetwork) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, DepositButton_objectSpread(DepositButton_objectSpread({
        disabled: isSwichingNetwork,
        onClick: handleSwitchNetwork
      }, props), {}, {
        children: [isSwichingNetwork && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mr: "12px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          bold: true,
          fontSize: "14px",
          color: submiting ? 'textSubtle' : 'text',
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(es_Trans/* Trans */.c, {
            children: ["Switch To ", {
              chainName: constants_network/* NETWORK_MAP */.mF[selectedToken.network].networkInfo.displayName
            }]
          })
        })]
      })), walletInfo.adapter instanceof walletconnect_connector_esm/* WalletConnectConnector */.zw && isSwichingNetwork && /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        mt: "12px",
        alignItems: "center",
        justifyContent: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          fontSize: "14px",
          color: "textSubtle",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "If you can't switch network. Try"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledReconnect, {
          fontSize: "14px",
          ml: "4px",
          onClick: function onClick() {
            walletConnector[wallet.type].connect(walletInfo.adapter);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Reconnect"
          })
        })]
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, DepositButton_objectSpread(DepositButton_objectSpread({
    flexDirection: "column",
    alignItems: "center"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      width: "100%",
      children: [(approveProcess === constants/* FetchingStatus.Fetched */._u.Fetched || !isApproved) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        disabled: approveProcess === constants/* FetchingStatus.Fetching */._u.Fetching || isApproved,
        onClick: handleApproval,
        style: {
          flex: 1
        },
        mr: "12px",
        children: [approveProcess === constants/* FetchingStatus.Fetching */._u.Fetching && /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* RowCenter */.K7, {
          mr: "12px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          bold: true,
          fontSize: "14px",
          color: approveProcess === constants/* FetchingStatus.Fetching */._u.Fetching || isApproved ? 'textSubtle' : 'text',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Approve"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        disabled: !isApproved || submiting || loading || disabled,
        onClick: handleDeposit,
        style: {
          flex: 1
        },
        children: [(submiting || loading) && /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* RowCenter */.K7, {
          mr: "12px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          bold: true,
          fontSize: "14px",
          color: disabled ? 'textSubtle' : 'text',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Deposit"
          })
        })]
      })]
    }), (approveProcess === constants/* FetchingStatus.Fetched */._u.Fetched || !isApproved) && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledStepContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledStepPoint, {
        className: account && allowance !== null && allowance !== void 0 && allowance.gt(0) ? 'completed' : 'active',
        children: isApproved ? /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.SuccessIcon */.P.SuccessIcon, {}) : '1'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledStepBar, {
        className: account && (allowance === null || allowance === void 0 ? void 0 : allowance.gt(0)) && 'active'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledStepPoint, {
        className: account && (allowance === null || allowance === void 0 ? void 0 : allowance.gt(0)) && 'active',
        children: "2"
      })]
    })]
  }));
};

var StyledReconnect = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
  displayName: "DepositButton__StyledReconnect",
  componentId: "sc-1rvzv6a-0"
})(["\n  cursor: pointer;\n  color: ", ";\n  text-decoration: underline;\n"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
});
var StyledStepContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DepositButton__StyledStepContainer",
  componentId: "sc-1rvzv6a-1"
})(["\n  margin-top: 12px;\n  width: 60%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n\n  margin-bottom: 24px;\n"]);
var StyledStepBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DepositButton__StyledStepBar",
  componentId: "sc-1rvzv6a-2"
})(["\n  width: 100%;\n  height: 2px;\n  flex: 1;\n  background: linear-gradient(90deg, #e960af 0%, #e960af20 100%);\n\n  &.active {\n    background: linear-gradient(90deg, #06c270 0%, #f3c622 100%);\n  }\n"]);
var StyledStepPoint = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DepositButton__StyledStepPoint",
  componentId: "sc-1rvzv6a-3"
})(["\n  z-index: 1;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-size: 15px;\n  color: white;\n  transition: 0.3;\n  background: #e960af20;\n\n  &.active {\n    background: linear-gradient(270deg, #e960af -10.61%, #f3c622 112.88%);\n    opacity: 1;\n  }\n\n  &.completed {\n    background: transparent;\n    border: 4px solid ", ";\n    opacity: 1;\n\n    svg {\n      min-width: 28px;\n      fill: ", ";\n    }\n  }\n"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.success;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.success;
});
/* harmony default export */ var Deposit_DepositButton = (DepositButton);
;// CONCATENATED MODULE: ./src/views/Payment/components/Deposit/DepositByContract.tsx



var DepositByContract_excluded = ["depositToken", "selectedBonus", "isSelectedBonusExpired", "handleSelectedBonus", "setIsDepositing", "isDepositing"];

function DepositByContract_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DepositByContract_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DepositByContract_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DepositByContract_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



























var DepositInputErrorMessages = {
  depositValue: (0,defineProperty/* default */.Z)({}, validator/* ValidationError.Insufficient */.p.Insufficient, 'Insufficient Balance')
};

var DepositByContract = function DepositByContract(_ref) {
  var depositToken = _ref.depositToken,
      selectedBonus = _ref.selectedBonus,
      isSelectedBonusExpired = _ref.isSelectedBonusExpired,
      handleSelectedBonus = _ref.handleSelectedBonus,
      setIsDepositing = _ref.setIsDepositing,
      isDepositing = _ref.isDepositing,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, DepositByContract_excluded);

  var _useAuth = (0,auth_hooks/* useAuth */.aC)(),
      isSigned = _useAuth.isSigned;

  var estimatedFee = hooks_useDepositFee(depositToken);
  var wallet = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth.wallet;
  });
  var tokenAmount = (0,profile_hooks/* useTokenWalletBalance */.tW)(depositToken, wallet === null || wallet === void 0 ? void 0 : wallet.address);

  var _useState = (0,react.useState)(null),
      confirmingHash = _useState[0],
      setConfirmingHash = _useState[1];

  var isConfirmingHashProcessingRef = (0,react.useRef)(false);
  var pendingDepositTransactionHash = (0,state/* useAppSelector */.CG)(function (state) {
    return state.transaction.pendingDepositTransactionHash || [];
  });
  var handleAddDepositTransaction = (0,transaction_hooks/* useAddDepositTransaction */.YQ)();

  var _useForm = (0,useForm/* default */.Z)({
    amount: {
      validators: [formValidator/* default.lte */.ZP.lte(0), formValidator/* default.max */.ZP.max(tokenAmount === null || tokenAmount === void 0 ? void 0 : tokenAmount.amount)],
      value: ''
    }
  }),
      states = _useForm.states,
      controls = _useForm.controls,
      validateAll = _useForm.validateAll,
      isValid = _useForm.isValid;

  var balance = tokenAmount ? tokenAmount.amount : number/* BIG_ZERO */.HW;

  var onStartDeposit = function onStartDeposit() {
    setIsDepositing(true);
  };

  var onFailed = function onFailed() {
    setIsDepositing(false);
  };

  var onDepositSuccess = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(transaction) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleAddDepositTransaction(transaction, depositToken, controls.amount.value);
              setTimeout(function () {
                return setConfirmingHash((0,utils_transaction/* combineDepositHash */.U)(transaction.hash, depositToken));
              }, 500);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onDepositSuccess(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (!confirmingHash || !pendingDepositTransactionHash) return;
    var isInclude = !!pendingDepositTransactionHash.find(function (pending) {
      return pending.txnHash === confirmingHash;
    });

    if (!isInclude && isConfirmingHashProcessingRef.current) {
      controls.amount.onValueChanged('');
      setIsDepositing(false);
      setConfirmingHash(null);
    } else if (isInclude && !isConfirmingHashProcessingRef.current) {
      isConfirmingHashProcessingRef.current = true;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [confirmingHash, isDepositing, pendingDepositTransactionHash, setIsDepositing]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, DepositByContract_objectSpread(DepositByContract_objectSpread({
    mt: "24px",
    flexDirection: "column"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
      flex: "1 1",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styled/* StyledControlContainer */.l, {
        state: states.amount,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLabel, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputLabel */.AZ, {
            mb: "0px !important",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Amount"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputLabel */.AZ, {
            mb: "0px !important",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                children: "Wallet Balance"
              }), ":", tokenAmount ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [' ', (0,formatBalance/* getFullDisplayBalance */.NJ)(balance, 0, 6), " ", depositToken === null || depositToken === void 0 ? void 0 : depositToken.name]
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                display: "inline",
                minWidth: "50px",
                ml: "4px",
                minHeight: "16px !important"
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_TokenInput, {
          disabled: isDepositing,
          value: states.amount.value,
          token: depositToken,
          errors: states.amount.errors,
          validators: controls.amount.validators,
          onErrorChanged: controls.amount.onErrorChanged,
          onValueChanged: controls.amount.onValueChanged,
          max: tokenAmount === null || tokenAmount === void 0 ? void 0 : tokenAmount.amount,
          getFee: depositToken.isNative ? estimatedFee : null
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          minHeight: "24px",
          mt: "4px",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputMessage */.LK, {
            color: "error",
            textAlign: "right",
            mb: "4px",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: DepositInputErrorMessages.depositValue[states.amount.errors[0]]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
            color: "textAlt",
            fontSize: "12px",
            textAlign: "right",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "No deposit fee"
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      width: "100%",
      mt: "24px",
      mb: "10px",
      children: isSigned && /*#__PURE__*/(0,jsx_runtime.jsx)(Deposit_DepositButton, {
        id: "deposit-button",
        width: "100%",
        loading: isDepositing,
        onStart: onStartDeposit,
        onFailed: onFailed,
        selectedToken: depositToken,
        validateAll: validateAll,
        handleSelectedBonus: handleSelectedBonus,
        onSucceed: onDepositSuccess,
        value: states.amount.value,
        disabled: !isValid || !states.amount.value || isSelectedBonusExpired,
        selectedBonus: selectedBonus
      })
    })]
  }));
};

var StyledLabel = (0,styled_components_browser_esm/* default */.ZP)(Input_styled/* InputLabel */.AZ).withConfig({
  displayName: "DepositByContract__StyledLabel",
  componentId: "sc-1ict8f4-0"
})(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]);
/* harmony default export */ var Deposit_DepositByContract = (DepositByContract);
// EXTERNAL MODULE: ./src/components/Button/CopyButton.tsx + 2 modules
var CopyButton = __webpack_require__(30384);
// EXTERNAL MODULE: ./node_modules/qrcode.react/lib/esm/index.js
var esm = __webpack_require__(84059);
;// CONCATENATED MODULE: ./src/views/Payment/components/Deposit/DepositByQRCode.tsx



















var DepositByQRCode = function DepositByQRCode(_ref) {
  var depositToken = _ref.depositToken;

  var _useState = (0,react.useState)(''),
      depositAddress = _useState[0],
      setDepositAddress = _useState[1];

  var _useState2 = (0,react.useState)(''),
      minDepositAmount = _useState2[0],
      setMinDepositAmount = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isFetchingDepositInfo = _useState3[0],
      setIsFetchingDepositInfo = _useState3[1];

  var debounce = (0,useDebounceCallback/* default */.Z)();

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute;

  (0,react.useEffect)(function () {
    debounce(function () {
      return PaymentService/* default.subscribeDeposit */.Z.subscribeDeposit(depositToken.network, depositToken);
    }, 5000);
  }, [debounce, depositToken]);
  (0,react.useEffect)(function () {
    if (depositToken) {
      var fetchDepositAddress = /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          var response, _response$data, _response$data2;

          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setIsFetchingDepositInfo(true);
                  _context.next = 3;
                  return execute(PaymentService/* default.traditionalDeposit */.Z.traditionalDeposit({
                    currency: depositToken
                  }));

                case 3:
                  response = _context.sent;

                  if (response) {
                    setDepositAddress((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.address);
                    setMinDepositAmount((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.minAmount);
                  }

                  setIsFetchingDepositInfo(false);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function fetchDepositAddress() {
          return _ref2.apply(this, arguments);
        };
      }();

      fetchDepositAddress();
    }
  }, [depositToken, execute]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputContainer */.fv, {
      p: "15px",
      my: "20px",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledDepositAddress, {
          fontSize: ['12px', '12px', '14px'],
          children: depositAddress
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CopyButton/* default */.Z, {
          text: depositAddress
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      m: "20px auto",
      p: "20px",
      background: theme/* default.colors.text */.Z.colors.text,
      width: "fit-content",
      borderRadius: theme/* default.radii.small */.Z.radii.small,
      children: [!isFetchingDepositInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledQRCode, {
        value: depositAddress,
        renderAs: "svg"
      }), isFetchingDepositInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledQRCodeLoader, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      background: "rgba(255, 255, 255, 0.04)",
      borderRadius: theme/* default.radii.small */.Z.radii.small,
      height: "48px",
      padding: "12px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        fontSize: ['12px', '12px', '14px'],
        color: "textSubtle",
        textTransform: "capitalize",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "minimum deposit"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          fontSize: ['12px', '12px', '14px'],
          as: "span",
          children: minDepositAmount
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          fontSize: ['12px', '12px', '14px'],
          as: "span",
          ml: "5px",
          children: depositToken === null || depositToken === void 0 ? void 0 : depositToken.code
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      width: "100%",
      mt: "30px",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
        fontSize: ['12px', '12px', '14px'],
        textAlign: "center",
        fontStyle: "italic",
        children: ["*", /*#__PURE__*/(0,jsx_runtime.jsxs)(es_Trans/* Trans */.c, {
          children: ["Send only ", {
            tokenName: depositToken === null || depositToken === void 0 ? void 0 : depositToken.name
          }, " to this deposit address"]
        })]
      })
    })]
  });
};

var StyledDepositAddress = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
  displayName: "DepositByQRCode__StyledDepositAddress",
  componentId: "sc-1b4oq9b-0"
})(["\n  max-width: 90%;\n  word-break: break-word;\n"]);
var StyledQRCodeLoader = (0,styled_components_browser_esm/* default */.ZP)(Skeleton/* default */.Z).withConfig({
  displayName: "DepositByQRCode__StyledQRCodeLoader",
  componentId: "sc-1b4oq9b-1"
})(["\n  width: 180px;\n  height: 180px;\n\n  padding: 20px;\n"]);
var StyledQRCode = (0,styled_components_browser_esm/* default */.ZP)(esm/* default */.ZP).withConfig({
  displayName: "DepositByQRCode__StyledQRCode",
  componentId: "sc-1b4oq9b-2"
})(["\n  width: 180px !important;\n  height: 180px !important;\n"]);
/* harmony default export */ var Deposit_DepositByQRCode = (DepositByQRCode);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx + 1 modules
var Text_Text = __webpack_require__(50011);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/state/bonus/hooks.ts + 1 modules
var bonus_hooks = __webpack_require__(2309);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(87625);
;// CONCATENATED MODULE: ./src/views/Payment/components/Deposit/WaitingDepositBonusList/WaitingDepositBonusCountdown.tsx


var WaitingDepositBonusCountdown_excluded = ["expiryDate", "onBonusExpired", "color"];

function WaitingDepositBonusCountdown_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WaitingDepositBonusCountdown_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WaitingDepositBonusCountdown_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WaitingDepositBonusCountdown_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var WaitingDepositBonusCountdown = function WaitingDepositBonusCountdown(_ref) {
  var expiryDate = _ref.expiryDate,
      onBonusExpired = _ref.onBonusExpired,
      color = _ref.color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, WaitingDepositBonusCountdown_excluded);

  var shudownTimeTextRef = (0,useCountdown/* useCountDown */.h)(expiryDate, function (s, m, h, d) {
    return "<div>".concat(d.toString().padStart(2, '0'), "</div><span>:</span> <div>").concat(h.toString().padStart(2, '0'), "</div> <span>:</span> <div>").concat(m.toString().padStart(2, '0'), "</div> <span>:</span> <div>").concat(s.toString().padStart(2, '0'), "</div>");
  }, function () {
    onBonusExpired();
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTimeoutBonus, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCountdownContent, WaitingDepositBonusCountdown_objectSpread(WaitingDepositBonusCountdown_objectSpread({
      ref: shudownTimeTextRef
    }, props), {}, {
      color: color
    }))
  });
};

var StyledTimeoutBonus = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "WaitingDepositBonusCountdown__StyledTimeoutBonus",
  componentId: "sc-p8fmb-0"
})(["\n  flex-direction: column;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);
var StyledCountdownContent = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).withConfig({
  displayName: "WaitingDepositBonusCountdown__StyledCountdownContent",
  componentId: "sc-p8fmb-1"
})(["\n  display: flex;\n  font-size: 10px;\n  font-weight: bold;\n\n  .expired {\n    color: ", ";\n    width: 100%;\n  }\n  div {\n    width: 15px;\n    text-align: center;\n  }\n\n  span {\n    color: ", ";\n    width: 10px;\n    text-align: center;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.error;
}, function (_ref3) {
  var colors = _ref3.theme.colors;
  return colors.textAlt;
});
/* harmony default export */ var WaitingDepositBonusList_WaitingDepositBonusCountdown = (WaitingDepositBonusCountdown);
;// CONCATENATED MODULE: ./src/views/Payment/components/Deposit/WaitingDepositBonusList/WaitingDepositBonusItem.tsx



var WaitingDepositBonusItem_excluded = ["bonus", "selectedToken", "isSelected", "disabled"];

function WaitingDepositBonusItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WaitingDepositBonusItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WaitingDepositBonusItem_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WaitingDepositBonusItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var WaitingDepositBonusItem = function WaitingDepositBonusItem(_ref) {
  var _bonus$condition;

  var bonus = _ref.bonus,
      selectedToken = _ref.selectedToken,
      isSelected = _ref.isSelected,
      disabled = _ref.disabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, WaitingDepositBonusItem_excluded);

  var _useDisplayBonusName = (0,bonus_hooks/* useDisplayBonusName */.GN)(bonus),
      _useDisplayBonusName2 = (0,slicedToArray/* default */.Z)(_useDisplayBonusName, 1),
      name = _useDisplayBonusName2[0];

  var tokenPrice = (0,hooks/* useTokenUsdPrice */.KT)(selectedToken);

  var _useState = (0,react.useState)(false),
      isExpired = _useState[0],
      setIsExpired = _useState[1];

  var handleBonusExpired = (0,react.useCallback)(function () {
    setIsExpired(true);
  }, []);
  var isDisabled = ((_bonus$condition = bonus.condition) === null || _bonus$condition === void 0 ? void 0 : _bonus$condition.isExpired) || isExpired || disabled;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, WaitingDepositBonusItem_objectSpread(WaitingDepositBonusItem_objectSpread({
    disabled: isDisabled
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyleContainer, {
      $active: isSelected,
      $disabled: isDisabled,
      height: "100%",
      width: "114px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledCheck, {
        width: "20px",
        height: "20px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.SuccessCheckIcon */.P.SuccessCheckIcon, {
          width: "16px",
          fill: "#fff"
        })
      }), bonus.id ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "14.5px",
            color: isDisabled && !isSelected ? 'textAlt1' : 'text',
            children: bonus.info.name || name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
            fontSize: "10px",
            fontWeight: "300",
            mt: "8px",
            color: isDisabled && !isSelected ? 'textAlt1' : 'textSubtle',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Min Deposit"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
            fontSize: "12px",
            fontWeight: "500",
            mt: "4px",
            lineHeight: "15px",
            color: isDisabled && !isSelected ? 'textAlt1' : 'text',
            children: [(0,formatBalance/* getFullDisplayBalance */.NJ)(new bignumber/* default */.Z(bonus.minDeposit).dividedBy(tokenPrice), 0, tokenPrice.gt(10) ? 6 : 2), ' ', selectedToken.code]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
            fontSize: "10px",
            fontWeight: "300",
            mt: "4px",
            color: isDisabled && !isSelected ? 'textAlt1' : 'textSubtle',
            children: ["~$", bonus.minDeposit]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WaitingDepositBonusList_WaitingDepositBonusCountdown, {
          color: isDisabled && !isSelected ? 'textAlt1' : 'text',
          expiryDate: bonus.condition.expiryDate,
          onBonusExpired: handleBonusExpired
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
          fontSize: "12px",
          width: "64px",
          textAlign: "center",
          lineHeight: "15px",
          color: isDisabled && !isSelected ? 'textAlt1' : 'text',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Without bonus"
          })
        })
      })]
    })
  }));
};

var StyleContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "WaitingDepositBonusItem__StyleContainer",
  componentId: "sc-1qc0ip9-0"
})(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n\n  background: linear-gradient(97.95deg, rgba(255, 255, 255, 0.04) -1.76%, rgba(255, 255, 255, 0) 131.09%),\n    radial-gradient(at 39% 66%, #2af6ff40 -215%, transparent 70%);\n  backdrop-filter: blur(6px);\n  border-radius: 12px;\n  padding: 10px;\n  border: 1px solid ", ";\n\n  ", ";\n\n  ", ";\n"], function (_ref2) {
  var colors = _ref2.theme.colors;
  return colors.providerBackground;
}, function (_ref3) {
  var $active = _ref3.$active,
      theme = _ref3.theme;
  return $active ? (0,styled_components_browser_esm/* css */.iv)(["\n          border: 1px solid ", ";\n          background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 65.91%),\n            radial-gradient(at 39% 66%, #2af6ff87 -215%, transparent 70%) !important;\n          ", " {\n            display: flex;\n          }\n        "], theme.colors.success, StyledCheck) : '';
}, function (_ref4) {
  var $disabled = _ref4.$disabled;
  return $disabled ? (0,styled_components_browser_esm/* css */.iv)(["\n          background: linear-gradient(132deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0) 100%),\n            radial-gradient(at 39% 66%, #2af6ff20 -215%, transparent 70%);\n        "]) : '';
});
var StyledCheck = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "WaitingDepositBonusItem__StyledCheck",
  componentId: "sc-1qc0ip9-1"
})(["\n  border-radius: 0px 10px 0px 8px;\n  background: ", ";\n  display: none;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: -1px;\n  right: -1px;\n"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.success;
});
/* harmony default export */ var WaitingDepositBonusList_WaitingDepositBonusItem = (WaitingDepositBonusItem);
;// CONCATENATED MODULE: ./src/views/Payment/components/Deposit/WaitingDepositBonusList/index.tsx


var WaitingDepositBonusList_excluded = ["selectedToken", "selectedBonus", "bonuses", "isSelectedBonusExpired", "disabled", "handleSelectedBonus"];

function WaitingDepositBonusList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WaitingDepositBonusList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WaitingDepositBonusList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WaitingDepositBonusList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var WaitingDepositBonusList = function WaitingDepositBonusList(_ref) {
  var selectedToken = _ref.selectedToken,
      selectedBonus = _ref.selectedBonus,
      bonuses = _ref.bonuses,
      isSelectedBonusExpired = _ref.isSelectedBonusExpired,
      disabled = _ref.disabled,
      handleSelectedBonus = _ref.handleSelectedBonus,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, WaitingDepositBonusList_excluded);

  return bonuses.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, WaitingDepositBonusList_objectSpread(WaitingDepositBonusList_objectSpread({}, props), {}, {
    width: "100%",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
      alignItems: "center",
      justifyContent: "space-between",
      mb: "12px",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
        small: true,
        bold: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Choose a bonus"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTabs, {
      value: selectedBonus,
      onTagChanged: handleSelectedBonus,
      indicator: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
      backgroundBlurColor: colors/* colors.modalBackground */.O.modalBackground,
      children: bonuses.map(function (bonus) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(WaitingDepositBonusList_WaitingDepositBonusItem, {
          disabled: disabled,
          value: bonus,
          height: "132px",
          maxWidth: "114px",
          marginRight: "8px",
          bonus: bonus,
          selectedToken: selectedToken,
          isSelected: bonus === selectedBonus
        }, bonus.id);
      })
    }), isSelectedBonusExpired ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
      mt: "8px",
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        minWidth: "16px",
        mr: "4px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.WarningIcon */.P.WarningIcon, {
          width: "16px",
          fill: colors/* colors.error */.O.error
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
        color: "error",
        fontSize: "12px",
        lineHeight: "14.5px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Your bonus has been ended. Please choose another bonus"
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
      mt: "8px",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
        color: "textSubtle",
        display: "block",
        fontSize: "12px",
        lineHeight: "14.5px",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          as: "span",
          minWidth: "16px",
          mr: "4px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.WarningIcon */.P.WarningIcon, {
            style: {
              transform: 'translateY(2px)'
            },
            width: "16px",
            fill: colors/* colors.textSubtle */.O.textSubtle
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Don't change the selected bonus until your deposit is credited to your game balance to activate it"
        })]
      })
    })]
  }));
};

var StyledTabs = (0,styled_components_browser_esm/* default */.ZP)(Tabs/* default */.Z).withConfig({
  displayName: "WaitingDepositBonusList__StyledTabs",
  componentId: "sc-egr76m-0"
})(["\n  .tabs-right-blur {\n    background: radial-gradient(\n      586.71% 162.98% at 460.71% 50%,\n      ", " 65.62%,\n      rgba(22, 28, 36, 0) 79.69%\n    );\n    width: 40px;\n  }\n\n  .tabs-left-blur {\n    background: radial-gradient(\n      586.71% 162.98% at 460.71% 50%,\n      ", " 65.62%,\n      rgba(22, 28, 36, 0) 79.69%\n    );\n    width: 40px;\n    transform: rotate(180deg) translateY(50%);\n  }\n"], function (_ref2) {
  var colors = _ref2.theme.colors;
  return colors.modalBackground;
}, function (_ref3) {
  var colors = _ref3.theme.colors;
  return colors.modalBackground;
});
/* harmony default export */ var Deposit_WaitingDepositBonusList = (WaitingDepositBonusList);
;// CONCATENATED MODULE: ./src/views/Payment/components/Deposit/index.tsx

































var Deposit = function Deposit() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useModal = (0,useModal/* default */.Z)(views_HistoryTransaction),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      onPresentModalHistoryTxn = _useModal2[0];

  var _useQueryDepositModal = useQueryDepositModal(),
      onPresentQueryDeposit = _useQueryDepositModal.onPresentQueryDeposit;

  var _useWaitingDepositToA = (0,Deposit_hooks/* useWaitingDepositToActiveBonus */.h)(),
      bonuses = _useWaitingDepositToA.bonuses,
      handleSelectedBonus = _useWaitingDepositToA.handleSelectedBonus,
      selectedBonus = _useWaitingDepositToA.selectedBonus,
      isSelectedBonusExpired = _useWaitingDepositToA.isSelectedBonusExpired;

  var _useState = (0,react.useState)(false),
      isDepositing = _useState[0],
      setIsDepositing = _useState[1];

  var playToken = (0,hooks/* useTokenSelected */.cl)();
  var networks = (0,hooks/* useListNetworks */.Yb)({
    excludeChains: [constants_network/* ChainIdEnum.HPO */.Li.HPO]
  });
  var fallbackToken = (0,react.useMemo)(function () {
    return playToken.network === constants_network/* ChainIdEnum.HPO */.Li.HPO ? tokens/* default */.Z[networks[0].chainId].BNB : playToken;
  }, [networks, playToken]);

  var _useState2 = (0,react.useState)(fallbackToken),
      selectedToken = _useState2[0],
      setSelectedToken = _useState2[1];

  var wallet = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth.wallet;
  });
  var address = wallet === null || wallet === void 0 ? void 0 : wallet.address;

  var _useUserInfo = (0,auth_hooks/* useUserInfo */.Pc)(),
      loginBy = _useUserInfo.loginBy; // INTERGRATE SOLANA
  // wallet?.type == WalletType.SOL
  //   ? { selectChains: [ChainIdEnum.SOL, ChainIdEnum.SOL_TESTNET] }
  //   : { excludeChains: [ChainIdEnum.SOL, ChainIdEnum.SOL_TESTNET] },


  var isDepositByQRCorde = loginBy === auth/* LoginMethod.Email */.p.Email;
  var fetchTokenBalanceFn = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(token) {
      var amount;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (address) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              _context.next = 4;
              return (0,infura/* getCurrencyBalance */.CP)(token, address);

            case 4:
              amount = _context.sent;
              return _context.abrupt("return", amount.amount);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [address]);
  var isTokenBlackList = (0,utils_token/* validateTokenBlackList */.U)(selectedToken);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Deposit_StyledContainer, {
    id: "modalpayment",
    mb: "15px",
    openType: "grow",
    duration: 0.4,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentTokenSelect, {
      disabled: isDepositing,
      token: selectedToken,
      onTokenSelect: function onTokenSelect(token) {
        return setSelectedToken(token);
      },
      networks: networks,
      fetchTokenBalanceFn: isDepositByQRCorde ? null : fetchTokenBalanceFn
    }), isTokenBlackList ? /*#__PURE__*/(0,jsx_runtime.jsx)(Text_TextError, {
      maxWidth: "100% !important",
      my: "12px",
      message: t("Deposit with ".concat(selectedToken.name, "(").concat(constants_network/* NETWORK_MAP */.mF[selectedToken.network].networkInfo.shortName, ") has been suspended."))
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Deposit_WaitingDepositBonusList, {
        mt: "20px",
        disabled: isDepositing,
        selectedToken: selectedToken,
        bonuses: bonuses,
        handleSelectedBonus: handleSelectedBonus,
        selectedBonus: selectedBonus,
        isSelectedBonusExpired: isSelectedBonusExpired
      }), isDepositByQRCorde ? /*#__PURE__*/(0,jsx_runtime.jsx)(Deposit_DepositByQRCode, {
        depositToken: selectedToken
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Deposit_DepositByContract, {
        setIsDepositing: setIsDepositing,
        isDepositing: isDepositing,
        depositToken: selectedToken,
        flex: "1 1",
        handleSelectedBonus: handleSelectedBonus,
        selectedBonus: selectedBonus,
        isSelectedBonusExpired: isSelectedBonusExpired
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
        justifyContent: "center",
        mt: 2,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          id: "link-querydeposit",
          color: "textHighlight",
          display: "block",
          margin: "auto",
          onClick: function onClick() {
            onPresentQueryDeposit();
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
            fontSize: "12px",
            color: "textTertiary",
            fontWeight: 300,
            lineHeight: "18px",
            style: {
              letterSpacing: '-0.02em',
              cursor: 'pointer'
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
              children: "Deposit haven't arrived?"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: {
                color: theme/* default.colors.textHighlight */.Z.colors.textHighlight,
                fontWeight: 400,
                marginLeft: '6px'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                children: "Click here"
              })
            })]
          }), ' ']
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        id: "view-history",
        justifyContent: "flex-end",
        alignItems: "center",
        mt: 2,
        onClick: onPresentModalHistoryTxn,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledViewHistoryText, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "View History"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          position: "relative",
          top: 1.6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.ChevronRightIcon */.P.ChevronRightIcon, {
            width: 20,
            height: 12,
            fill: theme/* default.colors.text */.Z.colors.text
          })
        })]
      })]
    })]
  });
};

var Deposit_StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(OpenEffect/* default */.Z).withConfig({
  displayName: "Deposit__StyledContainer",
  componentId: "sc-1rdzhl1-0"
})(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"]);
var StyledViewHistoryText = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
  displayName: "Deposit__StyledViewHistoryText",
  componentId: "sc-1rdzhl1-1"
})(["\n  cursor: pointer;\n  font-size: 12px;\n"]);
/* harmony default export */ var components_Deposit = (Deposit);
// EXTERNAL MODULE: ./src/components/FormControl/index.tsx + 1 modules
var FormControl = __webpack_require__(66938);
// EXTERNAL MODULE: ./src/components/FormControl/FormInput.tsx + 2 modules
var FormInput = __webpack_require__(38097);
;// CONCATENATED MODULE: ./src/hooks/useDebounce.ts
 // modified from https://usehooks.com/useDebounce/

function useDebounce(value, delay) {
  var _useState = (0,react.useState)(value),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  (0,react.useEffect)(function () {
    // Update debounced value after delay
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay); // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.

    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}
// EXTERNAL MODULE: ./src/views/Authentication/components/Traditional/modals/EmailVerificationModal.tsx
var EmailVerificationModal = __webpack_require__(5730);
;// CONCATENATED MODULE: ./src/views/Payment/components/Withdraw/TraditionalWithdrawButton.tsx




var TraditionalWithdrawButton_excluded = ["selectedToken", "validateAll", "toAddress", "fee", "value", "onSuccess", "disabled"];


function TraditionalWithdrawButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TraditionalWithdrawButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TraditionalWithdrawButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TraditionalWithdrawButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var TraditionalWithdrawButton = function TraditionalWithdrawButton(_ref) {
  var selectedToken = _ref.selectedToken,
      validateAll = _ref.validateAll,
      toAddress = _ref.toAddress,
      fee = _ref.fee,
      value = _ref.value,
      onSuccess = _ref.onSuccess,
      disabled = _ref.disabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, TraditionalWithdrawButton_excluded);

  var _useAppSelector = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth;
  }),
      email = _useAppSelector.email;

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute;

  var _useModal = (0,useModal/* default */.Z)(EmailVerificationModal/* default */.Z),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      handlePresentEmailVerificationModal = _useModal2[0];

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      recordEvent = _useAnalytics.recordEvent;

  var _useState = (0,react.useState)(false),
      submiting = _useState[0],
      setSubmiting = _useState[1];

  var handleWithdraw = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var isValid, parsedWithdrawPayload, verification;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSubmiting(true);
              _context2.next = 3;
              return validateAll();

            case 3:
              isValid = _context2.sent;

              if (isValid) {
                _context2.next = 7;
                break;
              }

              setSubmiting(false);
              return _context2.abrupt("return");

            case 7:
              parsedWithdrawPayload = {
                currency: selectedToken,
                toAddress: toAddress,
                amount: value
              };
              _context2.next = 10;
              return execute(PaymentService/* default.prepareTraditionalWithdraw */.Z.prepareTraditionalWithdraw(parsedWithdrawPayload));

            case 10:
              verification = _context2.sent;

              if (verification !== null && verification !== void 0 && verification.data) {
                _context2.next = 13;
                break;
              }

              return _context2.abrupt("return", setSubmiting(false));

            case 13:
              handlePresentEmailVerificationModal({
                email: email,
                initialVerifiedResult: verification.data,
                verifiedHunnyRequestFn: function verifiedHunnyRequestFn() {
                  return (0,requestHelper/* transformHunnyRequest */.Tc)(PaymentService/* default.prepareTraditionalWithdraw */.Z.prepareTraditionalWithdraw(parsedWithdrawPayload), function (res) {
                    return res === null || res === void 0 ? void 0 : res.data;
                  });
                },
                onSubmit: function onSubmit(verification, otp) {
                  return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                    var withdrawResponse, _withdrawResponse$dat;

                    return regenerator_default().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return PaymentService/* default.traditionalWithdraw */.Z.traditionalWithdraw(TraditionalWithdrawButton_objectSpread(TraditionalWithdrawButton_objectSpread({}, parsedWithdrawPayload), {}, {
                              otp: otp,
                              verificationCode: verification.token
                            }));

                          case 2:
                            withdrawResponse = _context.sent;

                            if (withdrawResponse !== null && withdrawResponse !== void 0 && withdrawResponse.data) {
                              recordEvent('withdraw', (0,defineProperty/* default */.Z)({}, constants_network/* ChainIdEnum */.Li[selectedToken.network], selectedToken.name));
                              onSuccess(withdrawResponse === null || withdrawResponse === void 0 ? void 0 : (_withdrawResponse$dat = withdrawResponse.data) === null || _withdrawResponse$dat === void 0 ? void 0 : _withdrawResponse$dat.ref.toString());
                            }

                            return _context.abrupt("return", withdrawResponse);

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }))();
                }
              });
              setSubmiting(false);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleWithdraw() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, TraditionalWithdrawButton_objectSpread(TraditionalWithdrawButton_objectSpread({
    disabled: submiting || disabled,
    onClick: handleWithdraw
  }, props), {}, {
    children: [submiting && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      mr: "12px",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      bold: true,
      fontSize: "14px",
      color: submiting ? 'textSubtle' : 'text',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
        children: "Withdraw"
      })
    })]
  }));
};

/* harmony default export */ var Withdraw_TraditionalWithdrawButton = (TraditionalWithdrawButton);
// EXTERNAL MODULE: ./src/hooks/useSignMessage.ts
var useSignMessage = __webpack_require__(69176);
;// CONCATENATED MODULE: ./src/views/Payment/components/Withdraw/WalletWithdrawButton.tsx



var WalletWithdrawButton_excluded = ["selectedToken", "validateAll", "value", "onSuccess", "disabled"];

function WalletWithdrawButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletWithdrawButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletWithdrawButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletWithdrawButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

























var WalletWithdrawButton = function WalletWithdrawButton(_ref) {
  var selectedToken = _ref.selectedToken,
      validateAll = _ref.validateAll,
      value = _ref.value,
      onSuccess = _ref.onSuccess,
      disabled = _ref.disabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, WalletWithdrawButton_excluded);

  var _useAppSelector = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth;
  }),
      wallet = _useAppSelector.wallet;

  var walletInfo = (0,react.useMemo)(function () {
    return constants_wallet/* WALLET_INFO.find */.I.find(function (item) {
      return item.name === wallet.name && item.type === wallet.type;
    });
  }, [wallet.name, wallet.type]);
  var walletConnector = (0,useConnectWallet/* useConnectWallet */.O)();
  var signMessage = (0,useSignMessage/* default */.Z)(wallet.type);
  var accounts = (0,useWalletAccount/* default */.Z)();
  var account = accounts[wallet === null || wallet === void 0 ? void 0 : wallet.type];

  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute;

  var _useState = (0,react.useState)(false),
      submiting = _useState[0],
      setSubmiting = _useState[1];

  var handleWithdraw = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _withdrawResponse$dat;

      var isValid, prepareData, messageSignature, withdrawResponse;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmiting(true);
              _context.next = 3;
              return validateAll();

            case 3:
              isValid = _context.sent;

              if (isValid) {
                _context.next = 7;
                break;
              }

              setSubmiting(false);
              return _context.abrupt("return");

            case 7:
              _context.next = 9;
              return execute(PaymentService/* default.prepareWalletWithdraw */.Z.prepareWalletWithdraw(value, selectedToken));

            case 9:
              prepareData = _context.sent;

              if (prepareData.data) {
                _context.next = 13;
                break;
              }

              setSubmiting(false);
              return _context.abrupt("return");

            case 13:
              _context.next = 15;
              return signMessage(prepareData.data.acceptMessageText);

            case 15:
              messageSignature = _context.sent;

              if (messageSignature) {
                _context.next = 19;
                break;
              }

              setSubmiting(false);
              return _context.abrupt("return");

            case 19:
              _context.next = 21;
              return PaymentService/* default.walletWithdraw */.Z.walletWithdraw(selectedToken, value, messageSignature);

            case 21:
              withdrawResponse = _context.sent;

              if (withdrawResponse !== null && withdrawResponse !== void 0 && (_withdrawResponse$dat = withdrawResponse.data) !== null && _withdrawResponse$dat !== void 0 && _withdrawResponse$dat.ref) {
                onSuccess(withdrawResponse.data.ref.toString());
              }

              setSubmiting(false);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleWithdraw() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (!account) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, WalletWithdrawButton_objectSpread(WalletWithdrawButton_objectSpread({}, props), {}, {
      onClick: function onClick() {
        walletConnector[wallet.type].connect(walletInfo.adapter);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
        bold: true,
        fontSize: "14px",
        color: submiting ? 'textSubtle' : 'text',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
          children: "Connect Wallet"
        })
      })
    }));
  }

  if (account !== (wallet === null || wallet === void 0 ? void 0 : wallet.address)) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, WalletWithdrawButton_objectSpread(WalletWithdrawButton_objectSpread({
        alignItems: "center",
        border: "1px solid ".concat(colors/* colors.warning */.O.warning),
        padding: "12px",
        borderRadius: theme/* default.radii.small */.Z.radii.small
      }, props), {}, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mr: "12px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.WarningIcon */.P.WarningIcon, {
            width: "24px",
            fill: colors/* colors.warning */.O.warning
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          bold: true,
          fontSize: "12px",
          color: "warning",
          textAlign: "center",
          lineHeight: "16px",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(es_Trans/* Trans */.c, {
            children: ["It seems your wallet connected is active different address, please switch to account", ' ', {
              account: (0,stringHelper/* formatUsername */.Kf)(wallet.address)
            }]
          })
        })]
      })), walletInfo.adapter instanceof walletconnect_connector_esm/* WalletConnectConnector */.zw && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "12px",
        width: "100%",
        onClick: function onClick() {
          walletConnector[wallet.type].connect(walletInfo.adapter);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
          bold: true,
          fontSize: "14px",
          color: submiting ? 'textSubtle' : 'text',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "Switch account"
          })
        })
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, WalletWithdrawButton_objectSpread(WalletWithdrawButton_objectSpread({
    disabled: submiting || disabled,
    onClick: handleWithdraw
  }, props), {}, {
    children: [submiting && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      mr: "12px",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
      bold: true,
      fontSize: "14px",
      color: submiting ? 'textSubtle' : 'text',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
        children: "Withdraw"
      })
    })]
  }));
};

/* harmony default export */ var Withdraw_WalletWithdrawButton = (WalletWithdrawButton);
;// CONCATENATED MODULE: ./src/views/Payment/components/Withdraw/hooks.ts






var useWithdrawFee = function useWithdrawFee(selectedToken) {
  var _useRequest = (0,useRequest/* useRequest */.Q)(),
      execute = _useRequest.execute;

  var _useState = (0,react.useState)(''),
      withdrawFee = _useState[0],
      setWithdrawFee = _useState[1];

  var fetchFee = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(amount) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return execute(PaymentService/* default.getWithdrawFee */.Z.getWithdrawFee({
                currency: selectedToken,
                amount: amount
              }));

            case 2:
              response = _context.sent;
              if (response !== null && response !== void 0 && response.data) setWithdrawFee(response.data.withdrawFee);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [execute, selectedToken]);
  (0,react.useEffect)(function () {
    fetchFee('1');
    return function () {
      setWithdrawFee('0');
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedToken]);
  return (0,react.useMemo)(function () {
    return {
      withdrawFee: new bignumber/* default */.Z(withdrawFee),
      updateFeeWithdraw: fetchFee
    };
  }, [fetchFee, withdrawFee]);
};
;// CONCATENATED MODULE: ./src/views/Payment/components/Withdraw/index.tsx




var _receiveAddress, _withdrawValue;








































var WithdrawInputErrorMessages = {
  receiveAddress: (_receiveAddress = {}, (0,defineProperty/* default */.Z)(_receiveAddress, validator/* ValidationError.Required */.p.Required, 'Address is required'), (0,defineProperty/* default */.Z)(_receiveAddress, validator/* ValidationError.IsEtherAddress */.p.IsEtherAddress, 'Your address is invalid'), _receiveAddress),
  withdrawValue: (_withdrawValue = {}, (0,defineProperty/* default */.Z)(_withdrawValue, validator/* ValidationError.Insufficient */.p.Insufficient, 'Insufficient Balance'), (0,defineProperty/* default */.Z)(_withdrawValue, validator/* ValidationError.LessThanEqual */.p.LessThanEqual, 'Amount must be greater than withdraw fee'), _withdrawValue)
};

var Withdraw = function Withdraw() {
  var _useUserInfo = (0,auth_hooks/* useUserInfo */.Pc)(),
      loginBy = _useUserInfo.loginBy,
      username = _useUserInfo.username;

  var _useAppSelector = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth;
  }),
      wallet = _useAppSelector.wallet;

  var isLoginByEmail = loginBy === auth/* LoginMethod.Email */.p.Email;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useModal = (0,useModal/* default */.Z)(views_HistoryTransaction),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      onPresentModalHistoryTxn = _useModal2[0];

  var initialToken = (0,hooks/* useTokenSelected */.cl)();
  var networks = (0,hooks/* useListNetworks */.Yb)({
    excludeChains: [constants_network/* ChainIdEnum.HPO */.Li.HPO]
  });
  var fallbackToken = (0,react.useMemo)(function () {
    var _networks$;

    return initialToken.network === constants_network/* ChainIdEnum.HPO */.Li.HPO ? tokens/* default */.Z[(_networks$ = networks[0]) === null || _networks$ === void 0 ? void 0 : _networks$.chainId].BNB : initialToken;
  }, [networks, initialToken]);

  var _useState = (0,react.useState)(fallbackToken),
      selectedToken = _useState[0],
      setSelectedToken = _useState[1];

  var tokenBalances = (0,state/* useAppSelector */.CG)(function (state) {
    return state.profile.balances;
  });
  var selectTokenAmount = (0,profile_hooks/* useTokenAppBalance */.bH)(selectedToken);

  var _useWithdrawFee = useWithdrawFee(selectedToken),
      withdrawFee = _useWithdrawFee.withdrawFee,
      updateFeeWithdraw = _useWithdrawFee.updateFeeWithdraw;

  var handleAddWithdrawTransaction = (0,transaction_hooks/* useAddWithdrawTransaction */.M2)();

  var _useForm = (0,useForm/* default */.Z)({
    value: {
      validators: [formValidator/* default.lte */.ZP.lte(withdrawFee), formValidator/* default.max */.ZP.max(selectTokenAmount === null || selectTokenAmount === void 0 ? void 0 : selectTokenAmount.amount)],
      value: ''
    },
    receiveAddress: {
      validators: [formValidator/* default.required */.ZP.required, formValidator/* default.etherAddress */.ZP.etherAddress],
      value: isLoginByEmail ? '' : (wallet === null || wallet === void 0 ? void 0 : wallet.address) || username
    }
  }),
      states = _useForm.states,
      controls = _useForm.controls,
      validateAll = _useForm.validateAll,
      isValid = _useForm.isValid,
      validate = _useForm.validate;

  var fetchTokenBalanceFn = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(token) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new bignumber/* default */.Z(tokenBalances[(0,utils/* getBalanceTokenKey */.D$)(token.network, token.code)] || 0)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [tokenBalances]);

  var onWithdrawSuccess = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(txnCode) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              handleAddWithdrawTransaction(txnCode, selectTokenAmount.token, states.value.value.toString(), withdrawFee.toString());
              controls.value.onValueChanged('');

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onWithdrawSuccess(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var amountDebounce = useDebounce(states.value.value, 1000);
  var feeDebounce = useDebounce(withdrawFee.toString(), 1000);
  (0,react.useEffect)(function () {
    if (states.value.isDirty && !Number.isNaN(feeDebounce)) {
      validate('value');
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [feeDebounce]);
  (0,react.useEffect)(function () {
    if (!Number.isNaN(amountDebounce) && Number(amountDebounce) > 0) {
      updateFeeWithdraw(amountDebounce.toString());
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [amountDebounce]);

  var handleSelectToken = function handleSelectToken(token) {
    setSelectedToken(token);
    controls.value.onValueChanged('');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(OpenEffect/* default */.Z, {
    openType: "fade",
    duration: 1,
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Withdraw_StyledWrapper, {
      flexDirection: "column",
      width: "100%",
      height: "100%",
      justifyContent: "space-between",
      pb: "24px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flex: "1 1",
        flexDirection: "column",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentTokenSelect, {
          token: selectedToken,
          onTokenSelect: handleSelectToken,
          fetchTokenBalanceFn: fetchTokenBalanceFn,
          networks: networks
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [loginBy === auth/* LoginMethod.Email */.p.Email && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormControl, {
            mt: "16px",
            state: states.receiveAddress,
            label: t('Address'),
            formatErrorMessage: function formatErrorMessage(errors) {
              return WithdrawInputErrorMessages.receiveAddress[errors[0]];
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
              control: controls.receiveAddress,
              placeholder: t('Address'),
              type: "address",
              name: "address"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styled/* StyledControlContainer */.l, {
            mt: "16px",
            state: states.value,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Withdraw_StyledLabel, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputLabel */.AZ, {
                mb: "0px !important",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                  children: "Amount"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Input_styled/* InputLabel */.AZ, {
                mb: "0px !important",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                  children: "Withdrawable"
                }), ": ", (0,formatBalance/* getFullDisplayBalance */.NJ)(selectTokenAmount === null || selectTokenAmount === void 0 ? void 0 : selectTokenAmount.amount, 0, 5), ' ', selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.name]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_TokenInput, {
              value: states.value.value,
              token: selectedToken,
              errors: states.value.errors,
              validators: controls.value.validators,
              onErrorChanged: controls.value.onErrorChanged,
              onValueChanged: controls.value.onValueChanged,
              max: selectTokenAmount === null || selectTokenAmount === void 0 ? void 0 : selectTokenAmount.amount
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
              flexDirection: ['column'],
              justifyContent: "space-between",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styled/* InputMessage */.LK, {
                textAlign: "right",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                  children: WithdrawInputErrorMessages.withdrawValue[states.value.errors[0]]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                color: "textAlt",
                fontSize: "14px",
                textAlign: "right",
                mt: "4px",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(es_Trans/* Trans */.c, {
                  children: ["Withdrawal fee", ' ', {
                    withdrawFee: Number.isNaN(withdrawFee.toNumber()) ? '...' : withdrawFee.toNumber()
                  }, ' ', {
                    currency: selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.name
                  }]
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Flex/* default */.Z, {
            mt: "30px",
            justifyContent: "space-between",
            height: "16px",
            children: states.value.value && Number(states.value.value) > withdrawFee.toNumber() && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                fontSize: ['12px', '12px', '14px'],
                color: "primary",
                bold: true,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
                  children: "You will get"
                }), ":"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                fontSize: ['12px', '12px', '14px'],
                color: "primary",
                bold: true,
                children: [(0,formatBalance/* getFullDisplayBalance */.NJ)(new bignumber/* default */.Z(states.value.value).minus(withdrawFee), 0, selectedToken.decimals), ' ', selectedToken.name]
              })]
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        width: "100%",
        mt: "12px",
        mb: "10px",
        children: loginBy === auth/* LoginMethod.Email */.p.Email ? /*#__PURE__*/(0,jsx_runtime.jsx)(Withdraw_TraditionalWithdrawButton, {
          width: "100%",
          fee: withdrawFee.toString(),
          selectedToken: selectedToken,
          toAddress: states.receiveAddress.value,
          validateAll: validateAll,
          onSuccess: onWithdrawSuccess,
          value: states.value.value,
          disabled: !isValid || !states.value.value
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Withdraw_WalletWithdrawButton, {
          width: "100%",
          selectedToken: selectedToken,
          validateAll: validateAll,
          onSuccess: onWithdrawSuccess,
          value: states.value.value,
          disabled: !isValid || !states.value.value
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "flex-end",
        alignItems: "center",
        mt: 2,
        onClick: onPresentModalHistoryTxn,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Withdraw_StyledViewHistoryText, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_Trans/* Trans */.c, {
            children: "View History"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          position: "relative",
          top: 1.6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.ChevronRightIcon */.P.ChevronRightIcon, {
            width: 20,
            height: 12,
            fill: theme/* default.colors.text */.Z.colors.text
          })
        })]
      })]
    })
  });
};

var Withdraw_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "Withdraw__StyledWrapper",
  componentId: "sc-i8gdnj-0"
})(["\n  flex: 1;\n\n  ", " {\n    min-height: 480px;\n  }\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.xs;
});
var Withdraw_StyledLabel = (0,styled_components_browser_esm/* default */.ZP)(Input_styled/* InputLabel */.AZ).withConfig({
  displayName: "Withdraw__StyledLabel",
  componentId: "sc-i8gdnj-1"
})(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]);
var StyledFormControl = (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
  displayName: "Withdraw__StyledFormControl",
  componentId: "sc-i8gdnj-2"
})(["\n  ", " {\n    height: 46px;\n  }\n"], Input_styled/* StyledInput */.Fy);
var Withdraw_StyledViewHistoryText = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
  displayName: "Withdraw__StyledViewHistoryText",
  componentId: "sc-i8gdnj-3"
})(["\n  cursor: pointer;\n  font-size: 12px;\n"]);
/* harmony default export */ var components_Withdraw = (Withdraw);
;// CONCATENATED MODULE: ./src/views/Payment/index.tsx
















var PaymentPageEnums;

(function (PaymentPageEnums) {
  PaymentPageEnums[PaymentPageEnums["Deposit"] = 0] = "Deposit";
  PaymentPageEnums[PaymentPageEnums["Withdraw"] = 1] = "Withdraw";
})(PaymentPageEnums || (PaymentPageEnums = {}));

var Payment = function Payment(_ref) {
  var defaultPage = _ref.data.defaultPage,
      onDismiss = _ref.onDismiss;

  var _useState = (0,react.useState)(defaultPage || PaymentPageEnums.Deposit),
      paymentPage = _useState[0],
      setPaymentPage = _useState[1];

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Payment_StyledModal, {
    id: "payment",
    onDismiss: onDismiss,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledModalHeader, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Payment_StyledTabs, {
        indicator: /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs/* StyledIndicator */.C, {
          width: "50% !important",
          borderRadius: "20px"
        }),
        value: paymentPage,
        onTagChanged: function onTagChanged(value) {
          setPaymentPage(value);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTab, {
          value: PaymentPageEnums.Deposit,
          $active: paymentPage === PaymentPageEnums.Deposit,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_TabLabel, {
            Icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.DepositIcon */.P.DepositIcon, {
              fill: colors/* colors.text */.O.text
            }),
            label: t('Deposit')
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTab, {
          value: PaymentPageEnums.Withdraw,
          $active: paymentPage === PaymentPageEnums.Withdraw,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_TabLabel, {
            Icon: /*#__PURE__*/(0,jsx_runtime.jsx)(svgs/* Icons.WithdrawIcon */.P.WithdrawIcon, {
              fill: colors/* colors.text */.O.text
            }),
            label: t('Withdraw')
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* ModalBody */.fe, {
      height: "100%",
      overflowY: "auto",
      borderTopLeftRadius: theme/* default.radii.default */.Z.radii["default"],
      borderTopRightRadius: theme/* default.radii.default */.Z.radii["default"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
        children: [paymentPage === PaymentPageEnums.Deposit && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Deposit, {}), paymentPage === PaymentPageEnums.Withdraw && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Withdraw, {})]
      })
    })]
  });
};

var Payment_StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
  displayName: "Payment__StyledModal",
  componentId: "sc-oakjy4-0"
})(["\n  padding: 0;\n\n  box-sizing: border-box;\n\n  background: ", ";\n  min-height: 85vh;\n\n  overflow-y: hidden;\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n\n  & .modal-closebutton {\n    right: 12px;\n    top: 24px;\n  }\n\n  ", " {\n    min-width: 420px;\n    max-width: 420px;\n    min-height: 576px;\n    border-radius: ", ";\n  }\n"], function (_ref2) {
  var colors = _ref2.theme.colors;
  return colors.modalBackground;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.large;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radii.large;
}, function (_ref5) {
  var mediaQueries = _ref5.theme.mediaQueries;
  return mediaQueries.sm;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.radii.large;
});
var Payment_StyledTabs = (0,styled_components_browser_esm/* default */.ZP)(Tabs/* default */.Z).withConfig({
  displayName: "Payment__StyledTabs",
  componentId: "sc-oakjy4-1"
})(["\n  width: calc(100% - 48px);\n  ", " {\n    width: 100%;\n  }\n"], function (_ref7) {
  var mediaQueries = _ref7.theme.mediaQueries;
  return mediaQueries.sm;
});
var StyledModalHeader = (0,styled_components_browser_esm/* default */.ZP)(Modal/* ModalHeader */.xB).withConfig({
  displayName: "Payment__StyledModalHeader",
  componentId: "sc-oakjy4-2"
})(["\n  display: flex;\n  align-items: flex-end;\n\n  ", " {\n    padding-left: 6px;\n  }\n"], function (_ref8) {
  var mediaQueries = _ref8.theme.mediaQueries;
  return mediaQueries.sm;
});
var StyledTab = (0,styled_components_browser_esm/* default */.ZP)(Tab/* default */.Z).withConfig({
  displayName: "Payment__StyledTab",
  componentId: "sc-oakjy4-3"
})(["\n  padding: 12px;\n\n  svg {\n    min-width: 20px;\n    transition: ", ";\n    fill: ", ";\n  }\n\n  ", " {\n    transition: ", ";\n    color: ", ";\n    white-space: pre !important;\n  }\n"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.transitions.fast;
}, function (_ref10) {
  var theme = _ref10.theme,
      $active = _ref10.$active;
  return $active ? "".concat(theme.colors.primary, " !important") : theme.colors.textSubtle;
}, components_Text/* default */.Z, function (_ref11) {
  var theme = _ref11.theme;
  return theme.transitions.fast;
}, function (_ref12) {
  var theme = _ref12.theme,
      $active = _ref12.$active;
  return $active ? "".concat(theme.colors.primary, " !important") : theme.colors.textSubtle;
});
var StyledContent = (0,styled_components_browser_esm/* default */.ZP)(Column/* default */.ZP).withConfig({
  displayName: "Payment__StyledContent",
  componentId: "sc-oakjy4-4"
})(["\n  flex: 1;\n\n  width: 100%;\n  height: 100%;\n\n  padding: 20px 20px;\n\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n\n  ", " {\n    padding: 12px 32px;\n  }\n"], function (_ref13) {
  var radii = _ref13.theme.radii;
  return radii.small;
}, function (_ref14) {
  var radii = _ref14.theme.radii;
  return radii.small;
}, function (_ref15) {
  var mediaQueries = _ref15.theme.mediaQueries;
  return mediaQueries.sm;
});
/* harmony default export */ var views_Payment = (Payment);

/***/ }),

/***/ 88677:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 62808:
/***/ (function() {

/* (ignored) */

/***/ })

}]);